/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * Represents fractional signed decimal numeric values. To avoid floating-point
   * number precision problems, it's encoded as a string.
   */
  BigDecimal: { input: any; output: any; }
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: { input: any; output: any; }
  /** Represents an email address, encoded as a String */
  EmailAddress: { input: any; output: any; }
  /** ID that returns an Integer for legacy numeric IDs (<= MAX_LEGACY_ID) and a String for new big IDs */
  HybridId: { input: any; output: any; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any; }
  /** Represents untyped JSON */
  JSON: { input: any; output: any; }
  /** Represents a password, encoded as a String */
  Password: { input: any; output: any; }
  /** Represents a phone number, encoded as a String */
  PhoneNumberDigits: { input: any; output: any; }
  /** 6 character, upper-case alpha numeric Rewards code */
  RewardsCode: { input: any; output: any; }
  /** Formatted Time object */
  Time: { input: any; output: any; }
  /** Represents a UUID, encoded as a String */
  UUID: { input: any; output: any; }
};

export type AblySubscriptionData = {
  __typename?: 'AblySubscriptionData';
  channel: Scalars['String']['output'];
  jwtToken: Scalars['String']['output'];
};

export type AcceptMobileOrderingOrder = {
  id: Scalars['ID']['input'];
  version: Scalars['ID']['input'];
};

/** Autogenerated return type of AcceptMobileOrderingOrder. */
export type AcceptMobileOrderingOrderPayload = {
  __typename?: 'AcceptMobileOrderingOrderPayload';
  error?: Maybe<OperationError>;
  order?: Maybe<MobileOrderingOrder>;
};

/** An account */
export type Account = {
  __typename?: 'Account';
  accountInfoNotes?: Maybe<Array<AccountNote>>;
  accountManager?: Maybe<User>;
  activeForRewards: Scalars['Boolean']['output'];
  /** @deprecated Use popup_billing_policy */
  billingPolicy?: Maybe<BillingPolicy>;
  buildings?: Maybe<Array<Building>>;
  cards?: Maybe<Array<AccountPaymentCard>>;
  cateringBillingPolicy?: Maybe<BillingPolicy>;
  contacts?: Maybe<Array<Contact>>;
  deliveryBillingPolicy?: Maybe<BillingPolicy>;
  id: Scalars['ID']['output'];
  marketingSegments?: Maybe<Array<MarketingSegment>>;
  name: Scalars['String']['output'];
  popupBillingPolicy?: Maybe<BillingPolicy>;
};


/** An account */
export type AccountCardsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** An account building */
export type AccountBuilding = {
  __typename?: 'AccountBuilding';
  account: AccountPublic;
  building: Building;
};

export type AccountBuildingInput = {
  accountId: Scalars['ID']['input'];
  buildingId: Scalars['String']['input'];
};

/** Account delivery event member */
export type AccountDeliveryEventMember = {
  __typename?: 'AccountDeliveryEventMember';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Full name of the member */
  name?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<Array<AccountDeliveryEventMemberOrder>>;
  status?: Maybe<AccountDeliveryOrderStatus>;
  userId: Scalars['ID']['output'];
};

/** The connection type for AccountDeliveryEventMember. */
export type AccountDeliveryEventMemberConnection = {
  __typename?: 'AccountDeliveryEventMemberConnection';
  currentPage: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AccountDeliveryEventMemberEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AccountDeliveryEventMember>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AccountDeliveryEventMemberEdge = {
  __typename?: 'AccountDeliveryEventMemberEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AccountDeliveryEventMember>;
};

/** Order placed by an account delivery event member */
export type AccountDeliveryEventMemberOrder = {
  __typename?: 'AccountDeliveryEventMemberOrder';
  id: Scalars['ID']['output'];
  status: AccountDeliveryOrderStatus;
  subsidyPrograms?: Maybe<Array<Scalars['String']['output']>>;
  vendors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Aggregated order summary for delivery event members */
export type AccountDeliveryEventSummary = {
  __typename?: 'AccountDeliveryEventSummary';
  notOrderedCount: Scalars['Int']['output'];
  orderedCount: Scalars['Int']['output'];
  totalMembersCount: Scalars['Int']['output'];
};

export enum AccountDeliveryMemberFilter {
  All = 'ALL',
  HaveNotOrdered = 'HAVE_NOT_ORDERED',
  Ordered = 'ORDERED'
}

export enum AccountDeliveryMemberSortField {
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

export enum AccountDeliveryOrderStatus {
  Canceled = 'CANCELED',
  NoOrder = 'NO_ORDER',
  Ordered = 'ORDERED'
}

/** A user's membership with an account */
export type AccountMembership = {
  __typename?: 'AccountMembership';
  accountId: Scalars['ID']['output'];
  addedByUser?: Maybe<User>;
  id: Scalars['ID']['output'];
  permissions: Array<AccountRolePermission>;
  role: AccountRoleEnum;
  subsidyState?: Maybe<SubsidyStateEnum>;
  user: User;
};

/** An account note */
export type AccountNote = {
  __typename?: 'AccountNote';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Account note id */
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** created by user */
  user: User;
};

/** An account offered as a picker option, with the parent company that covers it */
export type AccountOption = {
  __typename?: 'AccountOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** The parent company this account reports into, if any */
  parentCompany?: Maybe<ParentCompanyOption>;
};

/** An account card payment method */
export type AccountPaymentCard = {
  __typename?: 'AccountPaymentCard';
  /** Cardholder's full name */
  cardholderName?: Maybe<Scalars['String']['output']>;
  expirationMonth?: Maybe<Scalars['Int']['output']>;
  expirationYear?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Account payment method id of the card */
  id: Scalars['ID']['output'];
  /** Last four card digits */
  last4?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  products: Array<ProductEnum>;
};

/** Arguments to update an account member's permissions */
export type AccountPermission = {
  active: Scalars['Boolean']['input'];
  name: AccountRolePermission;
};

/** An account */
export type AccountPublic = {
  __typename?: 'AccountPublic';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum AccountRoleEnum {
  Administrator = 'ADMINISTRATOR',
  CafeCashier = 'CAFE_CASHIER',
  Member = 'MEMBER'
}

export enum AccountRolePermission {
  BillingAdmin = 'BILLING_ADMIN',
  CateringAdmin = 'CATERING_ADMIN',
  DeliveryAdmin = 'DELIVERY_ADMIN',
  InvoiceDetailedReport = 'INVOICE_DETAILED_REPORT',
  InvoiceSummaryReport = 'INVOICE_SUMMARY_REPORT',
  PantryReporting = 'PANTRY_REPORTING',
  SubsidyAdmin = 'SUBSIDY_ADMIN'
}

/** Account subsidy settings configuration */
export type AccountSubsidySettings = {
  __typename?: 'AccountSubsidySettings';
  approvalAction?: Maybe<SubsidyApprovalAction>;
  approvalType?: Maybe<SubsidyApproval>;
  defaultRuleIds?: Maybe<Array<Scalars['ID']['output']>>;
  id: Scalars['ID']['output'];
  notificationFrequency?: Maybe<SubsidyNotificationFrequency>;
  rulePrivate?: Maybe<Scalars['Boolean']['output']>;
  sendEmailNotification?: Maybe<Scalars['Boolean']['output']>;
  whiteListedDomains?: Maybe<Array<Scalars['String']['output']>>;
};

export type AccountingSiteOwner = {
  __typename?: 'AccountingSiteOwner';
  accountingSiteId: Scalars['Int']['output'];
  effectiveEnd?: Maybe<Scalars['ISO8601Date']['output']>;
  effectiveStart: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  past: Scalars['Boolean']['output'];
  roleTypeIds: Array<Scalars['ID']['output']>;
  roleTypeNames: Array<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

/** Attributes for creating or updating an AccountingSiteOwner */
export type AccountingSiteOwnerInput = {
  effectiveEnd?: InputMaybe<Scalars['ISO8601Date']['input']>;
  effectiveStart?: InputMaybe<Scalars['ISO8601Date']['input']>;
  roleTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type AccountingSiteRoleType = {
  __typename?: 'AccountingSiteRoleType';
  active: Scalars['Boolean']['output'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AccountingSiteType = {
  __typename?: 'AccountingSiteType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ActionBreakdown = {
  __typename?: 'ActionBreakdown';
  action: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
};

/** Arguments to activate a popup event */
export type ActivatePopupEvent = {
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ActivatePopupEvent. */
export type ActivatePopupEventPayload = {
  __typename?: 'ActivatePopupEventPayload';
  error?: Maybe<OperationError>;
  popupEvent?: Maybe<PopupEvent>;
};

export type Activity = DeliveryOrder | FoodaCardActivity | PopupOrder | RewardsPointEntry;

/** The connection type for Activity. */
export type ActivityConnection = {
  __typename?: 'ActivityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ActivityEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Activity>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ActivityEdge = {
  __typename?: 'ActivityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Activity>;
};

export type AddRewardsPoints = {
  points: Scalars['Int']['input'];
  requestToken: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddRewardsPoints. */
export type AddRewardsPointsPayload = {
  __typename?: 'AddRewardsPointsPayload';
  error?: Maybe<OperationError>;
  rewardsPointEntry?: Maybe<PointEntry>;
};

/** An Address */
export type Address = {
  __typename?: 'Address';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  state: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type AddressInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

/** An agent */
export type Agent = {
  __typename?: 'Agent';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  siteManagementFeeRecipientType: SiteManagementFeeRecipientEnum;
};

/** Allergens and Sensitivities */
export enum AllergenCode {
  /** Eggs */
  Eggs = 'EGGS',
  /** Fish */
  Fish = 'FISH',
  /** Meat */
  Meat = 'MEAT',
  /** Milk / Dairy */
  Milk = 'MILK',
  /** Peanuts */
  Peanuts = 'PEANUTS',
  /** Sesame */
  Sesame = 'SESAME',
  /** Shellfish */
  Shellfish = 'SHELLFISH',
  /** Soy */
  Soy = 'SOY',
  /** Tree Nuts */
  TreeNuts = 'TREE_NUTS',
  /** Wheat */
  Wheat = 'WHEAT'
}

/** An Allergen or Sensitivity customers can filter menus by */
export type AllergenDefinition = {
  __typename?: 'AllergenDefinition';
  code: AllergenCode;
  /** Display name, e.g. Milk / Dairy */
  name: Scalars['String']['output'];
};

/** How an item answers an Allergen or Sensitivity */
export enum AllergenStatus {
  Contains = 'CONTAINS',
  DoesNotContain = 'DOES_NOT_CONTAIN'
}

/** Fooda rewards wallet for Android */
export type AndroidWallet = {
  __typename?: 'AndroidWallet';
  downloadLink?: Maybe<Scalars['String']['output']>;
  passes: Array<AndroidWalletPass>;
};

/** A Fooda rewards Android wallet pass */
export type AndroidWalletPass = {
  __typename?: 'AndroidWalletPass';
  passTypeIdentifier: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
};

export type ApiClient = {
  __typename?: 'ApiClient';
  label: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export enum ApiVersion {
  MobileOrdering = 'MOBILE_ORDERING',
  PosOrder = 'POS_ORDER',
  PosOrderLegacy = 'POS_ORDER_LEGACY',
  ScanToPay = 'SCAN_TO_PAY'
}

export type AppVersionPolicy = {
  __typename?: 'AppVersionPolicy';
  forceVersions?: Maybe<Array<Scalars['String']['output']>>;
  minVersion: Scalars['String']['output'];
  nextMinVersion?: Maybe<Scalars['String']['output']>;
  nextMinVersionDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  platform: Scalars['String']['output'];
  platformReadable: Scalars['String']['output'];
};

/** Attributes for creating or updating an AppVersionPolicy */
export type AppVersionPolicyInput = {
  forceVersions?: InputMaybe<Array<Scalars['String']['input']>>;
  minVersion?: InputMaybe<Scalars['String']['input']>;
  nextMinVersion?: InputMaybe<Scalars['String']['input']>;
  nextMinVersionDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  platform: Scalars['String']['input'];
};

/** Enum for different applications */
export enum ApplicationEnum {
  FoodaForBusiness = 'FOODA_FOR_BUSINESS',
  FoodaForRestaurants = 'FOODA_FOR_RESTAURANTS',
  PointOfSale = 'POINT_OF_SALE',
  Snappea = 'SNAPPEA'
}

/** Autogenerated return type of ArchiveRecommendationsModel. */
export type ArchiveRecommendationsModelPayload = {
  __typename?: 'ArchiveRecommendationsModelPayload';
  error?: Maybe<OperationError>;
  modelConfig?: Maybe<ModelConfig>;
};

export type AssignAccountPaymentCardToProduct = {
  /** Account payment method id of the card */
  id: Scalars['ID']['input'];
  product: ProductEnum;
  unassign?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of AssignAccountPaymentCardToProduct. */
export type AssignAccountPaymentCardToProductPayload = {
  __typename?: 'AssignAccountPaymentCardToProductPayload';
  card?: Maybe<AccountPaymentCard>;
  error?: Maybe<OperationError>;
};

export type AttachOrderRequestUser = {
  requestId: Scalars['UUID']['input'];
  userIdentifier: UserIdentifier;
};

/** Autogenerated return type of AttachOrderRequestUser. */
export type AttachOrderRequestUserPayload = {
  __typename?: 'AttachOrderRequestUserPayload';
  error?: Maybe<OperationError>;
  orderRequest?: Maybe<OrderRequest>;
};

/** Mapping of Domains and Authentication Providers */
export type AuthenticationDomain = {
  __typename?: 'AuthenticationDomain';
  /** Linked SnapPea Accounts */
  accounts?: Maybe<Array<AccountPublic>>;
  /** ID of the Auth Provider */
  authenticationProviderId: Scalars['ID']['output'];
  /** SCIM Connection ID */
  connectionId?: Maybe<Scalars['String']['output']>;
  /** Created At Timestamp */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Domain Name */
  domainName: Scalars['String']['output'];
  /** Auth Effective Date */
  effectiveDate: Scalars['ISO8601DateTime']['output'];
  /** ID of the Auth Domain */
  id: Scalars['ID']['output'];
  /** List of Users */
  listOfUsers?: Maybe<Array<Scalars['String']['output']>>;
  /** Mobile Session Expiration */
  mobileSessionExpiration?: Maybe<Scalars['Int']['output']>;
  /** Mobile Session Timeout */
  mobileSessionTimeout?: Maybe<Scalars['Int']['output']>;
  /** Organization Code in Authentication Provider */
  organization: Scalars['String']['output'];
  /** Organization Name in Authentication Provider */
  organizationName: Scalars['String']['output'];
  /** SCIM Enabled */
  scimEnabled: Scalars['Boolean']['output'];
  /** Test Mode */
  testMode: Scalars['Boolean']['output'];
  /** Updated At Timestamp */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Use Login Hint */
  useLoginHint: Scalars['Boolean']['output'];
  /** Web Session Expiration */
  webSessionExpiration?: Maybe<Scalars['Int']['output']>;
  /** Web Session Timeout */
  webSessionTimeout?: Maybe<Scalars['Int']['output']>;
};

/** Authentication Providers */
export type AuthenticationProvider = {
  __typename?: 'AuthenticationProvider';
  /** Created At Timestamp */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** ID of the Auth Provider */
  id: Scalars['ID']['output'];
  /** Auth Provider is Default? */
  isDefault: Scalars['Boolean']['output'];
  /** Machine Name of the Auth Provider */
  machineName: Scalars['String']['output'];
  /** Human-readable Name of the Auth Provider */
  name: Scalars['String']['output'];
  /** Updated At Timestamp */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** URL Suffix of the Auth Provider */
  urlSuffix: Scalars['String']['output'];
};

export type AvailabilityDate = {
  __typename?: 'AvailabilityDate';
  available: Scalars['Boolean']['output'];
  date: Scalars['ISO8601Date']['output'];
};

export type AvailabilityDateInput = {
  available: Scalars['Boolean']['input'];
  date: Scalars['ISO8601Date']['input'];
};

export type AvailabilityMealPeriods = {
  __typename?: 'AvailabilityMealPeriods';
  appetizers: Scalars['Boolean']['output'];
  breakfast: Scalars['Boolean']['output'];
  dinner: Scalars['Boolean']['output'];
  lunch: Scalars['Boolean']['output'];
};

export enum AvailabilityStatusEnum {
  /** Availability not yet submitted and is required */
  ActionRequired = 'ACTION_REQUIRED',
  /** Monthly submission not required for product */
  NotRequired = 'NOT_REQUIRED',
  /** Availability submitted for the target month */
  Submitted = 'SUBMITTED'
}

export type AvailabilitySubmissionMetadata = {
  __typename?: 'AvailabilitySubmissionMetadata';
  submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  submittedByEmail?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** Aggregate metrics across all test cases in a backtest run */
export type BacktestAggregates = {
  __typename?: 'BacktestAggregates';
  avgPriceAlignmentPct?: Maybe<Scalars['Float']['output']>;
  dietaryViolationRate?: Maybe<Scalars['Float']['output']>;
  directMatchRate?: Maybe<Scalars['Float']['output']>;
  failedCount?: Maybe<Scalars['Int']['output']>;
  futureMatchRate?: Maybe<Scalars['Float']['output']>;
  hitRate?: Maybe<Scalars['Float']['output']>;
  nearMissRate?: Maybe<Scalars['Float']['output']>;
  passedCount?: Maybe<Scalars['Int']['output']>;
  totalCost?: Maybe<Scalars['Float']['output']>;
  totalDurationMs?: Maybe<Scalars['Int']['output']>;
};

/** Base execution data for a backtest test case */
export type BacktestBaseData = {
  __typename?: 'BacktestBaseData';
  completionTokens?: Maybe<Scalars['Int']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  promptTokens?: Maybe<Scalars['Int']['output']>;
  recommendations: Array<BacktestRecommendation>;
  totalTokens?: Maybe<Scalars['Int']['output']>;
  triggerPriceCents?: Maybe<Scalars['Int']['output']>;
  triggerTags?: Maybe<Array<Scalars['String']['output']>>;
};

/** Evaluation metrics for a backtest test case */
export type BacktestEvaluation = {
  __typename?: 'BacktestEvaluation';
  dietaryAligned?: Maybe<Scalars['Boolean']['output']>;
  directHits?: Maybe<Scalars['Int']['output']>;
  directTotal?: Maybe<Scalars['Int']['output']>;
  futureHits?: Maybe<Scalars['Int']['output']>;
  futureTotal?: Maybe<Scalars['Int']['output']>;
  priceAlignmentPct?: Maybe<Scalars['Float']['output']>;
  tagMatches?: Maybe<Scalars['Int']['output']>;
  tagTotal?: Maybe<Scalars['Int']['output']>;
};

/** Metadata for a backtest test case */
export type BacktestMetadata = {
  __typename?: 'BacktestMetadata';
  eventId?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  futureOrders?: Maybe<Scalars['String']['output']>;
  groundTruth?: Maybe<Scalars['String']['output']>;
  historySize?: Maybe<Scalars['Int']['output']>;
  itemsOrdered?: Maybe<Scalars['Int']['output']>;
  remainingCartItems?: Maybe<Scalars['String']['output']>;
  targetDate?: Maybe<Scalars['String']['output']>;
  triggerItem?: Maybe<Scalars['String']['output']>;
  vendorId?: Maybe<Scalars['String']['output']>;
};

/** A single recommendation from a backtest execution */
export type BacktestRecommendation = {
  __typename?: 'BacktestRecommendation';
  hitType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  reasoning?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
};

/** Result of a single backtest test case execution */
export type BacktestResult = {
  __typename?: 'BacktestResult';
  baseData?: Maybe<BacktestBaseData>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  evaluation?: Maybe<BacktestEvaluation>;
  metadata: BacktestMetadata;
  status: Scalars['String']['output'];
  testCaseIndex: Scalars['Int']['output'];
  userId: Scalars['ID']['output'];
};

/** Summary of a backtest run for the recent runs list */
export type BacktestRunSummary = {
  __typename?: 'BacktestRunSummary';
  avgPriceAlignmentPct?: Maybe<Scalars['Float']['output']>;
  backtestId: Scalars['String']['output'];
  completedCases: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  directMatchRate?: Maybe<Scalars['Float']['output']>;
  evaluatorType?: Maybe<Scalars['String']['output']>;
  failedCases: Scalars['Int']['output'];
  futureMatchRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  task?: Maybe<RecommendationRequestTypes>;
  totalCases: Scalars['Int']['output'];
};

/** A banner */
export type Banner = {
  __typename?: 'Banner';
  content: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  platform?: Maybe<BannerPlatform>;
  style?: Maybe<Style>;
  title: Scalars['String']['output'];
};

export enum BannerPlatform {
  Email = 'EMAIL',
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export type Barcode = {
  __typename?: 'Barcode';
  barcodeType: BarcodeTypes;
  barcodeValue: Scalars['String']['output'];
};

export type BarcodeInput = {
  barcodeType: BarcodeTypes;
  barcodeValue?: InputMaybe<Scalars['String']['input']>;
};

export enum BarcodeTypes {
  FoodaBarcodeNumber = 'FOODA_BARCODE_NUMBER',
  Plu = 'PLU',
  Upc = 'UPC'
}

/** A billing address without database ID */
export type BillingAddress = {
  __typename?: 'BillingAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type BillingPolicy = {
  __typename?: 'BillingPolicy';
  billingPattern: Scalars['String']['output'];
  billingPatternClass: Scalars['String']['output'];
  customInvoiceEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  partyId: Scalars['ID']['output'];
  partyType: Scalars['String']['output'];
  paymentMethod: PaymentMethodEnum;
  paymentTerms: PaymentTermEnum;
};

export type BraintreeToken = {
  __typename?: 'BraintreeToken';
  value: Scalars['String']['output'];
};

/** Bucket Configuration */
export type BucketConfiguration = {
  __typename?: 'BucketConfiguration';
  active: Scalars['Boolean']['output'];
  allocationPercentage: Scalars['Int']['output'];
  bucketName: Scalars['String']['output'];
  conditions?: Maybe<Scalars['JSON']['output']>;
  entryPointId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  priority: Scalars['Int']['output'];
  recommendationModelName: Scalars['String']['output'];
  recommendationModelVersion: Scalars['String']['output'];
};

/** A building */
export type Building = {
  __typename?: 'Building';
  address: Address;
  geolocation?: Maybe<Geolocation>;
  id: Scalars['ID']['output'];
  market?: Maybe<Market>;
  name: Scalars['String']['output'];
  showNameOnCatering: Scalars['Boolean']['output'];
};

/** A building with public access */
export type BuildingPublic = {
  __typename?: 'BuildingPublic';
  address: Address;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  showNameOnCatering: Scalars['Boolean']['output'];
};

/** A cafe event */
export type CafeEvent = {
  __typename?: 'CafeEvent';
  building: Building;
  cafeName: Scalars['String']['output'];
  cafePin: Scalars['ID']['output'];
  cafeStations?: Maybe<Array<EventStation>>;
  eventEndTime: Scalars['ISO8601DateTime']['output'];
  eventStartTime: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  menuTiles?: Maybe<Array<CafeMenuTile>>;
};


/** A cafe event */
export type CafeEventCafeStationsArgs = {
  withActiveVendors?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A cafe event */
export type CafeEventMenuTilesArgs = {
  filterTypes?: InputMaybe<Array<CafeEventMenuTileTypeEnum>>;
};

export type CafeEventDetail = EventDetail & {
  __typename?: 'CafeEventDetail';
  endTime: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** All locations associated with the event */
  locations: Array<LocationPublic>;
  restaurants: Array<CafeRestaurant>;
  startTime: Scalars['ISO8601DateTime']['output'];
  status: EventStatus;
  /**
   * IANA identifier, e.g. 'America/Chicago'. Start and end times already carry
   * this zone's offset; this names the zone so it can be shown alongside them
   */
  timezone: Scalars['String']['output'];
};

/** A category of items on a Cafe Menu, eg. 'entrees', 'sides' */
export type CafeEventMenuCategoryGroup = {
  __typename?: 'CafeEventMenuCategoryGroup';
  customItems: Array<CustomCafeEventMenuItem>;
  id: Scalars['ID']['output'];
  isCustom: Scalars['Boolean']['output'];
  items: Array<CafeEventMenuItem>;
  name: Scalars['String']['output'];
};

/** A cafe menu group tile */
export type CafeEventMenuGroupTile = {
  __typename?: 'CafeEventMenuGroupTile';
  eventVendor: CafeEventVendor;
  id: Scalars['ID']['output'];
  menuGroup: CafeEventMenuCategoryGroup;
  menuGroups: Array<CafeEventMenuCategoryGroup>;
  menuTemplate: MenuTemplate;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  recordedCategoryId?: Maybe<Scalars['Int']['output']>;
  station: EventStation;
};

/** A food item on a menu */
export type CafeEventMenuItem = {
  __typename?: 'CafeEventMenuItem';
  availableInPersonOnly: Scalars['Boolean']['output'];
  /** Whether this item is the POS Express Checkout default for its menu template */
  defaultForExpressCheckout: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nameForVendor?: Maybe<Scalars['String']['output']>;
  namePublic?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  otherTaxCents: Scalars['BigDecimal']['output'];
  postTaxPriceCents: Scalars['Int']['output'];
  preTaxPriceCents: Scalars['BigDecimal']['output'];
  /** Price type (per item, per ounce, per pound) */
  priceType: PriceTypeEnum;
  salesTaxCents: Scalars['BigDecimal']['output'];
  scannableId?: Maybe<Scalars['String']['output']>;
  selectionGroupPositions?: Maybe<Array<Scalars['ID']['output']>>;
  selectionGroups?: Maybe<Array<PopupEventMenuItemSelectionGroup>>;
  showOnPos: Scalars['Boolean']['output'];
  /** Subsidy for this menu item */
  subsidy?: Maybe<EventMenuItemSubsidizedPrice>;
  /** @deprecated Not used anymore */
  taxRules?: Maybe<Array<CafeEventMenuItemTaxRule>>;
};

/** A menu group scoped to the single item targeted by an item tile */
export type CafeEventMenuItemGroup = {
  __typename?: 'CafeEventMenuItemGroup';
  customItems: Array<CustomCafeEventMenuItem>;
  id: Scalars['ID']['output'];
  isCustom: Scalars['Boolean']['output'];
  items: Array<CafeEventMenuItem>;
  name: Scalars['String']['output'];
};

/** A tax rule for a cafe menu item. Contains the exact cents value of the tax applied to the item. */
export type CafeEventMenuItemTaxRule = {
  __typename?: 'CafeEventMenuItemTaxRule';
  cents: Scalars['BigDecimal']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rule: TaxRuleRule;
  /** A unique identifier for a type of tax rule. Can be used for grouping taxes across items. */
  taxRuleId: Scalars['ID']['output'];
};

/** A cafe event menu tile targeting a single item */
export type CafeEventMenuItemTile = {
  __typename?: 'CafeEventMenuItemTile';
  eventVendor: CafeEventVendor;
  id: Scalars['ID']['output'];
  menuGroup: CafeEventMenuCategoryGroup;
  menuGroups: Array<CafeEventMenuItemGroup>;
  menuItem: CafeEventMenuItem;
  menuTemplate: MenuTemplate;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  recordedCategory?: Maybe<CafeEventMenuCategoryGroup>;
  station: EventStation;
};

/** A Cafe Event Menu Tile Input */
export type CafeEventMenuTileInput = {
  popupEventLocationId: Scalars['Int']['input'];
  position: Scalars['Int']['input'];
  recordedCategoryId?: InputMaybe<Scalars['Int']['input']>;
  targetId?: InputMaybe<Scalars['BigInt']['input']>;
  targetType: CafeEventMenuTileTypeEnum;
};

export enum CafeEventMenuTileTypeEnum {
  Popuppopupeventlocation = 'POPUPPOPUPEVENTLOCATION',
  PopupEventMenuGroup = 'POPUP_EVENT_MENU_GROUP',
  PopupEventMenuItem = 'POPUP_EVENT_MENU_ITEM',
  PopupEventVendor = 'POPUP_EVENT_VENDOR',
  SalesOptimizerToFill = 'SALES_OPTIMIZER_TO_FILL',
  SaleOptimizerToFill = 'SALE_OPTIMIZER_TO_FILL'
}

export type CafeEventPublic = PublicEvent & {
  __typename?: 'CafeEventPublic';
  account: AccountPublic;
  cafeName: Scalars['String']['output'];
  endTime: Scalars['ISO8601DateTime']['output'];
  endTimeOffsetInDays: Scalars['Int']['output'];
  healthscoreLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRewardsEnabled: Scalars['Boolean']['output'];
  /** First location associated with the event, if any */
  location?: Maybe<LocationPublic>;
  /** All locations associated with the event, in creation order */
  locations: Array<LocationPublic>;
  mealPeriod?: Maybe<MealPeriodEnum>;
  restaurants: Array<CafeRestaurant>;
  startTime: Scalars['ISO8601DateTime']['output'];
  status: EventStatus;
  /**
   * IANA identifier, e.g. 'America/Chicago'. Start and end times already carry
   * this zone's offset; this names the zone so it can be shown alongside them
   */
  timezone: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** A cafe event sales optimizer tile */
export type CafeEventSalesOptimizerTile = {
  __typename?: 'CafeEventSalesOptimizerTile';
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  recordedCategoryId?: Maybe<Scalars['Int']['output']>;
  station: EventStation;
};

export type CafeEventScheduleMenuTile = MenuTemplateCategoryTile | MenuTemplateInventoryItemTile | MenuTemplateTile | SalesOptimizerTile;

/** A vendor assigned to a Cafe event */
export type CafeEventVendor = {
  __typename?: 'CafeEventVendor';
  cafeEvent: CafeEvent;
  id: Scalars['ID']['output'];
  mobileOrdering: MobileOrderingEventVendorInfo;
  posHidePrice: Scalars['Boolean']['output'];
  taxRate: Scalars['BigDecimal']['output'];
  tempLogs: Array<CafeTemperatureLogType>;
  vendor: Vendor;
};

/** A cafe event menu tile with a vendor and menu template */
export type CafeEventVendorTile = {
  __typename?: 'CafeEventVendorTile';
  eventVendor: CafeEventVendor;
  /**
   * True when this vendor's published menu has an Express Checkout default item,
   * used to gate the POS Express Checkout Mode toggle
   */
  hasDefaultForExpressCheckoutItem: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  menuGroups: Array<CafeEventMenuCategoryGroup>;
  menuTemplate: MenuTemplate;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  station: EventStation;
};

/** A cafe location */
export type CafeLocation = {
  __typename?: 'CafeLocation';
  accessibleToPublic: Scalars['Boolean']['output'];
  account: Account;
  audienceSize?: Maybe<Scalars['Int']['output']>;
  building: Building;
  contact?: Maybe<Contact>;
  hideFromScheduling?: Maybe<Scalars['Boolean']['output']>;
  hideFromSearch: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  stations?: Maybe<Array<Station>>;
};

/** A cafe menu tile for a location */
export type CafeLocationMenuTile = {
  __typename?: 'CafeLocationMenuTile';
  eventVendor: CafeEventVendor;
  eventVendorId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  menuGroups: Array<CafeEventMenuCategoryGroup>;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

/** A cafe event's menu. */
export type CafeMenu = {
  __typename?: 'CafeMenu';
  cafeId: Scalars['ID']['output'];
  menuTiles: Array<CafeMenuTile>;
};


/** A cafe event's menu. */
export type CafeMenuMenuTilesArgs = {
  filterTypes?: InputMaybe<Array<CafeEventMenuTileTypeEnum>>;
};

/** A tile containing an item to display on a menu */
export type CafeMenuTile = CafeEventMenuGroupTile | CafeEventMenuItemTile | CafeEventSalesOptimizerTile | CafeEventVendorTile | CafeLocationMenuTile;

export type CafeRestaurant = {
  __typename?: 'CafeRestaurant';
  cuisines?: Maybe<Array<Scalars['String']['output']>>;
  defaultCuisine?: Maybe<Scalars['String']['output']>;
  essenceImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  location: LocationPublic;
  logoUrl?: Maybe<Scalars['String']['output']>;
  mealPeriod?: Maybe<MealPeriodEnum>;
  /** Path of the customer menu page, filtered to this restaurant */
  menuUrl?: Maybe<Scalars['String']['output']>;
  mobileOrdering: MobileOrderingEventVendorInfo;
  name: Scalars['String']['output'];
  serviceEndTime: Scalars['ISO8601DateTime']['output'];
  serviceStartTime: Scalars['ISO8601DateTime']['output'];
  stationType: StationTypes;
  vendorId: Scalars['ID']['output'];
};

export type CafeScheduleFrequencyType = DailyFrequency | MonthlyByDayOfMonthFrequency | MonthlyByDayOfWeekFrequency | WeeklyFrequency | YearlyFrequency;

export type CafeScheduleMenuTile = {
  id?: InputMaybe<Scalars['Int']['input']>;
  position: Scalars['Int']['input'];
  recordedCategoryId?: InputMaybe<Scalars['Int']['input']>;
  stationId: Scalars['Int']['input'];
  type: MenuTileTypeEnum;
};

/** A site direction document for a station */
export type CafeStationSiteDirectionDocument = {
  __typename?: 'CafeStationSiteDirectionDocument';
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdByName: Scalars['String']['output'];
  documentName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CafeTemperatureLogType = {
  __typename?: 'CafeTemperatureLogType';
  cloudinaryResponse?: Maybe<CloudinaryResponse>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  eventVendor: CafeEventVendor;
  id: Scalars['ID']['output'];
  reviewedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: Scalars['String']['output'];
  submittedBy?: Maybe<User>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type CalculateEventSubsidies = {
  codes: Array<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  product: SubsidyRuleProduct;
  totalCents: Scalars['Int']['input'];
};

/** Autogenerated return type of CalculateEventSubsidies. */
export type CalculateEventSubsidiesPayload = {
  __typename?: 'CalculateEventSubsidiesPayload';
  error?: Maybe<OperationError>;
  subsidies?: Maybe<Array<CalculatedSubsidyMembership>>;
};

export type CalculateMobileOrderingCart = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  eventVendorId: Scalars['ID']['input'];
  items: Array<MobileOrderingCartItem>;
  /** Subsidy code for a cart. Please send 'none' if no subsidy is applied, otherwise a default one will be applied */
  subsidyCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CalculateMobileOrderingCart. */
export type CalculateMobileOrderingCartPayload = {
  __typename?: 'CalculateMobileOrderingCartPayload';
  cart?: Maybe<MobileOrderingCart>;
  error?: Maybe<OperationError>;
};

export type CalculateScanToPayCart = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  items: Array<ScanToPayInputCartItem>;
  /** Subsidy code for a cart. Please send 'none' if no subsidy is applied, otherwise a default one will be applied */
  subsidyCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CalculateScanToPayCart. */
export type CalculateScanToPayCartPayload = {
  __typename?: 'CalculateScanToPayCartPayload';
  cart?: Maybe<ScanToPayCart>;
  error?: Maybe<OperationError>;
};

export type CalculatedSubsidyMembership = {
  __typename?: 'CalculatedSubsidyMembership';
  availableCents: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  redeemableCents: Scalars['Int']['output'];
};

/** A campaign */
export type Campaign = {
  __typename?: 'Campaign';
  banners: Array<Banner>;
  category: CampaignCategory;
  endsAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  startsAt: Scalars['ISO8601DateTime']['output'];
  strategy?: Maybe<CampaignStrategy>;
  threadId?: Maybe<Scalars['ID']['output']>;
};

export enum CampaignCategory {
  Feedback = 'FEEDBACK',
  Rewards = 'REWARDS'
}

export enum CampaignStrategy {
  Double = 'DOUBLE',
  Variant_1 = 'VARIANT_1',
  Variant_2 = 'VARIANT_2'
}

/** A campaign user */
export type CampaignUser = {
  __typename?: 'CampaignUser';
  campaignId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type CancelDeliveryOrder = {
  cancelationRequestor?: InputMaybe<OrderCancelationRequestorEnum>;
  requestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelDeliveryOrder. */
export type CancelDeliveryOrderPayload = {
  __typename?: 'CancelDeliveryOrderPayload';
  deliveryOrder?: Maybe<DeliveryOrderDetails>;
  error?: Maybe<OperationError>;
};

export type CancelMobileOrderingOrder = {
  id: Scalars['ID']['input'];
  version: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelMobileOrderingOrderByUser. */
export type CancelMobileOrderingOrderByUserPayload = {
  __typename?: 'CancelMobileOrderingOrderByUserPayload';
  error?: Maybe<OperationError>;
  order?: Maybe<ConsumerMobileOrderingOrderDetails>;
};

/** Autogenerated return type of CancelMobileOrderingOrder. */
export type CancelMobileOrderingOrderPayload = {
  __typename?: 'CancelMobileOrderingOrderPayload';
  error?: Maybe<OperationError>;
  order?: Maybe<MobileOrderingOrder>;
};

export type CanceledPaymentGatewayInfo = {
  paymentGateway: PaymentGateway;
  response: UnpaidPaymentResponse;
};

export type Card = {
  __typename?: 'Card';
  cardType?: Maybe<CardIssuer>;
  cardTypeHumanized?: Maybe<Scalars['String']['output']>;
  cardholderName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  expirationMonth: Scalars['Int']['output'];
  expirationYear: Scalars['Int']['output'];
  gatewayProfileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  isDefaultDelivery: Scalars['Boolean']['output'];
  last4: Scalars['Int']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  processor?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export enum CardIssuer {
  AmericanExpress = 'AMERICAN_EXPRESS',
  ApplePayAmericanExpress = 'APPLE_PAY_AMERICAN_EXPRESS',
  ApplePayDiscover = 'APPLE_PAY_DISCOVER',
  ApplePayMastercard = 'APPLE_PAY_MASTERCARD',
  ApplePayVisa = 'APPLE_PAY_VISA',
  ApplePayVisaDiscover = 'APPLE_PAY_VISA_DISCOVER',
  Discover = 'DISCOVER',
  GooglePayAmericanExpress = 'GOOGLE_PAY_AMERICAN_EXPRESS',
  GooglePayDiscover = 'GOOGLE_PAY_DISCOVER',
  GooglePayMastercard = 'GOOGLE_PAY_MASTERCARD',
  GooglePayVisa = 'GOOGLE_PAY_VISA',
  GooglePayVisaMaestro = 'GOOGLE_PAY_VISA_MAESTRO',
  Jcb = 'JCB',
  Maestro = 'MAESTRO',
  Mastercard = 'MASTERCARD',
  Paypal = 'PAYPAL',
  Unionpay = 'UNIONPAY',
  Unknown = 'UNKNOWN',
  Visa = 'VISA'
}

export type CardPaymentInfo = {
  __typename?: 'CardPaymentInfo';
  cardType?: Maybe<CardIssuer>;
  id: Scalars['ID']['output'];
  last4: Scalars['Int']['output'];
};

export type CateringEventDetail = EventDetail & {
  __typename?: 'CateringEventDetail';
  /** The event end time in UTC */
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** All locations associated with the event */
  locations: Array<LocationPublic>;
  name?: Maybe<Scalars['String']['output']>;
  /**
   * The event's receipt, if one has been generated. A catering event is a single
   * order, so the newest receipt document supersedes any regenerated ones
   */
  receipt?: Maybe<Receipt>;
  restaurants: Array<CateringRestaurant>;
  /** The setup start time in UTC */
  setupTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The event start time in UTC */
  startTime: Scalars['ISO8601DateTime']['output'];
  status: EventStatus;
  /** Rails TimeZone name, e.g. 'Central Time (US & Canada)'. Start, end and setup times are in UTC, convert them with this */
  timezone: Scalars['String']['output'];
};

export type CateringEventPublic = PublicEvent & {
  __typename?: 'CateringEventPublic';
  account: AccountPublic;
  chaffingFrames: Scalars['Boolean']['output'];
  /** The event end time in UTC */
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  healthscoreLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  individualLabel: Scalars['Boolean']['output'];
  /** Location associated with the event */
  location?: Maybe<LocationPublic>;
  /** All locations associated with the event */
  locations: Array<LocationPublic>;
  mealPeriod: MealPeriodEnum;
  menuImages: Array<Maybe<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  restaurants: Array<CateringRestaurant>;
  /** The service style for the catering event */
  serviceStyle?: Maybe<Scalars['String']['output']>;
  servingUtensils: Scalars['Boolean']['output'];
  /** The setup start time in UTC */
  setupTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The event start time in UTC */
  startTime: Scalars['ISO8601DateTime']['output'];
  status: EventStatus;
  sternos: Scalars['Boolean']['output'];
  /** Rails TimeZone name, e.g. 'Central Time (US & Canada)'. Start, end and setup times are in UTC, convert them with this */
  timezone: Scalars['String']['output'];
  url: Scalars['String']['output'];
  utensilsPlatesNapkins: Scalars['Boolean']['output'];
};

/** A vendor assigned to a catering event */
export type CateringEventVendor = EventVendor & {
  __typename?: 'CateringEventVendor';
  event: CateringEventPublic;
  id: Scalars['ID']['output'];
  /** The menu line items associated with the catering event vendor */
  menuLineItems?: Maybe<Array<CateringMenuLineItem>>;
  menuTemplate: MenuTemplate;
  /** Whether the packing slip has been confirmed for the catering event vendor */
  packingSlipConfirmed: Scalars['Boolean']['output'];
  /** The packing slip link for the catering event vendor */
  packingSlipUrl?: Maybe<Scalars['String']['output']>;
  productType: EventProduct;
  /** Whether the purchase order has been confirmed for the catering event vendor */
  purchaseOrderConfirmed: Scalars['Boolean']['output'];
  /** The purchase order link for the catering event vendor */
  purchaseOrderUrl?: Maybe<Scalars['String']['output']>;
  /** The total number of menu line items associated with the catering event vendor */
  totalMenuLineItems: Scalars['Int']['output'];
  vendor: Vendor;
};


/** A vendor assigned to a catering event */
export type CateringEventVendorMenuLineItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** An inventory item for catering events */
export type CateringInventoryItem = {
  __typename?: 'CateringInventoryItem';
  cogs: Scalars['BigDecimal']['output'];
  cogsCents: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  destroyable: Scalars['Boolean']['output'];
  /** Dietary Preferences and Allergens and Sensitivities of the item */
  dietaryInfo: MenuItemDietaryInfo;
  dietaryRestrictions: Array<InventoryItemDietaryRestrictions>;
  eligibleForAddOns: Scalars['Boolean']['output'];
  externalTags: Array<InventoryItemExternalTags>;
  feedsMax?: Maybe<Scalars['Int']['output']>;
  feedsMin?: Maybe<Scalars['Int']['output']>;
  foodaSku: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  internalTags: Array<InventoryItemInternalTags>;
  mealType: InventoryItemMealType;
  minSelfServiceQuantity: Scalars['Int']['output'];
  nameForVendor: Scalars['String']['output'];
  namePublic: Scalars['String']['output'];
  packagingDetails: CateringPackagingDetails;
  premiumCogs: Scalars['BigDecimal']['output'];
  premiumCogsCents: Scalars['Int']['output'];
  premiumSellPrice: Scalars['BigDecimal']['output'];
  premiumSellPriceCents: Scalars['Int']['output'];
  retailPrice: Scalars['BigDecimal']['output'];
  retailPriceCents: Scalars['Int']['output'];
  sellPrice: Scalars['BigDecimal']['output'];
  sellPriceCents: Scalars['Int']['output'];
  taxCategoryId?: Maybe<Scalars['Int']['output']>;
  useAsInventoryItemOption: Scalars['Boolean']['output'];
};

/** A Menu LineItem for Catering event */
export type CateringMenuLineItem = {
  __typename?: 'CateringMenuLineItem';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  totalPriceCents: Scalars['Int']['output'];
  unitPriceCents: Scalars['Int']['output'];
};

export enum CateringPackagingDetails {
  FamilyStyle = 'FAMILY_STYLE',
  IndividuallyPackaged = 'INDIVIDUALLY_PACKAGED'
}

export type CateringRestaurant = {
  __typename?: 'CateringRestaurant';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CateringUserAccount = {
  __typename?: 'CateringUserAccount';
  accountId: Scalars['ID']['output'];
  accountName: Scalars['String']['output'];
  address1: Scalars['String']['output'];
  city: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  locationId: Scalars['ID']['output'];
  locationName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  state: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type CateringVendorMenuItem = VendorMenuItem & {
  __typename?: 'CateringVendorMenuItem';
  category?: Maybe<VendorMenuCategory>;
  /** The id of the image the item shows, as the seen value of an image edit. Null for no image, and for non-delivery items. */
  currentImageRef?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Dietary restriction/allergen labels (e.g. Contains Nuts, Vegan). */
  dietaryRestrictions: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** All item image URLs, for the larger-format image modal. */
  images: Array<Scalars['String']['output']>;
  /** The item's type, as the seen value of an item type edit. Null for non-delivery items. */
  itemType?: Maybe<InventoryItemMealType>;
  nameForVendor: Scalars['String']['output'];
  namePublic: Scalars['String']['output'];
  optionGroups: Array<VendorMenuOptionGroup>;
  /**
   * The vendor's other delivery menus that carry this item, so an edit that
   * reaches them can be shown. Empty for non-delivery items.
   */
  otherMenus: Array<MenuChangeOtherMenu>;
  /** Restaurant pre-tax price in cents (may be sub-cent), resolved per product type. Null for menu-level priced catering. */
  preTaxPriceCents?: Maybe<Scalars['BigDecimal']['output']>;
  /** First image, or a placeholder when the item has no image. */
  primaryImageUrl: Scalars['String']['output'];
  /**
   * The tax category the item is charged under, as the seen value of a tax
   * category edit: its own, or the global default when it has none. Null for
   * non-delivery items.
   */
  taxCategoryId?: Maybe<Scalars['ID']['output']>;
  /** Whether the item can be used as an option, as the seen value of a usable-as-option edit. Null for non-delivery items. */
  usableAsOption?: Maybe<Scalars['Boolean']['output']>;
  /**
   * True when the item is also used on a non-draft, non-expired popup or catering
   * menu. FFR shows the item, its option groups and their options locked, and
   * edits to them are refused with ITEM_USED_OUTSIDE_DELIVERY; removing it from
   * this menu is still allowed. Null for non-delivery items.
   */
  usedOutsideDelivery?: Maybe<Scalars['Boolean']['output']>;
};

export type CateringVendorMenuTemplate = VendorMenuTemplate & {
  __typename?: 'CateringVendorMenuTemplate';
  /** Whether the signed-in manager can edit this menu in FFR. */
  canEditInFfr: Scalars['Boolean']['output'];
  categories: Array<VendorMenuCategory>;
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Why canEditInFfr is false, for the disabled "Edit menu" reason. Null when the menu can be edited. */
  ffrEditBlockedReason?: Maybe<MenuChangeEditBlockedReason>;
  id: Scalars['ID']['output'];
  /** Top-level menu items (options excluded), ordered by category then position; 25 per page. */
  items: VendorMenuItemConnection;
  mealPeriods: Array<MealPeriodEnum>;
  /** Per-person menu-level restaurant price. Present only for menu-level catering. */
  menuLevelPriceCents?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** The menu change request waiting for a decision, which locks FFR submits to this template. */
  pendingChangeRequest?: Maybe<MenuChangeRequest>;
  /** item_level or menu_level. When menu_level, use menuLevelPriceCents instead of per-item prices. */
  pricingType?: Maybe<Scalars['String']['output']>;
  productType: ProductEnum;
  /** True when the template or any of its items changed within the last 2 weeks. */
  recentlyUpdated: Scalars['Boolean']['output'];
  startDate: Scalars['ISO8601DateTime']['output'];
  state: MenuTemplateStateEnum;
  /** Latest of the template's own change and its items' changes. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type CateringVendorMenuTemplateItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatHistory = {
  __typename?: 'ChatHistory';
  conversationId?: Maybe<Scalars['String']['output']>;
  messages?: Maybe<Array<ChatMessage>>;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  content: Scalars['String']['output'];
  feedbackGiven?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  sources?: Maybe<Array<ChatMessageSource>>;
};

export type ChatMessageSource = {
  __typename?: 'ChatMessageSource';
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ChatResponse = {
  __typename?: 'ChatResponse';
  content: Scalars['String']['output'];
  conversationId: Scalars['String']['output'];
  messageId: Scalars['String']['output'];
  sources?: Maybe<Array<ChatMessageSource>>;
};

/** Autogenerated return type of CheckPhoneVerification. */
export type CheckPhoneVerificationPayload = {
  __typename?: 'CheckPhoneVerificationPayload';
  digits?: Maybe<Scalars['String']['output']>;
  error?: Maybe<OperationError>;
  inProgress?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated return type of CheckReloginQuery. */
export type CheckReloginQueryPayload = {
  __typename?: 'CheckReloginQueryPayload';
  error?: Maybe<OperationError>;
  needsRelogin?: Maybe<Scalars['Boolean']['output']>;
};

export type ClearChatHistory = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ClearChatHistory. */
export type ClearChatHistoryPayload = {
  __typename?: 'ClearChatHistoryPayload';
  error?: Maybe<OperationError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CloudinaryResponse = {
  __typename?: 'CloudinaryResponse';
  bytes?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  originalFilename?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  placeholder?: Maybe<Scalars['Boolean']['output']>;
  publicId?: Maybe<Scalars['String']['output']>;
  resourceType?: Maybe<Scalars['String']['output']>;
  secureUrl?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type CloudinaryResponseAttributes = {
  bytes: Scalars['Int']['input'];
  createdAt: Scalars['String']['input'];
  etag: Scalars['String']['input'];
  format: Scalars['String']['input'];
  height: Scalars['Int']['input'];
  originalFilename: Scalars['String']['input'];
  path: Scalars['String']['input'];
  placeholder: Scalars['Boolean']['input'];
  publicId: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
  secureUrl: Scalars['String']['input'];
  signature: Scalars['String']['input'];
  tags: Array<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
  version: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type Configuration = {
  __typename?: 'Configuration';
  paymentProcessor?: Maybe<PaymentProcessor>;
};

/** Arguments to confirm a site directions token */
export type ConfirmSiteDirectionsToken = {
  digest: Scalars['String']['input'];
};

/** Autogenerated return type of ConfirmSiteDirectionsTokenMutation. */
export type ConfirmSiteDirectionsTokenMutationPayload = {
  __typename?: 'ConfirmSiteDirectionsTokenMutationPayload';
  error?: Maybe<OperationError>;
  siteDirectionsToken?: Maybe<SiteDirectionsToken>;
};

/** A complete Transcend preference snapshot from airgap.getConsent() after confirmed is true. */
export type ConsentPreferenceEventInput = {
  airgapVersion?: InputMaybe<Scalars['String']['input']>;
  consentGivenAt: Scalars['ISO8601DateTime']['input'];
  experienceSlug?: InputMaybe<Scalars['String']['input']>;
  legalRegimes: Array<Scalars['String']['input']>;
  /** Complete Transcend purpose preferences. */
  preferences: Array<ConsentPurposePreferenceInput>;
  privacySignals: Array<Scalars['String']['input']>;
};

export type ConsentPreferenceSnapshot = {
  __typename?: 'ConsentPreferenceSnapshot';
  consentGivenAt: Scalars['ISO8601DateTime']['output'];
  preferences: Array<ConsentPurposePreference>;
  recordedAt: Scalars['ISO8601DateTime']['output'];
};

export enum ConsentPreferenceValue {
  Allowed = 'ALLOWED',
  Auto = 'AUTO',
  Denied = 'DENIED'
}

export type ConsentPurposePreference = {
  __typename?: 'ConsentPurposePreference';
  purpose: Scalars['String']['output'];
  value: ConsentPreferenceValue;
};

export type ConsentPurposePreferenceInput = {
  purpose: Scalars['String']['input'];
  value: ConsentPreferenceValue;
};

/** A Consumer Data Requestt */
export type ConsumerDataRequest = {
  __typename?: 'ConsumerDataRequest';
  /** ISO8601 DateTime of when request was fulfilled */
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** ISO8601 DateTime of when request needs to be process */
  processAfter?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Why the request was refused, when state is refused */
  refusalReason?: Maybe<Scalars['String']['output']>;
  /** ISO8601 DateTime of when request was requested */
  requestedAt: Scalars['ISO8601DateTime']['output'];
  /** pending, fulfilled or refused */
  state: Scalars['String']['output'];
  /** User requesting data */
  user: ConsumerDataRequestUser;
};

/** The connection type for ConsumerDataRequest. */
export type ConsumerDataRequestConnection = {
  __typename?: 'ConsumerDataRequestConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ConsumerDataRequestEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ConsumerDataRequest>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ConsumerDataRequestEdge = {
  __typename?: 'ConsumerDataRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ConsumerDataRequest>;
};

export enum ConsumerDataRequestProcessingTimeEnum {
  Delayed = 'DELAYED',
  Now = 'NOW'
}

export enum ConsumerDataRequestStatusEnum {
  Fulfilled = 'FULFILLED',
  Refused = 'REFUSED',
  Unfulfilled = 'UNFULFILLED'
}

export enum ConsumerDataRequestTypeEnum {
  Export = 'EXPORT',
  Removal = 'REMOVAL'
}

/** An User */
export type ConsumerDataRequestUser = {
  __typename?: 'ConsumerDataRequestUser';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  unconfirmedEmail?: Maybe<Scalars['String']['output']>;
};

/** Full details of a popup mobile order */
export type ConsumerMobileOrderingOrderDetails = {
  __typename?: 'ConsumerMobileOrderingOrderDetails';
  account: AccountPublic;
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  canceledByUser: Scalars['Boolean']['output'];
  cancellableForUser: Scalars['Boolean']['output'];
  cardDetails?: Maybe<CardPaymentInfo>;
  couponDiscountCents: Scalars['Int']['output'];
  eventId: Scalars['ID']['output'];
  eventType: EventProduct;
  id: Scalars['ID']['output'];
  items: Array<ConsumerMobileOrderingOrderItemDetails>;
  location?: Maybe<Location>;
  lockVersion: Scalars['Int']['output'];
  pickupInfo: MobileOrderingPickupInfo;
  requestId: Scalars['ID']['output'];
  state: MobileOrderingOrderStatus;
  subsidyDiscountCents: Scalars['Int']['output'];
  subtotalCents: Scalars['Int']['output'];
  taxCents: Scalars['Int']['output'];
  totalPaidCents: Scalars['Int']['output'];
  user?: Maybe<OrderRequestUser>;
  userPrice: UserPrice;
  vendorName: Scalars['String']['output'];
};

/** A placed order item */
export type ConsumerMobileOrderingOrderItemDetails = {
  __typename?: 'ConsumerMobileOrderingOrderItemDetails';
  customizationDescription?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  napkins: Scalars['Boolean']['output'];
  postTaxCents: Scalars['Int']['output'];
  preTaxCents: Scalars['Int']['output'];
  selectionGroups?: Maybe<Array<ConsumerMobileOrderingOrderSelectionGroupDetails>>;
  silverware: Scalars['Boolean']['output'];
  taxCents: Scalars['Int']['output'];
  userPrice: UserPrice;
};

/** Base shared item fields */
export type ConsumerMobileOrderingOrderOptionItemDetails = {
  __typename?: 'ConsumerMobileOrderingOrderOptionItemDetails';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  postTaxCents: Scalars['Int']['output'];
  preTaxCents: Scalars['Int']['output'];
  taxCents: Scalars['Int']['output'];
  userPrice: UserPrice;
};

/** A placed order item selection group */
export type ConsumerMobileOrderingOrderSelectionGroupDetails = {
  __typename?: 'ConsumerMobileOrderingOrderSelectionGroupDetails';
  id: Scalars['ID']['output'];
  namePublic: Scalars['String']['output'];
  options?: Maybe<Array<ConsumerMobileOrderingOrderOptionItemDetails>>;
};

/** A consumer vendor */
export type ConsumerVendor = {
  __typename?: 'ConsumerVendor';
  deliveryMenuTemplates?: Maybe<Array<MenuTemplate>>;
  id: Scalars['ID']['output'];
  internalName: Scalars['String']['output'];
  legalName?: Maybe<Scalars['String']['output']>;
  menuTemplates: Array<MenuTemplate>;
  name: Scalars['String']['output'];
  siteManagementFeeRecipientType: SiteManagementFeeRecipientEnum;
};

/** A contact */
export type Contact = {
  __typename?: 'Contact';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** A country */
export type Country = {
  __typename?: 'Country';
  countryCode: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
};

/** Autogenerated return type of CreateAccountAuthenticationDomainAssociation. */
export type CreateAccountAuthenticationDomainAssociationPayload = {
  __typename?: 'CreateAccountAuthenticationDomainAssociationPayload';
  authenticationDomain?: Maybe<AuthenticationDomain>;
  error?: Maybe<OperationError>;
};

export type CreateAccountPaymentCard = {
  accountId: Scalars['ID']['input'];
  address?: InputMaybe<CreateCardAddressInput>;
  cardholderName?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<Scalars['String']['input']>;
  paymentMethodNonce: Scalars['String']['input'];
  processor?: InputMaybe<PaymentGateway>;
};

/** Autogenerated return type of CreateAccountPaymentCard. */
export type CreateAccountPaymentCardPayload = {
  __typename?: 'CreateAccountPaymentCardPayload';
  card?: Maybe<AccountPaymentCard>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of CreateAccountingSiteOwner. */
export type CreateAccountingSiteOwnerPayload = {
  __typename?: 'CreateAccountingSiteOwnerPayload';
  error?: Maybe<OperationError>;
  owner?: Maybe<AccountingSiteOwner>;
};

/** Autogenerated return type of CreateAccountingSiteRole. */
export type CreateAccountingSiteRolePayload = {
  __typename?: 'CreateAccountingSiteRolePayload';
  error?: Maybe<OperationError>;
  roleType?: Maybe<AccountingSiteRoleType>;
};

/** Autogenerated return type of CreateAccountingSite. */
export type CreateAccountingSiteTypePayload = {
  __typename?: 'CreateAccountingSiteTypePayload';
  error?: Maybe<OperationError>;
  siteType?: Maybe<AccountingSiteType>;
};

export type CreateAuthenticationDomain = {
  accountsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  authenticationProviderId: Scalars['ID']['input'];
  connectionId?: InputMaybe<Scalars['String']['input']>;
  domainName: Scalars['String']['input'];
  effectiveDate: Scalars['ISO8601DateTime']['input'];
  listOfUsers?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileSessionExpiration?: InputMaybe<Scalars['Int']['input']>;
  mobileSessionTimeout?: InputMaybe<Scalars['Int']['input']>;
  organization: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  scimEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  testMode?: InputMaybe<Scalars['Boolean']['input']>;
  useLoginHint?: InputMaybe<Scalars['Boolean']['input']>;
  webSessionExpiration?: InputMaybe<Scalars['Int']['input']>;
  webSessionTimeout?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateAuthenticationDomain. */
export type CreateAuthenticationDomainPayload = {
  __typename?: 'CreateAuthenticationDomainPayload';
  authenticationDomain?: Maybe<AuthenticationDomain>;
  error?: Maybe<OperationError>;
};

export type CreateBanner = {
  content: Scalars['String']['input'];
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<BannerPlatform>;
  style: CreateStyle;
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateBanner. */
export type CreateBannerPayload = {
  __typename?: 'CreateBannerPayload';
  banner?: Maybe<Banner>;
  error?: Maybe<OperationError>;
};

export type CreateBiometricsToken = {
  password: Scalars['String']['input'];
};

/** Autogenerated return type of CreateBiometricsToken. */
export type CreateBiometricsTokenPayload = {
  __typename?: 'CreateBiometricsTokenPayload';
  biometricsToken?: Maybe<Scalars['String']['output']>;
  error?: Maybe<OperationError>;
};

export type CreateCafeEventSchedule = {
  accountId: Scalars['ID']['input'];
  attributes: CreateCafeEventScheduleAttributes;
};

export type CreateCafeEventScheduleAttributes = {
  cafeLocationId: Scalars['ID']['input'];
  emailListId?: InputMaybe<Scalars['String']['input']>;
  eventEndTime: Scalars['Time']['input'];
  eventEndTimeOffsetInDays: Scalars['Int']['input'];
  eventScheduleOwnerId?: InputMaybe<Scalars['ID']['input']>;
  eventStartTime: Scalars['Time']['input'];
  finalEmail?: InputMaybe<EmailConfigurationInput>;
  fixedPricePerConsumerCents?: InputMaybe<Scalars['Int']['input']>;
  introductionEmail?: InputMaybe<EmailConfigurationInput>;
  minSalesGuaranteeCents?: InputMaybe<Scalars['Int']['input']>;
  pauseEndDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  pauseStartDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  scheduleEndDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  scheduleFrequency: ScheduleFrequencyInput;
  scheduleStartDate: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated return type of CreateCafeEventSchedule. */
export type CreateCafeEventSchedulePayload = {
  __typename?: 'CreateCafeEventSchedulePayload';
  cafeEventSchedule?: Maybe<EventSchedule>;
  error?: Maybe<OperationError>;
};

export type CreateCafeEventScheduleStation = {
  attributes: CreateCafeEventScheduleStationAttributes;
  cafeEventScheduleId: Scalars['ID']['input'];
};

export type CreateCafeEventScheduleStationAttributes = {
  endTime: Scalars['Time']['input'];
  endTimeOffsetInDays: Scalars['Int']['input'];
  mealPeriod?: InputMaybe<MealPeriodEnum>;
  menuTemplateId?: InputMaybe<Scalars['ID']['input']>;
  pickupOrderingWindows?: InputMaybe<Array<PickupOrderingWindowInput>>;
  positionOnCafeMenu: Scalars['Int']['input'];
  prepFor?: InputMaybe<Scalars['Int']['input']>;
  setupTimeMinutes: Scalars['Int']['input'];
  startTime: Scalars['Time']['input'];
  stationId: Scalars['ID']['input'];
  stationType: StationTypes;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateCafeEventScheduleStation. */
export type CreateCafeEventScheduleStationPayload = {
  __typename?: 'CreateCafeEventScheduleStationPayload';
  cafeEventScheduleStation?: Maybe<EventScheduleStation>;
  error?: Maybe<OperationError>;
};

export type CreateCafeEventStation = {
  cafeEventId: Scalars['ID']['input'];
  cafeEventStationAttributes: CreateCafeEventStationAttributes;
};

export type CreateCafeEventStationAttributes = {
  endTime: Scalars['ISO8601DateTime']['input'];
  mealPeriod?: InputMaybe<MealPeriodEnum>;
  menuTemplateId: Scalars['ID']['input'];
  positionOnCafeMenu: Scalars['Int']['input'];
  prepFor: Scalars['Int']['input'];
  setupTimeMinutes: Scalars['Int']['input'];
  startTime: Scalars['ISO8601DateTime']['input'];
  stationId: Scalars['ID']['input'];
  stationType: StationTypes;
  vendorId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateCafeEventStation. */
export type CreateCafeEventStationPayload = {
  __typename?: 'CreateCafeEventStationPayload';
  cafeEventStation?: Maybe<EventStation>;
  error?: Maybe<OperationError>;
};

export type CreateCafeLocation = {
  accountId: Scalars['ID']['input'];
  attributes: CreateCafeLocationAttributes;
};

export type CreateCafeLocationAttributes = {
  accessibleToPublic?: InputMaybe<Scalars['Boolean']['input']>;
  audienceSize?: InputMaybe<Scalars['Int']['input']>;
  buildingId: Scalars['Int']['input'];
  contactId?: InputMaybe<Scalars['Int']['input']>;
  hideFromScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromSearch?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

/** Autogenerated return type of CreateCafeLocation. */
export type CreateCafeLocationPayload = {
  __typename?: 'CreateCafeLocationPayload';
  cafeLocation?: Maybe<CafeLocation>;
  error?: Maybe<OperationError>;
};

export type CreateCafeStation = {
  cafeLocationId: Scalars['ID']['input'];
  cafeStationAttributes: CreateCafeStationAttributes;
};

export type CreateCafeStationAttributes = {
  hideFromScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  menuType?: InputMaybe<Menu>;
  mobileOrderCapacityPercentage?: InputMaybe<Scalars['Int']['input']>;
  mobileOrderingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  mobileOrderingExtended?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

/** Autogenerated return type of CreateCafeStation. */
export type CreateCafeStationPayload = {
  __typename?: 'CreateCafeStationPayload';
  cafeStation?: Maybe<Station>;
  error?: Maybe<OperationError>;
};

export type CreateCampaign = {
  bannerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  category: CampaignCategory;
  endsAt: Scalars['ISO8601DateTime']['input'];
  startsAt: Scalars['ISO8601DateTime']['input'];
  strategy?: InputMaybe<CampaignStrategy>;
  threadId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateCampaign. */
export type CreateCampaignPayload = {
  __typename?: 'CreateCampaignPayload';
  campaign?: Maybe<Campaign>;
  error?: Maybe<OperationError>;
};

export type CreateCampaignUsers = {
  campaignId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateCampaignUsers. */
export type CreateCampaignUsersPayload = {
  __typename?: 'CreateCampaignUsersPayload';
  campaignUsers?: Maybe<Array<CampaignUser>>;
  error?: Maybe<OperationError>;
  failedUsers?: Maybe<Array<User>>;
};

export type CreateCard = {
  address: CreateCardAddressInput;
  cardToken: Scalars['String']['input'];
  cardholderName?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<Scalars['String']['input']>;
  makeDefault?: InputMaybe<Scalars['Boolean']['input']>;
  makeDefaultDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  processor: PaymentGateway;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCardAddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};

/** Autogenerated return type of CreateCardAsync. */
export type CreateCardAsyncPayload = {
  __typename?: 'CreateCardAsyncPayload';
  error?: Maybe<OperationError>;
  requestToken?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateCard. */
export type CreateCardPayload = {
  __typename?: 'CreateCardPayload';
  card?: Maybe<Card>;
  error?: Maybe<OperationError>;
};

export type CreateCateringInventoryItem = {
  attributes: CreateCateringInventoryItemAttributes;
  dietaryInfo?: InputMaybe<InventoryItemDietaryInfoInput>;
  vendorId: Scalars['ID']['input'];
};

export type CreateCateringInventoryItemAttributes = {
  cogs?: InputMaybe<Scalars['BigDecimal']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dietaryRestrictions?: InputMaybe<Array<InventoryItemDietaryRestrictions>>;
  eligibleForAddOns?: InputMaybe<Scalars['Boolean']['input']>;
  externalTags?: InputMaybe<Array<InventoryItemExternalTags>>;
  feedsMax?: InputMaybe<Scalars['Int']['input']>;
  feedsMin?: InputMaybe<Scalars['Int']['input']>;
  foodaSku?: InputMaybe<Scalars['String']['input']>;
  internalTags?: InputMaybe<Array<InventoryItemInternalTags>>;
  mealType?: InputMaybe<InventoryItemMealType>;
  minSelfServiceQuantity?: InputMaybe<Scalars['Int']['input']>;
  nameForVendor: Scalars['String']['input'];
  namePublic: Scalars['String']['input'];
  packagingDetails?: InputMaybe<CateringPackagingDetails>;
  premiumCogs?: InputMaybe<Scalars['BigDecimal']['input']>;
  premiumSellPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  retailPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  sellPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  taxCategoryId?: InputMaybe<Scalars['Int']['input']>;
  useAsInventoryItemOption?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CreateCateringInventoryItem. */
export type CreateCateringInventoryItemPayload = {
  __typename?: 'CreateCateringInventoryItemPayload';
  cateringInventoryItem?: Maybe<CateringInventoryItem>;
  error?: Maybe<OperationError>;
};

export type CreateCateringUserAccount = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  accountName?: InputMaybe<Scalars['String']['input']>;
  address1?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isRecaptchaV2?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  recaptchaToken: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCateringUserAccount. */
export type CreateCateringUserAccountPayload = {
  __typename?: 'CreateCateringUserAccountPayload';
  destination?: Maybe<Scalars['String']['output']>;
  error?: Maybe<OperationError>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  omniauthCallback?: Maybe<Scalars['String']['output']>;
  result?: Maybe<CateringUserAccount>;
  sessionToken?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type CreateConsumerDataRequest = {
  action: ConsumerDataRequestTypeEnum;
  processingTime?: InputMaybe<ConsumerDataRequestProcessingTimeEnum>;
};

/** Autogenerated return type of CreateConsumerDataRequest. */
export type CreateConsumerDataRequestPayload = {
  __typename?: 'CreateConsumerDataRequestPayload';
  consumerDataRequest?: Maybe<ConsumerDataRequest>;
  error?: Maybe<OperationError>;
};

export type CreateCrossDock = {
  address: AddressInput;
  dropOffInstruction?: InputMaybe<Scalars['String']['input']>;
  marketIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  merchantId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  pickupInstruction?: InputMaybe<Scalars['String']['input']>;
  status: CrossDockStatus;
};

/** Autogenerated return type of CreateCrossDock. */
export type CreateCrossDockPayload = {
  __typename?: 'CreateCrossDockPayload';
  crossDock?: Maybe<CrossDock>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of CreateCustomInvoice. */
export type CreateCustomInvoicePayload = {
  __typename?: 'CreateCustomInvoicePayload';
  customInvoice?: Maybe<CustomInvoice>;
  error?: Maybe<OperationError>;
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of CreateCustomInvoiceSettings. */
export type CreateCustomInvoiceSettingsPayload = {
  __typename?: 'CreateCustomInvoiceSettingsPayload';
  error?: Maybe<OperationError>;
  settings?: Maybe<CustomInvoiceSettings>;
};

export type CreateDeliveryInventoryItem = {
  attributes: CreateDeliveryInventoryItemAttributes;
  dietaryInfo?: InputMaybe<InventoryItemDietaryInfoInput>;
  vendorId: Scalars['ID']['input'];
};

export type CreateDeliveryInventoryItemAttributes = {
  capacityExempt?: InputMaybe<Scalars['Boolean']['input']>;
  cogs: Scalars['BigDecimal']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dietaryRestrictions?: InputMaybe<Array<InventoryItemDietaryRestrictions>>;
  disallowWriteIn?: InputMaybe<Scalars['Boolean']['input']>;
  eligibleForAddOns?: InputMaybe<Scalars['Boolean']['input']>;
  externalTags?: InputMaybe<Array<InventoryItemExternalTags>>;
  foodaSku?: InputMaybe<Scalars['String']['input']>;
  internalTags?: InputMaybe<Array<InventoryItemInternalTags>>;
  mealType?: InputMaybe<InventoryItemMealType>;
  nameForVendor: Scalars['String']['input'];
  namePublic: Scalars['String']['input'];
  premiumSellPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  prepLine?: InputMaybe<Scalars['Int']['input']>;
  sellPrice: Scalars['BigDecimal']['input'];
  showOnMenu?: InputMaybe<Scalars['Boolean']['input']>;
  signatureItem?: InputMaybe<Scalars['Boolean']['input']>;
  taxCategoryId?: InputMaybe<Scalars['Int']['input']>;
  temperatureClassification?: InputMaybe<InventoryItemTemperatureClassification>;
  useAsInventoryItemOption?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CreateDeliveryInventoryItem. */
export type CreateDeliveryInventoryItemPayload = {
  __typename?: 'CreateDeliveryInventoryItemPayload';
  deliveryInventoryItem?: Maybe<DeliveryInventoryItem>;
  error?: Maybe<OperationError>;
};

export type CreateDeliveryVendorMarketCapacity = {
  capacity: Scalars['Int']['input'];
  marketManifestTimeId: Scalars['ID']['input'];
  vendorConstraintId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateDeliveryVendorMarketCapacity. */
export type CreateDeliveryVendorMarketCapacityPayload = {
  __typename?: 'CreateDeliveryVendorMarketCapacityPayload';
  error?: Maybe<OperationError>;
  marketManifestCapacity?: Maybe<MarketManifestCapacity>;
};

export type CreateFeedbackResponse = {
  comments?: InputMaybe<Scalars['String']['input']>;
  feedbackRequestId: Scalars['ID']['input'];
  rating: Scalars['Int']['input'];
  reviews?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of CreateFeedbackResponse. */
export type CreateFeedbackResponsePayload = {
  __typename?: 'CreateFeedbackResponsePayload';
  error?: Maybe<OperationError>;
  feedbackResponse?: Maybe<FeedbackResponse>;
};

/** Onboard a pull-funding bank account from a client-side bank-account token (btok_...) */
export type CreateFoodaCardBankAccount = {
  accountHolderEmail?: InputMaybe<Scalars['String']['input']>;
  accountHolderName: Scalars['String']['input'];
  bankAccountToken: Scalars['String']['input'];
  mandateAcceptedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  stripeAccountId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateFoodaCardBankAccount. */
export type CreateFoodaCardBankAccountPayload = {
  __typename?: 'CreateFoodaCardBankAccountPayload';
  bankAccount?: Maybe<FoodaCardBankAccount>;
  error?: Maybe<OperationError>;
};

/** Manually create a top-up (pull funds) for a connected account's Issuing balance */
export type CreateFoodaCardTopup = {
  amountCents: Scalars['Int']['input'];
  bankAccountId?: InputMaybe<Scalars['ID']['input']>;
  stripeAccountId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateFoodaCardTopup. */
export type CreateFoodaCardTopupPayload = {
  __typename?: 'CreateFoodaCardTopupPayload';
  error?: Maybe<OperationError>;
  topup?: Maybe<FoodaCardTopup>;
};

export type CreateGuestPasses = {
  accountId: Scalars['ID']['input'];
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  printablePassCount?: InputMaybe<Scalars['Int']['input']>;
  subsidyRuleAttributes: SubsidyRuleAttributes;
};

/** Autogenerated return type of CreateGuestPasses. */
export type CreateGuestPassesPayload = {
  __typename?: 'CreateGuestPassesPayload';
  error?: Maybe<OperationError>;
  rule?: Maybe<SubsidyRule>;
};

/** Create Limits Group */
export type CreateLimitsGroup = {
  maxDailyCostCents?: InputMaybe<Scalars['Int']['input']>;
  maxMonthlyCostCents?: InputMaybe<Scalars['Int']['input']>;
  maxSessionCostCents?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type CreateMarket = {
  accountingMarketName?: InputMaybe<Scalars['String']['input']>;
  active: Scalars['Boolean']['input'];
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  checkAverage?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  defaultAccountantId: Scalars['ID']['input'];
  defaultCrossDockId?: InputMaybe<Scalars['ID']['input']>;
  defaultOperationEmail?: InputMaybe<Scalars['String']['input']>;
  defaultTaxRate?: InputMaybe<Scalars['Float']['input']>;
  defaultTaxRemitter?: InputMaybe<TaxRemitter>;
  deliverySupportPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  directorId?: InputMaybe<Scalars['ID']['input']>;
  displayCommission: Scalars['Boolean']['input'];
  healthDepartmentJurisdictions?: InputMaybe<Array<HealthDepartmentJurisdictionInput>>;
  marketCohortName?: InputMaybe<Scalars['String']['input']>;
  marketManifestTime?: InputMaybe<MarketManifestTimeInput>;
  name: Scalars['String']['input'];
  noDefaultCrossDock?: InputMaybe<Scalars['Boolean']['input']>;
  officeDefaultEmail?: InputMaybe<Scalars['String']['input']>;
  officeDefaultFax?: InputMaybe<Scalars['String']['input']>;
  officeDefaultPhone?: InputMaybe<Scalars['String']['input']>;
  officeDefaultSms?: InputMaybe<Scalars['String']['input']>;
  popupSupportPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
  zipCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of CreateMarket. */
export type CreateMarketPayload = {
  __typename?: 'CreateMarketPayload';
  error?: Maybe<OperationError>;
  market?: Maybe<Market>;
};

export type CreateMenuChangeRequestUploadInput = {
  byteSize: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
  menuTemplateId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateMenuChangeRequestUpload. */
export type CreateMenuChangeRequestUploadPayload = {
  __typename?: 'CreateMenuChangeRequestUploadPayload';
  error?: Maybe<OperationError>;
  upload?: Maybe<MenuChangeRequestUploadTarget>;
};

export type CreateMenuTemplateCategoryGroupAttributes = {
  name: Scalars['String']['input'];
  selectedInventoryItems: Array<MenuTemplateInventoryItemAttributes>;
};

export type CreateMobileOrderingOrderRequest = {
  coupon?: InputMaybe<MobileOrderingOrderRequestCoupon>;
  eventVendorId: Scalars['ID']['input'];
  idempotencyKey: Scalars['UUID']['input'];
  items: Array<MobileOrderingOrderRequestItem>;
  payment?: InputMaybe<MobileOrderingPayment>;
  pickupTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  subsidy?: InputMaybe<MobileOrderingOrderRequestSubsidy>;
};

/** Autogenerated return type of CreateMobileOrderingOrderRequest. */
export type CreateMobileOrderingOrderRequestPayload = {
  __typename?: 'CreateMobileOrderingOrderRequestPayload';
  error?: Maybe<OperationError>;
  orderRequest?: Maybe<MobileOrderingOrderRequest>;
};

/** Create a new model version */
export type CreateModelVersionInput = {
  changeNotes: Scalars['String']['input'];
  /** Configuration fields to override (e.g., {'prompt_instructions': 'new prompt'} for LLM models) */
  configurationOverrides?: InputMaybe<Scalars['JSON']['input']>;
  /** Optional new model name/alias */
  name?: InputMaybe<Scalars['String']['input']>;
  sourceModelId: Scalars['ID']['input'];
  /** Either 'major' or 'minor' */
  versionType: Scalars['String']['input'];
};

export type CreateOrderItemsUnavailableErrorDetail = OperationErrorDetail & {
  __typename?: 'CreateOrderItemsUnavailableErrorDetail';
  codeAsString: Scalars['String']['output'];
  itemIds: Array<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type CreateOrderRequest = {
  clientCreatedAt: Scalars['ISO8601DateTime']['input'];
  /** DEPRECATED: use userIdentifier for phone input */
  customerPhoneNumber?: InputMaybe<Scalars['PhoneNumberDigits']['input']>;
  discounts?: InputMaybe<Array<OrderDiscount>>;
  eventId: Scalars['ID']['input'];
  isSelfCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<OrderItem>;
  paymentGatewayInfo?: InputMaybe<PaymentGatewayInfo>;
  paymentMethod: OrderRequestPaymentMethod;
  /** DEPRECATED: End of support in 2023 */
  paypalInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  /** DEPRECATED: End of support in 2023 */
  paypalResponse?: InputMaybe<PaypalResponse>;
  receiptRequest?: InputMaybe<OrderReceiptRequest>;
  requestId: Scalars['UUID']['input'];
  terminalId?: InputMaybe<Scalars['String']['input']>;
  transactedOnline: Scalars['Boolean']['input'];
  userIdentifier?: InputMaybe<UserIdentifier>;
};

/** Autogenerated return type of CreateOrderRequest. */
export type CreateOrderRequestPayload = {
  __typename?: 'CreateOrderRequestPayload';
  error?: Maybe<OperationError>;
  orderRequest?: Maybe<OrderRequest>;
};

export type CreatePhysicalSecurityResponse = {
  device: DeviceAttributes;
  responses: Array<PhysicalSecurityResponse>;
};

/** Autogenerated return type of CreatePhysicalSecurityResponse. */
export type CreatePhysicalSecurityResponsePayload = {
  __typename?: 'CreatePhysicalSecurityResponsePayload';
  error?: Maybe<OperationError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreatePopupInventoryItem = {
  attributes: CreatePopupInventoryItemAttributes;
  dietaryInfo?: InputMaybe<InventoryItemDietaryInfoInput>;
  taxRuleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vendorId: Scalars['ID']['input'];
};

export type CreatePopupInventoryItemAttributes = {
  availableInPersonOnly?: InputMaybe<Scalars['Boolean']['input']>;
  barcodeIdentifier?: InputMaybe<BarcodeInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  dietaryRestrictions?: InputMaybe<Array<InventoryItemDietaryRestrictions>>;
  disallowWriteIn?: InputMaybe<Scalars['Boolean']['input']>;
  externalTags?: InputMaybe<Array<InventoryItemExternalTags>>;
  foodaSku?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  mealType?: InputMaybe<InventoryItemMealType>;
  nameForVendor: Scalars['String']['input'];
  namePublic: Scalars['String']['input'];
  preTaxPrice: Scalars['BigDecimal']['input'];
  priceType: PriceTypeEnum;
  showOnMenu?: InputMaybe<Scalars['Boolean']['input']>;
  showOnPos?: InputMaybe<Scalars['Boolean']['input']>;
  taxCategoryId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreatePopupInventoryItem. */
export type CreatePopupInventoryItemPayload = {
  __typename?: 'CreatePopupInventoryItemPayload';
  error?: Maybe<OperationError>;
  popupInventoryItem?: Maybe<PopupInventoryItem>;
};

export type CreatePopupMenuTemplate = {
  popupMenuTemplateAttributes: PopupMenuTemplateAttributes;
  vendorId: Scalars['ID']['input'];
};

export type CreatePopupMenuTemplateCategoryGroup = {
  menuTemplateCategoryGroupAttributes: CreateMenuTemplateCategoryGroupAttributes;
  menuTemplateId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreatePopupMenuTemplateCategoryGroup. */
export type CreatePopupMenuTemplateCategoryGroupPayload = {
  __typename?: 'CreatePopupMenuTemplateCategoryGroupPayload';
  error?: Maybe<OperationError>;
  menuTemplateCategoryGroup?: Maybe<PopupMenuTemplateCategoryGroup>;
};

/** Autogenerated return type of CreatePopupMenuTemplate. */
export type CreatePopupMenuTemplatePayload = {
  __typename?: 'CreatePopupMenuTemplatePayload';
  error?: Maybe<OperationError>;
  popupMenuTemplate?: Maybe<PopupMenuTemplate>;
};

export type CreatePopupMenuTemplateSelectionGroup = {
  defaultSelectionInventoryItemId?: InputMaybe<Scalars['ID']['input']>;
  maxSelections: Scalars['Int']['input'];
  minSelections: Scalars['Int']['input'];
  nameForVendor: Scalars['String']['input'];
  namePublic: Scalars['String']['input'];
  parentItemId: Scalars['ID']['input'];
  selectedInventoryItems: Array<MenuTemplateSelectionGroupItemAttributes>;
};

/** Autogenerated return type of CreatePopupMenuTemplateSelectionGroup. */
export type CreatePopupMenuTemplateSelectionGroupPayload = {
  __typename?: 'CreatePopupMenuTemplateSelectionGroupPayload';
  error?: Maybe<OperationError>;
  menuTemplateSelectionGroup?: Maybe<PopupMenuTemplateSelectionGroup>;
};

/** Autogenerated return type of CreateRecommendationsLimitsGroup. */
export type CreateRecommendationsLimitsGroupPayload = {
  __typename?: 'CreateRecommendationsLimitsGroupPayload';
  error?: Maybe<OperationError>;
  limitsGroup?: Maybe<LimitsGroup>;
};

/** Autogenerated return type of CreateRecommendationsModelVersion. */
export type CreateRecommendationsModelVersionPayload = {
  __typename?: 'CreateRecommendationsModelVersionPayload';
  error?: Maybe<OperationError>;
  modelConfig?: Maybe<ModelConfig>;
};

/** Create Report Configuration input */
export type CreateReportConfigurationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  headline: Scalars['String']['input'];
  iconName: Scalars['String']['input'];
  menuTitle: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  reportType: ReportConfigurationTypeEnum;
  requiredRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  subtitle: Scalars['String']['input'];
  tableauDesktopUrl: Scalars['String']['input'];
  tableauMobileUrl: Scalars['String']['input'];
  terms: Array<TermsWithDescriptionInput>;
};

/** Autogenerated return type of CreateReportConfigurationQuery. */
export type CreateReportConfigurationQueryPayload = {
  __typename?: 'CreateReportConfigurationQueryPayload';
  error?: Maybe<OperationError>;
  reportConfiguration?: Maybe<ReportConfigurations>;
};

/** Autogenerated return type of CreateScanToPayOrderRequest. */
export type CreateScanToPayOrderRequestPayload = {
  __typename?: 'CreateScanToPayOrderRequestPayload';
  error?: Maybe<OperationError>;
  orderRequest?: Maybe<MobileOrderingOrderRequest>;
};

export type CreateSelectEventVendor = {
  selectEventId: Scalars['ID']['input'];
  selectEventVendorAttributes: CreateSelectEventVendorAttributes;
};

export type CreateSelectEventVendorAttributes = {
  crossDockId?: InputMaybe<Scalars['ID']['input']>;
  deliveryVendorId: Scalars['ID']['input'];
  menuTemplateId: Scalars['ID']['input'];
  prepFor?: InputMaybe<Scalars['Int']['input']>;
  status: Scalars['String']['input'];
  vendorId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateSelectEventVendor. */
export type CreateSelectEventVendorPayload = {
  __typename?: 'CreateSelectEventVendorPayload';
  error?: Maybe<OperationError>;
  selectEventVendor?: Maybe<SelectEventVendor>;
};

export type CreateSession = {
  biometricsToken?: InputMaybe<Scalars['String']['input']>;
  device?: InputMaybe<DeviceAttributes>;
  getBiometricsToken?: InputMaybe<Scalars['Boolean']['input']>;
  nonce?: InputMaybe<Scalars['String']['input']>;
  omniauthRequest?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  posOperator?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateSession. */
export type CreateSessionPayload = {
  __typename?: 'CreateSessionPayload';
  error?: Maybe<OperationError>;
  session?: Maybe<Session>;
};

export type CreateSignedUploadLink = {
  documentType: UploadLinkDocument;
};

/** Autogenerated return type of CreateSignedUploadLink. */
export type CreateSignedUploadLinkPayload = {
  __typename?: 'CreateSignedUploadLinkPayload';
  error?: Maybe<OperationError>;
  signedUploadLink?: Maybe<SignedUploadLink>;
};

/** Autogenerated return type of CreateStripeAccount. */
export type CreateStripeAccountPayload = {
  __typename?: 'CreateStripeAccountPayload';
  error?: Maybe<OperationError>;
  stripeAccount?: Maybe<FoodaCardStripeAccount>;
};

export type CreateStyle = {
  bodyTextColor: Scalars['String']['input'];
  borderColor: Scalars['String']['input'];
  fillColor: Scalars['String']['input'];
  titleTextColor: Scalars['String']['input'];
};

export type CreateSubsidyRule = {
  accountId: Scalars['ID']['input'];
  autoApply: Scalars['Boolean']['input'];
  coverageDescriptionOverride?: InputMaybe<Scalars['String']['input']>;
  dailyMaxCents?: InputMaybe<Scalars['Int']['input']>;
  daysAvailable: Array<Day>;
  displayPreSubsidyPrice: Scalars['Boolean']['input'];
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  eventMaxCents?: InputMaybe<Scalars['Int']['input']>;
  externalTags?: InputMaybe<Array<InventoryItemExternalTags>>;
  foodaCardStripeAccountId?: InputMaybe<Scalars['ID']['input']>;
  hasFoodaCardProgram?: InputMaybe<Scalars['Boolean']['input']>;
  locationRestriction?: InputMaybe<SubsidyLocationRestrictionEnum>;
  mealTypes?: InputMaybe<Array<InventoryItemMealType>>;
  minOrderCents: Scalars['Int']['input'];
  monthlyMaxCents?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  noQr: Scalars['Boolean']['input'];
  percentageCap: Scalars['BigDecimal']['input'];
  /** Item-level only: when true, min_order_cents and event_max_cents are interpreted as pre-tax. */
  preTaxEmployeeContribution?: InputMaybe<Scalars['Boolean']['input']>;
  product: SubsidyRuleProduct;
  /**
   * Max $ per user for the whole program (declining balance). Order-level QR
   * programs only: not allowed with no_qr or auto_apply.
   */
  programMaxCents?: InputMaybe<Scalars['Int']['input']>;
  redemptionsPerDay?: InputMaybe<Scalars['Int']['input']>;
  ruleType: SubsidyRuleTypeEnum;
  /**
   * Order-level QR member programs only: when true, members added to or joining
   * this program get an active subsidy without confirming their email first.
   */
  skipEmailVerification?: InputMaybe<Scalars['Boolean']['input']>;
  specificAccountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  startsAt: Scalars['ISO8601DateTime']['input'];
  subsidyType: SubsidyTypeEnum;
  supportedMealPeriods?: InputMaybe<Array<MealPeriodEnum>>;
  timeZone: SubsidyTimezone;
  validEverywhere: Scalars['Boolean']['input'];
  /** Item-level only: limit the subsidy to items from these vendors. Empty or omitted means every vendor. */
  vendorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  weeklyMaxCents?: InputMaybe<Scalars['Int']['input']>;
  weeklyRecurrence: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateSubsidyRule. */
export type CreateSubsidyRulePayload = {
  __typename?: 'CreateSubsidyRulePayload';
  error?: Maybe<OperationError>;
  rule?: Maybe<SubsidyRule>;
};

/** Create Tax Category */
export type CreateTaxCategory = {
  categoryType: TaxCategoryTypeEnum;
  code: Scalars['String']['input'];
  isSync?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateTaxCategory. */
export type CreateTaxCategoryPayload = {
  __typename?: 'CreateTaxCategoryPayload';
  error?: Maybe<OperationError>;
  taxCategory?: Maybe<TaxCategory>;
};

export type CreateTempUser = {
  consentPhoneVerification?: InputMaybe<Scalars['Boolean']['input']>;
  consentSmsPromotions?: InputMaybe<Scalars['Boolean']['input']>;
  device?: InputMaybe<DeviceAttributes>;
  email: Scalars['EmailAddress']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['Password']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  recaptchaToken: Scalars['String']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  shortMessageServiceContactId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateTempUser. */
export type CreateTempUserPayload = {
  __typename?: 'CreateTempUserPayload';
  error?: Maybe<OperationError>;
  tempUserId?: Maybe<Scalars['ID']['output']>;
};

export type CreateTenderMethodInput = {
  /** Account IDs that can use this tender method */
  accountIds: Array<Scalars['ID']['input']>;
  /** Days of the week when tender method is available (defaults to weekdays) */
  daysAvailable: Array<Day>;
  /** End date for the tender method */
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** External system identifier */
  externalId: Scalars['String']['input'];
  /** Name of the tender method program */
  name: Scalars['String']['input'];
  /** Product type this tender method applies to */
  productType: ProductEnum;
  /** Start date for the tender method */
  startDate: Scalars['ISO8601DateTime']['input'];
  /** Timezone for the tender method schedule (defaults to Central) */
  timezone: Timezone;
};

/** Autogenerated return type of CreateTenderMethod. */
export type CreateTenderMethodPayload = {
  __typename?: 'CreateTenderMethodPayload';
  error?: Maybe<OperationError>;
  tenderMethod?: Maybe<TenderMethod>;
};

export type CreateUser = {
  device?: InputMaybe<DeviceAttributes>;
  email: Scalars['EmailAddress']['input'];
  firstName: Scalars['String']['input'];
  isRecaptchaV2?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  omniauthRequest?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['Password']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  recaptchaToken: Scalars['String']['input'];
  referrals?: InputMaybe<ReferralAttributes>;
  shortMessageServiceContactId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateUserAccountErrorDetail = OperationErrorDetail & {
  __typename?: 'CreateUserAccountErrorDetail';
  code: CreateUserErrorCodeEnum;
  codeAsString: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum CreateUserErrorCodeEnum {
  /** Error code 409 */
  DuplicateEmail = 'DUPLICATE_EMAIL',
  /** Error code 422 */
  ReferralCode = 'REFERRAL_CODE',
  /** Error code 400 */
  UserFactory = 'USER_FACTORY'
}

export type CreateUserNote = {
  note: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateUserNote. */
export type CreateUserNotePayload = {
  __typename?: 'CreateUserNotePayload';
  error?: Maybe<OperationError>;
  userNote?: Maybe<UserNote>;
};

/** Autogenerated return type of CreateUser. */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  error?: Maybe<OperationError>;
  omniauthCallback?: Maybe<Scalars['String']['output']>;
  sessionToken?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type CreateVerificationRequest = {
  tempUserId?: InputMaybe<Scalars['ID']['input']>;
  verificationMethod: UserVerificationMethod;
};

/** Autogenerated return type of CreateVerificationRequest. */
export type CreateVerificationRequestPayload = {
  __typename?: 'CreateVerificationRequestPayload';
  error?: Maybe<OperationError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** A Cross-Dock */
export type CrossDock = {
  __typename?: 'CrossDock';
  address: Address;
  dropOffInstruction?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  markets?: Maybe<Array<Market>>;
  merchantId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  pickupInstruction?: Maybe<Scalars['String']['output']>;
  status: CrossDockStatus;
};

export enum CrossDockStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Cross Sell recommendation request */
export type CrossSellRequestInput = {
  /** Array of menu items for cross-sell recommendations */
  items: Array<RecommendationItemInput>;
};

/** Cuisine */
export type Cuisine = {
  __typename?: 'Cuisine';
  available: Scalars['Boolean']['output'];
  availableForMenuTemplate: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum CuisineNames {
  African = 'AFRICAN',
  American = 'AMERICAN',
  Argentine = 'ARGENTINE',
  Asian = 'ASIAN',
  Australian = 'AUSTRALIAN',
  Bakery = 'BAKERY',
  Barbecue = 'BARBECUE',
  Bbq = 'BBQ',
  Brazilian = 'BRAZILIAN',
  Breakfast = 'BREAKFAST',
  Burgers = 'BURGERS',
  Burmese = 'BURMESE',
  Cajun = 'CAJUN',
  Cambodian = 'CAMBODIAN',
  Caribbean = 'CARIBBEAN',
  ChickenSandwiches = 'CHICKEN_SANDWICHES',
  Chinese = 'CHINESE',
  CoffeeAndTea = 'COFFEE_AND_TEA',
  Comfort = 'COMFORT',
  Cuban = 'CUBAN',
  Deli = 'DELI',
  Dessert = 'DESSERT',
  EasternEuropean = 'EASTERN_EUROPEAN',
  Egyptian = 'EGYPTIAN',
  English = 'ENGLISH',
  Ethiopian = 'ETHIOPIAN',
  FastFood = 'FAST_FOOD',
  French = 'FRENCH',
  FriedChicken = 'FRIED_CHICKEN',
  German = 'GERMAN',
  Greek = 'GREEK',
  Grill = 'GRILL',
  Halal = 'HALAL',
  Hawaiian = 'HAWAIIAN',
  Healthy = 'HEALTHY',
  HotDogs = 'HOT_DOGS',
  IceCream = 'ICE_CREAM',
  Indian = 'INDIAN',
  Indonesian = 'INDONESIAN',
  Irish = 'IRISH',
  Israeli = 'ISRAELI',
  Italian = 'ITALIAN',
  Jamaican = 'JAMAICAN',
  Japanese = 'JAPANESE',
  Korean = 'KOREAN',
  LatinAmerican = 'LATIN_AMERICAN',
  Lebanese = 'LEBANESE',
  Mediterranean = 'MEDITERRANEAN',
  Mexican = 'MEXICAN',
  MicroMarket = 'MICRO_MARKET',
  MiddleEastern = 'MIDDLE_EASTERN',
  Moroccan = 'MOROCCAN',
  OfficeCoffeeSolution = 'OFFICE_COFFEE_SOLUTION',
  Pantry = 'PANTRY',
  Pasta = 'PASTA',
  Peruvian = 'PERUVIAN',
  Philippine = 'PHILIPPINE',
  Pizza = 'PIZZA',
  Poke = 'POKE',
  Polish = 'POLISH',
  PubFood = 'PUB_FOOD',
  Ramen = 'RAMEN',
  Salads = 'SALADS',
  Sandwiches = 'SANDWICHES',
  Seafood = 'SEAFOOD',
  SmoothiesAndJuices = 'SMOOTHIES_AND_JUICES',
  SoulFood = 'SOUL_FOOD',
  Soup = 'SOUP',
  Southern = 'SOUTHERN',
  Spanish = 'SPANISH',
  Steakhouses = 'STEAKHOUSES',
  Subs = 'SUBS',
  Sushi = 'SUSHI',
  TexMex = 'TEX_MEX',
  Thai = 'THAI',
  Turkish = 'TURKISH',
  Ukrainian = 'UKRAINIAN',
  Vegan = 'VEGAN',
  Vegetarian = 'VEGETARIAN',
  Vending = 'VENDING',
  Vietnamese = 'VIETNAMESE',
  Wings = 'WINGS'
}

/** A custom food item on a menu, created from the Point of Sale */
export type CustomCafeEventMenuItem = {
  __typename?: 'CustomCafeEventMenuItem';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** @deprecated Not used anymore */
  otherTaxCents: Scalars['BigDecimal']['output'];
  postTaxPriceCents: Scalars['Int']['output'];
  preTaxPriceCents: Scalars['BigDecimal']['output'];
  salesTaxCents: Scalars['BigDecimal']['output'];
  taxCategoryId?: Maybe<Scalars['Int']['output']>;
};

/** A custom invoice registered against one or more accounts */
export type CustomInvoice = {
  __typename?: 'CustomInvoice';
  amountCents: Scalars['Int']['output'];
  externalId: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  generatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  invoiceDate: Scalars['ISO8601Date']['output'];
  outstandingBalanceCents?: Maybe<Scalars['Int']['output']>;
  products: Array<ProductEnum>;
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  sentToEmails: Array<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CustomInvoiceInput = {
  amountCents: Scalars['Int']['input'];
  externalId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  generatedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  invoiceDate: Scalars['ISO8601Date']['input'];
  outstandingBalanceCents?: InputMaybe<Scalars['Int']['input']>;
  parties: Array<CustomInvoicePartyInput>;
  persistedKey: Scalars['String']['input'];
  products: Array<ProductEnum>;
  replacesConsolidatedInvoiceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sentAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  sentToEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** A member of the entity and its own PO, named by the member's type and id */
export type CustomInvoiceMemberPoInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  memberType: CustomInvoiceMemberTypeEnum;
  parentCompanyId?: InputMaybe<Scalars['ID']['input']>;
  poValue: Scalars['String']['input'];
};

export enum CustomInvoiceMemberTypeEnum {
  Account = 'ACCOUNT',
  AccountParent = 'ACCOUNT_PARENT',
  Location = 'LOCATION'
}

/** An active entity a draft entity would collide with on account and product */
export type CustomInvoiceOverlap = {
  __typename?: 'CustomInvoiceOverlap';
  accountIds: Array<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  memberIndexes: Array<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** The draft already collided with this entity before the edit, so it does not block the save */
  preExisting: Scalars['Boolean']['output'];
  products: Array<ProductEnum>;
};

export type CustomInvoicePartyInput = {
  partyId: Scalars['Int']['input'];
  partyType: Scalars['String']['input'];
};

/**
 * PO by day of service and fee type: as by day of service, except that its fee
 * types are divided across the day groups by fee share
 */
export type CustomInvoicePoByDayAndFeeTypeRule = {
  __typename?: 'CustomInvoicePoByDayAndFeeTypeRule';
  dayGroups: Array<CustomInvoicePoDayGroupWithFeeShare>;
  feeTypes: Array<CustomInvoicePoFeeTypeEnum>;
};

export type CustomInvoicePoByDayAndFeeTypeRuleInput = {
  dayGroups: Array<CustomInvoicePoDayGroupWithFeeShareInput>;
  feeTypes: Array<CustomInvoicePoFeeTypeEnum>;
};

/** PO by day of service: each charge gets the PO of the day group holding its weekday */
export type CustomInvoicePoByDayRule = {
  __typename?: 'CustomInvoicePoByDayRule';
  dayGroups: Array<CustomInvoicePoDayGroup>;
};

export type CustomInvoicePoByDayRuleInput = {
  dayGroups: Array<CustomInvoicePoDayGroupInput>;
};

export enum CustomInvoicePoDayEnum {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

/** Some weekdays and the PO they get */
export type CustomInvoicePoDayGroup = {
  __typename?: 'CustomInvoicePoDayGroup';
  days: Array<CustomInvoicePoDayEnum>;
  poValue?: Maybe<Scalars['String']['output']>;
};

export type CustomInvoicePoDayGroupInput = {
  days: Array<CustomInvoicePoDayEnum>;
  poValue?: InputMaybe<Scalars['String']['input']>;
};

/** Some weekdays, the PO they get, and the group's share of the split fees */
export type CustomInvoicePoDayGroupWithFeeShare = {
  __typename?: 'CustomInvoicePoDayGroupWithFeeShare';
  days: Array<CustomInvoicePoDayEnum>;
  feeShare: Scalars['BigDecimal']['output'];
  poValue?: Maybe<Scalars['String']['output']>;
};

export type CustomInvoicePoDayGroupWithFeeShareInput = {
  days: Array<CustomInvoicePoDayEnum>;
  feeShare: Scalars['BigDecimal']['input'];
  poValue?: InputMaybe<Scalars['String']['input']>;
};

export enum CustomInvoicePoFeeTypeEnum {
  ClientFee = 'CLIENT_FEE',
  FeeTax = 'FEE_TAX',
  OtherFee = 'OTHER_FEE'
}

/** One PO rule of an entity. Each type of rule has its own fields */
export type CustomInvoicePoRule = CustomInvoicePoByDayAndFeeTypeRule | CustomInvoicePoByDayRule;

/** One PO rule. Exactly one of its fields is set, naming the rule's type */
export type CustomInvoicePoRuleInput =
  { byDay: CustomInvoicePoByDayRuleInput; byDayAndFeeType?: never; }
  |  { byDay?: never; byDayAndFeeType: CustomInvoicePoByDayAndFeeTypeRuleInput; };

export type CustomInvoicePoSetupInput = {
  /** The PO for a charge that no rule places and no member's PO covers. An empty string is a real value */
  fallback: Scalars['String']['input'];
  /** Every member's own PO; a member left out has none */
  members: Array<CustomInvoiceMemberPoInput>;
  /** The entity's PO rule; empty removes it. An entity can have one PO by day of service rule */
  rules: Array<CustomInvoicePoRuleInput>;
};

/** A named custom invoice definition and the accounts, locations and parents it covers */
export type CustomInvoiceSettings = {
  __typename?: 'CustomInvoiceSettings';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  members: Array<CustomInvoiceSettingsMember>;
  name: Scalars['String']['output'];
  poFallback: Scalars['String']['output'];
  /** The entity's PO rules: at most one PO by day of service rule */
  poRules: Array<CustomInvoicePoRule>;
  poUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Who last changed the PO setup: the rule, members' POs or the fallback */
  poUpdatedByName?: Maybe<Scalars['String']['output']>;
  products: Array<ProductEnum>;
  splitAttributes: Array<CustomInvoiceSplitAttribute>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type CustomInvoiceSettingsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  members: Array<CustomInvoiceSettingsMemberInput>;
  name: Scalars['String']['input'];
  products: Array<ProductEnum>;
  splitAttributes?: InputMaybe<Array<CustomInvoiceSplitAttributeInput>>;
};

/** One account, location or account parent covered by a custom invoice entity */
export type CustomInvoiceSettingsMember = {
  __typename?: 'CustomInvoiceSettingsMember';
  /**
   * The account this member resolves to — its own for an account member, the
   * location's for a location member, null for an account parent
   */
  account?: Maybe<AccountOption>;
  accountId?: Maybe<Scalars['ID']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inactive: Scalars['Boolean']['output'];
  locationId?: Maybe<Scalars['ID']['output']>;
  memberType: CustomInvoiceMemberTypeEnum;
  parentCompanyId?: Maybe<Scalars['ID']['output']>;
  /** The member's own PO, if it has one */
  poValue?: Maybe<Scalars['String']['output']>;
  secondaryLine?: Maybe<Scalars['String']['output']>;
};

export type CustomInvoiceSettingsMemberInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  memberType: CustomInvoiceMemberTypeEnum;
  parentCompanyId?: InputMaybe<Scalars['ID']['input']>;
};

/** One split attribute on an invoice entity, in the order the admin arranged it */
export type CustomInvoiceSplitAttribute = {
  __typename?: 'CustomInvoiceSplitAttribute';
  type: CustomInvoiceSplitAttributeTypeEnum;
  value?: Maybe<Scalars['String']['output']>;
};

/** How many values a split attribute would divide an entity's activity by */
export type CustomInvoiceSplitAttributeCount = {
  __typename?: 'CustomInvoiceSplitAttributeCount';
  attributeType: CustomInvoiceSplitAttributeTypeEnum;
  blankGroup: Scalars['Boolean']['output'];
  count?: Maybe<Scalars['Int']['output']>;
  quality: CustomInvoiceSplitAttributeCountQualityEnum;
};

export enum CustomInvoiceSplitAttributeCountQualityEnum {
  Exact = 'EXACT',
  Unavailable = 'UNAVAILABLE',
  UpperBound = 'UPPER_BOUND'
}

export type CustomInvoiceSplitAttributeInput = {
  type: CustomInvoiceSplitAttributeTypeEnum;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum CustomInvoiceSplitAttributeTypeEnum {
  CateringEventName = 'CATERING_EVENT_NAME',
  ClientDefinedService = 'CLIENT_DEFINED_SERVICE',
  DayOfService = 'DAY_OF_SERVICE',
  DepartmentPo = 'DEPARTMENT_PO',
  Location = 'LOCATION',
  Product = 'PRODUCT',
  SubsidyProgram = 'SUBSIDY_PROGRAM'
}

/** A custom food item on a menu, created from the Point of Sale */
export type CustomPopupEventMenuItem = {
  __typename?: 'CustomPopupEventMenuItem';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** @deprecated Not used anymore */
  otherTaxCents: Scalars['BigDecimal']['output'];
  position: Scalars['Int']['output'];
  postTaxPriceCents: Scalars['Int']['output'];
  preTaxPriceCents: Scalars['BigDecimal']['output'];
  salesTaxCents: Scalars['BigDecimal']['output'];
  taxCategoryId?: Maybe<Scalars['Int']['output']>;
};

/** A user's food preference tag with a like/dislike weight */
export type CustomPreference = {
  __typename?: 'CustomPreference';
  /** Display name of the tag */
  name: Scalars['String']['output'];
  tag: InventoryItemExternalTags;
  weight: Scalars['Float']['output'];
};

export enum CustomerOrderPaymentMethodEnum {
  Card = 'CARD',
  Cash = 'CASH',
  Discount = 'DISCOUNT'
}

export type DailyFrequency = {
  __typename?: 'DailyFrequency';
  interval: Scalars['Int']['output'];
};

export enum DateRecurrence {
  DailyFrequency = 'DAILY_FREQUENCY',
  MonthlyByDayOfMonthFrequency = 'MONTHLY_BY_DAY_OF_MONTH_FREQUENCY',
  MonthlyByDayOfWeekFrequency = 'MONTHLY_BY_DAY_OF_WEEK_FREQUENCY',
  WeeklyFrequency = 'WEEKLY_FREQUENCY',
  YearlyFrequency = 'YEARLY_FREQUENCY'
}

export enum Day {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

/** Autogenerated return type of DeactivateAccountingSiteRole. */
export type DeactivateAccountingSiteRolePayload = {
  __typename?: 'DeactivateAccountingSiteRolePayload';
  error?: Maybe<OperationError>;
  roleType?: Maybe<AccountingSiteRoleType>;
};

export type DeclineMobileOrderingOrder = {
  id: Scalars['ID']['input'];
  version: Scalars['ID']['input'];
};

/** Autogenerated return type of DeclineMobileOrderingOrder. */
export type DeclineMobileOrderingOrderPayload = {
  __typename?: 'DeclineMobileOrderingOrderPayload';
  error?: Maybe<OperationError>;
  order?: Maybe<MobileOrderingOrder>;
};

/** Autogenerated return type of DeleteAccountAuthenticationDomainAssociation. */
export type DeleteAccountAuthenticationDomainAssociationPayload = {
  __typename?: 'DeleteAccountAuthenticationDomainAssociationPayload';
  error?: Maybe<OperationError>;
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteAccountPaymentCard = {
  /** Account payment method id of the card */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteAccountPaymentCard. */
export type DeleteAccountPaymentCardPayload = {
  __typename?: 'DeleteAccountPaymentCardPayload';
  card?: Maybe<AccountPaymentCard>;
  error?: Maybe<OperationError>;
};

export type DeleteCafeEventSchedule = {
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteCafeEventSchedule. */
export type DeleteCafeEventSchedulePayload = {
  __typename?: 'DeleteCafeEventSchedulePayload';
  cafeEventSchedule?: Maybe<EventSchedule>;
  error?: Maybe<OperationError>;
};

export type DeleteCafeEventScheduleStation = {
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteCafeEventScheduleStation. */
export type DeleteCafeEventScheduleStationPayload = {
  __typename?: 'DeleteCafeEventScheduleStationPayload';
  error?: Maybe<OperationError>;
};

export type DeleteCampaignUsers = {
  campaignId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of DeleteCampaignUsers. */
export type DeleteCampaignUsersPayload = {
  __typename?: 'DeleteCampaignUsersPayload';
  error?: Maybe<OperationError>;
  failedUsers?: Maybe<Array<User>>;
  removedUsers?: Maybe<Array<User>>;
};

/** Arguments to delete a card */
export type DeleteCard = {
  cardId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteCard. */
export type DeleteCardPayload = {
  __typename?: 'DeleteCardPayload';
  error?: Maybe<OperationError>;
};

export type DeleteCateringInventoryItem = {
  /** ID of the Catering Inventory Item */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteCateringInventoryItem. */
export type DeleteCateringInventoryItemPayload = {
  __typename?: 'DeleteCateringInventoryItemPayload';
  cateringInventoryItem?: Maybe<CateringInventoryItem>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of DeleteCustomInvoice. */
export type DeleteCustomInvoicePayload = {
  __typename?: 'DeleteCustomInvoicePayload';
  error?: Maybe<OperationError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteDeliveryInventoryItem = {
  /** ID of the Delivery Inventory Item */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteDeliveryInventoryItem. */
export type DeleteDeliveryInventoryItemPayload = {
  __typename?: 'DeleteDeliveryInventoryItemPayload';
  deliveryInventoryItem?: Maybe<DeliveryInventoryItem>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of DeleteDeliveryVendorMarketCapacity. */
export type DeleteDeliveryVendorMarketCapacityPayload = {
  __typename?: 'DeleteDeliveryVendorMarketCapacityPayload';
  error?: Maybe<OperationError>;
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type DeletePopupInventoryItem = {
  /** ID of the Popup Inventory Item */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeletePopupInventoryItem. */
export type DeletePopupInventoryItemPayload = {
  __typename?: 'DeletePopupInventoryItemPayload';
  error?: Maybe<OperationError>;
  popupInventoryItem?: Maybe<PopupInventoryItem>;
};

export type DeletePopupMenuTemplateCategoryGroup = {
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeletePopupMenuTemplateCategoryGroup. */
export type DeletePopupMenuTemplateCategoryGroupPayload = {
  __typename?: 'DeletePopupMenuTemplateCategoryGroupPayload';
  error?: Maybe<OperationError>;
};

export type DeletePopupMenuTemplateSelectionGroup = {
  selectionGroupId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeletePopupMenuTemplateSelectionGroup. */
export type DeletePopupMenuTemplateSelectionGroupPayload = {
  __typename?: 'DeletePopupMenuTemplateSelectionGroupPayload';
  error?: Maybe<OperationError>;
};

/** Delete Report Configuration input */
export type DeleteReportConfigurationInput = {
  /** ID of the Report Configuration */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteReportConfigurationQuery. */
export type DeleteReportConfigurationQueryPayload = {
  __typename?: 'DeleteReportConfigurationQueryPayload';
  error?: Maybe<OperationError>;
  reportConfiguration?: Maybe<ReportConfigurations>;
};

export type DeleteSelectEventVendor = {
  selectEventVendorId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteSelectEventVendor. */
export type DeleteSelectEventVendorPayload = {
  __typename?: 'DeleteSelectEventVendorPayload';
  error?: Maybe<OperationError>;
  selectEventVendor?: Maybe<SelectEventVendor>;
};

/** Arguments to delete a session */
export type DeleteSession = {
  password?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

/** Autogenerated return type of DeleteSession. */
export type DeleteSessionPayload = {
  __typename?: 'DeleteSessionPayload';
  error?: Maybe<OperationError>;
};

/** Arguments to delete a subsidy rule */
export type DeleteSubsidyRule = {
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteSubsidyRule. */
export type DeleteSubsidyRulePayload = {
  __typename?: 'DeleteSubsidyRulePayload';
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of DeleteTenderMethod. */
export type DeleteTenderMethodPayload = {
  __typename?: 'DeleteTenderMethodPayload';
  error?: Maybe<OperationError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated return type of DeleteUserNote. */
export type DeleteUserNotePayload = {
  __typename?: 'DeleteUserNotePayload';
  error?: Maybe<OperationError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeliveryEventDetail = EventDetail & {
  __typename?: 'DeliveryEventDetail';
  /**
   * When the food arrives, falling back to the ordering window opening when no
   * delivery time is set yet. Unlike deliveryTime this is never null, so it is
   * safe to sort or group on
   */
  deliveryStartTime: Scalars['ISO8601DateTime']['output'];
  deliveryTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deliveryWindow: DeliveryWindow;
  endTime: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** All locations associated with the event */
  locations: Array<LocationPublic>;
  readyAndBaggedTime: Scalars['ISO8601DateTime']['output'];
  restaurants: Array<DeliveryRestaurant>;
  startTime: Scalars['ISO8601DateTime']['output'];
  status: EventStatus;
  /** Rails TimeZone name, e.g. 'Central Time (US & Canada)' */
  timezone: Scalars['String']['output'];
};

/** A category of items on a delivery menu, eg. 'entrees', 'sides' */
export type DeliveryEventMenuCategoryGroup = {
  __typename?: 'DeliveryEventMenuCategoryGroup';
  id: Scalars['ID']['output'];
  items: Array<DeliveryEventMenuItem>;
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
};

/** A food item on a delivery menu */
export type DeliveryEventMenuItem = {
  __typename?: 'DeliveryEventMenuItem';
  description?: Maybe<Scalars['String']['output']>;
  /** Dietary Preferences and Allergens and Sensitivities of the item */
  dietaryInfo: MenuItemDietaryInfo;
  /** Legacy dietary restriction tag names (e.g. Vegan, Gluten-Free), the labels the web menu shows and filters on */
  dietaryRestrictions: Array<Scalars['String']['output']>;
  disallowWriteIn?: Maybe<Scalars['Boolean']['output']>;
  /** InventoryItem id, the REST cart's item_id */
  id: Scalars['ID']['output'];
  /** Photo URLs, default photo first; a placeholder takes its place when the item has no default photo */
  images: Array<Scalars['String']['output']>;
  /** SelectEventMenuItem id, the web item page's :id */
  menuItemId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  /** Pre-tax price in cents. Tax and subsidy are applied in the cart. */
  preTaxPriceCents: Scalars['BigDecimal']['output'];
  /** Special instructions from that same order */
  previousCustomization?: Maybe<Scalars['String']['output']>;
  /**
   * The signed-in user's picks from their latest completed order with this item.
   * Loaded for every item in one lookup, and only when requested.
   */
  previousSelection?: Maybe<DeliveryEventMenuItemPreviousSelection>;
  selectionGroups?: Maybe<Array<DeliveryEventMenuItemSelectionGroup>>;
};

/** Previously selected options, as in the REST menu's previous customizations */
export type DeliveryEventMenuItemPreviousSelection = {
  __typename?: 'DeliveryEventMenuItemPreviousSelection';
  /** InventoryItem ids of the picked options */
  options: Array<Scalars['ID']['output']>;
  /** InventoryItem ids of the picked side options */
  sideOptions: Array<Scalars['ID']['output']>;
};

/** A selection group for a delivery menu item, eg. 'Choose a side' */
export type DeliveryEventMenuItemSelectionGroup = {
  __typename?: 'DeliveryEventMenuItemSelectionGroup';
  id: Scalars['ID']['output'];
  /** Maximum number of picks; the number of options when the group is unlimited */
  maxSelections: Scalars['Int']['output'];
  /** Minimum number of picks; 0 when the group is optional */
  minSelections: Scalars['Int']['output'];
  namePublic: Scalars['String']['output'];
  /** Ingredient choices; picks go in the cart's options. Null for a side group. */
  options?: Maybe<Array<DeliveryEventMenuItemSelectionGroupOption>>;
  /** Side items; picks go in the cart's side_options. Null for an ingredient group. */
  sideOptions?: Maybe<Array<DeliveryEventMenuItemSelectionGroupOption>>;
};

/** An option for a delivery selection group, eg. 'Side salad' */
export type DeliveryEventMenuItemSelectionGroupOption = {
  __typename?: 'DeliveryEventMenuItemSelectionGroupOption';
  /**
   * Dietary Preferences and Allergens and Sensitivities of the option, same shape
   * as items. Modifier rows display only allergens with status CONTAINS; filter on status.
   */
  dietaryInfo: MenuItemDietaryInfo;
  /** InventoryItemsOptionGroup id; goes in the REST cart's options or side_options */
  id: Scalars['ID']['output'];
  /** InventoryItem id; matches the ids in previousSelection */
  inventoryItemId: Scalars['ID']['output'];
  namePublic: Scalars['String']['output'];
  /** Price in cents. The cart charges this unless premiumPreTaxPriceCents is set. */
  preTaxPriceCents: Scalars['BigDecimal']['output'];
  /**
   * Premium price in cents. When set, the cart charges this instead of preTaxPriceCents.
   * Null when the option has no premium price.
   */
  premiumPreTaxPriceCents?: Maybe<Scalars['BigDecimal']['output']>;
};

export type DeliveryEventPublic = PublicEvent & {
  __typename?: 'DeliveryEventPublic';
  account: AccountPublic;
  defaultTileImageUrl: Scalars['String']['output'];
  /**
   * When the food arrives, falling back to the ordering window opening when no
   * delivery time is set yet. Unlike deliveryTime this is never null, so it is
   * safe to sort or group on
   */
  deliveryStartTime: Scalars['ISO8601DateTime']['output'];
  deliveryTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deliveryWindow: DeliveryWindow;
  endTime: Scalars['ISO8601DateTime']['output'];
  healthscoreLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** First location associated with the event, if any */
  location?: Maybe<LocationPublic>;
  /** All delivery drop points associated with the event */
  locations: Array<LocationPublic>;
  mealPeriod: MealPeriodEnum;
  readyAndBaggedTime: Scalars['ISO8601DateTime']['output'];
  restaurants: Array<DeliveryRestaurant>;
  startTime: Scalars['ISO8601DateTime']['output'];
  status: EventStatus;
  /**
   * Subsidy headline for the signed-in user, as shown in the delivery section.
   * Null when no user is signed in or no subsidy applies.
   */
  subsidyHeadline?: Maybe<Scalars['String']['output']>;
  /** Rails TimeZone name, e.g. 'Central Time (US & Canada)' */
  timezone: Scalars['String']['output'];
  url: Scalars['String']['output'];
  /**
   * The signed-in user's orders for this event, canceled ones included.
   * Null when no user is signed in.
   */
  userOrders?: Maybe<Array<DeliveryOrderDetails>>;
};

/** Menu item details for a delivery recommendation */
export type DeliveryEventRecommendationMenuItem = RecommendationMenuItem & {
  __typename?: 'DeliveryEventRecommendationMenuItem';
  /** The id to open the item page with. */
  deliveryEventMenuItemId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** True when the item has options, so the options form is needed instead of adding directly. */
  hasOptions: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  images: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Price the user pays. Subsidy-aware where the product supports item-level subsidy. */
  priceCents: Scalars['Int']['output'];
  tags: Array<Scalars['String']['output']>;
};

/** A restaurant's customer menu at a delivery event. */
export type DeliveryEventVendorMenu = {
  __typename?: 'DeliveryEventVendorMenu';
  eventVendorId: Scalars['ID']['output'];
  menuGroups: Array<DeliveryEventMenuCategoryGroup>;
  /** Null while the restaurant has delivery capacity; otherwise whether to show it as sold out or hide it */
  soldOutState?: Maybe<SoldOutRestaurantEnum>;
};

/** An inventory item for delivery events */
export type DeliveryInventoryItem = {
  __typename?: 'DeliveryInventoryItem';
  capacityExempt: Scalars['Boolean']['output'];
  cogs: Scalars['BigDecimal']['output'];
  cogsCents: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  destroyable: Scalars['Boolean']['output'];
  /** Dietary Preferences and Allergens and Sensitivities of the item */
  dietaryInfo: MenuItemDietaryInfo;
  dietaryRestrictions: Array<InventoryItemDietaryRestrictions>;
  disallowWriteIn?: Maybe<Scalars['Boolean']['output']>;
  eligibleForAddOns: Scalars['Boolean']['output'];
  externalTags: Array<InventoryItemExternalTags>;
  foodaSku: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use image_url */
  image?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  internalTags: Array<InventoryItemInternalTags>;
  mealType: InventoryItemMealType;
  nameForVendor: Scalars['String']['output'];
  namePublic: Scalars['String']['output'];
  premiumSellPrice: Scalars['BigDecimal']['output'];
  premiumSellPriceCents: Scalars['Int']['output'];
  prepLine: Scalars['Int']['output'];
  readonlyFields?: Maybe<Array<Scalars['String']['output']>>;
  sellPrice: Scalars['BigDecimal']['output'];
  sellPriceCents: Scalars['Int']['output'];
  showOnMenu: Scalars['Boolean']['output'];
  signatureItem: Scalars['Boolean']['output'];
  taxCategoryId?: Maybe<Scalars['Int']['output']>;
  temperatureClassification: InventoryItemTemperatureClassification;
  useAsInventoryItemOption: Scalars['Boolean']['output'];
};

/** Brief details of a Delivery Order for Activity Stream */
export type DeliveryOrder = {
  __typename?: 'DeliveryOrder';
  /** ISO8601 DateTime of when order was canceled */
  canceledDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Delivery state and times for order history. Null for canceled orders */
  deliveryTiming?: Maybe<DeliveryTiming>;
  /** Names of items sold */
  itemNames: Array<Scalars['String']['output']>;
  /** ISO8601 DateTime of when order was placed */
  orderFulfilledTime: Scalars['ISO8601DateTime']['output'];
  /** Time order was placed in unix seconds format */
  orderFulfilledTimeUnix: Scalars['Int']['output'];
  /** Top level item names on an order (excludes modifiers) */
  parentItemNames: Array<Scalars['String']['output']>;
  /** Amount customer paid */
  paymentCents: Scalars['Int']['output'];
  /** Unique ID of order */
  requestId: Scalars['ID']['output'];
  /** Names of vendors with sales on order */
  vendorNames: Array<Scalars['String']['output']>;
};

/** Full details of a delivery order */
export type DeliveryOrderDetails = {
  __typename?: 'DeliveryOrderDetails';
  accountName: Scalars['String']['output'];
  /** ISO8601 DateTime of when order was canceled */
  canceledDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  cancellable: Scalars['Boolean']['output'];
  /** Delivery state and times for order history. Null for canceled orders */
  deliveryTiming?: Maybe<DeliveryTiming>;
  /** Discounts on order */
  discounts: Array<DiscountLineItem>;
  /** ISO8601 DateTime of when the event drop off time is scheduled */
  eventDropOffTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** URL to the event page */
  eventPath?: Maybe<Scalars['String']['output']>;
  /** Pretty ID of the event */
  eventPrettyId?: Maybe<Scalars['String']['output']>;
  /** Fees on order */
  fees: Array<FeeLineItem>;
  /** Food sold */
  items?: Maybe<Array<DeliveryOrderItem>>;
  /** Location of delivery */
  location?: Maybe<Location>;
  /** ISO8601 DateTime of when order was delivered */
  orderFulfilledTime: Scalars['ISO8601DateTime']['output'];
  /** Time order was delivered in unix seconds format */
  orderFulfilledTimeUnix: Scalars['Int']['output'];
  /** URL to the order page */
  orderPath?: Maybe<Scalars['String']['output']>;
  /** ISO8601 DateTime of when order was placed */
  orderTime: Scalars['ISO8601DateTime']['output'];
  /** Time order was placed in unix seconds format */
  orderTimeUnix: Scalars['Int']['output'];
  /** Refunds of payments on order */
  paymentRefunds: Array<PaymentRefundLineItem>;
  /** Details of card payments */
  paymentTransaction: Array<PaymentTransaction>;
  /** Payments on order */
  payments: Array<PaymentLineItem>;
  /** Pretty ID of order */
  prettyId?: Maybe<Scalars['String']['output']>;
  /** Unique ID of order */
  requestId: Scalars['ID']['output'];
  /** Order subtotal */
  subtotalAmountCents: Scalars['Int']['output'];
  /** Order tax total */
  taxAmountCents: Scalars['Int']['output'];
  /** Order total */
  totalAmountCents: Scalars['Int']['output'];
  /** Order total commission */
  totalCommissionCents?: Maybe<Scalars['Int']['output']>;
  /** User facing status of the order */
  userFacingStatus?: Maybe<Scalars['String']['output']>;
  /** Vendors with food sales in order */
  vendors: Array<Vendor>;
};

/** The connection type for DeliveryOrderDetails. */
export type DeliveryOrderDetailsConnection = {
  __typename?: 'DeliveryOrderDetailsConnection';
  currentPage: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeliveryOrderDetailsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DeliveryOrderDetails>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeliveryOrderDetailsEdge = {
  __typename?: 'DeliveryOrderDetailsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeliveryOrderDetails>;
};

/** Details of food sales on a delivery order */
export type DeliveryOrderItem = {
  __typename?: 'DeliveryOrderItem';
  /** ID of menu item */
  id: Scalars['ID']['output'];
  /** Name of item */
  name: Scalars['String']['output'];
  /** Modifier for order */
  options?: Maybe<Array<DeliveryOrderItem>>;
  /** ID of this line on the order. Null when the line cannot be refunded */
  orderItemId?: Maybe<Scalars['ID']['output']>;
  /** Price of item */
  priceCents: Scalars['Int']['output'];
  /** Quantity sold. Probably 1. */
  quantity: Scalars['Int']['output'];
  /** Flag of if item was refunded */
  refunded?: Maybe<Scalars['Boolean']['output']>;
  /** Additions/exclusions for the item */
  specialInstructions?: Maybe<Scalars['String']['output']>;
  /** ID of vendor of item */
  vendorId: Scalars['ID']['output'];
};

/** Party that carries the cost of a delivery order refund */
export enum DeliveryRefundPartyAtFaultEnum {
  /** The courier that delivered the order */
  DeliveryVendor = 'DELIVERY_VENDOR',
  /** Fooda */
  Fooda = 'FOODA',
  /** The restaurant that sold the item */
  Vendor = 'VENDOR'
}

/** Reason recorded against a delivery order refund */
export enum DeliveryRefundReasonEnum {
  CustomizationNotFollowed = 'CUSTOMIZATION_NOT_FOLLOWED',
  FoodQuality = 'FOOD_QUALITY',
  LateOrder = 'LATE_ORDER',
  MissingItems = 'MISSING_ITEMS',
  WrongItem = 'WRONG_ITEM'
}

export type DeliveryRestaurant = {
  __typename?: 'DeliveryRestaurant';
  cuisines?: Maybe<Array<Scalars['String']['output']>>;
  defaultCuisine?: Maybe<Scalars['String']['output']>;
  essenceImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Path of the customer menu page, filtered to this restaurant */
  menuUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  soldOutState?: Maybe<SoldOutRestaurantEnum>;
  vendorId: Scalars['ID']['output'];
};

export type DeliverySchedulingConstraint = {
  __typename?: 'DeliverySchedulingConstraint';
  id: Scalars['ID']['output'];
  marketManifestTime: MarketManifestTimeCapacity;
  markets: Array<Scalars['String']['output']>;
  minManifestPerMonth: Scalars['Int']['output'];
  vendor: Scalars['String']['output'];
  vendorId: Scalars['ID']['output'];
};

/** When a delivery order arrives, as order history shows it */
export type DeliveryTiming = {
  __typename?: 'DeliveryTiming';
  /**
   * When the arrival email for the last restaurant was sent, resends included.
   * Null while delivering, and when the confirmation wait passed before every
   * restaurant arrived
   */
  deliveredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Scheduled delivery time */
  deliveryTime: Scalars['ISO8601DateTime']['output'];
  /** Whether the order is still on its way */
  state: DeliveryTimingState;
  /**
   * IANA identifier, e.g. 'America/Chicago'. deliveredAt, deliveryTime and window
   * already carry this zone's offset; this names the zone so it can be shown alongside them
   */
  timezone: Scalars['String']['output'];
  /** Delivery time ± 15 minutes, only while delivering */
  window?: Maybe<DeliveryWindow>;
};

/** Whether a delivery order in order history is still on its way */
export enum DeliveryTimingState {
  /** Every restaurant on the order has arrived, or the delivery confirmation wait has passed */
  Delivered = 'DELIVERED',
  /** A restaurant on the order has not arrived yet and the delivery confirmation wait has not passed */
  Delivering = 'DELIVERING'
}

export type DeliveryVendorMenuItem = VendorMenuItem & {
  __typename?: 'DeliveryVendorMenuItem';
  category?: Maybe<VendorMenuCategory>;
  /** The id of the image the item shows, as the seen value of an image edit. Null for no image, and for non-delivery items. */
  currentImageRef?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Dietary restriction/allergen labels (e.g. Contains Nuts, Vegan). */
  dietaryRestrictions: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** All item image URLs, for the larger-format image modal. */
  images: Array<Scalars['String']['output']>;
  /** The item's type, as the seen value of an item type edit. Null for non-delivery items. */
  itemType?: Maybe<InventoryItemMealType>;
  nameForVendor: Scalars['String']['output'];
  namePublic: Scalars['String']['output'];
  optionGroups: Array<VendorMenuOptionGroup>;
  /**
   * The vendor's other delivery menus that carry this item, so an edit that
   * reaches them can be shown. Empty for non-delivery items.
   */
  otherMenus: Array<MenuChangeOtherMenu>;
  /** Restaurant pre-tax price in cents (may be sub-cent), resolved per product type. Null for menu-level priced catering. */
  preTaxPriceCents?: Maybe<Scalars['BigDecimal']['output']>;
  /** First image, or a placeholder when the item has no image. */
  primaryImageUrl: Scalars['String']['output'];
  /**
   * The tax category the item is charged under, as the seen value of a tax
   * category edit: its own, or the global default when it has none. Null for
   * non-delivery items.
   */
  taxCategoryId?: Maybe<Scalars['ID']['output']>;
  /** Whether the item can be used as an option, as the seen value of a usable-as-option edit. Null for non-delivery items. */
  usableAsOption?: Maybe<Scalars['Boolean']['output']>;
  /**
   * True when the item is also used on a non-draft, non-expired popup or catering
   * menu. FFR shows the item, its option groups and their options locked, and
   * edits to them are refused with ITEM_USED_OUTSIDE_DELIVERY; removing it from
   * this menu is still allowed. Null for non-delivery items.
   */
  usedOutsideDelivery?: Maybe<Scalars['Boolean']['output']>;
};

export type DeliveryVendorMenuOption = VendorMenuOption & {
  __typename?: 'DeliveryVendorMenuOption';
  /** Dietary restriction/allergen labels of the option's inventory item (e.g. Contains Soy). */
  dietaryRestrictions: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The option's item type, as the seen value of an item type edit. Null for popup options. */
  itemType?: Maybe<InventoryItemMealType>;
  nameForVendor: Scalars['String']['output'];
  namePublic: Scalars['String']['output'];
  /** Restaurant pre-tax incremental price for this option, in cents (may be sub-cent). */
  preTaxPriceCents?: Maybe<Scalars['BigDecimal']['output']>;
  /**
   * The tax category the option is charged under, as the seen value of a tax
   * category edit: its own, or the global default when it has none. Null for popup options.
   */
  taxCategoryId?: Maybe<Scalars['ID']['output']>;
  /** The number of option groups that use this option. Always 0 for popup options. */
  usedInGroupsCount: Scalars['Int']['output'];
  /**
   * True when the option is also used on a non-draft, non-expired popup or
   * catering menu. FFR shows it locked, and an edit to it is refused with
   * OPTION_USED_OUTSIDE_DELIVERY. Null for popup options.
   */
  usedOutsideDelivery?: Maybe<Scalars['Boolean']['output']>;
};

export type DeliveryVendorMenuTemplate = VendorMenuTemplate & {
  __typename?: 'DeliveryVendorMenuTemplate';
  /** Whether the signed-in manager can edit this menu in FFR. */
  canEditInFfr: Scalars['Boolean']['output'];
  categories: Array<VendorMenuCategory>;
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Why canEditInFfr is false, for the disabled "Edit menu" reason. Null when the menu can be edited. */
  ffrEditBlockedReason?: Maybe<MenuChangeEditBlockedReason>;
  id: Scalars['ID']['output'];
  /** Top-level menu items (options excluded), ordered by category then position; 25 per page. */
  items: VendorMenuItemConnection;
  mealPeriods: Array<MealPeriodEnum>;
  name?: Maybe<Scalars['String']['output']>;
  /** The menu change request waiting for a decision, which locks FFR submits to this template. */
  pendingChangeRequest?: Maybe<MenuChangeRequest>;
  productType: ProductEnum;
  /** True when the template or any of its items changed within the last 2 weeks. */
  recentlyUpdated: Scalars['Boolean']['output'];
  startDate: Scalars['ISO8601DateTime']['output'];
  state: MenuTemplateStateEnum;
  /** Latest of the template's own change and its items' changes. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type DeliveryVendorMenuTemplateItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type DeliveryWindow = {
  __typename?: 'DeliveryWindow';
  endTime: Scalars['ISO8601DateTime']['output'];
  startTime: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated return type of DestroyAccountingSiteOwner. */
export type DestroyAccountingSiteOwnerPayload = {
  __typename?: 'DestroyAccountingSiteOwnerPayload';
  error?: Maybe<OperationError>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type DetailedFeedback = {
  __typename?: 'DetailedFeedback';
  actionBreakdown: Array<ActionBreakdown>;
  modelId: Scalars['ID']['output'];
  timeSeriesData: Array<TimeSeriesDataPoint>;
  totalInteractions: Scalars['Int']['output'];
};

export type DeviceAttributes = {
  deviceId: Scalars['String']['input'];
  deviceName: Scalars['String']['input'];
  devicePlatform: Scalars['String']['input'];
  osVersion: Scalars['String']['input'];
};

/** Dietary Preferences */
export enum DietaryPreferenceCode {
  /** Gluten-Free */
  GlutenFree = 'GLUTEN_FREE',
  /** Halal */
  Halal = 'HALAL',
  /** Kosher */
  Kosher = 'KOSHER',
  /** Pescatarian */
  Pescatarian = 'PESCATARIAN',
  /** Vegan */
  Vegan = 'VEGAN',
  /** Vegetarian */
  Vegetarian = 'VEGETARIAN'
}

/** A Dietary Preference customers can filter menus by */
export type DietaryPreferenceDefinition = {
  __typename?: 'DietaryPreferenceDefinition';
  code: DietaryPreferenceCode;
  /** Display name, e.g. Gluten-Free */
  name: Scalars['String']['output'];
};

/** How an item answers a Dietary Preference */
export enum DietaryPreferenceStatus {
  No = 'NO',
  /** Not answered yet */
  Unknown = 'UNKNOWN',
  Yes = 'YES'
}

/** A Discount LineItem for orders */
export type DiscountLineItem = {
  __typename?: 'DiscountLineItem';
  amountCents: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayAmount: Scalars['BigDecimal']['output'];
  displayAmountCents: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  lineItemType: DiscountLineItemTypeEnum;
};

export enum DiscountLineItemTypeEnum {
  CashierDiscount = 'CASHIER_DISCOUNT',
  Coupon = 'COUPON',
  DeliveryFeeSubsidy = 'DELIVERY_FEE_SUBSIDY',
  DeliveryTaxSubsidy = 'DELIVERY_TAX_SUBSIDY',
  InvalidCoupon = 'INVALID_COUPON',
  InvalidSubsidy = 'INVALID_SUBSIDY',
  InvalidTenderMethod = 'INVALID_TENDER_METHOD',
  InvalidVoucher = 'INVALID_VOUCHER',
  ItemSubsidy = 'ITEM_SUBSIDY',
  Promotion = 'PROMOTION',
  RewardRedemption = 'REWARD_REDEMPTION',
  Subsidy = 'SUBSIDY',
  TenderMethod = 'TENDER_METHOD',
  Voucher = 'VOUCHER',
  VoucherChange = 'VOUCHER_CHANGE'
}

/** A Discount Refund LineItem for orders */
export type DiscountRefundLineItem = {
  __typename?: 'DiscountRefundLineItem';
  amountCents: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayAmount: Scalars['BigDecimal']['output'];
  displayAmountCents: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  lineItemType: DiscountRefundLineItemTypeEnum;
};

export enum DiscountRefundLineItemTypeEnum {
  CashierDiscountRefund = 'CASHIER_DISCOUNT_REFUND',
  CouponRefund = 'COUPON_REFUND',
  DeliveryFeeSubsidyRefund = 'DELIVERY_FEE_SUBSIDY_REFUND',
  DeliveryTaxSubsidyRefund = 'DELIVERY_TAX_SUBSIDY_REFUND',
  InvalidCouponRefund = 'INVALID_COUPON_REFUND',
  InvalidSubsidyRefund = 'INVALID_SUBSIDY_REFUND',
  InvalidTenderMethodRefund = 'INVALID_TENDER_METHOD_REFUND',
  InvalidVoucherRefund = 'INVALID_VOUCHER_REFUND',
  ItemSubsidyRefund = 'ITEM_SUBSIDY_REFUND',
  RewardRedemptionRefund = 'REWARD_REDEMPTION_REFUND',
  SubsidyRefund = 'SUBSIDY_REFUND',
  TenderMethodRefund = 'TENDER_METHOD_REFUND',
  VoucherRefund = 'VOUCHER_REFUND'
}

/** Result of a backtest discovery scan */
export type DiscoveryResult = {
  __typename?: 'DiscoveryResult';
  /** UUID identifying this backtest discovery */
  backtestId: Scalars['ID']['output'];
  /** Number of users with enough order history */
  eligibleUserCount: Scalars['Int']['output'];
  /** Users that were not eligible with reasons */
  ineligibleUsers: Array<IneligibleUser>;
  /** Per-user preview of selected test cases */
  perUser: Array<UserPreview>;
  /** Number of test cases selected after distribution */
  selectedCount: Scalars['Int']['output'];
};

export enum DomainEnum {
  /** AccountingSite Domain */
  AccountingSite = 'ACCOUNTING_SITE',
  /** AccountingSiteOwnership Domain */
  AccountingSiteOwnership = 'ACCOUNTING_SITE_OWNERSHIP',
  /** AccountingSiteRoleType Domain */
  AccountingSiteRoleType = 'ACCOUNTING_SITE_ROLE_TYPE',
  /** AccountingSiteType Domain */
  AccountingSiteType = 'ACCOUNTING_SITE_TYPE',
  /** AccountAccountingSite Domain */
  AccountAccountingSite = 'ACCOUNT_ACCOUNTING_SITE',
  /** AccountCateringActivePaymentMethod Domain */
  AccountCateringActivePaymentMethod = 'ACCOUNT_CATERING_ACTIVE_PAYMENT_METHOD',
  /** AccountCateringAdmin Domain */
  AccountCateringAdmin = 'ACCOUNT_CATERING_ADMIN',
  /** AccountCateringBillingConfigEmailSend Domain */
  AccountCateringBillingConfigEmailSend = 'ACCOUNT_CATERING_BILLING_CONFIG_EMAIL_SEND',
  /** AccountCateringBillingConfigPreferences Domain */
  AccountCateringBillingConfigPreferences = 'ACCOUNT_CATERING_BILLING_CONFIG_PREFERENCES',
  /** AccountCateringFinanceBillingConfig Domain */
  AccountCateringFinanceBillingConfig = 'ACCOUNT_CATERING_FINANCE_BILLING_CONFIG',
  /** AccountCateringInvoiceNote Domain */
  AccountCateringInvoiceNote = 'ACCOUNT_CATERING_INVOICE_NOTE',
  /** AccountCollectionEmail Domain */
  AccountCollectionEmail = 'ACCOUNT_COLLECTION_EMAIL',
  /** AccountCommissions Domain */
  AccountCommissions = 'ACCOUNT_COMMISSIONS',
  /** AccountConnectedAccounts Domain */
  AccountConnectedAccounts = 'ACCOUNT_CONNECTED_ACCOUNTS',
  /** AccountConsolidateEmailsbyProduct Domain */
  AccountConsolidateEmailsbyProduct = 'ACCOUNT_CONSOLIDATE_EMAILSBY_PRODUCT',
  /** AccountConstraint Domain */
  AccountConstraint = 'ACCOUNT_CONSTRAINT',
  /** AccountCreditStatus Domain */
  AccountCreditStatus = 'ACCOUNT_CREDIT_STATUS',
  /** AccountCustomInvoice Domain */
  AccountCustomInvoice = 'ACCOUNT_CUSTOM_INVOICE',
  /** AccountCustomInvoicePoRules Domain */
  AccountCustomInvoicePoRules = 'ACCOUNT_CUSTOM_INVOICE_PO_RULES',
  /** AccountCustomInvoiceSettings Domain */
  AccountCustomInvoiceSettings = 'ACCOUNT_CUSTOM_INVOICE_SETTINGS',
  /** AccountDataProcessingRole Domain */
  AccountDataProcessingRole = 'ACCOUNT_DATA_PROCESSING_ROLE',
  /** AccountDeliveryActivePaymentMethod Domain */
  AccountDeliveryActivePaymentMethod = 'ACCOUNT_DELIVERY_ACTIVE_PAYMENT_METHOD',
  /** AccountDeliveryAdmin Domain */
  AccountDeliveryAdmin = 'ACCOUNT_DELIVERY_ADMIN',
  /** AccountDeliveryBillingConfigEmailSend Domain */
  AccountDeliveryBillingConfigEmailSend = 'ACCOUNT_DELIVERY_BILLING_CONFIG_EMAIL_SEND',
  /** AccountDeliveryBillingConfigPreferences Domain */
  AccountDeliveryBillingConfigPreferences = 'ACCOUNT_DELIVERY_BILLING_CONFIG_PREFERENCES',
  /** AccountDeliveryFinanceBillingConfig Domain */
  AccountDeliveryFinanceBillingConfig = 'ACCOUNT_DELIVERY_FINANCE_BILLING_CONFIG',
  /** AccountDeliveryInvoiceNote Domain */
  AccountDeliveryInvoiceNote = 'ACCOUNT_DELIVERY_INVOICE_NOTE',
  /** AccountDeliveryPromos Domain */
  AccountDeliveryPromos = 'ACCOUNT_DELIVERY_PROMOS',
  /** AccountDomainAssociation Domain */
  AccountDomainAssociation = 'ACCOUNT_DOMAIN_ASSOCIATION',
  /** AccountEventSchedulesCafe Domain */
  AccountEventSchedulesCafe = 'ACCOUNT_EVENT_SCHEDULES_CAFE',
  /** AccountFinancePayment Domain */
  AccountFinancePayment = 'ACCOUNT_FINANCE_PAYMENT',
  /** AccountGuestPassCreation Domain */
  AccountGuestPassCreation = 'ACCOUNT_GUEST_PASS_CREATION',
  /** AccountInvoicesPreview Domain */
  AccountInvoicesPreview = 'ACCOUNT_INVOICES_PREVIEW',
  /** AccountInvoiceDetailedReport Domain */
  AccountInvoiceDetailedReport = 'ACCOUNT_INVOICE_DETAILED_REPORT',
  /** AccountInvoiceSummaryReport Domain */
  AccountInvoiceSummaryReport = 'ACCOUNT_INVOICE_SUMMARY_REPORT',
  /** AccountLocationsCafe Domain */
  AccountLocationsCafe = 'ACCOUNT_LOCATIONS_CAFE',
  /** AccountManager Domain */
  AccountManager = 'ACCOUNT_MANAGER',
  /** AccountMembershipBillingAdmin Domain */
  AccountMembershipBillingAdmin = 'ACCOUNT_MEMBERSHIP_BILLING_ADMIN',
  /** AccountMembershipEnrollment Domain */
  AccountMembershipEnrollment = 'ACCOUNT_MEMBERSHIP_ENROLLMENT',
  /** AccountMinSalesGuarantee Domain */
  AccountMinSalesGuarantee = 'ACCOUNT_MIN_SALES_GUARANTEE',
  /** AccountMobileOrderingFlag Domain */
  AccountMobileOrderingFlag = 'ACCOUNT_MOBILE_ORDERING_FLAG',
  /** AccountNames Domain */
  AccountNames = 'ACCOUNT_NAMES',
  /** AccountPantryReporting Domain */
  AccountPantryReporting = 'ACCOUNT_PANTRY_REPORTING',
  /** AccountParent Domain */
  AccountParent = 'ACCOUNT_PARENT',
  /** AccountPaymentMethods Domain */
  AccountPaymentMethods = 'ACCOUNT_PAYMENT_METHODS',
  /** AccountPopupActivePaymentMethod Domain */
  AccountPopupActivePaymentMethod = 'ACCOUNT_POPUP_ACTIVE_PAYMENT_METHOD',
  /** AccountPopupBillingConfigEmailSend Domain */
  AccountPopupBillingConfigEmailSend = 'ACCOUNT_POPUP_BILLING_CONFIG_EMAIL_SEND',
  /** AccountPopupBillingConfigPreferences Domain */
  AccountPopupBillingConfigPreferences = 'ACCOUNT_POPUP_BILLING_CONFIG_PREFERENCES',
  /** AccountPopupFinanceBilling Domain */
  AccountPopupFinanceBilling = 'ACCOUNT_POPUP_FINANCE_BILLING',
  /** AccountPopupFinanceBillingConfig Domain */
  AccountPopupFinanceBillingConfig = 'ACCOUNT_POPUP_FINANCE_BILLING_CONFIG',
  /** AccountPopupFinanceConfig Domain */
  AccountPopupFinanceConfig = 'ACCOUNT_POPUP_FINANCE_CONFIG',
  /** AccountPopupInvoiceNote Domain */
  AccountPopupInvoiceNote = 'ACCOUNT_POPUP_INVOICE_NOTE',
  /** AccountProductStatusAccounting Domain */
  AccountProductStatusAccounting = 'ACCOUNT_PRODUCT_STATUS_ACCOUNTING',
  /** AccountProductStatusCompliance Domain */
  AccountProductStatusCompliance = 'ACCOUNT_PRODUCT_STATUS_COMPLIANCE',
  /** AccountPurchaseVouchers Domain */
  AccountPurchaseVouchers = 'ACCOUNT_PURCHASE_VOUCHERS',
  /** AccountReportEmbedded Domain */
  AccountReportEmbedded = 'ACCOUNT_REPORT_EMBEDDED',
  /** AccountSalesCommitment Domain */
  AccountSalesCommitment = 'ACCOUNT_SALES_COMMITMENT',
  /** AccountSalesReferrer Domain */
  AccountSalesReferrer = 'ACCOUNT_SALES_REFERRER',
  /** AccountSalesRep Domain */
  AccountSalesRep = 'ACCOUNT_SALES_REP',
  /** AccountSalesTaxOverride Domain */
  AccountSalesTaxOverride = 'ACCOUNT_SALES_TAX_OVERRIDE',
  /** AccountSubsidy Domain */
  AccountSubsidy = 'ACCOUNT_SUBSIDY',
  /** AccountSubsidyManager Domain */
  AccountSubsidyManager = 'ACCOUNT_SUBSIDY_MANAGER',
  /** AccountTaxExempt Domain */
  AccountTaxExempt = 'ACCOUNT_TAX_EXEMPT',
  /** AccountTenderMethods Domain */
  AccountTenderMethods = 'ACCOUNT_TENDER_METHODS',
  /** AccountWeekAheadEmail Domain */
  AccountWeekAheadEmail = 'ACCOUNT_WEEK_AHEAD_EMAIL',
  /** AchDocument Domain */
  AchDocument = 'ACH_DOCUMENT',
  /** AgentPrincipalDefaults Domain */
  AgentPrincipalDefaults = 'AGENT_PRINCIPAL_DEFAULTS',
  /** AIAssistant Domain */
  AiAssistant = 'AI_ASSISTANT',
  /** AppSnappea Domain */
  AppSnappea = 'APP_SNAPPEA',
  /** BuildingJurisdiction Domain */
  BuildingJurisdiction = 'BUILDING_JURISDICTION',
  /** CateringEventUnlock Domain */
  CateringEventUnlock = 'CATERING_EVENT_UNLOCK',
  /** CouponAccount Domain */
  CouponAccount = 'COUPON_ACCOUNT',
  /** CouponLaunch Domain */
  CouponLaunch = 'COUPON_LAUNCH',
  /** CouponPaper Domain */
  CouponPaper = 'COUPON_PAPER',
  /** CouponReferral Domain */
  CouponReferral = 'COUPON_REFERRAL',
  /** CouponReward Domain */
  CouponReward = 'COUPON_REWARD',
  /** CouponUser Domain */
  CouponUser = 'COUPON_USER',
  /** DeliveryOrderRefund Domain */
  DeliveryOrderRefund = 'DELIVERY_ORDER_REFUND',
  /** DeliverySchedulingAccountConstraint Domain */
  DeliverySchedulingAccountConstraint = 'DELIVERY_SCHEDULING_ACCOUNT_CONSTRAINT',
  /** EventOrder Domain */
  EventOrder = 'EVENT_ORDER',
  /** EventPayment Domain */
  EventPayment = 'EVENT_PAYMENT',
  /** GlobalSettings Domain */
  GlobalSettings = 'GLOBAL_SETTINGS',
  /** MarketConfig Domain */
  MarketConfig = 'MARKET_CONFIG',
  /** MarketJurisdiction Domain */
  MarketJurisdiction = 'MARKET_JURISDICTION',
  /** MCPServiceAccount Domain */
  McpServiceAccount = 'MCP_SERVICE_ACCOUNT',
  /** PartnerCollectionEmail Domain */
  PartnerCollectionEmail = 'PARTNER_COLLECTION_EMAIL',
  /** PartnerConfig Domain */
  PartnerConfig = 'PARTNER_CONFIG',
  /** PartnerInvoicesPreview Domain */
  PartnerInvoicesPreview = 'PARTNER_INVOICES_PREVIEW',
  /** PaymentAccessToken Domain */
  PaymentAccessToken = 'PAYMENT_ACCESS_TOKEN',
  /** PopupEventTaxRemittedBy Domain */
  PopupEventTaxRemittedBy = 'POPUP_EVENT_TAX_REMITTED_BY',
  /** PopupOrderRefund Domain */
  PopupOrderRefund = 'POPUP_ORDER_REFUND',
  /** RecommendationsSystemConfiguration Domain */
  RecommendationsSystemConfiguration = 'RECOMMENDATIONS_SYSTEM_CONFIGURATION',
  /** ReportsConfigurations Domain */
  ReportsConfigurations = 'REPORTS_CONFIGURATIONS',
  /** ShadowFalsePositivePermanent Domain */
  ShadowFalsePositivePermanent = 'SHADOW_FALSE_POSITIVE_PERMANENT',
  /** ShadowFalsePositiveTemporary Domain */
  ShadowFalsePositiveTemporary = 'SHADOW_FALSE_POSITIVE_TEMPORARY',
  /** ShadowScoring Domain */
  ShadowScoring = 'SHADOW_SCORING',
  /** TaxRule Domain */
  TaxRule = 'TAX_RULE',
  /** UserAuthenticationSettings Domain */
  UserAuthenticationSettings = 'USER_AUTHENTICATION_SETTINGS',
  /** UserCardsGatewayLinks Domain */
  UserCardsGatewayLinks = 'USER_CARDS_GATEWAY_LINKS',
  /** UserDeactivate Domain */
  UserDeactivate = 'USER_DEACTIVATE',
  /** UserForceVerifyEmail Domain */
  UserForceVerifyEmail = 'USER_FORCE_VERIFY_EMAIL',
  /** UserPasswordReset Domain */
  UserPasswordReset = 'USER_PASSWORD_RESET',
  /** UserPermissions Domain */
  UserPermissions = 'USER_PERMISSIONS',
  /** UserPhoneNumber Domain */
  UserPhoneNumber = 'USER_PHONE_NUMBER',
  /** UserProfileRoles Domain */
  UserProfileRoles = 'USER_PROFILE_ROLES',
  /** UserRewardPoints Domain */
  UserRewardPoints = 'USER_REWARD_POINTS',
  /** UserSnappeaRole Domain */
  UserSnappeaRole = 'USER_SNAPPEA_ROLE',
  /** UserVerificationEmail Domain */
  UserVerificationEmail = 'USER_VERIFICATION_EMAIL',
  /** VendorAvailability Domain */
  VendorAvailability = 'VENDOR_AVAILABILITY',
  /** VendorCateringCommissionRate Domain */
  VendorCateringCommissionRate = 'VENDOR_CATERING_COMMISSION_RATE',
  /** VendorCollectionEmail Domain */
  VendorCollectionEmail = 'VENDOR_COLLECTION_EMAIL',
  /** VendorDashboard Domain */
  VendorDashboard = 'VENDOR_DASHBOARD',
  /** VendorDeliveryCommissionRate Domain */
  VendorDeliveryCommissionRate = 'VENDOR_DELIVERY_COMMISSION_RATE',
  /** VendorEvents Domain */
  VendorEvents = 'VENDOR_EVENTS',
  /** VendorFoodTruckAvailable Domain */
  VendorFoodTruckAvailable = 'VENDOR_FOOD_TRUCK_AVAILABLE',
  /** VendorInvoicesPreview Domain */
  VendorInvoicesPreview = 'VENDOR_INVOICES_PREVIEW',
  /** VendorNames Domain */
  VendorNames = 'VENDOR_NAMES',
  /** VendorOwedBalanceTreatment Domain */
  VendorOwedBalanceTreatment = 'VENDOR_OWED_BALANCE_TREATMENT',
  /** VendorPantryManager Domain */
  VendorPantryManager = 'VENDOR_PANTRY_MANAGER',
  /** VendorParent Domain */
  VendorParent = 'VENDOR_PARENT',
  /** VendorPopupFinanceBilling Domain */
  VendorPopupFinanceBilling = 'VENDOR_POPUP_FINANCE_BILLING',
  /** VendorPopupFinanceConfig Domain */
  VendorPopupFinanceConfig = 'VENDOR_POPUP_FINANCE_CONFIG',
  /** VendorPopupOrder Domain */
  VendorPopupOrder = 'VENDOR_POPUP_ORDER',
  /** VendorProductsPopup Domain */
  VendorProductsPopup = 'VENDOR_PRODUCTS_POPUP',
  /** VendorProductStatusAccounting Domain */
  VendorProductStatusAccounting = 'VENDOR_PRODUCT_STATUS_ACCOUNTING',
  /** VendorProductStatusCompliance Domain */
  VendorProductStatusCompliance = 'VENDOR_PRODUCT_STATUS_COMPLIANCE',
  /** VendorSalesRep Domain */
  VendorSalesRep = 'VENDOR_SALES_REP',
  /** VendorSchedulingExclusion Domain */
  VendorSchedulingExclusion = 'VENDOR_SCHEDULING_EXCLUSION',
  /** VendorTrialSchedule Domain */
  VendorTrialSchedule = 'VENDOR_TRIAL_SCHEDULE'
}

/** Autogenerated return type of EffectiveConsentPreference. */
export type EffectiveConsentPreferencePayload = {
  __typename?: 'EffectiveConsentPreferencePayload';
  error?: Maybe<OperationError>;
  preference?: Maybe<ConsentPreferenceSnapshot>;
};

/** An email subscription category preference */
export type EmailCategoryPreference = {
  __typename?: 'EmailCategoryPreference';
  categoryKey: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  subscribed: Scalars['Boolean']['output'];
};

export type EmailCategoryPreferenceInput = {
  categoryKey: Scalars['String']['input'];
  subscribed: Scalars['Boolean']['input'];
};

export type EmailConfigurationInput = {
  sendDayOffset?: InputMaybe<Scalars['Int']['input']>;
  sendTime?: InputMaybe<Scalars['String']['input']>;
};

/** Arguments to update a vendor employee permissions */
export type EmployeePermission = {
  active: Scalars['Boolean']['input'];
  name: VendorEmployeePermission;
};

export type EndedEarly = HistoricalMealsSoldFactor & {
  __typename?: 'EndedEarly';
  relevant: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  value: Scalars['ISO8601DateTime']['output'];
  valueAsString: Scalars['String']['output'];
};

export type EndedEarlyInput = {
  relevant: Scalars['Boolean']['input'];
  value: Scalars['ISO8601DateTime']['input'];
};

/** Arguments to add a user to an account */
export type EnrollUserInAccount = {
  accountId: Scalars['ID']['input'];
  permissions?: InputMaybe<Array<AccountRolePermission>>;
  role?: InputMaybe<AccountRoleEnum>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of EnrollUserInAccountBuilding. */
export type EnrollUserInAccountBuildingPayload = {
  __typename?: 'EnrollUserInAccountBuildingPayload';
  error?: Maybe<OperationError>;
  subscribedAccountBuildings?: Maybe<Array<UserSubscribedAccountBuilding>>;
};

/** Autogenerated return type of EnrollUserInAccount. */
export type EnrollUserInAccountPayload = {
  __typename?: 'EnrollUserInAccountPayload';
  accountMembership?: Maybe<AccountMembership>;
  error?: Maybe<OperationError>;
};

/** Arguments to add a user to a vendor */
export type EnrollUserInVendor = {
  employeePermissions: Array<VendorEmployeePermission>;
  siteDirectionsNotifications: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
};

/** Autogenerated return type of EnrollUserInVendor. */
export type EnrollUserInVendorPayload = {
  __typename?: 'EnrollUserInVendorPayload';
  error?: Maybe<OperationError>;
  vendorMembership?: Maybe<VendorMembership>;
};

export type EntreeSoldOut = HistoricalMealsSoldFactor & {
  __typename?: 'EntreeSoldOut';
  relevant: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  value: Scalars['ID']['output'];
  valueAsString: Scalars['String']['output'];
};

export type EntreeSoldOutInput = {
  relevant: Scalars['Boolean']['input'];
  value: Scalars['ID']['input'];
};

/** Entry Point for recommendations */
export type EntryPoint = {
  __typename?: 'EntryPoint';
  bucketConfigurations: Array<BucketConfiguration>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** An event with account-protected details, resolved by getEvent */
export type EventDetail = {
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** All locations associated with the event */
  locations: Array<LocationPublic>;
  startTime: Scalars['ISO8601DateTime']['output'];
  status: EventStatus;
};

/** A line item */
export type EventFinanceLineItem = {
  __typename?: 'EventFinanceLineItem';
  amountCents?: Maybe<Scalars['Int']['output']>;
  contra: Scalars['Boolean']['output'];
  erasedCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  journaledCount: Scalars['Int']['output'];
  lineItemType: Scalars['String']['output'];
};

/** A subsidy for an event menu item */
export type EventMenuItemSubsidizedPrice = {
  __typename?: 'EventMenuItemSubsidizedPrice';
  postSubsidyPostTaxCents: Scalars['Int']['output'];
  postSubsidyPreTaxCents: Scalars['Int']['output'];
  postSubsidySalesTaxCents: Scalars['Int']['output'];
  rules: Array<EventMenuItemSubsidy>;
};

/** An applied subsidy rule */
export type EventMenuItemSubsidy = {
  __typename?: 'EventMenuItemSubsidy';
  displayPreSubsidyPrice: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  redeemableCents: Scalars['Int']['output'];
  versionId: Scalars['ID']['output'];
};

export enum EventProduct {
  Cafe = 'CAFE',
  Catering = 'CATERING',
  Delivery = 'DELIVERY',
  Popup = 'POPUP'
}

/** A Cafe Event Schedule */
export type EventSchedule = {
  __typename?: 'EventSchedule';
  cafeLocation: CafeLocation;
  eligibleSiteManagementFeeRecipients?: Maybe<Array<SiteManagementFeeRecipient>>;
  emailListId?: Maybe<Scalars['ID']['output']>;
  eventEndTime: Scalars['ISO8601DateTime']['output'];
  eventEndTimeOffsetInDays: Scalars['Int']['output'];
  eventScheduleOwner?: Maybe<User>;
  eventStartTime: Scalars['ISO8601DateTime']['output'];
  finalEmail?: Maybe<ScheduleEmailConfiguration>;
  fixedPricePerConsumerCents?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  ignoreFinalEmail: Scalars['Boolean']['output'];
  ignoreIntroductionEmail: Scalars['Boolean']['output'];
  introductionEmail?: Maybe<ScheduleEmailConfiguration>;
  menuTiles?: Maybe<Array<CafeEventScheduleMenuTile>>;
  minSalesGuaranteeCents?: Maybe<Scalars['Int']['output']>;
  pauseEndDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  pauseStartDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  residentVendorIsMissing: Scalars['Boolean']['output'];
  scheduleEndDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  scheduleFrequency: CafeScheduleFrequencyType;
  scheduleStartDate: Scalars['ISO8601DateTime']['output'];
  siteManagementFeeConfig: SiteManagementFeeConfig;
  stations: Array<EventScheduleStation>;
  timezone?: Maybe<Scalars['String']['output']>;
};


/** A Cafe Event Schedule */
export type EventScheduleMenuTilesArgs = {
  filterTypes?: InputMaybe<Array<MenuTileTypeEnum>>;
};

export type EventScheduleStation = {
  __typename?: 'EventScheduleStation';
  cafeStation: Station;
  endTime: Scalars['ISO8601DateTime']['output'];
  endTimeOffsetInDays: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  mealPeriod?: Maybe<MealPeriodEnum>;
  menuTemplate?: Maybe<MenuTemplate>;
  pickupOrderingWindows: Array<PickupOrderingWindow>;
  prepFor?: Maybe<Scalars['Int']['output']>;
  setupTimeMinutes: Scalars['Int']['output'];
  startTime: Scalars['ISO8601DateTime']['output'];
  stationType: StationTypes;
  vendor?: Maybe<Vendor>;
};

/** A Cafe Event Station */
export type EventStation = {
  __typename?: 'EventStation';
  cafeEventVendor?: Maybe<CafeEventVendor>;
  cafeStation: Station;
  id: Scalars['ID']['output'];
  mealPeriod?: Maybe<MealPeriodEnum>;
  menuTemplate: MenuTemplate;
  prepFor?: Maybe<Scalars['Int']['output']>;
  setupTimeMinutes: Scalars['Int']['output'];
  stationEndTime: Scalars['ISO8601DateTime']['output'];
  stationStartTime: Scalars['ISO8601DateTime']['output'];
  stationType: StationTypes;
  vendor?: Maybe<Vendor>;
};

export enum EventStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Final = 'FINAL',
  InProgress = 'IN_PROGRESS',
  Proposed = 'PROPOSED',
  Scheduled = 'SCHEDULED'
}

/** An instance of subsidy for an event */
export type EventSubsidyMembership = {
  __typename?: 'EventSubsidyMembership';
  accountName: Scalars['String']['output'];
  code: Scalars['String']['output'];
  coverage: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isDefault: Scalars['Boolean']['output'];
  isQuickAdd: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  product: SubsidyRuleProduct;
  redemptionMessage?: Maybe<Scalars['String']['output']>;
  startOn?: Maybe<Scalars['String']['output']>;
  state: SubsidyRuleState;
  validAt: Scalars['String']['output'];
};

export type EventVendor = {
  id: Scalars['ID']['output'];
  productType: EventProduct;
};

/** The connection type for EventVendor. */
export type EventVendorConnection = {
  __typename?: 'EventVendorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EventVendorEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EventVendor>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EventVendorEdge = {
  __typename?: 'EventVendorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EventVendor>;
};

/** Popup experience feedback type */
export type ExperienceFeedback = {
  __typename?: 'ExperienceFeedback';
  factors: Array<RestaurantFeedbackFactor>;
  percentage: Scalars['Float']['output'];
  rating: ExperienceRating;
};

export enum ExperienceRating {
  Awful = 'AWFUL',
  Good = 'GOOD',
  Great = 'GREAT',
  Okay = 'OKAY'
}

/** Autogenerated return type of ExpireGuestPass. */
export type ExpireGuestPassPayload = {
  __typename?: 'ExpireGuestPassPayload';
  error?: Maybe<OperationError>;
  guestPass?: Maybe<SubsidyGuestPass>;
};

/** A Feature Flag */
export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** A Fee LineItem for orders */
export type FeeLineItem = {
  __typename?: 'FeeLineItem';
  amountCents: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayAmount: Scalars['BigDecimal']['output'];
  displayAmountCents: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  lineItemType: FeeLineItemTypeEnum;
};

export enum FeeLineItemTypeEnum {
  CancellationFee = 'CANCELLATION_FEE',
  ClientFee = 'CLIENT_FEE',
  Commission = 'COMMISSION',
  DeliveryFee = 'DELIVERY_FEE',
  EventFee = 'EVENT_FEE',
  FeeTax = 'FEE_TAX',
  Gratuity = 'GRATUITY',
  OtherFee = 'OTHER_FEE',
  PartnerCommission = 'PARTNER_COMMISSION',
  PaymentProcessingFee = 'PAYMENT_PROCESSING_FEE',
  PaymentProcessingManualFee = 'PAYMENT_PROCESSING_MANUAL_FEE',
  PaymentProcessingSwipeFee = 'PAYMENT_PROCESSING_SWIPE_FEE',
  PaymentProcessingTokenFee = 'PAYMENT_PROCESSING_TOKEN_FEE',
  SiteManagementFee = 'SITE_MANAGEMENT_FEE'
}

export enum FeedbackFactor {
  CheckoutProcess = 'CHECKOUT_PROCESS',
  ItemAvailability = 'ITEM_AVAILABILITY',
  StaffFriendliness = 'STAFF_FRIENDLINESS',
  WaitTime = 'WAIT_TIME'
}

/** A Feedback Request */
export type FeedbackRequest = {
  __typename?: 'FeedbackRequest';
  eventFinanceOrderRequestBlobId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  ratingMax: Scalars['Int']['output'];
  ratingMin: Scalars['Int']['output'];
  requestId: Scalars['ID']['output'];
  reviewOptions?: Maybe<Array<ReviewOption>>;
  seenAt?: Maybe<Scalars['String']['output']>;
  subject: Subject;
};

/** A Feedback Response */
export type FeedbackResponse = {
  __typename?: 'FeedbackResponse';
  comments?: Maybe<Scalars['String']['output']>;
  feedbackRequest: FeedbackRequest;
  id: Scalars['ID']['output'];
  rating: Scalars['Int']['output'];
  reviews: Array<FeedbackReviewOption>;
};

/** A Feedback Review Option */
export type FeedbackReviewOption = {
  __typename?: 'FeedbackReviewOption';
  category: FeedbackReviewOptionCategory;
  disposition: FeedbackReviewOptionDisposition;
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export enum FeedbackReviewOptionCategory {
  Event = 'EVENT',
  Item = 'ITEM'
}

export enum FeedbackReviewOptionDisposition {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE'
}

/** FFR today delivery manifests */
export type FfrDeliveryManifests = {
  __typename?: 'FfrDeliveryManifests';
  confirmUrl?: Maybe<Scalars['String']['output']>;
  confirmationPreview?: Maybe<Scalars['Boolean']['output']>;
  confirmationToken?: Maybe<Scalars['String']['output']>;
  downloadPdfUrl?: Maybe<Scalars['String']['output']>;
  manifestId: Scalars['ID']['output'];
  manifestTime?: Maybe<Scalars['String']['output']>;
  readyAndBaggedTime?: Maybe<Scalars['String']['output']>;
  restaurantName: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type FinalizeMenuChangeRequestUploadInput = {
  uploadId: Scalars['ID']['input'];
};

/** Autogenerated return type of FinalizeMenuChangeRequestUpload. */
export type FinalizeMenuChangeRequestUploadPayload = {
  __typename?: 'FinalizeMenuChangeRequestUploadPayload';
  error?: Maybe<OperationError>;
  uploadId?: Maybe<Scalars['ID']['output']>;
};

/** Type for top items and supplementary financial info */
export type FinancialInfo = {
  __typename?: 'FinancialInfo';
  /** Average customer payment in cents */
  avgCustomerPaidCents: Scalars['Int']['output'];
  /** Financial breakdown of top items sold */
  foodTopSales: Array<FoodItemSale>;
  gfsCents: Scalars['Int']['output'];
  /** Number of meals sold */
  mealsSold: Scalars['Int']['output'];
  /** Total of cash payments in cents */
  totalCashPaymentsCents: Scalars['Int']['output'];
};


/** Type for top items and supplementary financial info */
export type FinancialInfoFoodTopSalesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Flavour Me recommendation request */
export type FlavourMeRequestInput = {
  /** Array of event vendor IDs */
  eventVendorIds: Array<Scalars['ID']['input']>;
};

export type FoodItemSale = {
  __typename?: 'FoodItemSale';
  cents: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  percentGfs: Scalars['Float']['output'];
};

/** Fooda Card entry in the user activity stream */
export type FoodaCardActivity = {
  __typename?: 'FoodaCardActivity';
  actionRequired: Scalars['Boolean']['output'];
  authorizationApproved?: Maybe<Scalars['Boolean']['output']>;
  authorizedAmountCents?: Maybe<Scalars['Int']['output']>;
  capturedAmountCents?: Maybe<Scalars['Int']['output']>;
  declineReason?: Maybe<Scalars['String']['output']>;
  declinedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  forceCaptured: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  orderFulfilledTimeUnix?: Maybe<Scalars['Int']['output']>;
  overageAmountCents?: Maybe<Scalars['Int']['output']>;
  paymentCents: Scalars['Int']['output'];
  paymentMethod?: Maybe<Scalars['String']['output']>;
  requestId: Scalars['ID']['output'];
  requestTimestampUuid: Scalars['String']['output'];
  requestedAmountCents?: Maybe<Scalars['Int']['output']>;
  reversedAmountCents?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subsidyAmountCents?: Maybe<Scalars['Int']['output']>;
};

/** Auto top-up configuration for a connected account's Issuing balance */
export type FoodaCardAutoTopupSettings = {
  __typename?: 'FoodaCardAutoTopupSettings';
  bankAccountId?: Maybe<Scalars['ID']['output']>;
  enabled: Scalars['Boolean']['output'];
  thresholdCents?: Maybe<Scalars['Int']['output']>;
  topupAmountCents?: Maybe<Scalars['Int']['output']>;
};

/** A tokenized ACH bank account used for pull funding (masked to last4) */
export type FoodaCardBankAccount = {
  __typename?: 'FoodaCardBankAccount';
  accountHolderName?: Maybe<Scalars['String']['output']>;
  /** Whether this is the account selected to fund top-ups (the auto-topup setting's bank account) */
  active: Scalars['Boolean']['output'];
  bankName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last4?: Maybe<Scalars['String']['output']>;
  status: FoodaCardBankAccountStatus;
  verificationMethod?: Maybe<Scalars['String']['output']>;
  verifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Verification status of a pull-funding bank account */
export enum FoodaCardBankAccountStatus {
  PendingVerification = 'PENDING_VERIFICATION',
  Removed = 'REMOVED',
  VerificationFailed = 'VERIFICATION_FAILED',
  Verified = 'VERIFIED'
}

/** Why microdeposit verification of a Fooda Card bank account failed */
export enum FoodaCardBankAccountVerifyErrorCodeEnum {
  AttemptsExceeded = 'ATTEMPTS_EXCEEDED',
  IncorrectAmounts = 'INCORRECT_AMOUNTS',
  StripeError = 'STRIPE_ERROR'
}

export type FoodaCardBankAccountVerifyErrorDetail = OperationErrorDetail & {
  __typename?: 'FoodaCardBankAccountVerifyErrorDetail';
  code: FoodaCardBankAccountVerifyErrorCodeEnum;
  codeAsString: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** Beneficiary address from Stripe funding instructions */
export type FoodaCardFundingAddress = {
  __typename?: 'FoodaCardFundingAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** Issuing balance for a connected account */
export type FoodaCardFundingBalance = {
  __typename?: 'FoodaCardFundingBalance';
  availableAmountCents: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  pendingAmountCents: Scalars['Int']['output'];
};

/** Funding overview for a connected account's Issuing balance */
export type FoodaCardFundingOverview = {
  __typename?: 'FoodaCardFundingOverview';
  autoTopupSettings?: Maybe<FoodaCardAutoTopupSettings>;
  balance?: Maybe<FoodaCardFundingBalance>;
  bankAccounts: Array<FoodaCardBankAccount>;
  pushInstructions?: Maybe<FoodaCardFundingPushInstructions>;
  topups: Array<FoodaCardFundingTopup>;
  /** True when older top-ups exist beyond the returned page. Fetch them via the retrieveStripeAccountFundingTopups mutation. */
  topupsHasMore: Scalars['Boolean']['output'];
};

/** Bank details for push-funding an Issuing balance */
export type FoodaCardFundingPushInstructions = {
  __typename?: 'FoodaCardFundingPushInstructions';
  /** US only */
  abaAccountNumber?: Maybe<Scalars['String']['output']>;
  /** US only */
  abaRoutingNumber?: Maybe<Scalars['String']['output']>;
  /** Beneficiary address for ACH/wire transfers; null when Stripe omits it */
  accountHolderAddress?: Maybe<FoodaCardFundingAddress>;
  /** Beneficiary name for ACH/wire transfers; null when Stripe omits it */
  accountHolderName?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  bankTransferType: Scalars['String']['output'];
  /** Stripe-provided reference for merchant to include in transfers */
  referenceNumber?: Maybe<Scalars['String']['output']>;
};

/** A top-up transfer to the Issuing balance */
export type FoodaCardFundingTopup = {
  __typename?: 'FoodaCardFundingTopup';
  amountCents: Scalars['Int']['output'];
  bankName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency: Scalars['String']['output'];
  failureCode?: Maybe<Scalars['String']['output']>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  last4?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  /** "auto" for min-balance auto top-ups, "manual" for one-time top-ups; null for push-funded/legacy transfers */
  trigger?: Maybe<Scalars['String']['output']>;
};

/** A user's FoodaCard membership */
export type FoodaCardMembership = {
  __typename?: 'FoodaCardMembership';
  backupCard?: Maybe<Card>;
  id: Scalars['ID']['output'];
  needsSetup: Scalars['Boolean']['output'];
  status: FoodaCardMembershipStatusEnum;
  stripeBillingAddress?: Maybe<BillingAddress>;
  stripeCard?: Maybe<FoodaCardStripeCard>;
  /** Reason the cardholder is disabled, if applicable */
  stripeCardholderDisabledReason?: Maybe<StripeCardholderDisabledReasonEnum>;
  /** Past due requirements from Stripe that must be fulfilled before card activation */
  stripeCardholderPastDueRequirements?: Maybe<Array<StripeCardholderRequirementEnum>>;
  /** Phone number of the Stripe cardholder in E.164 format */
  stripeCardholderPhoneNumber?: Maybe<Scalars['String']['output']>;
  subsidyRule: SubsidyRule;
};

/** Status for FoodaCard Membership */
export enum FoodaCardMembershipStatusEnum {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  PendingRequirements = 'PENDING_REQUIREMENTS'
}

export type FoodaCardMerchant = {
  __typename?: 'FoodaCardMerchant';
  category?: Maybe<Scalars['String']['output']>;
  categoryCode?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** A merchant category code (MCC) in a FoodaCard approval rule */
export type FoodaCardMerchantCategory = {
  __typename?: 'FoodaCardMerchantCategory';
  /**
   * Stripe Issuing category, as sent in merchant_data.category (e.g.
   * "eating_places_restaurants"); null when Stripe does not list the code
   */
  category?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
};

export type FoodaCardOrder = {
  __typename?: 'FoodaCardOrder';
  actionRequired: Scalars['Boolean']['output'];
  authorizationApproved: Scalars['Boolean']['output'];
  authorizedAmountCents?: Maybe<Scalars['Int']['output']>;
  authorizedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  capturedAmountCents?: Maybe<Scalars['Int']['output']>;
  capturedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency: Scalars['String']['output'];
  declineReason?: Maybe<Scalars['String']['output']>;
  declinedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Backup card the outstanding amount will be charged to; null unless it is due */
  duePaymentMethod?: Maybe<Card>;
  expiredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  forceCaptured: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  latestOverageTransactionStatus?: Maybe<Scalars['String']['output']>;
  merchant?: Maybe<FoodaCardMerchant>;
  overageAmountCents?: Maybe<Scalars['Int']['output']>;
  overagePaymentMethod?: Maybe<Card>;
  overageRefundedAmountCents: Scalars['Int']['output'];
  /** Purchase date in the subsidy program's time zone */
  purchaseDate: Scalars['ISO8601Date']['output'];
  requestedAmountCents: Scalars['Int']['output'];
  reversedAmountCents: Scalars['Int']['output'];
  reversedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: Scalars['String']['output'];
  stripeCard?: Maybe<FoodaCardStripeCard>;
  stripeDashboardUrl?: Maybe<Scalars['String']['output']>;
  subsidyAmountCents?: Maybe<Scalars['Int']['output']>;
  subsidyRefundedAmountCents: Scalars['Int']['output'];
  /** Subsidy program the Fooda Card belongs to */
  subsidyRule?: Maybe<SubsidyRule>;
  subtotalAmountCents: Scalars['Int']['output'];
};

/** The connection type for FoodaCardOrder. */
export type FoodaCardOrderConnection = {
  __typename?: 'FoodaCardOrderConnection';
  currentPage: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FoodaCardOrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FoodaCardOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FoodaCardOrderEdge = {
  __typename?: 'FoodaCardOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FoodaCardOrder>;
};

/** Fooda Card overage the user still owes on a single membership */
export type FoodaCardOutstandingBalance = {
  __typename?: 'FoodaCardOutstandingBalance';
  amountCents: Scalars['Int']['output'];
  /** Pass to getFoodaCardMembership to open the card management flow */
  foodaCardMembershipId: Scalars['ID']['output'];
  /** Last failed charge attempt. Compare against when payment was requested to tell a decline from an attempt still in flight. */
  lastFailedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** A FoodaCard program */
export type FoodaCardProgram = {
  __typename?: 'FoodaCardProgram';
  allowedHourRanges?: Maybe<Scalars['JSON']['output']>;
  allowedMerchantCategories: Array<FoodaCardMerchantCategory>;
  allowedMerchantCategoryIds?: Maybe<Array<Scalars['String']['output']>>;
  allowedMerchantNames?: Maybe<Array<Scalars['String']['output']>>;
  allowedZipCodes?: Maybe<Array<Scalars['String']['output']>>;
  blockedMerchantCategories: Array<FoodaCardMerchantCategory>;
  blockedMerchantCategoryIds?: Maybe<Array<Scalars['String']['output']>>;
  blockedMerchantNames?: Maybe<Array<Scalars['String']['output']>>;
  defaultMerchantCategoryIds: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: FoodaCardProgramStatusEnum;
  stripeAccount?: Maybe<FoodaCardStripeAccount>;
};

/** Nested FoodaCard program attributes for use within UpdateSubsidyRule */
export type FoodaCardProgramAttributes = {
  allowedHourRanges?: InputMaybe<Array<HourRangeInput>>;
  allowedMerchantCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedMerchantNames?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedZipCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  blockedMerchantCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  blockedMerchantNames?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<FoodaCardProgramStatusEnum>;
};

/** Status for FoodaCard Program */
export enum FoodaCardProgramStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** A FoodaCard Stripe Connected Account */
export type FoodaCardStripeAccount = {
  __typename?: 'FoodaCardStripeAccount';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  onboardingUrl?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  stripeAccountId: Scalars['String']['output'];
  subsidyRules: Array<SubsidyRule>;
};

export type FoodaCardStripeCard = {
  __typename?: 'FoodaCardStripeCard';
  activatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  cardType: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  last4: Scalars['String']['output'];
  status: Scalars['String']['output'];
  stripeCardId: Scalars['String']['output'];
  walletEligibility?: Maybe<FoodaCardStripeCardWallets>;
};

/** Digital wallet eligibility information for a Stripe Issuing card */
export type FoodaCardStripeCardWallets = {
  __typename?: 'FoodaCardStripeCardWallets';
  /** Whether the card is eligible for Apple Pay */
  applePayEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Reason the card is ineligible for Apple Pay */
  applePayIneligibleReason?: Maybe<Scalars['String']['output']>;
  /** Whether the card is eligible for Google Pay */
  googlePayEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Reason the card is ineligible for Google Pay */
  googlePayIneligibleReason?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the card used with digital wallets */
  primaryAccountIdentifier?: Maybe<Scalars['String']['output']>;
};

/** A Fooda Card pull-funding top-up record */
export type FoodaCardTopup = {
  __typename?: 'FoodaCardTopup';
  amountCents: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency: Scalars['String']['output'];
  expectedAvailabilityAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  stripeTopupId?: Maybe<Scalars['String']['output']>;
  trigger: Scalars['String']['output'];
};

export type Gfs = {
  __typename?: 'GFS';
  lifetimeCents: Scalars['BigInt']['output'];
  monthly: Array<MonthGfs>;
};


export type GfsMonthlyArgs = {
  from: Scalars['ISO8601DateTime']['input'];
  to: Scalars['ISO8601DateTime']['input'];
};

/** Geographic location details */
export type Geolocation = {
  __typename?: 'Geolocation';
  latitude: Scalars['String']['output'];
  longitude: Scalars['String']['output'];
};

/** Autogenerated return type of GetAccountAuthenticationDomains. */
export type GetAccountAuthenticationDomainsPayload = {
  __typename?: 'GetAccountAuthenticationDomainsPayload';
  authenticationDomains?: Maybe<Array<AuthenticationDomain>>;
  error?: Maybe<OperationError>;
};

export type GetAccountDeliveryEventMembersInput = {
  accountId: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
  status?: InputMaybe<AccountDeliveryMemberFilter>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userSearchText?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of GetAccountDeliveryEventMembers. */
export type GetAccountDeliveryEventMembersPayload = {
  __typename?: 'GetAccountDeliveryEventMembersPayload';
  error?: Maybe<OperationError>;
  members?: Maybe<AccountDeliveryEventMemberConnection>;
  summary?: Maybe<AccountDeliveryEventSummary>;
};


/** Autogenerated return type of GetAccountDeliveryEventMembers. */
export type GetAccountDeliveryEventMembersPayloadMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AccountDeliveryMemberSortField>>;
};

/** Autogenerated return type of GetAccountMembership. */
export type GetAccountMembershipPayload = {
  __typename?: 'GetAccountMembershipPayload';
  accountMembership?: Maybe<AccountMembership>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of GetAccountQuery. */
export type GetAccountQueryPayload = {
  __typename?: 'GetAccountQueryPayload';
  account?: Maybe<Account>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of GetAccountingSiteOwners. */
export type GetAccountingSiteOwnersPayload = {
  __typename?: 'GetAccountingSiteOwnersPayload';
  accountingSiteId?: Maybe<Scalars['ID']['output']>;
  error?: Maybe<OperationError>;
  owners?: Maybe<Array<AccountingSiteOwner>>;
};

/** Autogenerated return type of GetAccountingSiteRoleTypes. */
export type GetAccountingSiteRoleTypesPayload = {
  __typename?: 'GetAccountingSiteRoleTypesPayload';
  error?: Maybe<OperationError>;
  roleTypes?: Maybe<Array<AccountingSiteRoleType>>;
};

/** Autogenerated return type of GetAccountingSiteTypes. */
export type GetAccountingSiteTypesPayload = {
  __typename?: 'GetAccountingSiteTypesPayload';
  error?: Maybe<OperationError>;
  siteTypes?: Maybe<Array<AccountingSiteType>>;
};

/** Autogenerated return type of GetActiveBacktest. */
export type GetActiveBacktestPayload = {
  __typename?: 'GetActiveBacktestPayload';
  backtestId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of GetAppVersionPolicies. */
export type GetAppVersionPoliciesPayload = {
  __typename?: 'GetAppVersionPoliciesPayload';
  error?: Maybe<OperationError>;
  policies?: Maybe<Array<AppVersionPolicy>>;
};

/** Autogenerated return type of GetAppVersionPolicy. */
export type GetAppVersionPolicyPayload = {
  __typename?: 'GetAppVersionPolicyPayload';
  error?: Maybe<OperationError>;
  policy?: Maybe<AppVersionPolicy>;
};

/** Autogenerated return type of GetAuthProvider. */
export type GetAuthProviderPayload = {
  __typename?: 'GetAuthProviderPayload';
  error?: Maybe<OperationError>;
  providerUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of GetAuthenticationDomains. */
export type GetAuthenticationDomainsPayload = {
  __typename?: 'GetAuthenticationDomainsPayload';
  authenticationDomains?: Maybe<Array<AuthenticationDomain>>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of GetAuthenticationProviders. */
export type GetAuthenticationProvidersPayload = {
  __typename?: 'GetAuthenticationProvidersPayload';
  authenticationProviders?: Maybe<Array<AuthenticationProvider>>;
  error?: Maybe<OperationError>;
};

/** Full backtest run data with results and aggregates */
export type GetBacktest = {
  __typename?: 'GetBacktest';
  aggregates?: Maybe<BacktestAggregates>;
  backtestId: Scalars['String']['output'];
  completedCases: Scalars['Int']['output'];
  failedCases: Scalars['Int']['output'];
  results: Array<BacktestResult>;
  status: Scalars['String']['output'];
  totalCases: Scalars['Int']['output'];
};

/** Autogenerated return type of GetBacktest. */
export type GetBacktestPayload = {
  __typename?: 'GetBacktestPayload';
  error?: Maybe<OperationError>;
  getBacktest?: Maybe<GetBacktest>;
};

/** Autogenerated return type of GetBanners. */
export type GetBannersPayload = {
  __typename?: 'GetBannersPayload';
  banners?: Maybe<Array<Banner>>;
  error?: Maybe<OperationError>;
};

export type GetBillingPolicy = {
  partyId: Scalars['ID']['input'];
  partyType: Scalars['String']['input'];
};

/** Autogenerated return type of GetBillingPolicy. */
export type GetBillingPolicyPayload = {
  __typename?: 'GetBillingPolicyPayload';
  catering?: Maybe<BillingPolicy>;
  delivery?: Maybe<BillingPolicy>;
  error?: Maybe<OperationError>;
  popup?: Maybe<BillingPolicy>;
};

/** Autogenerated return type of GetBraintreeToken. */
export type GetBraintreeTokenPayload = {
  __typename?: 'GetBraintreeTokenPayload';
  braintreeToken?: Maybe<BraintreeToken>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of GetCafeAccountsForCurrentUser. */
export type GetCafeAccountsForCurrentUserPayload = {
  __typename?: 'GetCafeAccountsForCurrentUserPayload';
  accounts?: Maybe<Array<Account>>;
  error?: Maybe<OperationError>;
};

export type GetCafeEventForLocation = {
  cafeLocationId: Scalars['ID']['input'];
  time?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of GetCafeEventForLocation. */
export type GetCafeEventForLocationPayload = {
  __typename?: 'GetCafeEventForLocationPayload';
  cafeEvent?: Maybe<CafeEvent>;
  error?: Maybe<OperationError>;
};

export type GetCafeEventMenuInput = {
  cafeEventId: Scalars['ID']['input'];
};

/** Autogenerated return type of GetCafeEventMenu. */
export type GetCafeEventMenuPayload = {
  __typename?: 'GetCafeEventMenuPayload';
  cafeEventMenu?: Maybe<CafeMenu>;
  error?: Maybe<OperationError>;
  taxes?: Maybe<Array<TaxCategoryRate>>;
};

/** Autogenerated return type of GetCafeEvent. */
export type GetCafeEventPayload = {
  __typename?: 'GetCafeEventPayload';
  cafeEvent?: Maybe<CafeEvent>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of GetCafeEventSchedule. */
export type GetCafeEventSchedulePayload = {
  __typename?: 'GetCafeEventSchedulePayload';
  cafeEventSchedule?: Maybe<EventSchedule>;
  error?: Maybe<OperationError>;
};

export type GetCafeEventsForAccount = {
  accountId: Scalars['ID']['input'];
  endTime: Scalars['ISO8601DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated return type of GetCafeEventsForAccount. */
export type GetCafeEventsForAccountPayload = {
  __typename?: 'GetCafeEventsForAccountPayload';
  cafeEvents?: Maybe<Array<CafeEvent>>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of GetCafeLocation. */
export type GetCafeLocationPayload = {
  __typename?: 'GetCafeLocationPayload';
  cafeLocation?: Maybe<CafeLocation>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of GetCafeLocationsForAccount. */
export type GetCafeLocationsForAccountPayload = {
  __typename?: 'GetCafeLocationsForAccountPayload';
  cafeLocations?: Maybe<Array<CafeLocation>>;
  error?: Maybe<OperationError>;
};

export type GetCampaignUsers = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of GetCampaignUsers. */
export type GetCampaignUsersPayload = {
  __typename?: 'GetCampaignUsersPayload';
  campaignUsers?: Maybe<Array<CampaignUser>>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of GetCampaigns. */
export type GetCampaignsPayload = {
  __typename?: 'GetCampaignsPayload';
  campaigns?: Maybe<Array<Campaign>>;
  error?: Maybe<OperationError>;
};

export type GetCateringInventoryItem = {
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of GetCateringInventoryItem. */
export type GetCateringInventoryItemPayload = {
  __typename?: 'GetCateringInventoryItemPayload';
  cateringInventoryItem?: Maybe<CateringInventoryItem>;
  error?: Maybe<OperationError>;
};

export type GetCateringInventoryItemsForVendor = {
  searchInfo?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

/** Autogenerated return type of GetCateringInventoryItemsForVendor. */
export type GetCateringInventoryItemsForVendorPayload = {
  __typename?: 'GetCateringInventoryItemsForVendorPayload';
  cateringInventoryItems?: Maybe<Array<CateringInventoryItem>>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of GetChatHistory. */
export type GetChatHistoryPayload = {
  __typename?: 'GetChatHistoryPayload';
  error?: Maybe<OperationError>;
  history: ChatHistory;
};

/** Autogenerated return type of GetConfiguration. */
export type GetConfigurationPayload = {
  __typename?: 'GetConfigurationPayload';
  config?: Maybe<Configuration>;
  error?: Maybe<OperationError>;
};

/** Arguments to list consumer_data_requests */
export type GetConsumerDataRequests = {
  email?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConsumerDataRequestStatusEnum>;
  type?: InputMaybe<ConsumerDataRequestTypeEnum>;
};

/** Autogenerated return type of GetConsumerDataRequests. */
export type GetConsumerDataRequestsPayload = {
  __typename?: 'GetConsumerDataRequestsPayload';
  consumerDataRequests?: Maybe<ConsumerDataRequestConnection>;
  error?: Maybe<OperationError>;
};


/** Autogenerated return type of GetConsumerDataRequests. */
export type GetConsumerDataRequestsPayloadConsumerDataRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of GetConsumerMobileOrderingOrderDetails. */
export type GetConsumerMobileOrderingOrderDetailsPayload = {
  __typename?: 'GetConsumerMobileOrderingOrderDetailsPayload';
  error?: Maybe<OperationError>;
  orders?: Maybe<Array<ConsumerMobileOrderingOrderDetails>>;
};

/** Autogenerated return type of GetCountriesList. */
export type GetCountriesListPayload = {
  __typename?: 'GetCountriesListPayload';
  countries: Array<Country>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of GetCreateCardResult. */
export type GetCreateCardResultPayload = {
  __typename?: 'GetCreateCardResultPayload';
  card?: Maybe<Card>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of GetCrossDocks. */
export type GetCrossDocksPayload = {
  __typename?: 'GetCrossDocksPayload';
  crossDocks?: Maybe<Array<CrossDock>>;
  defaultCrossDockId?: Maybe<Scalars['ID']['output']>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of GetCuisines. */
export type GetCuisinesPayload = {
  __typename?: 'GetCuisinesPayload';
  cuisines?: Maybe<Array<Cuisine>>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of GetCustomInvoiceAvailableProducts. */
export type GetCustomInvoiceAvailableProductsPayload = {
  __typename?: 'GetCustomInvoiceAvailableProductsPayload';
  error?: Maybe<OperationError>;
  products?: Maybe<Array<ProductEnum>>;
};

/** Autogenerated return type of GetCustomInvoiceOverlaps. */
export type GetCustomInvoiceOverlapsPayload = {
  __typename?: 'GetCustomInvoiceOverlapsPayload';
  conflicts?: Maybe<Array<CustomInvoiceOverlap>>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of GetCustomInvoiceSettingsById. */
export type GetCustomInvoiceSettingsByIdPayload = {
  __typename?: 'GetCustomInvoiceSettingsByIdPayload';
  error?: Maybe<OperationError>;
  settings?: Maybe<CustomInvoiceSettings>;
};

/** Autogenerated return type of GetCustomInvoiceSettings. */
export type GetCustomInvoiceSettingsPayload = {
  __typename?: 'GetCustomInvoiceSettingsPayload';
  error?: Maybe<OperationError>;
  settings?: Maybe<Array<CustomInvoiceSettings>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated return type of GetCustomInvoiceSplitAttributeCounts. */
export type GetCustomInvoiceSplitAttributeCountsPayload = {
  __typename?: 'GetCustomInvoiceSplitAttributeCountsPayload';
  counts?: Maybe<Array<CustomInvoiceSplitAttributeCount>>;
  error?: Maybe<OperationError>;
};

export type GetDeliveryEventVendorMenu = {
  /** SelectEventVendor id, i.e. DeliveryRestaurant.vendorId */
  eventVendorId: Scalars['ID']['input'];
};

/** Autogenerated return type of GetDeliveryEventVendorMenu. */
export type GetDeliveryEventVendorMenuPayload = {
  __typename?: 'GetDeliveryEventVendorMenuPayload';
  error?: Maybe<OperationError>;
  vendorMenu?: Maybe<DeliveryEventVendorMenu>;
};

/** Autogenerated return type of GetDeliveryEventVendor. */
export type GetDeliveryEventVendorPayload = {
  __typename?: 'GetDeliveryEventVendorPayload';
  deliveryEventVendor?: Maybe<SelectEventVendor>;
  error?: Maybe<OperationError>;
};

export type GetDeliveryInventoryItem = {
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of GetDeliveryInventoryItem. */
export type GetDeliveryInventoryItemPayload = {
  __typename?: 'GetDeliveryInventoryItemPayload';
  deliveryInventoryItem?: Maybe<DeliveryInventoryItem>;
  error?: Maybe<OperationError>;
};

export type GetDeliveryInventoryItemsForVendor = {
  searchInfo?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

/** Autogenerated return type of GetDeliveryInventoryItemsForVendor. */
export type GetDeliveryInventoryItemsForVendorPayload = {
  __typename?: 'GetDeliveryInventoryItemsForVendorPayload';
  deliveryInventoryItems?: Maybe<Array<DeliveryInventoryItem>>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of GetDeliveryOrderDetails. */
export type GetDeliveryOrderDetailsPayload = {
  __typename?: 'GetDeliveryOrderDetailsPayload';
  deliveryOrderDetails?: Maybe<DeliveryOrderDetails>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of GetDeliveryOrderItemsTotalCostByEventVendor. */
export type GetDeliveryOrderItemsTotalCostByEventVendorPayload = {
  __typename?: 'GetDeliveryOrderItemsTotalCostByEventVendorPayload';
  deliveryEventVendor?: Maybe<SelectEventVendorWithOrderItemsTotal>;
  error?: Maybe<OperationError>;
};

export type GetDeliverySchedulingConstraint = {
  markets: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of GetDeliverySchedulingConstraints. */
export type GetDeliverySchedulingConstraintsPayload = {
  __typename?: 'GetDeliverySchedulingConstraintsPayload';
  constraints?: Maybe<Array<DeliverySchedulingConstraint>>;
  error?: Maybe<OperationError>;
};

/** Arguments to get all delivery menu templates of a vendor */
export type GetDeliveryVendorMenuTemplates = {
  expirationDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  vendorId: Scalars['ID']['input'];
};

/** Autogenerated return type of GetDeliveryVendorMenuTemplates. */
export type GetDeliveryVendorMenuTemplatesPayload = {
  __typename?: 'GetDeliveryVendorMenuTemplatesPayload';
  deliveryMenuTemplates?: Maybe<Array<MenuTemplate>>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of GetDietaryDefinitions. */
export type GetDietaryDefinitionsPayload = {
  __typename?: 'GetDietaryDefinitionsPayload';
  /** Available definitions, in catalog order */
  allergens?: Maybe<Array<AllergenDefinition>>;
  error?: Maybe<OperationError>;
  /** Available definitions, in catalog order */
  preferences?: Maybe<Array<DietaryPreferenceDefinition>>;
};

/** Autogenerated return type of GetEmailCategoryPreferences. */
export type GetEmailCategoryPreferencesPayload = {
  __typename?: 'GetEmailCategoryPreferencesPayload';
  error?: Maybe<OperationError>;
  globalUnsubscribed?: Maybe<Scalars['Boolean']['output']>;
  preferences?: Maybe<Array<EmailCategoryPreference>>;
};

/** Autogenerated return type of GetEventFinanceLineItems. */
export type GetEventFinanceLineItemsPayload = {
  __typename?: 'GetEventFinanceLineItemsPayload';
  error?: Maybe<OperationError>;
  lineItems?: Maybe<Array<EventFinanceLineItem>>;
};

export type GetEventInput = {
  eventId: Scalars['ID']['input'];
  productType: EventProduct;
};

/** Autogenerated return type of GetEventQuery. */
export type GetEventQueryPayload = {
  __typename?: 'GetEventQueryPayload';
  error?: Maybe<OperationError>;
  event?: Maybe<EventDetail>;
};

export type GetEventSubsidies = {
  eventId: Scalars['ID']['input'];
  product: SubsidyRuleProduct;
};

/** Autogenerated return type of GetEventSubsidies. */
export type GetEventSubsidiesPayload = {
  __typename?: 'GetEventSubsidiesPayload';
  error?: Maybe<OperationError>;
  subsidies?: Maybe<Array<EventSubsidyMembership>>;
};

export type GetEventVendorsInput = {
  /** Array of event vendor IDs sharing one product type */
  eventVendorIds: Array<Scalars['ID']['input']>;
  productType: EventProduct;
};

/** Autogenerated return type of GetEventVendorsQuery. */
export type GetEventVendorsQueryPayload = {
  __typename?: 'GetEventVendorsQueryPayload';
  error?: Maybe<OperationError>;
  eventVendors?: Maybe<Array<EventVendor>>;
};

/** Autogenerated return type of GetExternalTags. */
export type GetExternalTagsPayload = {
  __typename?: 'GetExternalTagsPayload';
  error?: Maybe<OperationError>;
  externalTags?: Maybe<Array<KeyValuePair>>;
};

export type GetFeatureFlag = {
  name: Scalars['String']['input'];
};

/** Autogenerated return type of GetFeatureFlag. */
export type GetFeatureFlagPayload = {
  __typename?: 'GetFeatureFlagPayload';
  error?: Maybe<OperationError>;
  featureFlag?: Maybe<FeatureFlag>;
};

export type GetFeedbackRequests = {
  requestId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of GetFeedbackRequests. */
export type GetFeedbackRequestsPayload = {
  __typename?: 'GetFeedbackRequestsPayload';
  error?: Maybe<OperationError>;
  feedbackRequests?: Maybe<Array<FeedbackRequest>>;
};

/** Arguments to get top items */
export type GetFinancialInfoForVendorAtLocation = {
  locationId: Scalars['ID']['input'];
  product?: InputMaybe<ProductEnum>;
  vendorId: Scalars['ID']['input'];
};

/** Autogenerated return type of GetFinancialInfoForVendorAtLocationQuery. */
export type GetFinancialInfoForVendorAtLocationQueryPayload = {
  __typename?: 'GetFinancialInfoForVendorAtLocationQueryPayload';
  error?: Maybe<OperationError>;
  sales?: Maybe<FinancialInfo>;
};

/** Autogenerated return type of GetFoodaCardMembership. */
export type GetFoodaCardMembershipPayload = {
  __typename?: 'GetFoodaCardMembershipPayload';
  error?: Maybe<OperationError>;
  foodaCardMembership?: Maybe<FoodaCardMembership>;
};

/** Autogenerated return type of GetFoodaCardOrderDetails. */
export type GetFoodaCardOrderDetailsPayload = {
  __typename?: 'GetFoodaCardOrderDetailsPayload';
  error?: Maybe<OperationError>;
  order?: Maybe<FoodaCardOrder>;
};

/** Autogenerated return type of GetFoodaCardOutstandingBalances. */
export type GetFoodaCardOutstandingBalancesPayload = {
  __typename?: 'GetFoodaCardOutstandingBalancesPayload';
  balances?: Maybe<Array<FoodaCardOutstandingBalance>>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of GetFoodaEmployeeOptions. */
export type GetFoodaEmployeeOptionsPayload = {
  __typename?: 'GetFoodaEmployeeOptionsPayload';
  error?: Maybe<OperationError>;
  users?: Maybe<Array<LightweightUser>>;
};

export type GetGfsForVendors = {
  product?: InputMaybe<ProductEnum>;
  vendors: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of GetGFSForVendorsQuery. */
export type GetGfsForVendorsQueryPayload = {
  __typename?: 'GetGFSForVendorsQueryPayload';
  error?: Maybe<OperationError>;
  gfs?: Maybe<Gfs>;
};

/** Get Grouped User Cards Input */
export type GetGroupedUserCardsQueryInput = {
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Page Size */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /** Sort Field */
  sortField?: InputMaybe<Scalars['String']['input']>;
  /** Sort Order */
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  /** User ID */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of GetGroupedUserCardsQuery. */
export type GetGroupedUserCardsQueryPayload = {
  __typename?: 'GetGroupedUserCardsQueryPayload';
  error?: Maybe<OperationError>;
  groupedUserCards?: Maybe<Array<GroupedUserCards>>;
  totalGroupedCards: Scalars['Int']['output'];
};

/** Autogenerated return type of GetInvoiceJobs. */
export type GetInvoiceJobsPayload = {
  __typename?: 'GetInvoiceJobsPayload';
  error?: Maybe<OperationError>;
  invoiceJobs?: Maybe<InvoiceJobConnection>;
};


/** Autogenerated return type of GetInvoiceJobs. */
export type GetInvoiceJobsPayloadInvoiceJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of GetLimitsGroups. */
export type GetLimitsGroupsPayload = {
  __typename?: 'GetLimitsGroupsPayload';
  error?: Maybe<OperationError>;
  limitsGroups?: Maybe<Array<LimitsGroup>>;
};

/** Autogenerated return type of GetLineItemTypesQuery. */
export type GetLineItemTypesQueryPayload = {
  __typename?: 'GetLineItemTypesQueryPayload';
  error?: Maybe<OperationError>;
  lineItemTypes?: Maybe<Array<LineItemType>>;
};

/** Autogenerated return type of GetLocationsForAccount. */
export type GetLocationsForAccountPayload = {
  __typename?: 'GetLocationsForAccountPayload';
  error?: Maybe<OperationError>;
  locations?: Maybe<Array<LocationOption>>;
};

export type GetMarket = {
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of GetMarketNames. */
export type GetMarketNamesPayload = {
  __typename?: 'GetMarketNamesPayload';
  error?: Maybe<OperationError>;
  markets?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of GetMarket. */
export type GetMarketPayload = {
  __typename?: 'GetMarketPayload';
  error?: Maybe<OperationError>;
  market?: Maybe<Market>;
};

/** Autogenerated return type of GetMarketsList. */
export type GetMarketsListPayload = {
  __typename?: 'GetMarketsListPayload';
  error?: Maybe<OperationError>;
  markets?: Maybe<Array<Market>>;
};

/** Autogenerated return type of GetMealTypes. */
export type GetMealTypesPayload = {
  __typename?: 'GetMealTypesPayload';
  error?: Maybe<OperationError>;
  mealTypes?: Maybe<Array<KeyValuePair>>;
};

export type GetMenuChangeRequestsInput = {
  menuTemplateId?: InputMaybe<Scalars['ID']['input']>;
  vendorId: Scalars['ID']['input'];
};

/** Autogenerated return type of GetMenuChangeRequests. */
export type GetMenuChangeRequestsPayload = {
  __typename?: 'GetMenuChangeRequestsPayload';
  error?: Maybe<OperationError>;
  menuChangeRequests?: Maybe<MenuChangeRequestConnection>;
};


/** Autogenerated return type of GetMenuChangeRequests. */
export type GetMenuChangeRequestsPayloadMenuChangeRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type GetMobileOrderingOrderDetails = {
  ids: Array<Scalars['ID']['input']>;
};

export type GetMobileOrderingOrderRequest = {
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of GetMobileOrderingOrderRequest. */
export type GetMobileOrderingOrderRequestPayload = {
  __typename?: 'GetMobileOrderingOrderRequestPayload';
  error?: Maybe<OperationError>;
  orderRequest?: Maybe<MobileOrderingOrderRequest>;
};

export type GetMobileOrderingOrders = {
  /** DEPRECATED: use eventVendorId */
  eventId?: InputMaybe<Scalars['ID']['input']>;
  eventVendorId?: InputMaybe<Scalars['ID']['input']>;
  /** DEPRECATED: use eventVendorId */
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of GetMobileOrderingOrders. */
export type GetMobileOrderingOrdersPayload = {
  __typename?: 'GetMobileOrderingOrdersPayload';
  error?: Maybe<OperationError>;
  orders?: Maybe<Array<MobileOrderingOrder>>;
};

export type GetOrderDetails = {
  requestId: Scalars['ID']['input'];
  userContext?: InputMaybe<UserContext>;
};

/** Autogenerated return type of GetOrderRequestDetails. */
export type GetOrderRequestDetailsPayload = {
  __typename?: 'GetOrderRequestDetailsPayload';
  error?: Maybe<OperationError>;
  order?: Maybe<OrderRequestDetails>;
};

/** Autogenerated return type of GetParentCompanies. */
export type GetParentCompaniesPayload = {
  __typename?: 'GetParentCompaniesPayload';
  error?: Maybe<OperationError>;
  parentCompanies?: Maybe<Array<ParentCompanyOption>>;
};

/** Autogenerated return type of GetPaypalAccessToken. */
export type GetPaypalAccessTokenPayload = {
  __typename?: 'GetPaypalAccessTokenPayload';
  error?: Maybe<OperationError>;
  paypalAccessToken?: Maybe<PaypalAccessToken>;
};

export type GetPhysicalSecurityQuestions = {
  device: DeviceAttributes;
};

/** Autogenerated return type of GetPhysicalSecurityQuestions. */
export type GetPhysicalSecurityQuestionsPayload = {
  __typename?: 'GetPhysicalSecurityQuestionsPayload';
  error?: Maybe<OperationError>;
  lastResponseSubmittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  questions?: Maybe<Array<PhysicalSecurityQuestion>>;
};

export type GetPopupEventVendorMenu = {
  eventVendorId: Scalars['ID']['input'];
};

/** Autogenerated return type of GetPopupEventVendorMenu. */
export type GetPopupEventVendorMenuPayload = {
  __typename?: 'GetPopupEventVendorMenuPayload';
  error?: Maybe<OperationError>;
  taxes?: Maybe<Array<TaxCategoryRate>>;
  vendorMenu?: Maybe<PopupEventVendorMenu>;
};

/** Autogenerated return type of GetPopupEventVendorQuery. */
export type GetPopupEventVendorQueryPayload = {
  __typename?: 'GetPopupEventVendorQueryPayload';
  error?: Maybe<OperationError>;
  popupEventVendor?: Maybe<PopupEventVendor>;
};

export type GetPopupFeedbackForVendors = {
  after: Scalars['ISO8601DateTime']['input'];
  before: Scalars['ISO8601DateTime']['input'];
  vendorIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of GetPopupFeedbackForVendors. */
export type GetPopupFeedbackForVendorsPayload = {
  __typename?: 'GetPopupFeedbackForVendorsPayload';
  error?: Maybe<OperationError>;
  feedback?: Maybe<VendorsPopupFeedback>;
};

export type GetPopupInventoryItem = {
  popupInventoryItemId: Scalars['ID']['input'];
};

/** Autogenerated return type of GetPopupInventoryItem. */
export type GetPopupInventoryItemPayload = {
  __typename?: 'GetPopupInventoryItemPayload';
  error?: Maybe<OperationError>;
  popupInventoryItem?: Maybe<PopupInventoryItem>;
};

export type GetPopupInventoryItemsForVendor = {
  mealTypes?: InputMaybe<Array<InventoryItemMealType>>;
  searchInfo?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

/** Autogenerated return type of GetPopupInventoryItemsForVendor. */
export type GetPopupInventoryItemsForVendorPayload = {
  __typename?: 'GetPopupInventoryItemsForVendorPayload';
  error?: Maybe<OperationError>;
  result?: Maybe<PopupInventoryItemsForVendorType>;
};

export type GetPopupMenuTemplate = {
  menuTemplateId: Scalars['ID']['input'];
};

export type GetPopupMenuTemplateInventoryItem = {
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of GetPopupMenuTemplateInventoryItem. */
export type GetPopupMenuTemplateInventoryItemPayload = {
  __typename?: 'GetPopupMenuTemplateInventoryItemPayload';
  error?: Maybe<OperationError>;
  menuTemplateInventoryItem?: Maybe<PopupMenuTemplateInventoryItem>;
};

/** Autogenerated return type of GetPopupMenuTemplate. */
export type GetPopupMenuTemplatePayload = {
  __typename?: 'GetPopupMenuTemplatePayload';
  error?: Maybe<OperationError>;
  popupMenuTemplate?: Maybe<PopupMenuTemplate>;
};

/** Autogenerated return type of GetPopupOrderDetails. */
export type GetPopupOrderDetailsPayload = {
  __typename?: 'GetPopupOrderDetailsPayload';
  error?: Maybe<OperationError>;
  popupOrderDetails?: Maybe<PopupOrderDetails>;
};

export type GetPopupOrdersListForEventVendors = {
  apiVersions?: InputMaybe<Array<ApiVersion>>;
  eventVendorIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of GetPopupOrdersListForEventVendors. */
export type GetPopupOrdersListForEventVendorsPayload = {
  __typename?: 'GetPopupOrdersListForEventVendorsPayload';
  error?: Maybe<OperationError>;
  popupOrdersList?: Maybe<PopupOrderListItemConnection>;
};


/** Autogenerated return type of GetPopupOrdersListForEventVendors. */
export type GetPopupOrdersListForEventVendorsPayloadPopupOrdersListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of GetProductTypesQuery. */
export type GetProductTypesQueryPayload = {
  __typename?: 'GetProductTypesQueryPayload';
  error?: Maybe<OperationError>;
  productTypes: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of GetPushProvisioningEphemeralKey. */
export type GetPushProvisioningEphemeralKeyPayload = {
  __typename?: 'GetPushProvisioningEphemeralKeyPayload';
  ephemeralKey?: Maybe<PushProvisioningEphemeralKey>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of GetQaToolsQuery. */
export type GetQaToolsQueryPayload = {
  __typename?: 'GetQaToolsQueryPayload';
  error?: Maybe<OperationError>;
  scriptInfo?: Maybe<Array<QaToolsScript>>;
};

/** Autogenerated return type of GetRecommendationModelVersionHistory. */
export type GetRecommendationModelVersionHistoryPayload = {
  __typename?: 'GetRecommendationModelVersionHistoryPayload';
  error?: Maybe<OperationError>;
  versionHistory: Array<VersionHistoryEntry>;
};

/** Autogenerated return type of GetRecommendationsAvailableResolvers. */
export type GetRecommendationsAvailableResolversPayload = {
  __typename?: 'GetRecommendationsAvailableResolversPayload';
  error?: Maybe<OperationError>;
  resolvers: Array<ResolverMetadata>;
};

/** Autogenerated return type of GetRecommendationsCustomPreferences. */
export type GetRecommendationsCustomPreferencesPayload = {
  __typename?: 'GetRecommendationsCustomPreferencesPayload';
  availableTags?: Maybe<Array<KeyValuePair>>;
  error?: Maybe<OperationError>;
  preferences?: Maybe<Array<CustomPreference>>;
  /**
   * Digest of the current selection set; nil when there are none. Compare against
   * the value returned by the update mutation to detect a real change. Opaque — do
   * not parse or send back.
   */
  preferencesVersion?: Maybe<Scalars['String']['output']>;
  /** Ordered groups the customization form renders */
  tagGroups?: Maybe<Array<TagGroup>>;
};

/** Autogenerated return type of GetRecommendationsDetailedFeedback. */
export type GetRecommendationsDetailedFeedbackPayload = {
  __typename?: 'GetRecommendationsDetailedFeedbackPayload';
  detailedFeedback?: Maybe<DetailedFeedback>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of GetRecommendationsEntryPoints. */
export type GetRecommendationsEntryPointsPayload = {
  __typename?: 'GetRecommendationsEntryPointsPayload';
  entryPoints?: Maybe<Array<EntryPoint>>;
  error?: Maybe<OperationError>;
};

/** Get recommendations */
export type GetRecommendationsInput = {
  /** Cross Sell recommendation request data */
  crossSellRequest?: InputMaybe<CrossSellRequestInput>;
  /** Identifier of the recommendation entry point configured in SnapPea */
  entrypointCode: Scalars['String']['input'];
  /** Flavour Me recommendation request data */
  flavourMeRequest?: InputMaybe<FlavourMeRequestInput>;
  /** Existing session UUID to continue (optional) */
  sessionUuid?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the target entity (Event, Item, etc.) */
  targetId: Scalars['ID']['input'];
  /** Type of target entity (Event, SelectEvent, PopupEvent, etc.) */
  targetType: Scalars['String']['input'];
  /** Up Sell recommendation request data */
  upSellRequest?: InputMaybe<UpSellRequestInput>;
};

/** Autogenerated return type of GetRecommendationsModelConfigs. */
export type GetRecommendationsModelConfigsPayload = {
  __typename?: 'GetRecommendationsModelConfigsPayload';
  error?: Maybe<OperationError>;
  modelConfigs?: Maybe<Array<ModelConfig>>;
};

/** Autogenerated return type of GetRecommendationsModelMetricsBatch. */
export type GetRecommendationsModelMetricsBatchPayload = {
  __typename?: 'GetRecommendationsModelMetricsBatchPayload';
  error?: Maybe<OperationError>;
  metrics?: Maybe<Array<ModelMetrics>>;
};

/** Autogenerated return type of GetRecommendationsModelMetrics. */
export type GetRecommendationsModelMetricsPayload = {
  __typename?: 'GetRecommendationsModelMetricsPayload';
  error?: Maybe<OperationError>;
  metrics?: Maybe<ModelMetrics>;
};

/** Response for getting recommendations */
export type GetRecommendationsPayload = {
  __typename?: 'GetRecommendationsPayload';
  error?: Maybe<OperationError>;
  /** Generated recommendations when status is READY */
  recommendationsGroup?: Maybe<RecommendationGroup>;
  /** Session UUID for tracking */
  sessionUuid?: Maybe<Scalars['ID']['output']>;
  /** Request status - determines if client should continue polling */
  status?: Maybe<RecommendationStatus>;
};

/** Autogenerated return type of GetRecommendationsPreviewPrompt. */
export type GetRecommendationsPreviewPromptPayload = {
  __typename?: 'GetRecommendationsPreviewPromptPayload';
  error?: Maybe<OperationError>;
  /** The resolved prompt with all variables replaced */
  previewText: Scalars['String']['output'];
  /** Resolved user profile JSON (from manual input or cache) */
  profileJson?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of GetRecommendationsQuery. */
export type GetRecommendationsQueryPayload = {
  __typename?: 'GetRecommendationsQueryPayload';
  error?: Maybe<OperationError>;
  recommendations?: Maybe<GetRecommendationsPayload>;
};

/** Autogenerated return type of GetRecommendationsTagGroups. */
export type GetRecommendationsTagGroupsPayload = {
  __typename?: 'GetRecommendationsTagGroupsPayload';
  availableTags?: Maybe<Array<KeyValuePair>>;
  error?: Maybe<OperationError>;
  /** Configured tags missing from the catalog */
  staleTags?: Maybe<Array<Scalars['String']['output']>>;
  tagGroups?: Maybe<Array<TagGroup>>;
  versions?: Maybe<Array<TagGroupVersion>>;
};

/** Get Report Configuration input */
export type GetReportsConfigurationsQueryInput = {
  application?: InputMaybe<ApplicationEnum>;
  /** Menu titles of Reports Configurations */
  menuTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  reportsTypes?: InputMaybe<Array<ReportConfigurationTypeEnum>>;
};

/** Autogenerated return type of GetReportsConfigurationsQuery. */
export type GetReportsConfigurationsQueryPayload = {
  __typename?: 'GetReportsConfigurationsQueryPayload';
  /** All requirable roles for FFR and/or FFB Reports */
  allRequirableRoles?: Maybe<Array<Scalars['String']['output']>>;
  error?: Maybe<OperationError>;
  reportsConfigurations?: Maybe<Array<ReportConfigurations>>;
};

/** Arguments to get resident vendors for account */
export type GetResidentVendorsForAccount = {
  accountId: Scalars['ID']['input'];
};

/** Autogenerated return type of GetResidentVendorsForAccount. */
export type GetResidentVendorsForAccountPayload = {
  __typename?: 'GetResidentVendorsForAccountPayload';
  error?: Maybe<OperationError>;
  residentVendors?: Maybe<Array<ResidentVendor>>;
};

/** Autogenerated return type of GetScoringEventTypes. */
export type GetScoringEventTypesPayload = {
  __typename?: 'GetScoringEventTypesPayload';
  error?: Maybe<OperationError>;
  scoringEventTypes?: Maybe<Array<ScoringEventTypeDefinition>>;
};

/** Autogenerated return type of GetSelectEventVendors. */
export type GetSelectEventVendorsPayload = {
  __typename?: 'GetSelectEventVendorsPayload';
  error?: Maybe<OperationError>;
  selectEventVendors?: Maybe<Array<SelectEventVendor>>;
};

export type GetShadowInput = {
  shadowId: Scalars['ID']['input'];
};

/** Autogenerated return type of GetShadow. */
export type GetShadowPayload = {
  __typename?: 'GetShadowPayload';
  error?: Maybe<OperationError>;
  shadow?: Maybe<Shadow>;
};

/** Autogenerated return type of GetSignupConfig. */
export type GetSignupConfigPayload = {
  __typename?: 'GetSignupConfigPayload';
  domain: Scalars['String']['output'];
  error?: Maybe<OperationError>;
  initiationUrl?: Maybe<Scalars['String']['output']>;
  isWorkEmail: Scalars['Boolean']['output'];
  present: Scalars['Boolean']['output'];
  providerName: Scalars['String']['output'];
  signupConfig: SignupConfig;
};

/** Arguments to get a site directions token */
export type GetSiteDirectionsTokenForUser = {
  popupEventVendorId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of GetSiteDirectionsTokenForUserQuery. */
export type GetSiteDirectionsTokenForUserQueryPayload = {
  __typename?: 'GetSiteDirectionsTokenForUserQueryPayload';
  error?: Maybe<OperationError>;
  siteDirectionsToken?: Maybe<SiteDirectionsToken>;
};

/** Autogenerated return type of GetStatesList. */
export type GetStatesListPayload = {
  __typename?: 'GetStatesListPayload';
  error?: Maybe<OperationError>;
  states?: Maybe<Array<State>>;
};

/** Autogenerated return type of GetStripeAccountsForBillingAdmin. */
export type GetStripeAccountsForBillingAdminPayload = {
  __typename?: 'GetStripeAccountsForBillingAdminPayload';
  error?: Maybe<OperationError>;
  stripeAccounts: Array<FoodaCardStripeAccount>;
};

/** Autogenerated return type of GetStripeAccounts. */
export type GetStripeAccountsPayload = {
  __typename?: 'GetStripeAccountsPayload';
  error?: Maybe<OperationError>;
  stripeAccounts: Array<FoodaCardStripeAccount>;
};

/** Autogenerated return type of GetStripeCardEphemeralKey. */
export type GetStripeCardEphemeralKeyPayload = {
  __typename?: 'GetStripeCardEphemeralKeyPayload';
  /** The ephemeral key secret for use with Issuing Elements */
  ephemeralKey?: Maybe<Scalars['String']['output']>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of GetStripeVerificationSession. */
export type GetStripeVerificationSessionPayload = {
  __typename?: 'GetStripeVerificationSessionPayload';
  /** The client secret for use with web integration */
  clientSecret?: Maybe<Scalars['String']['output']>;
  /** The ephemeral key secret for use with mobile SDKs */
  ephemeralKeySecret?: Maybe<Scalars['String']['output']>;
  error?: Maybe<OperationError>;
  /** The Stripe VerificationSession ID */
  verificationSessionId?: Maybe<Scalars['String']['output']>;
};

/** Arguments to get subsidy members */
export type GetSubsidyMembers = {
  accountId: Scalars['ID']['input'];
  programIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  state?: InputMaybe<SubsidyMemberState>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userSearchText?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of GetSubsidyMembersCsvDownloadUrl. */
export type GetSubsidyMembersCsvDownloadUrlPayload = {
  __typename?: 'GetSubsidyMembersCsvDownloadUrlPayload';
  error?: Maybe<OperationError>;
  /** Signed URL for the members CSV export. Always the account's active members. */
  membersCsvDownloadUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of GetSubsidyMembers. */
export type GetSubsidyMembersPayload = {
  __typename?: 'GetSubsidyMembersPayload';
  error?: Maybe<OperationError>;
  /**
   * Distinct programs held by members on the current tab (account + state).
   * Unaffected by search text or the program filter selection -- powers the
   * frontend filter's dropdown options.
   */
  programOptions?: Maybe<Array<SubsidyMemberProgramOption>>;
  subsidyMembers?: Maybe<SubsidyMemberConnection>;
};


/** Autogenerated return type of GetSubsidyMembers. */
export type GetSubsidyMembersPayloadSubsidyMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubsidyMemberSortingField>>;
};

/** Autogenerated return type of GetSubsidyRuleHistory. */
export type GetSubsidyRuleHistoryPayload = {
  __typename?: 'GetSubsidyRuleHistoryPayload';
  error?: Maybe<OperationError>;
  history?: Maybe<Array<SubsidyRuleHistoryEntry>>;
};

/** Autogenerated return type of GetSubsidyRulesQuery. */
export type GetSubsidyRulesQueryPayload = {
  __typename?: 'GetSubsidyRulesQueryPayload';
  accountSettings?: Maybe<AccountSubsidySettings>;
  error?: Maybe<OperationError>;
  guestPassesEnabled?: Maybe<Scalars['Boolean']['output']>;
  printSubsidyQrCodesEnabled?: Maybe<Scalars['Boolean']['output']>;
  subsidyAdmins?: Maybe<Array<User>>;
  subsidyRules?: Maybe<Array<SubsidyRule>>;
};

/** Autogenerated return type of GetTableauTokenQuery. */
export type GetTableauTokenQueryPayload = {
  __typename?: 'GetTableauTokenQueryPayload';
  error?: Maybe<OperationError>;
  token?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of GetTaxCategories. */
export type GetTaxCategoriesPayload = {
  __typename?: 'GetTaxCategoriesPayload';
  error?: Maybe<OperationError>;
  taxCategories?: Maybe<Array<TaxCategory>>;
};

/** Autogenerated return type of GetTaxCategoryTypes. */
export type GetTaxCategoryTypesPayload = {
  __typename?: 'GetTaxCategoryTypesPayload';
  error?: Maybe<OperationError>;
  types: Array<KeyValuePair>;
};

/** Autogenerated return type of GetTaxCategoryVersions. */
export type GetTaxCategoryVersionsPayload = {
  __typename?: 'GetTaxCategoryVersionsPayload';
  error?: Maybe<OperationError>;
  versions?: Maybe<Array<TaxCategoryVersion>>;
};

export type GetTaxCategoryVersionsRequest = {
  taxCategoryId: Scalars['Int']['input'];
};

export type GetTaxRatesInput = {
  addressId: Scalars['ID']['input'];
  taxCategoryIds: Array<Scalars['ID']['input']>;
  timestamp?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of GetTaxRates. */
export type GetTaxRatesPayload = {
  __typename?: 'GetTaxRatesPayload';
  error?: Maybe<OperationError>;
  taxRates?: Maybe<Array<TaxRate>>;
};

export type GetTaxRulesForVendor = {
  vendorId: Scalars['ID']['input'];
};

/** Autogenerated return type of GetTaxRulesForVendor. */
export type GetTaxRulesForVendorPayload = {
  __typename?: 'GetTaxRulesForVendorPayload';
  error?: Maybe<OperationError>;
  taxRules?: Maybe<Array<TaxRule>>;
};

export type GetTenderMethods = {
  /** Filter by account ID */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by availability on a specific date */
  availableOnDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Filter by product type */
  productType?: InputMaybe<ProductEnum>;
  /** Filter by state (active/inactive) */
  state?: InputMaybe<TenderMethodStateEnum>;
};

/** Autogenerated return type of GetTenderMethods. */
export type GetTenderMethodsPayload = {
  __typename?: 'GetTenderMethodsPayload';
  error?: Maybe<OperationError>;
  tenderMethods?: Maybe<TenderMethodConnection>;
};


/** Autogenerated return type of GetTenderMethods. */
export type GetTenderMethodsPayloadTenderMethodsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of GetTodayDeliveryManifestsQuery. */
export type GetTodayDeliveryManifestsQueryPayload = {
  __typename?: 'GetTodayDeliveryManifestsQueryPayload';
  deliveryManifests?: Maybe<Array<FfrDeliveryManifests>>;
  error?: Maybe<OperationError>;
};

export type GetTodoTasksForVendors = {
  /** This is deprecated. Please, use expiresAfter argument */
  dueAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  expiresAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  todoTaskStates?: InputMaybe<Array<StateEnum>>;
  vendorIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of GetTodoTasksForVendorsQuery. */
export type GetTodoTasksForVendorsQueryPayload = {
  __typename?: 'GetTodoTasksForVendorsQueryPayload';
  error?: Maybe<OperationError>;
  todoTasks?: Maybe<Array<TodoTask>>;
};

/** Autogenerated return type of GetUserDeliveryOrders. */
export type GetUserDeliveryOrdersPayload = {
  __typename?: 'GetUserDeliveryOrdersPayload';
  error?: Maybe<OperationError>;
  orders?: Maybe<DeliveryOrderDetailsConnection>;
};


/** Autogenerated return type of GetUserDeliveryOrders. */
export type GetUserDeliveryOrdersPayloadOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of GetUserFoodaCardOrders. */
export type GetUserFoodaCardOrdersPayload = {
  __typename?: 'GetUserFoodaCardOrdersPayload';
  error?: Maybe<OperationError>;
  orders?: Maybe<FoodaCardOrderConnection>;
};


/** Autogenerated return type of GetUserFoodaCardOrders. */
export type GetUserFoodaCardOrdersPayloadOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of GetUserNotes. */
export type GetUserNotesPayload = {
  __typename?: 'GetUserNotesPayload';
  error?: Maybe<OperationError>;
  userNotes?: Maybe<UserNoteConnection>;
};


/** Autogenerated return type of GetUserNotes. */
export type GetUserNotesPayloadUserNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of GetUserQuery. */
export type GetUserQueryPayload = {
  __typename?: 'GetUserQueryPayload';
  error?: Maybe<OperationError>;
  user?: Maybe<User>;
};

export type GetUserSubsidies = {
  product: SubsidyRuleProduct;
  states?: InputMaybe<Array<SubsidyRuleState>>;
};

/** Autogenerated return type of GetUserSubsidies. */
export type GetUserSubsidiesPayload = {
  __typename?: 'GetUserSubsidiesPayload';
  error?: Maybe<OperationError>;
  subsidies?: Maybe<Array<UserSubsidyMembership>>;
};

export type GetUsersInput = {
  roleScope: UserRoleScope;
};

/** Autogenerated return type of GetUsers. */
export type GetUsersPayload = {
  __typename?: 'GetUsersPayload';
  error?: Maybe<OperationError>;
  users?: Maybe<Array<User>>;
};

export type GetVendorAvailabilityInput = {
  month: Scalars['Int']['input'];
  productType: ProductEnum;
  vendorId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

/** Autogenerated return type of GetVendorAvailabilityList. */
export type GetVendorAvailabilityListPayload = {
  __typename?: 'GetVendorAvailabilityListPayload';
  error?: Maybe<OperationError>;
  vendors: Array<VendorAvailabilityListItem>;
};

/** Autogenerated return type of GetVendorAvailability. */
export type GetVendorAvailabilityPayload = {
  __typename?: 'GetVendorAvailabilityPayload';
  availability?: Maybe<VendorAvailabilityDetail>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of GetVendorMembership. */
export type GetVendorMembershipPayload = {
  __typename?: 'GetVendorMembershipPayload';
  error?: Maybe<OperationError>;
  vendorMembership?: Maybe<VendorMembership>;
};

export type GetVendorMenuTemplate = {
  /** Menu template id. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of GetVendorMenuTemplate. */
export type GetVendorMenuTemplatePayload = {
  __typename?: 'GetVendorMenuTemplatePayload';
  error?: Maybe<OperationError>;
  menuTemplate?: Maybe<VendorMenuTemplate>;
};

export type GetVendorMenuTemplates = {
  /** Match templates with ANY of these meal periods. Omit for all. */
  mealPeriods?: InputMaybe<Array<MealPeriodEnum>>;
  /** Filter to these product types. Omit for all. */
  productTypes?: InputMaybe<Array<ProductEnum>>;
  /** Filter to these statuses. Restricted server-side to Published/Approved/Pending Approval. */
  states?: InputMaybe<Array<MenuTemplateStateEnum>>;
  vendorId: Scalars['ID']['input'];
};

/** Autogenerated return type of GetVendorMenuTemplates. */
export type GetVendorMenuTemplatesPayload = {
  __typename?: 'GetVendorMenuTemplatesPayload';
  error?: Maybe<OperationError>;
  menuTemplates?: Maybe<Array<MenuTemplateSummary>>;
};

/** Autogenerated return type of GetVendorPopupCapacityQuery. */
export type GetVendorPopupCapacityQueryPayload = {
  __typename?: 'GetVendorPopupCapacityQueryPayload';
  error?: Maybe<OperationError>;
  /** Read from the vendor's popup scheduling constraint */
  maxEventsPerDay?: Maybe<Scalars['Int']['output']>;
  /** Read from the vendor's popup scheduling constraint */
  maxEventsPerWeek?: Maybe<Scalars['Int']['output']>;
  vendor?: Maybe<PopupCapacityVendor>;
};

/** Grouped User Cards Type */
export type GroupedUserCards = {
  __typename?: 'GroupedUserCards';
  cards?: Maybe<Array<Card>>;
  parentCardId: Scalars['ID']['output'];
};

export enum GroupingEnum {
  /** Event Grouping */
  Event = 'Event',
  /** Onboarding Grouping */
  Onboarding = 'Onboarding',
  /** Schedule Grouping */
  Schedule = 'Schedule'
}

export enum GuestPassDistribution {
  Email = 'EMAIL',
  Print = 'PRINT'
}

/** A health department jurisdiction */
export type HealthDepartmentJurisdiction = {
  __typename?: 'HealthDepartmentJurisdiction';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type HealthDepartmentJurisdictionInput = {
  _destroy: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

/** A historical meals sold factor */
export type HistoricalMealsSoldFactor = {
  relevant: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  valueAsString: Scalars['String']['output'];
};

/** Hour range for time-based restrictions. Times in HH:MM format (00:00 to 23:59) */
export type HourRangeInput = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

/** A user ineligible for backtesting with the reason */
export type IneligibleUser = {
  __typename?: 'IneligibleUser';
  reason: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

/** An Allergen or Sensitivity answered for an inventory item */
export type InventoryItemAllergenInput = {
  code: AllergenCode;
  status: AllergenStatus;
};

/**
 * An item's Dietary Preferences and Allergens and Sensitivities as answered in
 * Snappea, in the shape of MenuItemDietaryInfo. The lists replace the item's answers.
 */
export type InventoryItemDietaryInfoInput = {
  /** Allergens and Sensitivities the item contains or does not contain. An allergen not listed is Not Specified. */
  allergens: Array<InventoryItemAllergenInput>;
  /** Dietary Preferences answered Yes or No. A preference not listed is Not Specified. */
  preferences: Array<InventoryItemDietaryPreferenceInput>;
};

/** A Dietary Preference answered for an inventory item */
export type InventoryItemDietaryPreferenceInput = {
  code: DietaryPreferenceCode;
  status: DietaryPreferenceStatus;
};

export enum InventoryItemDietaryRestrictions {
  ContainsNuts = 'CONTAINS_NUTS',
  DairyFree = 'DAIRY_FREE',
  GlutenFree = 'GLUTEN_FREE',
  Halal = 'HALAL',
  HeartHealthy = 'HEART_HEALTHY',
  Kosher = 'KOSHER',
  SoyFree = 'SOY_FREE',
  Vegan = 'VEGAN',
  Vegetarian = 'VEGETARIAN'
}

export enum InventoryItemExternalTags {
  Bacon = 'BACON',
  Bagels = 'BAGELS',
  Bakery = 'BAKERY',
  Beans = 'BEANS',
  Beef = 'BEEF',
  Beverages = 'BEVERAGES',
  BoxedLunch = 'BOXED_LUNCH',
  Bread = 'BREAD',
  Breakfast = 'BREAKFAST',
  Burritos = 'BURRITOS',
  Cheese = 'CHEESE',
  Chicken = 'CHICKEN',
  ChickenSandwich = 'CHICKEN_SANDWICH',
  Chili = 'CHILI',
  Chips = 'CHIPS',
  CoffeeAndTea = 'COFFEE_AND_TEA',
  ComfortFood = 'COMFORT_FOOD',
  Crepes = 'CREPES',
  DessertAndSweets = 'DESSERT_AND_SWEETS',
  DimSum = 'DIM_SUM',
  DipsAndSpreads = 'DIPS_AND_SPREADS',
  Dumplings = 'DUMPLINGS',
  Eggs = 'EGGS',
  Empanada = 'EMPANADA',
  Falafel = 'FALAFEL',
  Flatbread = 'FLATBREAD',
  FreshFruits = 'FRESH_FRUITS',
  Fries = 'FRIES',
  Grilled = 'GRILLED',
  Gyro = 'GYRO',
  Hamburgers = 'HAMBURGERS',
  Healthy = 'HEALTHY',
  HotDogs = 'HOT_DOGS',
  IceCream = 'ICE_CREAM',
  ItalianMeats = 'ITALIAN_MEATS',
  Lamb = 'LAMB',
  Legumes = 'LEGUMES',
  Lunch = 'LUNCH',
  Noodles = 'NOODLES',
  Organic = 'ORGANIC',
  Panini = 'PANINI',
  Pasta = 'PASTA',
  Pitas = 'PITAS',
  Pizza = 'PIZZA',
  Pork = 'PORK',
  Potato = 'POTATO',
  Poultry = 'POULTRY',
  Premium = 'PREMIUM',
  QualcommFreshFood = 'QUALCOMM_FRESH_FOOD',
  Ribs = 'RIBS',
  RiceAndGrains = 'RICE_AND_GRAINS',
  Salads = 'SALADS',
  Sandwiches = 'SANDWICHES',
  Sausage = 'SAUSAGE',
  Seafood = 'SEAFOOD',
  Skewers = 'SKEWERS',
  SmoothiesAndJuices = 'SMOOTHIES_AND_JUICES',
  SoftDrinks = 'SOFT_DRINKS',
  SoupsAndStews = 'SOUPS_AND_STEWS',
  Spicy = 'SPICY',
  Steak = 'STEAK',
  Subs = 'SUBS',
  Sushi = 'SUSHI',
  Taco = 'TACO',
  Tapas = 'TAPAS',
  Turkey = 'TURKEY',
  Vegetables = 'VEGETABLES',
  Wings = 'WINGS',
  Wraps = 'WRAPS'
}

export enum InventoryItemInternalTags {
  Bacon = 'BACON',
  Bagels = 'BAGELS',
  Bakery = 'BAKERY',
  Beans = 'BEANS',
  Beef = 'BEEF',
  Beverages = 'BEVERAGES',
  BoxedLunch = 'BOXED_LUNCH',
  Bread = 'BREAD',
  Breakfast = 'BREAKFAST',
  Burritos = 'BURRITOS',
  Cheese = 'CHEESE',
  Chicken = 'CHICKEN',
  ChickenSandwich = 'CHICKEN_SANDWICH',
  Chili = 'CHILI',
  Chips = 'CHIPS',
  CoffeeAndTea = 'COFFEE_AND_TEA',
  ComfortFood = 'COMFORT_FOOD',
  Crepes = 'CREPES',
  DessertAndSweets = 'DESSERT_AND_SWEETS',
  DimSum = 'DIM_SUM',
  DipsAndSpreads = 'DIPS_AND_SPREADS',
  Dumplings = 'DUMPLINGS',
  Eggs = 'EGGS',
  Empanada = 'EMPANADA',
  Falafel = 'FALAFEL',
  Flatbread = 'FLATBREAD',
  FreshFruits = 'FRESH_FRUITS',
  Fries = 'FRIES',
  Grilled = 'GRILLED',
  Gyro = 'GYRO',
  Hamburgers = 'HAMBURGERS',
  Healthy = 'HEALTHY',
  HotDogs = 'HOT_DOGS',
  IceCream = 'ICE_CREAM',
  ItalianMeats = 'ITALIAN_MEATS',
  Lamb = 'LAMB',
  Legumes = 'LEGUMES',
  Lunch = 'LUNCH',
  Noodles = 'NOODLES',
  Organic = 'ORGANIC',
  Panini = 'PANINI',
  Pasta = 'PASTA',
  Pitas = 'PITAS',
  Pizza = 'PIZZA',
  Pork = 'PORK',
  Potato = 'POTATO',
  Poultry = 'POULTRY',
  Premium = 'PREMIUM',
  QualcommFreshFood = 'QUALCOMM_FRESH_FOOD',
  Ribs = 'RIBS',
  RiceAndGrains = 'RICE_AND_GRAINS',
  Salads = 'SALADS',
  Sandwiches = 'SANDWICHES',
  Sausage = 'SAUSAGE',
  Seafood = 'SEAFOOD',
  Skewers = 'SKEWERS',
  SmoothiesAndJuices = 'SMOOTHIES_AND_JUICES',
  SoftDrinks = 'SOFT_DRINKS',
  SoupsAndStews = 'SOUPS_AND_STEWS',
  Spicy = 'SPICY',
  Steak = 'STEAK',
  Subs = 'SUBS',
  Sushi = 'SUSHI',
  Taco = 'TACO',
  Tapas = 'TAPAS',
  Turkey = 'TURKEY',
  Vegetables = 'VEGETABLES',
  Wings = 'WINGS',
  Wraps = 'WRAPS'
}

export enum InventoryItemMealType {
  Appetizers = 'APPETIZERS',
  Beverages = 'BEVERAGES',
  Combinations = 'COMBINATIONS',
  Desserts = 'DESSERTS',
  Entrees = 'ENTREES',
  RentalItems = 'RENTAL_ITEMS',
  Retail = 'RETAIL',
  RetailBakery = 'RETAIL_BAKERY',
  RetailBeverages = 'RETAIL_BEVERAGES',
  RetailGng = 'RETAIL_GNG',
  RetailRefrigeratedSnacks = 'RETAIL_REFRIGERATED_SNACKS',
  RetailSnacks = 'RETAIL_SNACKS',
  Salads = 'SALADS',
  Sides = 'SIDES'
}

/** A meal type filter for inventory type */
export type InventoryItemMealTypeFilter = {
  __typename?: 'InventoryItemMealTypeFilter';
  count: Scalars['Int']['output'];
  key: InventoryItemMealType;
  name: Scalars['String']['output'];
};

export enum InventoryItemTemperatureClassification {
  Cold = 'COLD',
  Hot = 'HOT',
  Off = 'OFF'
}

/** An invoice job */
export type InvoiceJob = {
  __typename?: 'InvoiceJob';
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  invoiceTasks?: Maybe<Array<InvoiceTask>>;
  jobType: Scalars['String']['output'];
  startedAt: Scalars['ISO8601DateTime']['output'];
  state: Scalars['String']['output'];
  subjectId: Scalars['ID']['output'];
  subjectType: Scalars['String']['output'];
  totalDurationSeconds?: Maybe<Scalars['Int']['output']>;
};

/** The connection type for InvoiceJob. */
export type InvoiceJobConnection = {
  __typename?: 'InvoiceJobConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InvoiceJobEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<InvoiceJob>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type InvoiceJobEdge = {
  __typename?: 'InvoiceJobEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InvoiceJob>;
};

/** An invoice task */
export type InvoiceTask = {
  __typename?: 'InvoiceTask';
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  startedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  state: Scalars['String']['output'];
  subjectId: Scalars['ID']['output'];
  subjectType: Scalars['String']['output'];
  totalDurationSeconds?: Maybe<Scalars['Int']['output']>;
};

/** Fooda rewards wallet for iOS */
export type IosWallet = {
  __typename?: 'IosWallet';
  downloadLink?: Maybe<Scalars['String']['output']>;
  passes: Array<IosWalletPass>;
};

/** A Fooda rewards iOS wallet pass */
export type IosWalletPass = {
  __typename?: 'IosWalletPass';
  passTypeIdentifier: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
};

export type KeyValuePair = {
  __typename?: 'KeyValuePair';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type LightweightUser = {
  __typename?: 'LightweightUser';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

/** The connection type for LightweightUser. */
export type LightweightUserConnection = {
  __typename?: 'LightweightUserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LightweightUserEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LightweightUser>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LightweightUserEdge = {
  __typename?: 'LightweightUserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LightweightUser>;
};

/** Recommendations Limits Group */
export type LimitsGroup = {
  __typename?: 'LimitsGroup';
  createdAt: Scalars['ISO8601DateTime']['output'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  maxDailyCostCents?: Maybe<Scalars['Int']['output']>;
  maxMonthlyCostCents?: Maybe<Scalars['Int']['output']>;
  maxSessionCostCents?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A LineItemType - template for creating autogenerated line items */
export type LineItemType = {
  __typename?: 'LineItemType';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  eventFinanceLineItemType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAvailableForUser: Scalars['Boolean']['output'];
  lineItemSubType?: Maybe<Scalars['String']['output']>;
  lineItemType?: Maybe<Scalars['String']['output']>;
  productType: Scalars['String']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  taxCategoryId?: Maybe<Scalars['Int']['output']>;
  taxCategoryType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated return type of ListBacktestRuns. */
export type ListBacktestRunsPayload = {
  __typename?: 'ListBacktestRunsPayload';
  error?: Maybe<OperationError>;
  runs?: Maybe<Array<BacktestRunSummary>>;
};

/** A location */
export type Location = {
  __typename?: 'Location';
  accountName?: Maybe<Scalars['String']['output']>;
  audienceSize?: Maybe<Scalars['Int']['output']>;
  building: Building;
  buildingAddressNotes: Scalars['String']['output'];
  cafeLocation?: Maybe<CafeLocation>;
  deliveryEventInstructions: Scalars['String']['output'];
  hideFromSearch: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  menuType: Menu;
  name: Scalars['String']['output'];
  siteDirectionsDocUrl?: Maybe<Scalars['String']['output']>;
};

/** A location offered as a picker option, with its address as the secondary line */
export type LocationOption = {
  __typename?: 'LocationOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  secondaryLine?: Maybe<Scalars['String']['output']>;
};

/** A location with public access */
export type LocationPublic = {
  __typename?: 'LocationPublic';
  building: BuildingPublic;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MakePopupMenuItemAvailable = {
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of MakePopupMenuItemAvailable. */
export type MakePopupMenuItemAvailablePayload = {
  __typename?: 'MakePopupMenuItemAvailablePayload';
  error?: Maybe<OperationError>;
  item?: Maybe<PopupEventMenuItem>;
};

export type MakePopupMenuItemUnavailable = {
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of MakePopupMenuItemUnavailable. */
export type MakePopupMenuItemUnavailablePayload = {
  __typename?: 'MakePopupMenuItemUnavailablePayload';
  error?: Maybe<OperationError>;
  item?: Maybe<PopupEventMenuItem>;
};

/** Autogenerated return type of MakePopupMenuItemsAvailable. */
export type MakePopupMenuItemsAvailablePayload = {
  __typename?: 'MakePopupMenuItemsAvailablePayload';
  error?: Maybe<OperationError>;
  items?: Maybe<Array<PopupEventMenuItem>>;
};

/** Autogenerated return type of MakePopupMenuItemsUnavailable. */
export type MakePopupMenuItemsUnavailablePayload = {
  __typename?: 'MakePopupMenuItemsUnavailablePayload';
  error?: Maybe<OperationError>;
  items?: Maybe<Array<PopupEventMenuItem>>;
};

export type MarkOrderRequestCanceled = {
  paymentGatewayInfo?: InputMaybe<CanceledPaymentGatewayInfo>;
  requestId: Scalars['UUID']['input'];
};

/** Autogenerated return type of MarkOrderRequestCanceled. */
export type MarkOrderRequestCanceledPayload = {
  __typename?: 'MarkOrderRequestCanceledPayload';
  error?: Maybe<OperationError>;
  orderRequest?: Maybe<OrderRequest>;
};

export type MarkOrderRequestsAborted = {
  requestIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of MarkOrderRequestsAborted. */
export type MarkOrderRequestsAbortedPayload = {
  __typename?: 'MarkOrderRequestsAbortedPayload';
  abortedOrderRequestIds?: Maybe<Array<Scalars['ID']['output']>>;
  error?: Maybe<OperationError>;
};

export type MarkReadyForPickupMobileOrderingOrder = {
  id: Scalars['ID']['input'];
  version: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkReadyForPickupMobileOrderingOrder. */
export type MarkReadyForPickupMobileOrderingOrderPayload = {
  __typename?: 'MarkReadyForPickupMobileOrderingOrderPayload';
  error?: Maybe<OperationError>;
  order?: Maybe<MobileOrderingOrder>;
};

export type MarkShadowFalsePositiveInput = {
  mode: ShadowFalsePositiveModeEnum;
  shadowId: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkShadowFalsePositive. */
export type MarkShadowFalsePositivePayload = {
  __typename?: 'MarkShadowFalsePositivePayload';
  error?: Maybe<OperationError>;
  shadow?: Maybe<Shadow>;
};

/** A market */
export type Market = {
  __typename?: 'Market';
  accountingMarketName?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  checkAverage?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  defaultAccountantId: Scalars['ID']['output'];
  defaultCrossDockId?: Maybe<Scalars['ID']['output']>;
  defaultOperationEmail: Scalars['String']['output'];
  defaultTaxRate: Scalars['Float']['output'];
  defaultTaxRemitter: TaxRemitter;
  deliveryDocks?: Maybe<Array<CrossDock>>;
  deliverySupportPhoneNumber?: Maybe<Scalars['String']['output']>;
  directorId?: Maybe<Scalars['ID']['output']>;
  displayCommission: Scalars['Boolean']['output'];
  foodaEmployeeOptions?: Maybe<LightweightUserConnection>;
  healthDepartmentJurisdictions?: Maybe<Array<HealthDepartmentJurisdiction>>;
  id: Scalars['ID']['output'];
  isAbleToCreateJurisdiction: Scalars['Boolean']['output'];
  isAbleToDeleteJurisdiction: Scalars['Boolean']['output'];
  marketCohortName?: Maybe<Scalars['String']['output']>;
  marketManifestTime?: Maybe<MarketManifestTime>;
  name: Scalars['String']['output'];
  officeDefaultEmail?: Maybe<Scalars['String']['output']>;
  officeDefaultFax?: Maybe<Scalars['String']['output']>;
  officeDefaultPhone?: Maybe<Scalars['String']['output']>;
  officeDefaultSms?: Maybe<Scalars['String']['output']>;
  popupSupportPhoneNumber?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  vendorId?: Maybe<Scalars['ID']['output']>;
  vendors?: Maybe<VendorConnection>;
  zipCodes?: Maybe<Array<Scalars['String']['output']>>;
};


/** A market */
export type MarketFoodaEmployeeOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A market */
export type MarketVendorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type MarketManifestCapacity = {
  __typename?: 'MarketManifestCapacity';
  capacity: Scalars['Int']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  market: Scalars['String']['output'];
  marketManifestTimeId?: Maybe<Scalars['ID']['output']>;
  time: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
  vendorConstraintId?: Maybe<Scalars['ID']['output']>;
};

/** A market manifest time */
export type MarketManifestTime = {
  __typename?: 'MarketManifestTime';
  breakfast?: Maybe<Array<Scalars['String']['output']>>;
  dinner?: Maybe<Array<Scalars['String']['output']>>;
  lunch?: Maybe<Array<Scalars['String']['output']>>;
};

export type MarketManifestTimeCapacity = {
  __typename?: 'MarketManifestTimeCapacity';
  breakfast?: Maybe<Array<MarketManifestCapacity>>;
  dinner?: Maybe<Array<MarketManifestCapacity>>;
  lunch?: Maybe<Array<MarketManifestCapacity>>;
};

export type MarketManifestTimeInput = {
  breakfast?: InputMaybe<Array<Scalars['String']['input']>>;
  dinner?: InputMaybe<Array<Scalars['String']['input']>>;
  lunch?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum MarketScope {
  AllAccountingMarketNames = 'ALL_ACCOUNTING_MARKET_NAMES',
  AllCohortNames = 'ALL_COHORT_NAMES',
  AllNames = 'ALL_NAMES'
}

/** A marketing segment */
export type MarketingSegment = {
  __typename?: 'MarketingSegment';
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  providerName: MarketingSegmentProviderEnum;
  segmentType: MarketingSegmentTypeEnum;
  state: MarketingSegmentStateEnum;
};

/** Marketing segment provider */
export enum MarketingSegmentProviderEnum {
  /** Mo Engage provider */
  MoEngage = 'MO_ENGAGE'
}

/** Marketing segment state */
export enum MarketingSegmentStateEnum {
  /** Segment is active */
  Active = 'ACTIVE',
  /** Segment is archived */
  Archived = 'ARCHIVED'
}

/** Marketing segment type */
export enum MarketingSegmentTypeEnum {
  /** Account segment */
  Account = 'ACCOUNT'
}

export enum MealPeriodEnum {
  Appetizers = 'APPETIZERS',
  Breakfast = 'BREAKFAST',
  Dinner = 'DINNER',
  Lunch = 'LUNCH'
}

export type MealPeriodsInput = {
  appetizers: Scalars['Boolean']['input'];
  breakfast: Scalars['Boolean']['input'];
  dinner: Scalars['Boolean']['input'];
  lunch: Scalars['Boolean']['input'];
};

/** Meal prep info for a vendor in a popup event */
export type MealPrep = {
  __typename?: 'MealPrep';
  factors?: Maybe<Array<MealPrepFactor>>;
  prepFor?: Maybe<Scalars['Int']['output']>;
};

/** Meal prep factor for a vendor in a popup event */
export type MealPrepFactor = {
  __typename?: 'MealPrepFactor';
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** User rewards membership details */
export type Membership = {
  __typename?: 'Membership';
  qrInfo: Scalars['String']['output'];
  walletInfo?: Maybe<Wallet>;
};

export enum Menu {
  ChannelPartnership = 'CHANNEL_PARTNERSHIP',
  FoodHall = 'FOOD_HALL',
  Popup = 'POPUP',
  PrePaidPopup = 'PRE_PAID_POPUP'
}

export type MenuCategory = {
  __typename?: 'MenuCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MenuChangeAddItemToMenu = {
  __typename?: 'MenuChangeAddItemToMenu';
  category: MenuChangeCategoryChoice;
  inventoryItemRef: Scalars['ID']['output'];
};

export type MenuChangeAddItemToMenuInput = {
  category: MenuChangeCategoryChoiceInput;
  inventoryItemRef: Scalars['ID']['input'];
};

export type MenuChangeAddOption = {
  __typename?: 'MenuChangeAddOption';
  option: MenuChangeOptionEntry;
  parentRef: Scalars['ID']['output'];
  scope: MenuChangeEditScope;
};

export type MenuChangeAddOptionGroup = {
  __typename?: 'MenuChangeAddOptionGroup';
  parentRef: Scalars['ID']['output'];
  scope: MenuChangeEditScope;
  subtree: MenuChangeOptionGroupSubtree;
};

export type MenuChangeAddOptionGroupInput = {
  parentRef: Scalars['ID']['input'];
  scope: MenuChangeEditScope;
  subtree: MenuChangeOptionGroupSubtreeInput;
};

export type MenuChangeAddOptionInput = {
  option: MenuChangeOptionEntryInput;
  parentRef: Scalars['ID']['input'];
  scope: MenuChangeEditScope;
};

export type MenuChangeBooleanValue = {
  __typename?: 'MenuChangeBooleanValue';
  boolean: Scalars['Boolean']['output'];
};

export type MenuChangeCategoryChoice = MenuChangeExistingCategory | MenuChangeNewCategory;

export type MenuChangeCategoryChoiceInput =
  { categoryRef: Scalars['ID']['input']; newCategory?: never; }
  |  { categoryRef?: never; newCategory: MenuChangeNewCategoryInput; };

export type MenuChangeCategoryRefValue = {
  __typename?: 'MenuChangeCategoryRefValue';
  categoryRef: Scalars['ID']['output'];
};

export type MenuChangeCentsInput = {
  cents: Scalars['Int']['input'];
};

export type MenuChangeCentsValue = {
  __typename?: 'MenuChangeCentsValue';
  cents: Scalars['Int']['output'];
};

export type MenuChangeCountInput = {
  count: Scalars['Int']['input'];
};

export type MenuChangeCountValue = {
  __typename?: 'MenuChangeCountValue';
  count: Scalars['Int']['output'];
};

export enum MenuChangeDecisionSource {
  Auto = 'AUTO',
  Reviewer = 'REVIEWER'
}

export type MenuChangeDisplaySnapshot = {
  __typename?: 'MenuChangeDisplaySnapshot';
  categoryName?: Maybe<Scalars['String']['output']>;
  parentName?: Maybe<Scalars['String']['output']>;
  targetName?: Maybe<Scalars['String']['output']>;
};

export enum MenuChangeEditBlockedReason {
  /** FFR editing is not turned on for this menu's product yet. */
  EditingNotAvailable = 'EDITING_NOT_AVAILABLE',
  /** An integration manages items on this menu, so it cannot be edited in FFR. */
  IntegrationManaged = 'INTEGRATION_MANAGED',
  /** Fooda has locked this menu for FFR editing. */
  LockedByFooda = 'LOCKED_BY_FOODA',
  /** The menu is hidden from FFR, a draft or expired. */
  MenuNotActive = 'MENU_NOT_ACTIVE',
  /** The signed-in user can view this menu but not edit it, e.g. crew. */
  NotAManager = 'NOT_A_MANAGER',
  /** FFR editing is not available for this type of menu. */
  ProductNotSupported = 'PRODUCT_NOT_SUPPORTED',
  /** Changes to this menu need a Fooda review, which is not available yet. */
  ReviewRequiredNotAvailable = 'REVIEW_REQUIRED_NOT_AVAILABLE'
}

export enum MenuChangeEditScope {
  AllMenus = 'ALL_MENUS',
  ThisMenu = 'THIS_MENU'
}

export enum MenuChangeErrorCode {
  ApplyFailed = 'APPLY_FAILED',
  CategoryAlreadyExists = 'CATEGORY_ALREADY_EXISTS',
  ConflictsWithRemoval = 'CONFLICTS_WITH_REMOVAL',
  DuplicateLine = 'DUPLICATE_LINE',
  FieldNotAllowed = 'FIELD_NOT_ALLOWED',
  GateOff = 'GATE_OFF',
  IdempotencyKeyConflict = 'IDEMPOTENCY_KEY_CONFLICT',
  ItemTypeNotAllowed = 'ITEM_TYPE_NOT_ALLOWED',
  ItemUsedOutsideDelivery = 'ITEM_USED_OUTSIDE_DELIVERY',
  MarkupRejected = 'MARKUP_REJECTED',
  MenuLocked = 'MENU_LOCKED',
  NotAuthorized = 'NOT_AUTHORIZED',
  NotImplemented = 'NOT_IMPLEMENTED',
  NotOwned = 'NOT_OWNED',
  OptionNotAllowedInGroup = 'OPTION_NOT_ALLOWED_IN_GROUP',
  OptionUsedOutsideDelivery = 'OPTION_USED_OUTSIDE_DELIVERY',
  PriceOutOfRange = 'PRICE_OUT_OF_RANGE',
  ProductTypeNotSupported = 'PRODUCT_TYPE_NOT_SUPPORTED',
  ReviewRequiredNotAvailable = 'REVIEW_REQUIRED_NOT_AVAILABLE',
  RuleGroupHasNoOptions = 'RULE_GROUP_HAS_NO_OPTIONS',
  RuleMaxBelowRequired = 'RULE_MAX_BELOW_REQUIRED',
  RuleNegativeCount = 'RULE_NEGATIVE_COUNT',
  RuleRequiredExceedsOptions = 'RULE_REQUIRED_EXCEEDS_OPTIONS',
  ScopeNotAllowed = 'SCOPE_NOT_ALLOWED',
  SubtreeTooLarge = 'SUBTREE_TOO_LARGE',
  TargetGone = 'TARGET_GONE',
  TaxCategoryNotAllowed = 'TAX_CATEGORY_NOT_ALLOWED',
  TemplateNotEditable = 'TEMPLATE_NOT_EDITABLE',
  TextTooLong = 'TEXT_TOO_LONG',
  TooManyLines = 'TOO_MANY_LINES',
  UploadNotOwned = 'UPLOAD_NOT_OWNED',
  UploadNotReady = 'UPLOAD_NOT_READY',
  ValueChanged = 'VALUE_CHANGED',
  ValueKindNotAllowed = 'VALUE_KIND_NOT_ALLOWED'
}

export type MenuChangeExistingCategory = {
  __typename?: 'MenuChangeExistingCategory';
  categoryRef: Scalars['ID']['output'];
};

export type MenuChangeExistingOptionEntry = {
  __typename?: 'MenuChangeExistingOptionEntry';
  optionRef: Scalars['ID']['output'];
};

export type MenuChangeExistingOptionInput = {
  optionRef: Scalars['ID']['input'];
};

export enum MenuChangeField {
  Category = 'CATEGORY',
  Description = 'DESCRIPTION',
  Image = 'IMAGE',
  ItemType = 'ITEM_TYPE',
  Max = 'MAX',
  Name = 'NAME',
  NamePublic = 'NAME_PUBLIC',
  NameVendor = 'NAME_VENDOR',
  Price = 'PRICE',
  PriceType = 'PRICE_TYPE',
  Required = 'REQUIRED',
  ShowOnMenu = 'SHOW_ON_MENU',
  TaxCategory = 'TAX_CATEGORY',
  UsableAsOption = 'USABLE_AS_OPTION'
}

export type MenuChangeFieldEdit = {
  __typename?: 'MenuChangeFieldEdit';
  field: MenuChangeField;
  fromValue: MenuChangeValue;
  parentRef: Scalars['ID']['output'];
  scope: MenuChangeEditScope;
  targetKind: MenuChangeTargetKind;
  targetRef: Scalars['ID']['output'];
  toValue: MenuChangeValue;
};

export type MenuChangeFieldEditInput = {
  field: MenuChangeField;
  fromValue: MenuChangeValueInput;
  parentRef: Scalars['ID']['input'];
  scope: MenuChangeEditScope;
  targetKind: MenuChangeTargetKind;
  targetRef: Scalars['ID']['input'];
  toValue: MenuChangeValueInput;
};

export type MenuChangeImageRefValue = {
  __typename?: 'MenuChangeImageRefValue';
  imageRef: Scalars['ID']['output'];
};

export type MenuChangeInput =
  { addItemToMenu: MenuChangeAddItemToMenuInput; addOption?: never; addOptionGroup?: never; fieldEdit?: never; newItem?: never; removeItemFromMenu?: never; removeOption?: never; removeOptionGroup?: never; }
  |  { addItemToMenu?: never; addOption: MenuChangeAddOptionInput; addOptionGroup?: never; fieldEdit?: never; newItem?: never; removeItemFromMenu?: never; removeOption?: never; removeOptionGroup?: never; }
  |  { addItemToMenu?: never; addOption?: never; addOptionGroup: MenuChangeAddOptionGroupInput; fieldEdit?: never; newItem?: never; removeItemFromMenu?: never; removeOption?: never; removeOptionGroup?: never; }
  |  { addItemToMenu?: never; addOption?: never; addOptionGroup?: never; fieldEdit: MenuChangeFieldEditInput; newItem?: never; removeItemFromMenu?: never; removeOption?: never; removeOptionGroup?: never; }
  |  { addItemToMenu?: never; addOption?: never; addOptionGroup?: never; fieldEdit?: never; newItem: MenuChangeNewItemInput; removeItemFromMenu?: never; removeOption?: never; removeOptionGroup?: never; }
  |  { addItemToMenu?: never; addOption?: never; addOptionGroup?: never; fieldEdit?: never; newItem?: never; removeItemFromMenu: MenuChangeRemoveItemFromMenuInput; removeOption?: never; removeOptionGroup?: never; }
  |  { addItemToMenu?: never; addOption?: never; addOptionGroup?: never; fieldEdit?: never; newItem?: never; removeItemFromMenu?: never; removeOption: MenuChangeRemoveOptionInput; removeOptionGroup?: never; }
  |  { addItemToMenu?: never; addOption?: never; addOptionGroup?: never; fieldEdit?: never; newItem?: never; removeItemFromMenu?: never; removeOption?: never; removeOptionGroup: MenuChangeRemoveOptionGroupInput; };

export enum MenuChangeInputKind {
  Boolean = 'BOOLEAN',
  Category = 'CATEGORY',
  Cents = 'CENTS',
  Count = 'COUNT',
  CountOrNoMaximum = 'COUNT_OR_NO_MAXIMUM',
  Image = 'IMAGE',
  ItemType = 'ITEM_TYPE',
  TaxCategory = 'TAX_CATEGORY',
  Text = 'TEXT'
}

export type MenuChangeItemTypeOption = {
  __typename?: 'MenuChangeItemTypeOption';
  label: Scalars['String']['output'];
  value: InventoryItemMealType;
};

export type MenuChangeItemTypeValue = {
  __typename?: 'MenuChangeItemTypeValue';
  itemType: InventoryItemMealType;
};

export type MenuChangeLine = {
  __typename?: 'MenuChangeLine';
  change: MenuChangeLineChange;
  clientLineId: Scalars['String']['output'];
  display: MenuChangeDisplaySnapshot;
  /** Why the line FAILED. Set on FAILED lines only; reviewer feedback is the request's decisionComment. */
  outcomeCode?: Maybe<MenuChangeErrorCode>;
  /** The system's message for outcomeCode, never exception text. Set on FAILED lines only. */
  reason?: Maybe<Scalars['String']['output']>;
  state: MenuChangeLineState;
};

export type MenuChangeLineChange = MenuChangeAddItemToMenu | MenuChangeAddOption | MenuChangeAddOptionGroup | MenuChangeFieldEdit | MenuChangeNewItem | MenuChangeRemoveItemFromMenu | MenuChangeRemoveOption | MenuChangeRemoveOptionGroup;

export type MenuChangeLineError = {
  __typename?: 'MenuChangeLineError';
  clientLineId: Scalars['String']['output'];
  code: MenuChangeErrorCode;
  current?: Maybe<MenuChangeValue>;
  message: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
};

export type MenuChangeLineInput = {
  change: MenuChangeInput;
  clientLineId: Scalars['String']['input'];
};

/**
 * Follows the line's request: every line is REJECTED when the request is rejected
 * and WITHDRAWN when it is withdrawn. A FAILED line carries its outcomeCode and reason.
 */
export enum MenuChangeLineState {
  Applied = 'APPLIED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Withdrawn = 'WITHDRAWN'
}

export type MenuChangeMaxInput =
  { count: Scalars['Int']['input']; noMaximum?: never; }
  |  { count?: never; noMaximum: MenuChangeNoMaximum; };

export type MenuChangeNewCategory = {
  __typename?: 'MenuChangeNewCategory';
  name: Scalars['String']['output'];
};

export type MenuChangeNewCategoryInput = {
  name: Scalars['String']['input'];
};

export type MenuChangeNewCategoryNameValue = {
  __typename?: 'MenuChangeNewCategoryNameValue';
  newCategoryName: Scalars['String']['output'];
};

export type MenuChangeNewImageInput = {
  uploadId: Scalars['ID']['input'];
};

export type MenuChangeNewItem = {
  __typename?: 'MenuChangeNewItem';
  category: MenuChangeCategoryChoice;
  subtree: MenuChangeNewItemSubtree;
};

export type MenuChangeNewItemInput = {
  category: MenuChangeCategoryChoiceInput;
  subtree: MenuChangeNewItemSubtreeInput;
};

export type MenuChangeNewItemSubtree = {
  __typename?: 'MenuChangeNewItemSubtree';
  description: Scalars['String']['output'];
  image?: Maybe<MenuChangeUploadIdValue>;
  itemType: InventoryItemMealType;
  namePublic: Scalars['String']['output'];
  nameVendor: Scalars['String']['output'];
  optionGroups: Array<MenuChangeOptionGroupSubtree>;
  price: MenuChangeCentsValue;
  taxCategoryRef: Scalars['ID']['output'];
  usableAsOption: Scalars['Boolean']['output'];
};

export type MenuChangeNewItemSubtreeInput = {
  description: Scalars['String']['input'];
  image?: InputMaybe<MenuChangeNewImageInput>;
  itemType: InventoryItemMealType;
  namePublic: Scalars['String']['input'];
  nameVendor: Scalars['String']['input'];
  optionGroups: Array<MenuChangeOptionGroupSubtreeInput>;
  price: MenuChangeCentsInput;
  taxCategoryRef: Scalars['ID']['input'];
  usableAsOption: Scalars['Boolean']['input'];
};

export type MenuChangeNewOptionEntry = {
  __typename?: 'MenuChangeNewOptionEntry';
  itemType: InventoryItemMealType;
  name: Scalars['String']['output'];
  price: MenuChangeCentsValue;
  taxCategoryRef: Scalars['ID']['output'];
};

export type MenuChangeNewOptionInput = {
  itemType: InventoryItemMealType;
  name: Scalars['String']['input'];
  price: MenuChangeCentsInput;
  taxCategoryRef: Scalars['ID']['input'];
};

export enum MenuChangeNoImage {
  NoImage = 'NO_IMAGE'
}

export type MenuChangeNoImageValue = {
  __typename?: 'MenuChangeNoImageValue';
  noImage: MenuChangeNoImage;
};

export enum MenuChangeNoMaximum {
  NoMaximum = 'NO_MAXIMUM'
}

export type MenuChangeNoMaximumValue = {
  __typename?: 'MenuChangeNoMaximumValue';
  noMaximum: MenuChangeNoMaximum;
};

export type MenuChangeOptionEntry = MenuChangeExistingOptionEntry | MenuChangeNewOptionEntry;

export type MenuChangeOptionEntryInput =
  { existingOption: MenuChangeExistingOptionInput; newOption?: never; }
  |  { existingOption?: never; newOption: MenuChangeNewOptionInput; };

export type MenuChangeOptionGroupSubtree = {
  __typename?: 'MenuChangeOptionGroupSubtree';
  groupType: MenuChangeOptionGroupType;
  max: MenuChangeValue;
  name: Scalars['String']['output'];
  options: Array<MenuChangeOptionEntry>;
  required: MenuChangeCountValue;
};

export type MenuChangeOptionGroupSubtreeInput = {
  groupType: MenuChangeOptionGroupType;
  max: MenuChangeMaxInput;
  name: Scalars['String']['input'];
  options: Array<MenuChangeOptionEntryInput>;
  required: MenuChangeCountInput;
};

/**
 * Which of the vendor's items a group's options come from: INGREDIENTS are items
 * flagged as options, SIDES are regular items that have no option groups of their own
 */
export enum MenuChangeOptionGroupType {
  Ingredients = 'INGREDIENTS',
  Sides = 'SIDES'
}

export type MenuChangeOptionPickerInput = {
  groupType: MenuChangeOptionGroupType;
  menuTemplateId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type MenuChangeOtherMenu = {
  __typename?: 'MenuChangeOtherMenu';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type MenuChangePickableItem = {
  __typename?: 'MenuChangePickableItem';
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  itemType?: Maybe<InventoryItemMealType>;
  namePublic: Scalars['String']['output'];
  preTaxPriceCents: Scalars['Int']['output'];
};

/** The connection type for MenuChangePickableItem. */
export type MenuChangePickableItemConnection = {
  __typename?: 'MenuChangePickableItemConnection';
  currentPage: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MenuChangePickableItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<MenuChangePickableItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MenuChangePickableItemEdge = {
  __typename?: 'MenuChangePickableItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MenuChangePickableItem>;
};

/** Autogenerated return type of MenuChangePickableItems. */
export type MenuChangePickableItemsPayload = {
  __typename?: 'MenuChangePickableItemsPayload';
  error?: Maybe<OperationError>;
  items?: Maybe<MenuChangePickableItemConnection>;
};


/** Autogenerated return type of MenuChangePickableItems. */
export type MenuChangePickableItemsPayloadItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuChangePickableOption = {
  __typename?: 'MenuChangePickableOption';
  /** Dietary restriction/allergen labels (e.g. Contains Soy). */
  dietaryRestrictions: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  namePublic: Scalars['String']['output'];
  preTaxPriceCents: Scalars['Int']['output'];
  /** The number of option groups that use this option. */
  usedInGroupsCount: Scalars['Int']['output'];
  /**
   * True when a non-draft, non-expired popup or catering menu also uses the
   * option. It can still be added to a group; FFR shows it locked for edits.
   */
  usedOutsideDelivery: Scalars['Boolean']['output'];
};

/** The connection type for MenuChangePickableOption. */
export type MenuChangePickableOptionConnection = {
  __typename?: 'MenuChangePickableOptionConnection';
  currentPage: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MenuChangePickableOptionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<MenuChangePickableOption>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MenuChangePickableOptionEdge = {
  __typename?: 'MenuChangePickableOptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MenuChangePickableOption>;
};

/** Autogenerated return type of MenuChangePickableOptions. */
export type MenuChangePickableOptionsPayload = {
  __typename?: 'MenuChangePickableOptionsPayload';
  error?: Maybe<OperationError>;
  options?: Maybe<MenuChangePickableOptionConnection>;
};


/** Autogenerated return type of MenuChangePickableOptions. */
export type MenuChangePickableOptionsPayloadOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuChangePickerInput = {
  menuTemplateId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type MenuChangePriceTypeValue = {
  __typename?: 'MenuChangePriceTypeValue';
  priceType: PriceTypeEnum;
};

export type MenuChangeRemoveItemFromMenu = {
  __typename?: 'MenuChangeRemoveItemFromMenu';
  parentRef: Scalars['ID']['output'];
  targetRef: Scalars['ID']['output'];
};

export type MenuChangeRemoveItemFromMenuInput = {
  parentRef: Scalars['ID']['input'];
  targetRef: Scalars['ID']['input'];
};

export type MenuChangeRemoveOption = {
  __typename?: 'MenuChangeRemoveOption';
  parentRef: Scalars['ID']['output'];
  scope: MenuChangeEditScope;
  targetRef: Scalars['ID']['output'];
};

export type MenuChangeRemoveOptionGroup = {
  __typename?: 'MenuChangeRemoveOptionGroup';
  parentRef: Scalars['ID']['output'];
  scope: MenuChangeEditScope;
  targetRef: Scalars['ID']['output'];
};

export type MenuChangeRemoveOptionGroupInput = {
  parentRef: Scalars['ID']['input'];
  scope: MenuChangeEditScope;
  targetRef: Scalars['ID']['input'];
};

export type MenuChangeRemoveOptionInput = {
  parentRef: Scalars['ID']['input'];
  scope: MenuChangeEditScope;
  targetRef: Scalars['ID']['input'];
};

export type MenuChangeRequest = {
  __typename?: 'MenuChangeRequest';
  decidedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The reviewer's one comment on the decision, shown to the restaurant. Null for an AUTO decision. */
  decisionComment?: Maybe<Scalars['String']['output']>;
  decisionSource?: Maybe<MenuChangeDecisionSource>;
  id: Scalars['ID']['output'];
  lines: Array<MenuChangeLine>;
  menuTemplateId?: Maybe<Scalars['ID']['output']>;
  status: MenuChangeRequestStatus;
  submittedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for MenuChangeRequest. */
export type MenuChangeRequestConnection = {
  __typename?: 'MenuChangeRequestConnection';
  currentPage: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MenuChangeRequestEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<MenuChangeRequest>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MenuChangeRequestEdge = {
  __typename?: 'MenuChangeRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MenuChangeRequest>;
};

export type MenuChangeRequestErrorDetail = OperationErrorDetail & {
  __typename?: 'MenuChangeRequestErrorDetail';
  code: MenuChangeErrorCode;
  codeAsString: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/**
 * Set by one decision on the whole submission, never derived from its lines. An
 * auto-applied request ends APPLIED or FAILED, all or nothing. A reviewed request
 * ends APPLIED, REJECTED or FAILED. WITHDRAWN when the restaurant withdraws it
 * before the decision.
 */
export enum MenuChangeRequestStatus {
  Applied = 'APPLIED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Withdrawn = 'WITHDRAWN'
}

export type MenuChangeRequestUploadTarget = {
  __typename?: 'MenuChangeRequestUploadTarget';
  fields: Array<KeyValuePair>;
  maxByteSize: Scalars['Int']['output'];
  uploadId: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export enum MenuChangeTargetKind {
  MenuItem = 'MENU_ITEM',
  Option = 'OPTION',
  OptionGroup = 'OPTION_GROUP'
}

export type MenuChangeTaxCategoryOption = {
  __typename?: 'MenuChangeTaxCategoryOption';
  label: Scalars['String']['output'];
  value: Scalars['ID']['output'];
};

export type MenuChangeTaxCategoryRefValue = {
  __typename?: 'MenuChangeTaxCategoryRefValue';
  taxCategoryRef: Scalars['ID']['output'];
};

export type MenuChangeTextValue = {
  __typename?: 'MenuChangeTextValue';
  text: Scalars['String']['output'];
};

export type MenuChangeUploadIdValue = {
  __typename?: 'MenuChangeUploadIdValue';
  uploadId: Scalars['ID']['output'];
};

export type MenuChangeValue = MenuChangeBooleanValue | MenuChangeCategoryRefValue | MenuChangeCentsValue | MenuChangeCountValue | MenuChangeImageRefValue | MenuChangeItemTypeValue | MenuChangeNewCategoryNameValue | MenuChangeNoImageValue | MenuChangeNoMaximumValue | MenuChangePriceTypeValue | MenuChangeTaxCategoryRefValue | MenuChangeTextValue | MenuChangeUploadIdValue;

export type MenuChangeValueInput =
  { boolean: Scalars['Boolean']['input']; categoryRef?: never; cents?: never; count?: never; imageRef?: never; itemType?: never; newCategoryName?: never; noImage?: never; noMaximum?: never; priceType?: never; taxCategoryRef?: never; text?: never; uploadId?: never; }
  |  { boolean?: never; categoryRef: Scalars['ID']['input']; cents?: never; count?: never; imageRef?: never; itemType?: never; newCategoryName?: never; noImage?: never; noMaximum?: never; priceType?: never; taxCategoryRef?: never; text?: never; uploadId?: never; }
  |  { boolean?: never; categoryRef?: never; cents: Scalars['Int']['input']; count?: never; imageRef?: never; itemType?: never; newCategoryName?: never; noImage?: never; noMaximum?: never; priceType?: never; taxCategoryRef?: never; text?: never; uploadId?: never; }
  |  { boolean?: never; categoryRef?: never; cents?: never; count: Scalars['Int']['input']; imageRef?: never; itemType?: never; newCategoryName?: never; noImage?: never; noMaximum?: never; priceType?: never; taxCategoryRef?: never; text?: never; uploadId?: never; }
  |  { boolean?: never; categoryRef?: never; cents?: never; count?: never; imageRef: Scalars['ID']['input']; itemType?: never; newCategoryName?: never; noImage?: never; noMaximum?: never; priceType?: never; taxCategoryRef?: never; text?: never; uploadId?: never; }
  |  { boolean?: never; categoryRef?: never; cents?: never; count?: never; imageRef?: never; itemType: InventoryItemMealType; newCategoryName?: never; noImage?: never; noMaximum?: never; priceType?: never; taxCategoryRef?: never; text?: never; uploadId?: never; }
  |  { boolean?: never; categoryRef?: never; cents?: never; count?: never; imageRef?: never; itemType?: never; newCategoryName: Scalars['String']['input']; noImage?: never; noMaximum?: never; priceType?: never; taxCategoryRef?: never; text?: never; uploadId?: never; }
  |  { boolean?: never; categoryRef?: never; cents?: never; count?: never; imageRef?: never; itemType?: never; newCategoryName?: never; noImage: MenuChangeNoImage; noMaximum?: never; priceType?: never; taxCategoryRef?: never; text?: never; uploadId?: never; }
  |  { boolean?: never; categoryRef?: never; cents?: never; count?: never; imageRef?: never; itemType?: never; newCategoryName?: never; noImage?: never; noMaximum: MenuChangeNoMaximum; priceType?: never; taxCategoryRef?: never; text?: never; uploadId?: never; }
  |  { boolean?: never; categoryRef?: never; cents?: never; count?: never; imageRef?: never; itemType?: never; newCategoryName?: never; noImage?: never; noMaximum?: never; priceType: PriceTypeEnum; taxCategoryRef?: never; text?: never; uploadId?: never; }
  |  { boolean?: never; categoryRef?: never; cents?: never; count?: never; imageRef?: never; itemType?: never; newCategoryName?: never; noImage?: never; noMaximum?: never; priceType?: never; taxCategoryRef: Scalars['ID']['input']; text?: never; uploadId?: never; }
  |  { boolean?: never; categoryRef?: never; cents?: never; count?: never; imageRef?: never; itemType?: never; newCategoryName?: never; noImage?: never; noMaximum?: never; priceType?: never; taxCategoryRef?: never; text: Scalars['String']['input']; uploadId?: never; }
  |  { boolean?: never; categoryRef?: never; cents?: never; count?: never; imageRef?: never; itemType?: never; newCategoryName?: never; noImage?: never; noMaximum?: never; priceType?: never; taxCategoryRef?: never; text?: never; uploadId: Scalars['ID']['input']; };

export type MenuChangeVocabulary = {
  __typename?: 'MenuChangeVocabulary';
  fields: Array<MenuChangeVocabularyField>;
  itemTypes: Array<MenuChangeItemTypeOption>;
  taxCategories: Array<MenuChangeTaxCategoryOption>;
};

export type MenuChangeVocabularyField = {
  __typename?: 'MenuChangeVocabularyField';
  field: MenuChangeField;
  grouping: Scalars['String']['output'];
  inputKind: MenuChangeInputKind;
  label: Scalars['String']['output'];
  max?: Maybe<Scalars['Int']['output']>;
  maxLength?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  scope: MenuChangeEditScope;
  targetKind: MenuChangeTargetKind;
};

export type MenuChangeVocabularyInput = {
  productType: ProductEnum;
};

/** Autogenerated return type of MenuChangeVocabulary. */
export type MenuChangeVocabularyPayload = {
  __typename?: 'MenuChangeVocabularyPayload';
  error?: Maybe<OperationError>;
  vocabulary?: Maybe<MenuChangeVocabulary>;
};

/** An Allergen or Sensitivity answered for a menu item */
export type MenuItemAllergen = {
  __typename?: 'MenuItemAllergen';
  code: AllergenCode;
  /** Display name, e.g. Milk / Dairy */
  name: Scalars['String']['output'];
  status: AllergenStatus;
};

/** An item's current Dietary Preferences and Allergens and Sensitivities */
export type MenuItemDietaryInfo = {
  __typename?: 'MenuItemDietaryInfo';
  /**
   * Allergens and Sensitivities the item contains or does not contain, in catalog
   * order. An allergen not listed is Not Specified.
   */
  allergens: Array<MenuItemAllergen>;
  /**
   * Every available Dietary Preference with the item's answer, in catalog order.
   * Empty when the menu row has no inventory item.
   */
  preferences: Array<MenuItemDietaryPreference>;
};

/** A Dietary Preference and how a menu item answers it */
export type MenuItemDietaryPreference = {
  __typename?: 'MenuItemDietaryPreference';
  code: DietaryPreferenceCode;
  /** Display name, e.g. Gluten-Free */
  name: Scalars['String']['output'];
  status: DietaryPreferenceStatus;
};

export type MenuItemSubsidy = {
  /** Redeemed amount in cents */
  amountCents: Scalars['Int']['input'];
  versionId: Scalars['UUID']['input'];
};

export type MenuTemplate = {
  __typename?: 'MenuTemplate';
  allowAsapOrdering: Scalars['Boolean']['output'];
  asapMinutes?: Maybe<Scalars['Int']['output']>;
  expectedPickupOrderPercentage?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  menuCategories?: Maybe<Array<MenuCategory>>;
  name: Scalars['String']['output'];
  overrideSpotLocationCapacity: Scalars['Boolean']['output'];
};

/** A cafe menu template category tile */
export type MenuTemplateCategoryTile = {
  __typename?: 'MenuTemplateCategoryTile';
  menuTemplate: MenuTemplate;
  menuTemplateCategory: PopupMenuTemplateCategoryGroup;
  position: Scalars['Int']['output'];
  recordedCategoryId?: Maybe<Scalars['Int']['output']>;
  station: EventScheduleStation;
  vendor: Vendor;
};

export type MenuTemplateInventoryItemAttributes = {
  inventoryItemId: Scalars['ID']['input'];
  preTaxPrice: Scalars['BigDecimal']['input'];
};

/** A cafe menu template inventory item tile */
export type MenuTemplateInventoryItemTile = {
  __typename?: 'MenuTemplateInventoryItemTile';
  menuTemplate: MenuTemplate;
  menuTemplateInventoryItem: PopupMenuTemplateInventoryItem;
  position: Scalars['Int']['output'];
  recordedCategory?: Maybe<PopupMenuTemplateCategoryGroup>;
  station: EventScheduleStation;
  vendor: Vendor;
};

export type MenuTemplateSelectionGroupItemAttributes = {
  inventoryItemId: Scalars['ID']['input'];
  namePublic: Scalars['String']['input'];
  preTaxPrice: Scalars['BigDecimal']['input'];
};

export enum MenuTemplateStateEnum {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  PendingApproval = 'PENDING_APPROVAL',
  Published = 'PUBLISHED'
}

/** Summary of a vendor's menu template for restaurant-facing menu views (cards + header) */
export type MenuTemplateSummary = {
  __typename?: 'MenuTemplateSummary';
  /** Whether the signed-in manager can edit this menu in FFR, for the menu card's lock. */
  canEditInFfr: Scalars['Boolean']['output'];
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Why canEditInFfr is false. Null when the menu can be edited. */
  ffrEditBlockedReason?: Maybe<MenuChangeEditBlockedReason>;
  id: Scalars['ID']['output'];
  mealPeriods: Array<MealPeriodEnum>;
  name?: Maybe<Scalars['String']['output']>;
  productType: ProductEnum;
  /** True when the template or any of its items changed within the last 2 weeks. */
  recentlyUpdated: Scalars['Boolean']['output'];
  startDate: Scalars['ISO8601DateTime']['output'];
  state: MenuTemplateStateEnum;
  /** Latest of the template's own change and its items' changes. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A cafe menu template tile */
export type MenuTemplateTile = {
  __typename?: 'MenuTemplateTile';
  menuTemplate: MenuTemplate;
  position: Scalars['Int']['output'];
  station: EventScheduleStation;
  vendor: Vendor;
};

export enum MenuTileTypeEnum {
  MenuTemplate = 'MENU_TEMPLATE',
  MenuTemplateCategory = 'MENU_TEMPLATE_CATEGORY',
  MenuTemplateInventoryItem = 'MENU_TEMPLATE_INVENTORY_ITEM',
  SalesOptimizerToFill = 'SALES_OPTIMIZER_TO_FILL',
  SaleOptimizerToFill = 'SALE_OPTIMIZER_TO_FILL'
}

/** Shared availability surface for resources that can be queried for mobile-ordering state. */
export type MobileOrderingAvailability = {
  /**
   * Whether this resource is currently accepting mobile orders. False when the
   * vendor is not enabled, the event is past its final viable pickup window, or
   * every pickup slot is at capacity.
   */
  mobileOrderingAvailable: Scalars['Boolean']['output'];
  /**
   * Populated only when `mobile_ordering_available` is false; always null
   * otherwise. See `MobileOrderingUnavailableReason` for possible values.
   */
  mobileOrderingUnavailableReason?: Maybe<MobileOrderingUnavailableReason>;
};

/**
 * A popup cart with pricing, pickup slots, and mobile-ordering state. For
 * pre-flight availability (including PAST_WINDOW), query
 * `MobileOrderingEventVendorInfo.mobileOrderingAvailable` on the event card before
 * building a cart — cart queries past the pickup window raise a conflict error
 * rather than returning a cart.
 */
export type MobileOrderingCart = MobileOrderingAvailability & {
  __typename?: 'MobileOrderingCart';
  couponDiscountCents: Scalars['Int']['output'];
  dueAmountCents: Scalars['Int']['output'];
  /** @deprecated Please use an array of time slots */
  estimatedPickupTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Total item level subsidy */
  itemSubsidyDiscountCents: Scalars['Int']['output'];
  /** Cart menu items */
  items: Array<MobileOrderingCartMenuItem>;
  /**
   * Whether this resource is currently accepting mobile orders. False when the
   * vendor is not enabled, the event is past its final viable pickup window, or
   * every pickup slot is at capacity.
   */
  mobileOrderingAvailable: Scalars['Boolean']['output'];
  /**
   * Populated only when `mobile_ordering_available` is false; always null
   * otherwise. See `MobileOrderingUnavailableReason` for possible values.
   */
  mobileOrderingUnavailableReason?: Maybe<MobileOrderingUnavailableReason>;
  pickupTimeSlots: Array<MobileOrderingPickupTimeSlot>;
  restaurantCommissionCents?: Maybe<Scalars['Int']['output']>;
  /** Rewards points potentially earned from cart */
  rewardsPoints: Scalars['Float']['output'];
  /** Order level subsidy applied to this cart */
  subsidy?: Maybe<MobileOrderingSubsidy>;
  /** Total order level subsidy */
  subsidyDiscountCents: Scalars['Int']['output'];
  subtotalCents: Scalars['Int']['output'];
  /** Subtotal after item level subsidy */
  subtotalPostSubsidyCents: Scalars['Int']['output'];
  taxCents: Scalars['Int']['output'];
  /** Tax after item level subsidy */
  taxPostSubsidyCents: Scalars['Int']['output'];
};

export type MobileOrderingCartChildMenuItem = {
  __typename?: 'MobileOrderingCartChildMenuItem';
  /** menu item id (hybrid numeric/string) */
  id: Scalars['HybridId']['output'];
  /** Subsidy rules applied to this option */
  rules?: Maybe<Array<EventMenuItemSubsidy>>;
};

export type MobileOrderingCartItem = {
  id: Scalars['ID']['input'];
  options?: InputMaybe<Array<MobileOrderingCartItemOption>>;
};

export type MobileOrderingCartItemOption = {
  groupCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type MobileOrderingCartMenuItem = {
  __typename?: 'MobileOrderingCartMenuItem';
  /** menu item id (hybrid numeric/string) */
  id: Scalars['HybridId']['output'];
  /** Options selected for this cart menu item */
  options?: Maybe<Array<MobileOrderingCartChildMenuItem>>;
  /** Subsidy rules applied to this item */
  rules?: Maybe<Array<EventMenuItemSubsidy>>;
};

/** Mobile-ordering state for an event vendor on a listing. */
export type MobileOrderingEventVendorInfo = MobileOrderingAvailability & {
  __typename?: 'MobileOrderingEventVendorInfo';
  enabled: Scalars['Boolean']['output'];
  /**
   * Whether this resource is currently accepting mobile orders. False when the
   * vendor is not enabled, the event is past its final viable pickup window, or
   * every pickup slot is at capacity.
   */
  mobileOrderingAvailable: Scalars['Boolean']['output'];
  /**
   * Populated only when `mobile_ordering_available` is false; always null
   * otherwise. See `MobileOrderingUnavailableReason` for possible values.
   */
  mobileOrderingUnavailableReason?: Maybe<MobileOrderingUnavailableReason>;
  orderingCloseTime: Scalars['ISO8601DateTime']['output'];
  orderingWindowEndTime: Scalars['ISO8601DateTime']['output'];
  orderingWindowStartTime: Scalars['ISO8601DateTime']['output'];
};

/** Base shared item fields */
export type MobileOrderingItem = {
  __typename?: 'MobileOrderingItem';
  customizationDescription?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  napkins: Scalars['Boolean']['output'];
  selectionGroups?: Maybe<Array<MobileOrderingSelectionGroup>>;
  silverware: Scalars['Boolean']['output'];
};

export type MobileOrderingItemInput = {
  customizationDescription?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Base shared item fields */
export type MobileOrderingOptionItem = {
  __typename?: 'MobileOrderingOptionItem';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MobileOrderingOrder = {
  __typename?: 'MobileOrderingOrder';
  canceledByUser: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  items: Array<MobileOrderingItem>;
  pickupId: Scalars['ID']['output'];
  pickupTime: Scalars['ISO8601DateTime']['output'];
  placedAt: Scalars['ISO8601DateTime']['output'];
  requestId: Scalars['ID']['output'];
  state: MobileOrderingOrderStatus;
  user?: Maybe<OrderRequestUser>;
  version: Scalars['ID']['output'];
};

export type MobileOrderingOrderChanged = {
  /** DEPRECATED: use eventVendorId */
  eventId?: InputMaybe<Scalars['ID']['input']>;
  eventVendorId?: InputMaybe<Scalars['ID']['input']>;
  /** DEPRECATED: use eventVendorId */
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of MobileOrderingOrderChanged. */
export type MobileOrderingOrderChangedPayload = {
  __typename?: 'MobileOrderingOrderChangedPayload';
  error?: Maybe<OperationError>;
  mobileOrderingOrder?: Maybe<MobileOrderingOrder>;
  subscriptionData?: Maybe<AblySubscriptionData>;
};

export type MobileOrderingOrderInput = {
  id: Scalars['ID']['input'];
  items: Array<MobileOrderingItemInput>;
  pickupId: Scalars['ID']['input'];
  pickupTime: Scalars['ISO8601DateTime']['input'];
  placedAt: Scalars['ISO8601DateTime']['input'];
  state: MobileOrderingOrderStatus;
};

/** Request to place a Mobile Ordering order */
export type MobileOrderingOrderRequest = {
  __typename?: 'MobileOrderingOrderRequest';
  id: Scalars['ID']['output'];
  order?: Maybe<ConsumerMobileOrderingOrderDetails>;
  paymentGatewayError?: Maybe<Scalars['String']['output']>;
  state: MobileOrderingOrderRequestState;
};

export type MobileOrderingOrderRequestChildItem = {
  groupId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  /** OBSOLETED: not used anymore */
  otherTaxCents?: InputMaybe<Scalars['Int']['input']>;
  postTaxPriceCents: Scalars['Int']['input'];
  preTaxPriceCents: Scalars['Int']['input'];
  salesTaxCents: Scalars['Int']['input'];
  /** Subsidies applied to this menu item */
  subsidies?: InputMaybe<Array<MenuItemSubsidy>>;
};

export type MobileOrderingOrderRequestCoupon = {
  amountCents: Scalars['Int']['input'];
  redemptionCode: Scalars['String']['input'];
};

export enum MobileOrderingOrderRequestErrorCodeEnum {
  /** Error code 40305 */
  CouponAlreadyRedeemed = 'COUPON_ALREADY_REDEEMED',
  /** Error code 40309 */
  CouponExpired = 'COUPON_EXPIRED',
  /** Error code 40313 */
  CouponNotFound = 'COUPON_NOT_FOUND',
  /** Error code 40317 */
  CouponNotYetActive = 'COUPON_NOT_YET_ACTIVE',
  /** Error code 0 */
  OrderRequest = 'ORDER_REQUEST',
  /** Error code 40069 */
  OrderRequestCancel = 'ORDER_REQUEST_CANCEL',
  /** Error code 40070 */
  OrderRequestCancelForUser = 'ORDER_REQUEST_CANCEL_FOR_USER',
  /** Error code 40059 */
  OrderRequestChildMenuItemWithoutGroup = 'ORDER_REQUEST_CHILD_MENU_ITEM_WITHOUT_GROUP',
  /** Error code 40061 */
  OrderRequestCustomItemInGroup = 'ORDER_REQUEST_CUSTOM_ITEM_IN_GROUP',
  /** Error code 40009 */
  OrderRequestDiscountCouponUnused = 'ORDER_REQUEST_DISCOUNT_COUPON_UNUSED',
  /** Error code 400013 */
  OrderRequestDiscountMultipleSameType = 'ORDER_REQUEST_DISCOUNT_MULTIPLE_SAME_TYPE',
  /** Error code 40017 */
  OrderRequestDiscountVoucherAmountInvalid = 'ORDER_REQUEST_DISCOUNT_VOUCHER_AMOUNT_INVALID',
  /** Error code 40025 */
  OrderRequestDiscountVoucherUnused = 'ORDER_REQUEST_DISCOUNT_VOUCHER_UNUSED',
  /** Error code 40029 */
  OrderRequestIdDuplicate = 'ORDER_REQUEST_ID_DUPLICATE',
  /** Error code 40037 */
  OrderRequestMenuItemCustomPriceInvalid = 'ORDER_REQUEST_MENU_ITEM_CUSTOM_PRICE_INVALID',
  /** Error code 40041 */
  OrderRequestMenuItemNormalInvalid = 'ORDER_REQUEST_MENU_ITEM_NORMAL_INVALID',
  /** Error code 40045 */
  OrderRequestMenuItemNormalPriceMismatch = 'ORDER_REQUEST_MENU_ITEM_NORMAL_PRICE_MISMATCH',
  /** Error code 40038 */
  OrderRequestMenuItemOpenPriceInvalid = 'ORDER_REQUEST_MENU_ITEM_OPEN_PRICE_INVALID',
  /** Error code 40046 */
  OrderRequestMenuItemSubsidyAmountMismatch = 'ORDER_REQUEST_MENU_ITEM_SUBSIDY_AMOUNT_MISMATCH',
  /** Error code 40051 */
  OrderRequestMoreThanOneParent = 'ORDER_REQUEST_MORE_THAN_ONE_PARENT',
  /** Error code 40055 */
  OrderRequestNotEnoughMenuItemSelections = 'ORDER_REQUEST_NOT_ENOUGH_MENU_ITEM_SELECTIONS',
  /** Error code 40053 */
  OrderRequestParentChildMenuItemMismatch = 'ORDER_REQUEST_PARENT_CHILD_MENU_ITEM_MISMATCH',
  /** Error code 40063 */
  OrderRequestParentMissingFromGroup = 'ORDER_REQUEST_PARENT_MISSING_FROM_GROUP',
  /** Error code 40005 */
  OrderRequestPaymentRequired = 'ORDER_REQUEST_PAYMENT_REQUIRED',
  /** Error code 40073 */
  OrderRequestScanToPayDisabled = 'ORDER_REQUEST_SCAN_TO_PAY_DISABLED',
  /** Error code 40067 */
  OrderRequestSync = 'ORDER_REQUEST_SYNC',
  /** Error code 40072 */
  OrderRequestTenderMethodInvalidForAccount = 'ORDER_REQUEST_TENDER_METHOD_INVALID_FOR_ACCOUNT',
  /** Error code 40071 */
  OrderRequestTenderMethodNotAvailable = 'ORDER_REQUEST_TENDER_METHOD_NOT_AVAILABLE',
  /** Error code 40057 */
  OrderRequestTooManyMenuItemSelections = 'ORDER_REQUEST_TOO_MANY_MENU_ITEM_SELECTIONS',
  /** Error code 40047 */
  OrderRequestTotalFoodSalesNotPositive = 'ORDER_REQUEST_TOTAL_FOOD_SALES_NOT_POSITIVE',
  /** Error code 40525 */
  SubsidyFullCoverageRequired = 'SUBSIDY_FULL_COVERAGE_REQUIRED',
  /** Error code 40509 */
  SubsidyInstanceNotFound = 'SUBSIDY_INSTANCE_NOT_FOUND',
  /** Error code 40511 */
  SubsidyInstancePreviouslyUsedToday = 'SUBSIDY_INSTANCE_PREVIOUSLY_USED_TODAY',
  /** Error code 40523 */
  SubsidyMaxAmountUsed = 'SUBSIDY_MAX_AMOUNT_USED',
  /** Error code 40513 */
  SubsidyMembershipNotPresent = 'SUBSIDY_MEMBERSHIP_NOT_PRESENT',
  /** Error code 40513 */
  SubsidyMinimumAmountNotMet = 'SUBSIDY_MINIMUM_AMOUNT_NOT_MET',
  /** Error code 40515 */
  SubsidyNewQrCode = 'SUBSIDY_NEW_QR_CODE',
  /** Error code 40507 */
  SubsidyNotAvailableAtLocation = 'SUBSIDY_NOT_AVAILABLE_AT_LOCATION',
  /** Error code 40518 */
  SubsidyNotAvailableForUser = 'SUBSIDY_NOT_AVAILABLE_FOR_USER',
  /** Error code 40517 */
  SubsidyNoLongerAvailable = 'SUBSIDY_NO_LONGER_AVAILABLE',
  /** Error code 40521 */
  SubsidyRequestedAmountMoreThanAvailable = 'SUBSIDY_REQUESTED_AMOUNT_MORE_THAN_AVAILABLE',
  /** Error code 40520 */
  SubsidyRuleNotAvailableToday = 'SUBSIDY_RULE_NOT_AVAILABLE_TODAY',
  /** Error code 40520 */
  SubsidyRuleNotValidOnDate = 'SUBSIDY_RULE_NOT_VALID_ON_DATE',
  /** Error code 40520 */
  SubsidyUsed = 'SUBSIDY_USED',
  /** Error code 40705 */
  VoucherInstanceNotFound = 'VOUCHER_INSTANCE_NOT_FOUND',
  /** Error code 40709 */
  VoucherInvalidAmount = 'VOUCHER_INVALID_AMOUNT',
  /** Error code 40713 */
  VoucherNotRedeemable = 'VOUCHER_NOT_REDEEMABLE'
}

export type MobileOrderingOrderRequestErrorDetail = OperationErrorDetail & {
  __typename?: 'MobileOrderingOrderRequestErrorDetail';
  code: MobileOrderingOrderRequestErrorCodeEnum;
  codeAsString: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type MobileOrderingOrderRequestItem = {
  customization?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  napkins: Scalars['Boolean']['input'];
  options?: InputMaybe<Array<MobileOrderingOrderRequestChildItem>>;
  /** OBSOLETED: not used anymore */
  otherTaxCents?: InputMaybe<Scalars['Int']['input']>;
  postTaxPriceCents: Scalars['Int']['input'];
  preTaxPriceCents: Scalars['Int']['input'];
  salesTaxCents: Scalars['Int']['input'];
  silverware: Scalars['Boolean']['input'];
  /** Subsidies applied to this menu item */
  subsidies?: InputMaybe<Array<MenuItemSubsidy>>;
};

export enum MobileOrderingOrderRequestPayment {
  BraintreeCcToken = 'BRAINTREE_CC_TOKEN',
  BraintreePaymentNonce = 'BRAINTREE_PAYMENT_NONCE',
  CardpointePaymentNonce = 'CARDPOINTE_PAYMENT_NONCE'
}

export enum MobileOrderingOrderRequestState {
  Accepted = 'ACCEPTED',
  PaymentRejected = 'PAYMENT_REJECTED',
  Pending = 'PENDING'
}

export type MobileOrderingOrderRequestSubsidy = {
  amountCents: Scalars['Int']['input'];
  redemptionCode: Scalars['String']['input'];
};

export enum MobileOrderingOrderStatus {
  Abandoned = 'ABANDONED',
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Declined = 'DECLINED',
  Pending = 'PENDING',
  ReadyForPickup = 'READY_FOR_PICKUP'
}

export type MobileOrderingPayment = {
  cardId?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MobileOrderingOrderRequestPayment>;
};

export type MobileOrderingPickupInfo = {
  __typename?: 'MobileOrderingPickupInfo';
  pickupId: Scalars['ID']['output'];
  pickupTime: Scalars['ISO8601DateTime']['output'];
};

/** Pickup time slot */
export type MobileOrderingPickupTimeSlot = {
  __typename?: 'MobileOrderingPickupTimeSlot';
  time: Scalars['ISO8601DateTime']['output'];
};

/** Base shared item fields */
export type MobileOrderingSelectionGroup = {
  __typename?: 'MobileOrderingSelectionGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  namePublic: Scalars['String']['output'];
  options?: Maybe<Array<MobileOrderingOptionItem>>;
};

export type MobileOrderingSubsidy = {
  __typename?: 'MobileOrderingSubsidy';
  amountCents: Scalars['Int']['output'];
  code: Scalars['String']['output'];
};

/**
 * Reason that `mobile_ordering_available` is false. Additional values may be added
 * over time; clients MUST treat unknown values as a generic 'unavailable' state
 * and fall back to `mobile_ordering_available == false`.
 */
export enum MobileOrderingUnavailableReason {
  /** All pickup slots for this popup event are at capacity. */
  CapacityReached = 'CAPACITY_REACHED',
  /** The vendor is not enabled for mobile ordering on this event. */
  Disabled = 'DISABLED',
  /** The popup event is past its final viable pickup window — no pickup slot remains within the minimum pickup lead time. */
  PastWindow = 'PAST_WINDOW'
}

/** Recommendation Model Configuration */
export type ModelConfig = {
  __typename?: 'ModelConfig';
  baseVersion?: Maybe<ModelConfig>;
  baseVersionId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  modelType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  primary: Scalars['Boolean']['output'];
  /** Resolver-based prompt configuration (JSONB) */
  promptConfig?: Maybe<PromptConfig>;
  status: Scalars['String']['output'];
  task: RecommendationRequestTypes;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  version: Scalars['String']['output'];
  versionAncestry: Array<ModelConfig>;
};

/** Recommendation Model Metrics */
export type ModelMetrics = {
  __typename?: 'ModelMetrics';
  clickThroughRate: Scalars['Float']['output'];
  conversionRate: Scalars['Float']['output'];
  last7dRequests: Scalars['Int']['output'];
  last24hRequests: Scalars['Int']['output'];
  modelId: Scalars['ID']['output'];
  totalClicked: Scalars['Int']['output'];
  totalDismissed: Scalars['Int']['output'];
  totalPurchased: Scalars['Int']['output'];
  totalRequests: Scalars['Int']['output'];
  totalShown: Scalars['Int']['output'];
};

export type MonthGfs = {
  __typename?: 'MonthGFS';
  cents: Scalars['Int']['output'];
  month: Scalars['ISO8601DateTime']['output'];
};

export type MonthlyByDayOfMonthFrequency = {
  __typename?: 'MonthlyByDayOfMonthFrequency';
  dates: Array<Scalars['Int']['output']>;
  interval: Scalars['Int']['output'];
};

export type MonthlyByDayOfWeekFrequency = {
  __typename?: 'MonthlyByDayOfWeekFrequency';
  daysOfWeek: Array<RecurrenceWeek>;
  interval: Scalars['Int']['output'];
};

export type MovePopupMenuTemplateCategoryGroup = {
  direction: MovementDirection;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of MovePopupMenuTemplateCategoryGroup. */
export type MovePopupMenuTemplateCategoryGroupPayload = {
  __typename?: 'MovePopupMenuTemplateCategoryGroupPayload';
  error?: Maybe<OperationError>;
  popupMenuTemplate?: Maybe<PopupMenuTemplate>;
};

export type MovePopupMenuTemplateInventoryItem = {
  direction: MovementDirection;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of MovePopupMenuTemplateInventoryItem. */
export type MovePopupMenuTemplateInventoryItemPayload = {
  __typename?: 'MovePopupMenuTemplateInventoryItemPayload';
  error?: Maybe<OperationError>;
  menuTemplateCategoryGroup?: Maybe<PopupMenuTemplateCategoryGroup>;
};

export type MovePopupMenuTemplateSelectionGroup = {
  direction: MovementDirection;
  id: Scalars['ID']['input'];
};

export type MovePopupMenuTemplateSelectionGroupOption = {
  direction: MovementDirection;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of MovePopupMenuTemplateSelectionGroupOption. */
export type MovePopupMenuTemplateSelectionGroupOptionPayload = {
  __typename?: 'MovePopupMenuTemplateSelectionGroupOptionPayload';
  error?: Maybe<OperationError>;
  menuTemplateSelectionGroup?: Maybe<PopupMenuTemplateSelectionGroup>;
};

/** Autogenerated return type of MovePopupMenuTemplateSelectionGroup. */
export type MovePopupMenuTemplateSelectionGroupPayload = {
  __typename?: 'MovePopupMenuTemplateSelectionGroupPayload';
  error?: Maybe<OperationError>;
  popupMenuTemplateInventoryItem?: Maybe<PopupMenuTemplateInventoryItem>;
};

export enum MovementDirection {
  Down = 'DOWN',
  Up = 'UP'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptMobileOrderingOrder?: Maybe<AcceptMobileOrderingOrderPayload>;
  /** Activate a popup event */
  activatePopupEvent?: Maybe<ActivatePopupEventPayload>;
  addRewardsPoints?: Maybe<AddRewardsPointsPayload>;
  archiveRecommendationsModel?: Maybe<ArchiveRecommendationsModelPayload>;
  assignAccountPaymentCardToProduct?: Maybe<AssignAccountPaymentCardToProductPayload>;
  attachOrderRequestUser?: Maybe<AttachOrderRequestUserPayload>;
  cancelDeliveryOrder?: Maybe<CancelDeliveryOrderPayload>;
  cancelMobileOrderingOrder?: Maybe<CancelMobileOrderingOrderPayload>;
  cancelMobileOrderingOrderByUser?: Maybe<CancelMobileOrderingOrderByUserPayload>;
  clearChatHistory?: Maybe<ClearChatHistoryPayload>;
  /** Confirm Site Directions Token */
  confirmSiteDirectionsToken?: Maybe<ConfirmSiteDirectionsTokenMutationPayload>;
  createAccountAuthenticationDomainAssociation?: Maybe<CreateAccountAuthenticationDomainAssociationPayload>;
  createAccountPaymentCard?: Maybe<CreateAccountPaymentCardPayload>;
  /** Create a Site Ownership record for an Accounting Site */
  createAccountingSiteOwner?: Maybe<CreateAccountingSiteOwnerPayload>;
  /** Create a new Site Ownership Role Type */
  createAccountingSiteRoleType?: Maybe<CreateAccountingSiteRolePayload>;
  /** Create a new Accounting Site Type */
  createAccountingSiteType?: Maybe<CreateAccountingSiteTypePayload>;
  createAuthenticationDomain?: Maybe<CreateAuthenticationDomainPayload>;
  createBanner?: Maybe<CreateBannerPayload>;
  createBiometricsToken?: Maybe<CreateBiometricsTokenPayload>;
  createCafeEventSchedule?: Maybe<CreateCafeEventSchedulePayload>;
  createCafeEventScheduleStation?: Maybe<CreateCafeEventScheduleStationPayload>;
  /** Mutation to create a station on a cafe event */
  createCafeEventStation?: Maybe<CreateCafeEventStationPayload>;
  createCafeLocation?: Maybe<CreateCafeLocationPayload>;
  /** Mutation to create a cafe station */
  createCafeStation?: Maybe<CreateCafeStationPayload>;
  createCampaign?: Maybe<CreateCampaignPayload>;
  createCampaignUsers?: Maybe<CreateCampaignUsersPayload>;
  createCard?: Maybe<CreateCardPayload>;
  createCardAsync?: Maybe<CreateCardAsyncPayload>;
  createCateringInventoryItem?: Maybe<CreateCateringInventoryItemPayload>;
  createCateringUserAccount?: Maybe<CreateCateringUserAccountPayload>;
  createConsumerDataRequest?: Maybe<CreateConsumerDataRequestPayload>;
  createCrossDock?: Maybe<CreateCrossDockPayload>;
  createCustomInvoice?: Maybe<CreateCustomInvoicePayload>;
  createCustomInvoiceSettings?: Maybe<CreateCustomInvoiceSettingsPayload>;
  createDeliveryInventoryItem?: Maybe<CreateDeliveryInventoryItemPayload>;
  createDeliveryVendorMarketCapacity?: Maybe<CreateDeliveryVendorMarketCapacityPayload>;
  createFeedbackResponse?: Maybe<CreateFeedbackResponsePayload>;
  /** Onboard a pull-funding bank account from a client-side bank-account token (btok_...) */
  createFoodaCardBankAccount?: Maybe<CreateFoodaCardBankAccountPayload>;
  /** Manually create a top-up (pull funds) for a connected account's Issuing balance */
  createFoodaCardTopup?: Maybe<CreateFoodaCardTopupPayload>;
  createGuestPasses?: Maybe<CreateGuestPassesPayload>;
  createMarket?: Maybe<CreateMarketPayload>;
  createMenuChangeRequestUpload?: Maybe<CreateMenuChangeRequestUploadPayload>;
  createMobileOrderingOrderRequest?: Maybe<CreateMobileOrderingOrderRequestPayload>;
  createOrderRequest?: Maybe<CreateOrderRequestPayload>;
  createPhysicalSecurityResponse?: Maybe<CreatePhysicalSecurityResponsePayload>;
  createPopupInventoryItem?: Maybe<CreatePopupInventoryItemPayload>;
  createPopupMenuTemplate?: Maybe<CreatePopupMenuTemplatePayload>;
  createPopupMenuTemplateCategoryGroup?: Maybe<CreatePopupMenuTemplateCategoryGroupPayload>;
  createPopupMenuTemplateSelectionGroup?: Maybe<CreatePopupMenuTemplateSelectionGroupPayload>;
  createRecommendationsLimitsGroup?: Maybe<CreateRecommendationsLimitsGroupPayload>;
  createRecommendationsModelVersion?: Maybe<CreateRecommendationsModelVersionPayload>;
  /** Create Report Configuration for Snappea Administration */
  createReportConfiguration?: Maybe<CreateReportConfigurationQueryPayload>;
  createScanToPayOrderRequest?: Maybe<CreateScanToPayOrderRequestPayload>;
  /** Mutation to create an Event Vendor on a Select event */
  createSelectEventVendor?: Maybe<CreateSelectEventVendorPayload>;
  createSession?: Maybe<CreateSessionPayload>;
  /** Create a signed upload link */
  createSignedUploadLink?: Maybe<CreateSignedUploadLinkPayload>;
  /** Create a new Stripe Connected Account */
  createStripeAccount?: Maybe<CreateStripeAccountPayload>;
  createSubsidyRule?: Maybe<CreateSubsidyRulePayload>;
  createTaxCategory?: Maybe<CreateTaxCategoryPayload>;
  /** Create new temporal user pending verification */
  createTempUser?: Maybe<CreateTempUserPayload>;
  /** Create a new tender method */
  createTenderMethod?: Maybe<CreateTenderMethodPayload>;
  /** Create new user */
  createUser?: Maybe<CreateUserPayload>;
  /** Create a note about a user */
  createUserNote?: Maybe<CreateUserNotePayload>;
  /** Request for a verification code */
  createVerificationRequest?: Maybe<CreateVerificationRequestPayload>;
  /** Soft-delete (deactivate) a Site Ownership Role Type */
  deactivateAccountingSiteRoleType?: Maybe<DeactivateAccountingSiteRolePayload>;
  declineMobileOrderingOrder?: Maybe<DeclineMobileOrderingOrderPayload>;
  deleteAccountAuthenticationDomainAssociation?: Maybe<DeleteAccountAuthenticationDomainAssociationPayload>;
  deleteAccountPaymentCard?: Maybe<DeleteAccountPaymentCardPayload>;
  deleteCafeEventSchedule?: Maybe<DeleteCafeEventSchedulePayload>;
  deleteCafeEventScheduleStation?: Maybe<DeleteCafeEventScheduleStationPayload>;
  deleteCampaignUsers?: Maybe<DeleteCampaignUsersPayload>;
  deleteCard?: Maybe<DeleteCardPayload>;
  deleteCateringInventoryItem?: Maybe<DeleteCateringInventoryItemPayload>;
  deleteCustomInvoice?: Maybe<DeleteCustomInvoicePayload>;
  deleteDeliveryInventoryItem?: Maybe<DeleteDeliveryInventoryItemPayload>;
  deleteDeliveryVendorMarketCapacity?: Maybe<DeleteDeliveryVendorMarketCapacityPayload>;
  deletePopupInventoryItem?: Maybe<DeletePopupInventoryItemPayload>;
  deletePopupMenuTemplateCategoryGroup?: Maybe<DeletePopupMenuTemplateCategoryGroupPayload>;
  deletePopupMenuTemplateSelectionGroup?: Maybe<DeletePopupMenuTemplateSelectionGroupPayload>;
  /** Delete Report Configuration for Snappea Administration */
  deleteReportConfiguration?: Maybe<DeleteReportConfigurationQueryPayload>;
  /** Mutation to delete an existing Event Vendor on a Select event */
  deleteSelectEventVendor?: Maybe<DeleteSelectEventVendorPayload>;
  /** Delete a user session given the client and user */
  deleteSession?: Maybe<DeleteSessionPayload>;
  deleteSubsidyRule?: Maybe<DeleteSubsidyRulePayload>;
  /** Delete a tender method */
  deleteTenderMethod?: Maybe<DeleteTenderMethodPayload>;
  /** Delete a user note */
  deleteUserNote?: Maybe<DeleteUserNotePayload>;
  /** Soft-delete a Site Ownership record */
  destroyAccountingSiteOwner?: Maybe<DestroyAccountingSiteOwnerPayload>;
  /** Create an account role and corresponding associations */
  enrollUserInAccount?: Maybe<EnrollUserInAccountPayload>;
  /** Add user to account-building location */
  enrollUserInAccountBuilding?: Maybe<EnrollUserInAccountBuildingPayload>;
  /** Create a vendor role and corresponding permissions */
  enrollUserInVendor?: Maybe<EnrollUserInVendorPayload>;
  /** Expire a guest subsidy pass on an FFB admin's request */
  expireGuestPass?: Maybe<ExpireGuestPassPayload>;
  finalizeMenuChangeRequestUpload?: Maybe<FinalizeMenuChangeRequestUploadPayload>;
  makePopupMenuItemAvailable?: Maybe<MakePopupMenuItemAvailablePayload>;
  makePopupMenuItemUnavailable?: Maybe<MakePopupMenuItemUnavailablePayload>;
  makePopupMenuItemsAvailable?: Maybe<MakePopupMenuItemsAvailablePayload>;
  makePopupMenuItemsUnavailable?: Maybe<MakePopupMenuItemsUnavailablePayload>;
  markOrderRequestCanceled?: Maybe<MarkOrderRequestCanceledPayload>;
  markOrderRequestsAborted?: Maybe<MarkOrderRequestsAbortedPayload>;
  markReadyForPickupMobileOrderingOrder?: Maybe<MarkReadyForPickupMobileOrderingOrderPayload>;
  markShadowFalsePositive?: Maybe<MarkShadowFalsePositivePayload>;
  movePopupMenuTemplateCategoryGroup?: Maybe<MovePopupMenuTemplateCategoryGroupPayload>;
  /** Change the position of a popup menu template inventory item */
  movePopupMenuTemplateInventoryItem?: Maybe<MovePopupMenuTemplateInventoryItemPayload>;
  movePopupMenuTemplateSelectionGroup?: Maybe<MovePopupMenuTemplateSelectionGroupPayload>;
  /** Change the position of a popup menu template selection group option */
  movePopupMenuTemplateSelectionGroupOption?: Maybe<MovePopupMenuTemplateSelectionGroupOptionPayload>;
  publishMobileOrderingUpdate?: Maybe<PublishMobileOrderingUpdatePayload>;
  publishRecommendationsModel?: Maybe<PublishRecommendationsModelPayload>;
  /**
   * Record a Transcend preference snapshot only when airgap.getConsent().confirmed
   * is true. Do not submit inferred default preferences.
   */
  recordConsentPreferenceEvent?: Maybe<RecordConsentPreferenceEventPayload>;
  refreshMarketingSegment?: Maybe<RefreshMarketingSegmentPayload>;
  /** Refunds a delivery order, either in full or line by line */
  refundDeliveryOrder?: Maybe<RefundDeliveryOrderPayload>;
  refundOrderRequest?: Maybe<RefundOrderRequestPayload>;
  registerPosPaymentAttempt?: Maybe<RegisterPosPaymentAttemptPayload>;
  /** Remove a pull-funding bank account */
  removeFoodaCardBankAccount?: Maybe<RemoveFoodaCardBankAccountPayload>;
  /** Re-run all cases or only failed cases in a completed backtest */
  rerunBacktestCases?: Maybe<RerunBacktestCasesPayload>;
  /** API to resend phone verification code for user phone number verification */
  resendPhoneVerificationCode?: Maybe<ResendPhoneVerificationCodePayload>;
  /** Restore a saved revision of the tag group configuration */
  restoreRecommendationsTagGroupsVersion?: Maybe<RestoreRecommendationsTagGroupsVersionPayload>;
  /** Retrieve funding overview for a connected account's Issuing balance */
  retrieveStripeAccountFunding?: Maybe<RetrieveStripeAccountFundingPayload>;
  /** Fetch an older page of top-ups for a connected account (Stripe cursor pagination, for 'Load more') */
  retrieveStripeAccountFundingTopups?: Maybe<RetrieveStripeAccountFundingTopupsPayload>;
  sendChatMessage?: Maybe<SendChatMessagePayload>;
  /** Send reset password email for user */
  sendResetPasswordEmail?: Maybe<SendResetPasswordEmailPayload>;
  sendSubsidyPasses?: Maybe<SendSubsidyPassesPayload>;
  /** Mutation to set a cafe station site direction */
  setCafeStationSiteDirection?: Maybe<SetCafeStationSiteDirectionPayload>;
  /** Set new password for user */
  setNewPassword?: Maybe<SetNewPasswordPayload>;
  /** Sort the positions of a popup menu template inventory items in one category group */
  sortPopupMenuTemplateCategoryGroup?: Maybe<SortPopupMenuTemplateCategoryGroupPayload>;
  /** Discover eligible backtest cases from user order histories */
  startBacktestDiscovery?: Maybe<StartBacktestDiscoveryPayload>;
  /** Start execution of a discovered backtest run */
  startBacktestRun?: Maybe<StartBacktestRunPayload>;
  submitChatFeedback?: Maybe<SubmitChatFeedbackPayload>;
  submitMenuChangeRequest?: Maybe<SubmitMenuChangeRequestPayload>;
  /** API to submit phone verification code for user phone number verification */
  submitPhoneVerificationCode?: Maybe<SubmitPhoneVerificationCodePayload>;
  submitRecommendationsFeedback?: Maybe<SubmitRecommendationsFeedbackMutationPayload>;
  submitVendorAvailability?: Maybe<SubmitVendorAvailabilityPayload>;
  /** API to submit  verification code for user phone or email number verification */
  submitVerificationCode?: Maybe<SubmitVerificationCodePayload>;
  syncPaidOrderRequest?: Maybe<SyncPaidOrderRequestPayload>;
  syncUnpaidOrderRequest?: Maybe<SyncUnpaidOrderRequestPayload>;
  /** Test a recommendations prompt configuration by executing it against OpenAI */
  testRecommendationsPrompt?: Maybe<TestRecommendationsPromptPayload>;
  /** Delete a user from an account-building location */
  unenrollUserFromAccountBuilding?: Maybe<UnenrollUserFromAccountBuildingPayload>;
  /** Delete a vendor role and corresponding permissions */
  unenrollUserFromVendor?: Maybe<UnenrollUserFromVendorPayload>;
  /** Update an account role and permissions */
  updateAccountMembership?: Maybe<UpdateAccountMembershipPayload>;
  updateAccountSubsidySettings?: Maybe<UpdateAccountSubsidySettingsPayload>;
  /** Update a Site Ownership record */
  updateAccountingSiteOwner?: Maybe<UpdateAccountingSiteOwnerPayload>;
  /** Update a Site Ownership Role Type (also works on deactivated rows) */
  updateAccountingSiteRoleType?: Maybe<UpdateAccountingSiteRolePayload>;
  /** Rename an Accounting Site Type */
  updateAccountingSiteType?: Maybe<UpdateAccountingSiteTypePayload>;
  /** Updates an app version policy */
  updateAppVersionPolicy?: Maybe<UpdateAppVersionPolicyPayload>;
  updateAuthenticationDomain?: Maybe<UpdateAuthenticationDomainPayload>;
  updateBanner?: Maybe<UpdateBannerPayload>;
  /** Update cafe event menu tile configurations */
  updateCafeEventMenuTileConfiguration?: Maybe<UpdateCafeEventMenuTileConfigurationPayload>;
  updateCafeEventSchedule?: Maybe<UpdateCafeEventSchedulePayload>;
  updateCafeEventScheduleMenuTiles?: Maybe<UpdateCafeEventScheduleMenuTilesPayload>;
  updateCafeEventScheduleStation?: Maybe<UpdateCafeEventScheduleStationPayload>;
  /** Mutation to update a station on a cafe event */
  updateCafeEventStation?: Maybe<UpdateCafeEventStationPayload>;
  updateCafeLocation?: Maybe<UpdateCafeLocationPayload>;
  /** Mutation to update a cafe station */
  updateCafeStation?: Maybe<UpdateCafeStationPayload>;
  /** Mutation to update cafe temperature log */
  updateCafeTemperatureLog?: Maybe<UpdateCafeTemperatureLogPayload>;
  updateCampaign?: Maybe<UpdateCampaignPayload>;
  updateCard?: Maybe<UpdateCardPayload>;
  updateCateringInventoryItem?: Maybe<UpdateCateringInventoryItemPayload>;
  updateCrossDock?: Maybe<UpdateCrossDockPayload>;
  updateCustomInvoice?: Maybe<UpdateCustomInvoicePayload>;
  updateCustomInvoicePoSetup?: Maybe<UpdateCustomInvoicePoSetupPayload>;
  updateCustomInvoiceSettings?: Maybe<UpdateCustomInvoiceSettingsPayload>;
  updateDeliveryInventoryItem?: Maybe<UpdateDeliveryInventoryItemPayload>;
  updateDeliverySchedulingConstraint?: Maybe<UpdateDeliverySchedulingConstraintPayload>;
  updateDeliveryVendorMarketCapacity?: Maybe<UpdateDeliveryVendorMarketCapacityPayload>;
  /**
   * Update the current user's email subscription preferences (per-category +
   * global). At least one of `categories` or `globalUnsubscribed` must be
   * supplied. The write is delivered to MoEngage in a single round-trip; MoEngage
   * applies the change asynchronously, so re-query to observe the new state.
   */
  updateEmailCategoryPreferences?: Maybe<UpdateEmailCategoryPreferencesPayload>;
  updateFeedbackRequest?: Maybe<UpdateFeedbackRequestPayload>;
  /** Create or update the auto-topup configuration for a connected account */
  updateFoodaCardAutoTopupSettings?: Maybe<UpdateFoodaCardAutoTopupSettingsPayload>;
  updateFoodaCardMembershipBackupCard?: Maybe<UpdateFoodaCardMembershipBackupCardPayload>;
  updateFoodaCardMembershipRequirements?: Maybe<UpdateFoodaCardMembershipRequirementsPayload>;
  updateFoodaCardProgram?: Maybe<UpdateFoodaCardProgramPayload>;
  /** update popup event vendor factors */
  updateHistoricalMealsSoldFactors?: Maybe<UpdateHistoricalMealsSoldFactorsPayload>;
  updateLineItemType?: Maybe<UpdateLineItemPayload>;
  updateMarket?: Maybe<UpdateMarketPayload>;
  updatePartyBillingPolicy?: Maybe<UpdatePartyBillingPolicyPayload>;
  updatePopupInventoryItem?: Maybe<UpdatePopupInventoryItemPayload>;
  updatePopupMenuTemplate?: Maybe<UpdatePopupMenuTemplatePayload>;
  /** Update popup menu template category group and respective items */
  updatePopupMenuTemplateCategoryGroup?: Maybe<UpdatePopupMenuTemplateCategoryGroupPayload>;
  updatePopupMenuTemplateInventoryItem?: Maybe<UpdatePopupMenuTemplateInventoryItemPayload>;
  updatePopupMenuTemplateSelectionGroup?: Maybe<UpdatePopupMenuTemplateSelectionGroupPayload>;
  /**
   * Replace the current user's food preference tag selections with the given set.
   * An empty list clears all selections. Tags must come from the predefined
   * item-tag catalog; weight is a like/dislike signal in [-1, 1].
   */
  updateRecommendationsCustomPreferences?: Maybe<UpdateRecommendationsCustomPreferencesPayload>;
  updateRecommendationsLimitsGroup?: Maybe<UpdateRecommendationsLimitsGroupPayload>;
  updateRecommendationsModelConfig?: Maybe<UpdateRecommendationsModelConfigPayload>;
  /** Replace the whole tag group configuration; array order is display order */
  updateRecommendationsTagGroups?: Maybe<UpdateRecommendationsTagGroupsPayload>;
  /** Update Report Configuration for Snappea Administration */
  updateReportConfiguration?: Maybe<UpdateReportConfigurationQueryPayload>;
  /** Update Reports Configurations order for Snappea Administration */
  updateReportsConfigurationsOrder?: Maybe<UpdateReportsConfigurationsOrderQueryPayload>;
  updateScoringEventTypes?: Maybe<UpdateScoringEventTypesPayload>;
  updateScoringEventsBatch?: Maybe<UpdateScoringEventsBatchPayload>;
  updateSelectEventStatus?: Maybe<UpdateSelectEventStatusPayload>;
  /** Mutation to update an Event Vendor on a Select event */
  updateSelectEventVendor?: Maybe<UpdateSelectEventVendorPayload>;
  updateShipFromBuildingsPerState?: Maybe<UpdateShipFromBuildingsPerStatePayload>;
  /** Update site directions for a vendor role */
  updateSiteDirectionsNotificationsForVendorMembership?: Maybe<UpdateSiteDirectionsNotificationsForVendorMembershipPayload>;
  updateSubsidyMember?: Maybe<UpdateSubsidyMemberPayload>;
  updateSubsidyRule?: Maybe<UpdateSubsidyRulePayload>;
  updateTaxCategory?: Maybe<UpdateTaxCategoryPayload>;
  /** Update an existing tender method */
  updateTenderMethod?: Maybe<UpdateTenderMethodPayload>;
  /** Update user API */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Update a user note */
  updateUserNote?: Maybe<UpdateUserNotePayload>;
  /** Update user notification configuration details */
  updateUserNotificationDetails?: Maybe<UpdateUserNotificationDetailsPayload>;
  /** Update user phone number API */
  updateUserPhoneNumber?: Maybe<UpdateUserPhoneNumberPayload>;
  /** Update a users FFR or POS permissions */
  updateVendorEmployeePermissions?: Maybe<UpdateVendorEmployeePermissionsPayload>;
  updateVendorPopupCapacity?: Maybe<UpdateVendorPopupCapacityPayload>;
  /** Complete microdeposit verification for a pending pull-funding bank account */
  verifyFoodaCardBankAccount?: Maybe<VerifyFoodaCardBankAccountPayload>;
};


export type MutationAcceptMobileOrderingOrderArgs = {
  input: AcceptMobileOrderingOrder;
};


export type MutationActivatePopupEventArgs = {
  input: ActivatePopupEvent;
};


export type MutationAddRewardsPointsArgs = {
  input: AddRewardsPoints;
};


export type MutationArchiveRecommendationsModelArgs = {
  modelId: Scalars['ID']['input'];
};


export type MutationAssignAccountPaymentCardToProductArgs = {
  input: AssignAccountPaymentCardToProduct;
};


export type MutationAttachOrderRequestUserArgs = {
  input: AttachOrderRequestUser;
};


export type MutationCancelDeliveryOrderArgs = {
  input: CancelDeliveryOrder;
};


export type MutationCancelMobileOrderingOrderArgs = {
  input: CancelMobileOrderingOrder;
};


export type MutationCancelMobileOrderingOrderByUserArgs = {
  input: CancelMobileOrderingOrder;
};


export type MutationClearChatHistoryArgs = {
  input: ClearChatHistory;
};


export type MutationConfirmSiteDirectionsTokenArgs = {
  input: ConfirmSiteDirectionsToken;
};


export type MutationCreateAccountAuthenticationDomainAssociationArgs = {
  accountId: Scalars['ID']['input'];
  domainName: Scalars['String']['input'];
};


export type MutationCreateAccountPaymentCardArgs = {
  input: CreateAccountPaymentCard;
};


export type MutationCreateAccountingSiteOwnerArgs = {
  accountingSiteId: Scalars['ID']['input'];
  input: AccountingSiteOwnerInput;
};


export type MutationCreateAccountingSiteRoleTypeArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateAccountingSiteTypeArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateAuthenticationDomainArgs = {
  input: CreateAuthenticationDomain;
};


export type MutationCreateBannerArgs = {
  input: CreateBanner;
};


export type MutationCreateBiometricsTokenArgs = {
  input: CreateBiometricsToken;
};


export type MutationCreateCafeEventScheduleArgs = {
  input: CreateCafeEventSchedule;
};


export type MutationCreateCafeEventScheduleStationArgs = {
  input: CreateCafeEventScheduleStation;
};


export type MutationCreateCafeEventStationArgs = {
  input: CreateCafeEventStation;
};


export type MutationCreateCafeLocationArgs = {
  input: CreateCafeLocation;
};


export type MutationCreateCafeStationArgs = {
  input: CreateCafeStation;
};


export type MutationCreateCampaignArgs = {
  input: CreateCampaign;
};


export type MutationCreateCampaignUsersArgs = {
  input: CreateCampaignUsers;
};


export type MutationCreateCardArgs = {
  input: CreateCard;
};


export type MutationCreateCardAsyncArgs = {
  input: CreateCard;
};


export type MutationCreateCateringInventoryItemArgs = {
  input: CreateCateringInventoryItem;
};


export type MutationCreateCateringUserAccountArgs = {
  input: CreateCateringUserAccount;
};


export type MutationCreateConsumerDataRequestArgs = {
  input: CreateConsumerDataRequest;
};


export type MutationCreateCrossDockArgs = {
  input: CreateCrossDock;
};


export type MutationCreateCustomInvoiceArgs = {
  input: CustomInvoiceInput;
};


export type MutationCreateCustomInvoiceSettingsArgs = {
  input: CustomInvoiceSettingsInput;
};


export type MutationCreateDeliveryInventoryItemArgs = {
  input: CreateDeliveryInventoryItem;
};


export type MutationCreateDeliveryVendorMarketCapacityArgs = {
  input: CreateDeliveryVendorMarketCapacity;
};


export type MutationCreateFeedbackResponseArgs = {
  input: CreateFeedbackResponse;
};


export type MutationCreateFoodaCardBankAccountArgs = {
  input: CreateFoodaCardBankAccount;
};


export type MutationCreateFoodaCardTopupArgs = {
  input: CreateFoodaCardTopup;
};


export type MutationCreateGuestPassesArgs = {
  input: CreateGuestPasses;
};


export type MutationCreateMarketArgs = {
  input: CreateMarket;
};


export type MutationCreateMenuChangeRequestUploadArgs = {
  input: CreateMenuChangeRequestUploadInput;
};


export type MutationCreateMobileOrderingOrderRequestArgs = {
  input: CreateMobileOrderingOrderRequest;
};


export type MutationCreateOrderRequestArgs = {
  input: CreateOrderRequest;
};


export type MutationCreatePhysicalSecurityResponseArgs = {
  input: CreatePhysicalSecurityResponse;
};


export type MutationCreatePopupInventoryItemArgs = {
  input: CreatePopupInventoryItem;
};


export type MutationCreatePopupMenuTemplateArgs = {
  input: CreatePopupMenuTemplate;
};


export type MutationCreatePopupMenuTemplateCategoryGroupArgs = {
  input: CreatePopupMenuTemplateCategoryGroup;
};


export type MutationCreatePopupMenuTemplateSelectionGroupArgs = {
  input: CreatePopupMenuTemplateSelectionGroup;
};


export type MutationCreateRecommendationsLimitsGroupArgs = {
  input: CreateLimitsGroup;
};


export type MutationCreateRecommendationsModelVersionArgs = {
  input: CreateModelVersionInput;
};


export type MutationCreateReportConfigurationArgs = {
  input: CreateReportConfigurationInput;
};


export type MutationCreateScanToPayOrderRequestArgs = {
  input: ScanToPayCreateOrderRequest;
};


export type MutationCreateSelectEventVendorArgs = {
  input: CreateSelectEventVendor;
};


export type MutationCreateSessionArgs = {
  input: CreateSession;
};


export type MutationCreateSignedUploadLinkArgs = {
  input: CreateSignedUploadLink;
};


export type MutationCreateStripeAccountArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateSubsidyRuleArgs = {
  input: CreateSubsidyRule;
};


export type MutationCreateTaxCategoryArgs = {
  input: CreateTaxCategory;
};


export type MutationCreateTempUserArgs = {
  input: CreateTempUser;
};


export type MutationCreateTenderMethodArgs = {
  input: CreateTenderMethodInput;
};


export type MutationCreateUserArgs = {
  input: CreateUser;
};


export type MutationCreateUserNoteArgs = {
  input: CreateUserNote;
};


export type MutationCreateVerificationRequestArgs = {
  input: CreateVerificationRequest;
};


export type MutationDeactivateAccountingSiteRoleTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeclineMobileOrderingOrderArgs = {
  input: DeclineMobileOrderingOrder;
};


export type MutationDeleteAccountAuthenticationDomainAssociationArgs = {
  accountId: Scalars['ID']['input'];
  domainId: Scalars['ID']['input'];
};


export type MutationDeleteAccountPaymentCardArgs = {
  input: DeleteAccountPaymentCard;
};


export type MutationDeleteCafeEventScheduleArgs = {
  input: DeleteCafeEventSchedule;
};


export type MutationDeleteCafeEventScheduleStationArgs = {
  input: DeleteCafeEventScheduleStation;
};


export type MutationDeleteCampaignUsersArgs = {
  input: DeleteCampaignUsers;
};


export type MutationDeleteCardArgs = {
  input: DeleteCard;
};


export type MutationDeleteCateringInventoryItemArgs = {
  input: DeleteCateringInventoryItem;
};


export type MutationDeleteCustomInvoiceArgs = {
  externalId: Scalars['String']['input'];
};


export type MutationDeleteDeliveryInventoryItemArgs = {
  input: DeleteDeliveryInventoryItem;
};


export type MutationDeleteDeliveryVendorMarketCapacityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePopupInventoryItemArgs = {
  input: DeletePopupInventoryItem;
};


export type MutationDeletePopupMenuTemplateCategoryGroupArgs = {
  input: DeletePopupMenuTemplateCategoryGroup;
};


export type MutationDeletePopupMenuTemplateSelectionGroupArgs = {
  input: DeletePopupMenuTemplateSelectionGroup;
};


export type MutationDeleteReportConfigurationArgs = {
  input: DeleteReportConfigurationInput;
};


export type MutationDeleteSelectEventVendorArgs = {
  input: DeleteSelectEventVendor;
};


export type MutationDeleteSessionArgs = {
  input: DeleteSession;
};


export type MutationDeleteSubsidyRuleArgs = {
  input: DeleteSubsidyRule;
};


export type MutationDeleteTenderMethodArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserNoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDestroyAccountingSiteOwnerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEnrollUserInAccountArgs = {
  input: EnrollUserInAccount;
};


export type MutationEnrollUserInAccountBuildingArgs = {
  input: Array<AccountBuildingInput>;
};


export type MutationEnrollUserInVendorArgs = {
  input: EnrollUserInVendor;
};


export type MutationExpireGuestPassArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFinalizeMenuChangeRequestUploadArgs = {
  input: FinalizeMenuChangeRequestUploadInput;
};


export type MutationMakePopupMenuItemAvailableArgs = {
  input: MakePopupMenuItemAvailable;
};


export type MutationMakePopupMenuItemUnavailableArgs = {
  input: MakePopupMenuItemUnavailable;
};


export type MutationMakePopupMenuItemsAvailableArgs = {
  input: UpdatePopupMenuItemsAvailablity;
};


export type MutationMakePopupMenuItemsUnavailableArgs = {
  input: UpdatePopupMenuItemsAvailablity;
};


export type MutationMarkOrderRequestCanceledArgs = {
  input: MarkOrderRequestCanceled;
};


export type MutationMarkOrderRequestsAbortedArgs = {
  input: MarkOrderRequestsAborted;
};


export type MutationMarkReadyForPickupMobileOrderingOrderArgs = {
  input: MarkReadyForPickupMobileOrderingOrder;
};


export type MutationMarkShadowFalsePositiveArgs = {
  input: MarkShadowFalsePositiveInput;
};


export type MutationMovePopupMenuTemplateCategoryGroupArgs = {
  input: MovePopupMenuTemplateCategoryGroup;
};


export type MutationMovePopupMenuTemplateInventoryItemArgs = {
  input: MovePopupMenuTemplateInventoryItem;
};


export type MutationMovePopupMenuTemplateSelectionGroupArgs = {
  input: MovePopupMenuTemplateSelectionGroup;
};


export type MutationMovePopupMenuTemplateSelectionGroupOptionArgs = {
  input: MovePopupMenuTemplateSelectionGroupOption;
};


export type MutationPublishMobileOrderingUpdateArgs = {
  input: PublishMobileOrderingUpdate;
};


export type MutationPublishRecommendationsModelArgs = {
  bucketConfigurationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  modelId: Scalars['ID']['input'];
};


export type MutationRecordConsentPreferenceEventArgs = {
  input: ConsentPreferenceEventInput;
};


export type MutationRefreshMarketingSegmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRefundDeliveryOrderArgs = {
  input: RefundDeliveryOrder;
};


export type MutationRefundOrderRequestArgs = {
  input: OrderRequestRefund;
};


export type MutationRegisterPosPaymentAttemptArgs = {
  input: RegisterPosPaymentAttempt;
};


export type MutationRemoveFoodaCardBankAccountArgs = {
  input: RemoveFoodaCardBankAccount;
};


export type MutationRerunBacktestCasesArgs = {
  input: RerunBacktestCasesInput;
};


export type MutationRestoreRecommendationsTagGroupsVersionArgs = {
  versionId: Scalars['ID']['input'];
};


export type MutationRetrieveStripeAccountFundingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetrieveStripeAccountFundingTopupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationSendChatMessageArgs = {
  input: SendChatMessage;
};


export type MutationSendResetPasswordEmailArgs = {
  input: SendResetPasswordEmail;
};


export type MutationSendSubsidyPassesArgs = {
  input: SendSubsidyPasses;
};


export type MutationSetCafeStationSiteDirectionArgs = {
  input: SetCafeStationSiteDirection;
};


export type MutationSetNewPasswordArgs = {
  input: SetNewPassword;
};


export type MutationSortPopupMenuTemplateCategoryGroupArgs = {
  menuTemplateGroupId: Scalars['Int']['input'];
};


export type MutationStartBacktestDiscoveryArgs = {
  input: StartBacktestDiscoveryInput;
};


export type MutationStartBacktestRunArgs = {
  input: StartBacktestRunInput;
};


export type MutationSubmitChatFeedbackArgs = {
  input: SubmitChatFeedback;
};


export type MutationSubmitMenuChangeRequestArgs = {
  input: SubmitMenuChangeRequestInput;
};


export type MutationSubmitPhoneVerificationCodeArgs = {
  input: SubmitPhoneVerificationCode;
};


export type MutationSubmitRecommendationsFeedbackArgs = {
  input: SubmitRecommendationsFeedbackInput;
};


export type MutationSubmitVendorAvailabilityArgs = {
  input: SubmitVendorAvailabilityInput;
};


export type MutationSubmitVerificationCodeArgs = {
  input: SubmitVerificationCode;
};


export type MutationSyncPaidOrderRequestArgs = {
  input: SyncPaidOrderRequest;
};


export type MutationSyncUnpaidOrderRequestArgs = {
  input: SyncUnpaidOrderRequest;
};


export type MutationTestRecommendationsPromptArgs = {
  context: PromptContextInput;
  promptConfig: PromptConfigInput;
};


export type MutationUnenrollUserFromAccountBuildingArgs = {
  input: Array<AccountBuildingInput>;
};


export type MutationUnenrollUserFromVendorArgs = {
  input: UnenrollUserFromVendor;
};


export type MutationUpdateAccountMembershipArgs = {
  input: UpdateAccountMembership;
};


export type MutationUpdateAccountSubsidySettingsArgs = {
  input: UpdateAccountSubsidySettings;
};


export type MutationUpdateAccountingSiteOwnerArgs = {
  id: Scalars['ID']['input'];
  input: AccountingSiteOwnerInput;
};


export type MutationUpdateAccountingSiteRoleTypeArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateAccountingSiteTypeArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateAppVersionPolicyArgs = {
  input: AppVersionPolicyInput;
};


export type MutationUpdateAuthenticationDomainArgs = {
  input: UpdateAuthenticationDomain;
};


export type MutationUpdateBannerArgs = {
  input: UpdateBanner;
};


export type MutationUpdateCafeEventMenuTileConfigurationArgs = {
  input: UpdateCafeEventMenuTileConfigurationInput;
};


export type MutationUpdateCafeEventScheduleArgs = {
  input: UpdateCafeEventSchedule;
};


export type MutationUpdateCafeEventScheduleMenuTilesArgs = {
  input: UpdateCafeEventScheduleMenuTiles;
};


export type MutationUpdateCafeEventScheduleStationArgs = {
  input: UpdateCafeEventScheduleStation;
};


export type MutationUpdateCafeEventStationArgs = {
  input: UpdateCafeEventStation;
};


export type MutationUpdateCafeLocationArgs = {
  input: UpdateCafeLocation;
};


export type MutationUpdateCafeStationArgs = {
  input: UpdateCafeStation;
};


export type MutationUpdateCafeTemperatureLogArgs = {
  input: UpdateTemperatureLog;
};


export type MutationUpdateCampaignArgs = {
  input: UpdateCampaign;
};


export type MutationUpdateCardArgs = {
  input: UpdateCard;
};


export type MutationUpdateCateringInventoryItemArgs = {
  input: UpdateCateringInventoryItem;
};


export type MutationUpdateCrossDockArgs = {
  input: UpdateCrossDock;
};


export type MutationUpdateCustomInvoiceArgs = {
  input: CustomInvoiceInput;
};


export type MutationUpdateCustomInvoicePoSetupArgs = {
  id: Scalars['ID']['input'];
  input: CustomInvoicePoSetupInput;
};


export type MutationUpdateCustomInvoiceSettingsArgs = {
  id: Scalars['ID']['input'];
  input: CustomInvoiceSettingsInput;
};


export type MutationUpdateDeliveryInventoryItemArgs = {
  input: UpdateDeliveryInventoryItem;
};


export type MutationUpdateDeliverySchedulingConstraintArgs = {
  input: UpdateDeliverySchedulingConstraint;
};


export type MutationUpdateDeliveryVendorMarketCapacityArgs = {
  input: UpdateDeliveryVendorMarketCapacity;
};


export type MutationUpdateEmailCategoryPreferencesArgs = {
  categories?: InputMaybe<Array<EmailCategoryPreferenceInput>>;
  globalUnsubscribed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateFeedbackRequestArgs = {
  input: UpdateFeedbackRequest;
};


export type MutationUpdateFoodaCardAutoTopupSettingsArgs = {
  input: UpdateFoodaCardAutoTopupSettings;
};


export type MutationUpdateFoodaCardMembershipBackupCardArgs = {
  input: UpdateFoodaCardMembershipBackupCard;
};


export type MutationUpdateFoodaCardMembershipRequirementsArgs = {
  input: UpdateFoodaCardMembershipRequirements;
};


export type MutationUpdateFoodaCardProgramArgs = {
  input: UpdateFoodaCardProgram;
};


export type MutationUpdateHistoricalMealsSoldFactorsArgs = {
  input: UpdateHistoricalMealsSoldFactors;
};


export type MutationUpdateLineItemTypeArgs = {
  input: UpdateLineItem;
};


export type MutationUpdateMarketArgs = {
  input: UpdateMarket;
};


export type MutationUpdatePartyBillingPolicyArgs = {
  input: UpdatePartyBillingPolicy;
};


export type MutationUpdatePopupInventoryItemArgs = {
  input: UpdatePopupInventoryItem;
};


export type MutationUpdatePopupMenuTemplateArgs = {
  input: UpdatePopupMenuTemplate;
};


export type MutationUpdatePopupMenuTemplateCategoryGroupArgs = {
  input: UpdatePopupMenuTemplateCategoryGroup;
};


export type MutationUpdatePopupMenuTemplateInventoryItemArgs = {
  input: UpdatePopupMenuTemplateInventoryItem;
};


export type MutationUpdatePopupMenuTemplateSelectionGroupArgs = {
  input: UpdatePopupMenuTemplateSelectionGroup;
};


export type MutationUpdateRecommendationsCustomPreferencesArgs = {
  preferences: Array<RecommendationsCustomPreferenceInput>;
};


export type MutationUpdateRecommendationsLimitsGroupArgs = {
  input: UpdateLimitsGroup;
};


export type MutationUpdateRecommendationsModelConfigArgs = {
  input: UpdateModelConfig;
};


export type MutationUpdateRecommendationsTagGroupsArgs = {
  groups: Array<RecommendationsTagGroupInput>;
};


export type MutationUpdateReportConfigurationArgs = {
  input: UpdateReportConfigurationInput;
};


export type MutationUpdateReportsConfigurationsOrderArgs = {
  input: UpdateReportsConfigurationsOrderQueryInput;
};


export type MutationUpdateScoringEventTypesArgs = {
  input: UpdateScoringEventTypes;
};


export type MutationUpdateScoringEventsBatchArgs = {
  inputs: Array<UpdateScoringEventInput>;
};


export type MutationUpdateSelectEventStatusArgs = {
  input: UpdateSelectEventStatusInput;
};


export type MutationUpdateSelectEventVendorArgs = {
  input: UpdateSelectEventVendor;
};


export type MutationUpdateShipFromBuildingsPerStateArgs = {
  input: UpdateShipFromBuildingsPerState;
};


export type MutationUpdateSiteDirectionsNotificationsForVendorMembershipArgs = {
  input: UpdateSiteDirectionsNotificationsForVendorMembership;
};


export type MutationUpdateSubsidyMemberArgs = {
  input: UpdateSubsidyMember;
};


export type MutationUpdateSubsidyRuleArgs = {
  input: UpdateSubsidyRule;
};


export type MutationUpdateTaxCategoryArgs = {
  input: UpdateTaxCategory;
};


export type MutationUpdateTenderMethodArgs = {
  input: UpdateTenderMethodInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUser;
};


export type MutationUpdateUserNoteArgs = {
  input: UpdateUserNote;
};


export type MutationUpdateUserNotificationDetailsArgs = {
  input: UpdateUserNotificationDetails;
};


export type MutationUpdateUserPhoneNumberArgs = {
  input: UpdateUserPhoneNumber;
};


export type MutationUpdateVendorEmployeePermissionsArgs = {
  input: UpdateVendorEmployeePermissions;
};


export type MutationUpdateVendorPopupCapacityArgs = {
  input: UpdateVendorPopupCapacity;
};


export type MutationVerifyFoodaCardBankAccountArgs = {
  input: VerifyFoodaCardBankAccount;
};

export type OperationError = {
  __typename?: 'OperationError';
  code: Scalars['Int']['output'];
  details?: Maybe<Array<OperationErrorDetail>>;
  message: Scalars['String']['output'];
};

/** Detail information for a mutation/query error */
export type OperationErrorDetail = {
  codeAsString: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum OperationsEnum {
  /** create operation */
  Create = 'CREATE',
  /** delete operation */
  Delete = 'DELETE',
  /** manage operation */
  Manage = 'MANAGE',
  /** read operation */
  Read = 'READ',
  /** update operation */
  Update = 'UPDATE'
}

/** Who asked for the order to be canceled */
export enum OrderCancelationRequestorEnum {
  /** The customer */
  Customer = 'CUSTOMER',
  /** The restaurant */
  Vendor = 'VENDOR'
}

export type OrderChildItem = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  postTaxPriceCents: Scalars['Int']['input'];
  preTaxPriceCents: Scalars['Int']['input'];
  salesTaxCents: Scalars['Int']['input'];
  /** Subsidies applied to this menu item */
  subsidies?: InputMaybe<Array<MenuItemSubsidy>>;
};

export type OrderCustomItem = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  preTaxPriceCents: Scalars['Int']['input'];
  salesTaxCents: Scalars['Int']['input'];
  taxCategoryId?: InputMaybe<Scalars['ID']['input']>;
  taxRate?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export type OrderDiscount = {
  amountCents: Scalars['Int']['input'];
  discountId?: InputMaybe<Scalars['ID']['input']>;
  redemptionCode?: InputMaybe<Scalars['String']['input']>;
  type: OrderDiscountEnum;
};

export enum OrderDiscountEnum {
  CashierDiscount = 'CASHIER_DISCOUNT',
  Coupon = 'COUPON',
  ItemSubsidy = 'ITEM_SUBSIDY',
  Subsidy = 'SUBSIDY',
  TenderMethod = 'TENDER_METHOD',
  Voucher = 'VOUCHER'
}

export type OrderItem = {
  customItem?: InputMaybe<OrderCustomItem>;
  eventVendorId: Scalars['ID']['input'];
  menuItem?: InputMaybe<OrderMenuItem>;
  openItem?: InputMaybe<OrderOpenItem>;
};

export type OrderMenuItem = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** Options selected for this menu item */
  options?: InputMaybe<Array<OrderChildItem>>;
  /** OBSOLETED: not used anymore */
  otherTaxCents?: InputMaybe<Scalars['Int']['input']>;
  postTaxPriceCents: Scalars['Int']['input'];
  preTaxPriceCents: Scalars['Int']['input'];
  /** Type of pricing applied, e.g. per item, per pound, etc */
  priceType?: InputMaybe<PriceTypeEnum>;
  /** Amount of product if not priced per item, e.g. 0.35 (lb) */
  quantity?: InputMaybe<Scalars['BigDecimal']['input']>;
  salesTaxCents: Scalars['Int']['input'];
  /** Subsidies applied to this menu item */
  subsidies?: InputMaybe<Array<MenuItemSubsidy>>;
};

export type OrderOpenItem = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  preTaxPriceCents: Scalars['Int']['input'];
  salesTaxCents: Scalars['Int']['input'];
  taxCategoryId?: InputMaybe<Scalars['Int']['input']>;
  taxRate?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export enum OrderPayment {
  BraintreePaymentNonce = 'BRAINTREE_PAYMENT_NONCE',
  Card = 'CARD',
  CardpointePaymentNonce = 'CARDPOINTE_PAYMENT_NONCE'
}

export type OrderReceiptRequest = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumberDigits']['input']>;
};

export type OrderRequest = {
  __typename?: 'OrderRequest';
  customerOrders: Array<OrderRequestCustomerOrder>;
  id: Scalars['ID']['output'];
  rewardPoints?: Maybe<Scalars['Int']['output']>;
  state: OrderRequestStateEnum;
  user?: Maybe<OrderRequestUser>;
  voucherChangeCents: Scalars['Int']['output'];
};

export type OrderRequestBlobErrorDetail = OperationErrorDetail & {
  __typename?: 'OrderRequestBlobErrorDetail';
  codeAsString: Scalars['String']['output'];
  message: Scalars['String']['output'];
  requestId: Scalars['ID']['output'];
};

export type OrderRequestCoupon = {
  amountCents: Scalars['Int']['input'];
  redemptionCode: Scalars['String']['input'];
};

export type OrderRequestCustomerOrder = {
  __typename?: 'OrderRequestCustomerOrder';
  externalItemId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items: Array<OrderRequestItem>;
};

/** Details of an order request */
export type OrderRequestDetails = {
  __typename?: 'OrderRequestDetails';
  accountName: Scalars['String']['output'];
  /** Discount refunds on order */
  discountRefunds: Array<DiscountRefundLineItem>;
  /** Discounts on order */
  discounts: Array<DiscountLineItem>;
  eventId: Scalars['ID']['output'];
  /** Feedback is requested */
  feedbackRequested: Scalars['Boolean']['output'];
  /** Flag to hide prices */
  hidePrices: Scalars['Boolean']['output'];
  /** Food sold */
  items?: Maybe<Array<PopupOrderItem>>;
  /** Location of popup event */
  location?: Maybe<Location>;
  /** ISO8601 DateTime of when order was placed */
  orderFulfilledTime: Scalars['ISO8601DateTime']['output'];
  /** Time order was placed in unix seconds format */
  orderFulfilledTimeUnix: Scalars['Int']['output'];
  /** ISO8601 DateTime of when order was processed */
  orderTime: Scalars['ISO8601DateTime']['output'];
  /** Time order was processed in unix seconds format */
  orderTimeUnix: Scalars['Int']['output'];
  /** Refunds of payments on order */
  paymentRefunds: Array<PaymentRefundLineItem>;
  /** Details of card payments */
  paymentTransaction: Array<PaymentTransaction>;
  /** Payments on order */
  payments: Array<PaymentLineItem>;
  /** Mobile Ordering info */
  pickupInfo?: Maybe<PopupUserOrderPickupInfo>;
  /** State of the order */
  processState: PopupOrderProcessState;
  /** Unique ID of order */
  requestId: Scalars['ID']['output'];
  /** State of the order */
  requestState: PopupOrderRequestState;
  /** Order commission */
  restaurantCommissionAmountCents: Scalars['Int']['output'];
  /** Rewards points earned from order */
  rewardsPoints: Scalars['Float']['output'];
  /** Original order subtotal */
  subtotalAmountCents: Scalars['Int']['output'];
  /** Original order tax total */
  taxAmountCents: Scalars['Int']['output'];
  /** Paid order total */
  totalAmountCents: Scalars['Int']['output'];
  /** Original order other tax total */
  totalOtherTaxCents: Scalars['Int']['output'];
  /** Original order sales tax total */
  totalSalesTaxCents: Scalars['Int']['output'];
  /** Total other and sales tax refunded */
  totalTaxRefundCents: Scalars['Int']['output'];
  /** Price shown to user */
  userPrice: UserPrice;
  /** Price refunds shown to user */
  userRefundPrice: UserPrice;
  /** Vendors with food sales in order */
  vendors: Array<ConsumerVendor>;
};

export enum OrderRequestErrorCodeEnum {
  /** Error code 40305 */
  CouponAlreadyRedeemed = 'COUPON_ALREADY_REDEEMED',
  /** Error code 40309 */
  CouponExpired = 'COUPON_EXPIRED',
  /** Error code 40313 */
  CouponNotFound = 'COUPON_NOT_FOUND',
  /** Error code 40317 */
  CouponNotYetActive = 'COUPON_NOT_YET_ACTIVE',
  /** Error code 0 */
  OrderRequest = 'ORDER_REQUEST',
  /** Error code 40069 */
  OrderRequestCancel = 'ORDER_REQUEST_CANCEL',
  /** Error code 40070 */
  OrderRequestCancelForUser = 'ORDER_REQUEST_CANCEL_FOR_USER',
  /** Error code 40059 */
  OrderRequestChildMenuItemWithoutGroup = 'ORDER_REQUEST_CHILD_MENU_ITEM_WITHOUT_GROUP',
  /** Error code 40061 */
  OrderRequestCustomItemInGroup = 'ORDER_REQUEST_CUSTOM_ITEM_IN_GROUP',
  /** Error code 40009 */
  OrderRequestDiscountCouponUnused = 'ORDER_REQUEST_DISCOUNT_COUPON_UNUSED',
  /** Error code 400013 */
  OrderRequestDiscountMultipleSameType = 'ORDER_REQUEST_DISCOUNT_MULTIPLE_SAME_TYPE',
  /** Error code 40017 */
  OrderRequestDiscountVoucherAmountInvalid = 'ORDER_REQUEST_DISCOUNT_VOUCHER_AMOUNT_INVALID',
  /** Error code 40025 */
  OrderRequestDiscountVoucherUnused = 'ORDER_REQUEST_DISCOUNT_VOUCHER_UNUSED',
  /** Error code 40029 */
  OrderRequestIdDuplicate = 'ORDER_REQUEST_ID_DUPLICATE',
  /** Error code 40031 */
  OrderRequestIdHasPendingReverse = 'ORDER_REQUEST_ID_HAS_PENDING_REVERSE',
  /** Error code 40037 */
  OrderRequestMenuItemCustomPriceInvalid = 'ORDER_REQUEST_MENU_ITEM_CUSTOM_PRICE_INVALID',
  /** Error code 40041 */
  OrderRequestMenuItemNormalInvalid = 'ORDER_REQUEST_MENU_ITEM_NORMAL_INVALID',
  /** Error code 40045 */
  OrderRequestMenuItemNormalPriceMismatch = 'ORDER_REQUEST_MENU_ITEM_NORMAL_PRICE_MISMATCH',
  /** Error code 40038 */
  OrderRequestMenuItemOpenPriceInvalid = 'ORDER_REQUEST_MENU_ITEM_OPEN_PRICE_INVALID',
  /** Error code 40046 */
  OrderRequestMenuItemSubsidyAmountMismatch = 'ORDER_REQUEST_MENU_ITEM_SUBSIDY_AMOUNT_MISMATCH',
  /** Error code 40051 */
  OrderRequestMoreThanOneParent = 'ORDER_REQUEST_MORE_THAN_ONE_PARENT',
  /** Error code 40055 */
  OrderRequestNotEnoughMenuItemSelections = 'ORDER_REQUEST_NOT_ENOUGH_MENU_ITEM_SELECTIONS',
  /** Error code 40053 */
  OrderRequestParentChildMenuItemMismatch = 'ORDER_REQUEST_PARENT_CHILD_MENU_ITEM_MISMATCH',
  /** Error code 40063 */
  OrderRequestParentMissingFromGroup = 'ORDER_REQUEST_PARENT_MISSING_FROM_GROUP',
  /** Error code 40005 */
  OrderRequestPaymentRequired = 'ORDER_REQUEST_PAYMENT_REQUIRED',
  /** Error code 40074 */
  OrderRequestPickupOrderNotReady = 'ORDER_REQUEST_PICKUP_ORDER_NOT_READY',
  /** Error code 40073 */
  OrderRequestScanToPayDisabled = 'ORDER_REQUEST_SCAN_TO_PAY_DISABLED',
  /** Error code 40067 */
  OrderRequestSync = 'ORDER_REQUEST_SYNC',
  /** Error code 40072 */
  OrderRequestTenderMethodInvalidForAccount = 'ORDER_REQUEST_TENDER_METHOD_INVALID_FOR_ACCOUNT',
  /** Error code 40071 */
  OrderRequestTenderMethodNotAvailable = 'ORDER_REQUEST_TENDER_METHOD_NOT_AVAILABLE',
  /** Error code 40057 */
  OrderRequestTooManyMenuItemSelections = 'ORDER_REQUEST_TOO_MANY_MENU_ITEM_SELECTIONS',
  /** Error code 40047 */
  OrderRequestTotalFoodSalesNotPositive = 'ORDER_REQUEST_TOTAL_FOOD_SALES_NOT_POSITIVE',
  /** Error code 40408 */
  OrderReverseIdempotent = 'ORDER_REVERSE_IDEMPOTENT',
  /** Error code 40525 */
  SubsidyFullCoverageRequired = 'SUBSIDY_FULL_COVERAGE_REQUIRED',
  /** Error code 40509 */
  SubsidyInstanceNotFound = 'SUBSIDY_INSTANCE_NOT_FOUND',
  /** Error code 40511 */
  SubsidyInstancePreviouslyUsedToday = 'SUBSIDY_INSTANCE_PREVIOUSLY_USED_TODAY',
  /** Error code 40523 */
  SubsidyMaxAmountUsed = 'SUBSIDY_MAX_AMOUNT_USED',
  /** Error code 40513 */
  SubsidyMembershipNotPresent = 'SUBSIDY_MEMBERSHIP_NOT_PRESENT',
  /** Error code 40513 */
  SubsidyMinimumAmountNotMet = 'SUBSIDY_MINIMUM_AMOUNT_NOT_MET',
  /** Error code 40515 */
  SubsidyNewQrCode = 'SUBSIDY_NEW_QR_CODE',
  /** Error code 40507 */
  SubsidyNotAvailableAtLocation = 'SUBSIDY_NOT_AVAILABLE_AT_LOCATION',
  /** Error code 40518 */
  SubsidyNotAvailableForUser = 'SUBSIDY_NOT_AVAILABLE_FOR_USER',
  /** Error code 40517 */
  SubsidyNoLongerAvailable = 'SUBSIDY_NO_LONGER_AVAILABLE',
  /** Error code 40521 */
  SubsidyRequestedAmountMoreThanAvailable = 'SUBSIDY_REQUESTED_AMOUNT_MORE_THAN_AVAILABLE',
  /** Error code 40520 */
  SubsidyRuleNotAvailableToday = 'SUBSIDY_RULE_NOT_AVAILABLE_TODAY',
  /** Error code 40520 */
  SubsidyRuleNotValidOnDate = 'SUBSIDY_RULE_NOT_VALID_ON_DATE',
  /** Error code 40520 */
  SubsidyUsed = 'SUBSIDY_USED',
  /** Error code 40705 */
  VoucherInstanceNotFound = 'VOUCHER_INSTANCE_NOT_FOUND',
  /** Error code 40709 */
  VoucherInvalidAmount = 'VOUCHER_INVALID_AMOUNT',
  /** Error code 40713 */
  VoucherNotRedeemable = 'VOUCHER_NOT_REDEEMABLE'
}

export type OrderRequestErrorDetail = OperationErrorDetail & {
  __typename?: 'OrderRequestErrorDetail';
  code: OrderRequestErrorCodeEnum;
  codeAsString: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type OrderRequestItem = {
  __typename?: 'OrderRequestItem';
  /** @deprecated Not used anymore */
  otherTaxCents: Scalars['Int']['output'];
  postTaxPriceCents: Scalars['Int']['output'];
  preTaxPriceCents: Scalars['Int']['output'];
  salesTaxCents: Scalars['Int']['output'];
};

export type OrderRequestPayment = {
  paymentId: Scalars['ID']['input'];
  paymentType: OrderPayment;
};

export enum OrderRequestPaymentMethod {
  Card = 'CARD',
  Cash = 'CASH',
  NoPayment = 'NO_PAYMENT'
}

export type OrderRequestRefund = {
  customerOrderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  requestId: Scalars['ID']['input'];
};

export enum OrderRequestStateEnum {
  Aborted = 'ABORTED',
  Authorized = 'AUTHORIZED',
  Canceled = 'CANCELED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  Unpaid = 'UNPAID'
}

export type OrderRequestSubsidy = {
  amountCents: Scalars['Int']['input'];
  redemptionCode: Scalars['String']['input'];
};

export type OrderRequestUser = {
  __typename?: 'OrderRequestUser';
  availableCoupons: Array<RedemptionLevel>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  rewardsPhoneNumber?: Maybe<PhoneNumber>;
  rewardsPointsBalance?: Maybe<Scalars['BigDecimal']['output']>;
  uuid: Scalars['ID']['output'];
};

export enum OwnerTypeEnum {
  /** Account Owner Type */
  Account = 'Account',
  /** Vendor Owner Type */
  Vendor = 'Vendor'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** A parent company offered as a picker option */
export type ParentCompanyOption = {
  __typename?: 'ParentCompanyOption';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/** A partner */
export type Partner = {
  __typename?: 'Partner';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  siteManagementFeeRecipientType: SiteManagementFeeRecipientEnum;
};

export enum PaymentGateway {
  Braintree = 'BRAINTREE',
  Cardpointe = 'CARDPOINTE',
  Paypal = 'PAYPAL',
  Worldnet = 'WORLDNET'
}

export type PaymentGatewayInfo = {
  paymentGateway: PaymentGateway;
  /** DEPRECATED: End of support in 2023 */
  paypalResponse?: InputMaybe<PaypalResponse>;
  worldnetResponse?: InputMaybe<WorldnetResponse>;
};

/** A Payment LineItem for orders */
export type PaymentLineItem = {
  __typename?: 'PaymentLineItem';
  amountCents: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayAmount: Scalars['BigDecimal']['output'];
  displayAmountCents: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  lineItemType: PaymentLineItemTypeEnum;
};

export enum PaymentLineItemTypeEnum {
  CardPayment = 'CARD_PAYMENT',
  CashPayment = 'CASH_PAYMENT',
  DiscountPayment = 'DISCOUNT_PAYMENT',
  InvoicePayment = 'INVOICE_PAYMENT',
  MiscPayment = 'MISC_PAYMENT'
}

export enum PaymentMethod {
  Card = 'CARD',
  Cash = 'CASH',
  Discount = 'DISCOUNT'
}

export enum PaymentMethodEnum {
  FoodaInitiatedAchPull = 'FOODA_INITIATED_ACH_PULL',
  FoodaInitiatedCreditCard = 'FOODA_INITIATED_CREDIT_CARD',
  PartyInitiatedAchPull = 'PARTY_INITIATED_ACH_PULL',
  PartyInitiatedCheck = 'PARTY_INITIATED_CHECK'
}

/** Payment processor configuration */
export type PaymentProcessor = {
  __typename?: 'PaymentProcessor';
  braintreeTokenizationKey?: Maybe<Scalars['String']['output']>;
  cardpointeUrlPrefix?: Maybe<Scalars['String']['output']>;
};

/** A Payment Refund LineItem for orders */
export type PaymentRefundLineItem = {
  __typename?: 'PaymentRefundLineItem';
  amountCents: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayAmount: Scalars['BigDecimal']['output'];
  displayAmountCents: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  lineItemType: PaymentRefundLineItemTypeEnum;
};

export enum PaymentRefundLineItemTypeEnum {
  CardPaymentRefund = 'CARD_PAYMENT_REFUND',
  CashPaymentRefund = 'CASH_PAYMENT_REFUND'
}

export enum PaymentTermEnum {
  Net_1 = 'NET_1',
  Net_2 = 'NET_2',
  Net_3 = 'NET_3',
  Net_4 = 'NET_4',
  Net_5 = 'NET_5',
  Net_6 = 'NET_6',
  Net_7 = 'NET_7',
  Net_8 = 'NET_8',
  Net_9 = 'NET_9',
  Net_10 = 'NET_10',
  Net_11 = 'NET_11',
  Net_12 = 'NET_12',
  Net_13 = 'NET_13',
  Net_14 = 'NET_14',
  Net_15 = 'NET_15',
  Net_16 = 'NET_16',
  Net_17 = 'NET_17',
  Net_18 = 'NET_18',
  Net_19 = 'NET_19',
  Net_20 = 'NET_20',
  Net_21 = 'NET_21',
  Net_22 = 'NET_22',
  Net_23 = 'NET_23',
  Net_24 = 'NET_24',
  Net_25 = 'NET_25',
  Net_26 = 'NET_26',
  Net_27 = 'NET_27',
  Net_28 = 'NET_28',
  Net_29 = 'NET_29',
  Net_30 = 'NET_30',
  Net_31 = 'NET_31',
  Net_32 = 'NET_32',
  Net_33 = 'NET_33',
  Net_34 = 'NET_34',
  Net_35 = 'NET_35',
  Net_36 = 'NET_36',
  Net_37 = 'NET_37',
  Net_38 = 'NET_38',
  Net_39 = 'NET_39',
  Net_40 = 'NET_40',
  Net_41 = 'NET_41',
  Net_42 = 'NET_42',
  Net_43 = 'NET_43',
  Net_44 = 'NET_44',
  Net_45 = 'NET_45',
  Net_60 = 'NET_60',
  Net_90 = 'NET_90',
  Net_120 = 'NET_120',
  NoTerms = 'NO_TERMS'
}

export type PaymentTransaction = {
  __typename?: 'PaymentTransaction';
  amountCents: Scalars['Int']['output'];
  cardType?: Maybe<Scalars['String']['output']>;
  ccLast4: Scalars['String']['output'];
  transactedAt: Scalars['ISO8601DateTime']['output'];
};

export type PaypalAccessToken = {
  __typename?: 'PaypalAccessToken';
  ttl: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type PaypalResponse = {
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  captureId?: InputMaybe<Scalars['String']['input']>;
  cardIssuer?: InputMaybe<CardIssuer>;
  cardholderName?: InputMaybe<Scalars['String']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  lastFour?: InputMaybe<Scalars['String']['input']>;
  receiptPreferenceToken?: InputMaybe<Scalars['String']['input']>;
  responseCode?: InputMaybe<Scalars['Int']['input']>;
  transactionHandle?: InputMaybe<Scalars['String']['input']>;
  transactionNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PermissionDomain = {
  __typename?: 'PermissionDomain';
  domain: DomainEnum;
  entityId: Scalars['ID']['output'];
  entityName: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  operations: Array<OperationsEnum>;
};

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  digits?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export enum PhoneVerificationMethod {
  Sms = 'SMS'
}

/** A physical security question */
export type PhysicalSecurityQuestion = {
  __typename?: 'PhysicalSecurityQuestion';
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
};

export type PhysicalSecurityResponse = {
  questionId: Scalars['ID']['input'];
  response: Scalars['String']['input'];
};

export type PickupOrderingWindow = {
  __typename?: 'PickupOrderingWindow';
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export type PickupOrderingWindowInput = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export type Ping = {
  __typename?: 'Ping';
  message: Scalars['String']['output'];
};

/** Autogenerated return type of PingQaToolsQuery. */
export type PingQaToolsQueryPayload = {
  __typename?: 'PingQaToolsQueryPayload';
  error?: Maybe<OperationError>;
  scriptInfo?: Maybe<Array<QaToolsScript>>;
};

/** Autogenerated return type of PingQuery. */
export type PingQueryPayload = {
  __typename?: 'PingQueryPayload';
  error?: Maybe<OperationError>;
  ping?: Maybe<Ping>;
};

/** An entry for the rewards points */
export type PointEntry = {
  __typename?: 'PointEntry';
  action: RewardsAction;
  adminId?: Maybe<Scalars['ID']['output']>;
  campaignId?: Maybe<Scalars['ID']['output']>;
  couponId?: Maybe<Scalars['ID']['output']>;
  customerOrderId?: Maybe<Scalars['ID']['output']>;
  points: Scalars['Float']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
};

/** A shared popup scheduling capacity group (vendors that share scheduling capacity) */
export type PopupCapacityGroup = {
  __typename?: 'PopupCapacityGroup';
  id: Scalars['ID']['output'];
  /** Other vendors sharing scheduling capacity with the vendor being viewed (excludes that vendor) */
  members: Array<PopupCapacityGroupMembership>;
};

/** Membership of a vendor in a popup scheduling capacity group */
export type PopupCapacityGroupMembership = {
  __typename?: 'PopupCapacityGroupMembership';
  /** When this vendor was added to the group */
  addedAt: Scalars['ISO8601DateTime']['output'];
  /** User who added this vendor to the group */
  addedBy: LightweightUser;
  id: Scalars['ID']['output'];
  vendor: Vendor;
};

/** A vendor with its popup scheduling capacity details */
export type PopupCapacityVendor = {
  __typename?: 'PopupCapacityVendor';
  /** The vendor's billing address */
  address?: Maybe<Address>;
  deliveryMenuTemplates?: Maybe<Array<MenuTemplate>>;
  id: Scalars['ID']['output'];
  internalName: Scalars['String']['output'];
  legalName?: Maybe<Scalars['String']['output']>;
  menuTemplates: Array<MenuTemplate>;
  name: Scalars['String']['output'];
  /** The shared popup scheduling capacity group this vendor belongs to, if any */
  popupCapacityGroup?: Maybe<PopupCapacityGroup>;
  siteManagementFeeRecipientType: SiteManagementFeeRecipientEnum;
  /** The vendor's lifecycle state */
  state?: Maybe<VendorState>;
};

/** A popup event */
export type PopupEvent = {
  __typename?: 'PopupEvent';
  account: Account;
  eventEndTime: Scalars['ISO8601DateTime']['output'];
  eventStartTime: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  productType: EventProduct;
  setupTime: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type PopupEventDetail = EventDetail & {
  __typename?: 'PopupEventDetail';
  endTime: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** All locations associated with the event */
  locations: Array<LocationPublic>;
  restaurants: Array<PopupRestaurant>;
  startTime: Scalars['ISO8601DateTime']['output'];
  status: EventStatus;
  /**
   * IANA identifier, e.g. 'America/Chicago'. Start and end times already carry
   * this zone's offset; this names the zone so it can be shown alongside them
   */
  timezone: Scalars['String']['output'];
};

/** A popup event location */
export type PopupEventLocation = {
  __typename?: 'PopupEventLocation';
  id: Scalars['ID']['output'];
  location: Location;
  mealPeriod?: Maybe<MealPeriodEnum>;
  serviceEndTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  serviceStartTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  setupTime?: Maybe<Scalars['Int']['output']>;
  stationType?: Maybe<StationTypes>;
};

/** A category of items on a Popup Menu, eg. 'entrees', 'sides' */
export type PopupEventMenuCategoryGroup = {
  __typename?: 'PopupEventMenuCategoryGroup';
  customItems: Array<CustomPopupEventMenuItem>;
  id: Scalars['ID']['output'];
  isCustom: Scalars['Boolean']['output'];
  items: Array<PopupEventMenuItem>;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

/** A food item on a menu */
export type PopupEventMenuItem = {
  __typename?: 'PopupEventMenuItem';
  available: Scalars['Boolean']['output'];
  availableInPersonOnly: Scalars['Boolean']['output'];
  /** Whether this item is the POS Express Checkout default for its menu template */
  defaultForExpressCheckout: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** Dietary Preferences and Allergens and Sensitivities of the item */
  dietaryInfo: MenuItemDietaryInfo;
  dietaryRestrictions?: Maybe<Array<InventoryItemDietaryRestrictions>>;
  disallowWriteIn?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isCustom: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  namePublic?: Maybe<Scalars['String']['output']>;
  nameVendor?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  otherTaxCents: Scalars['BigDecimal']['output'];
  position: Scalars['Int']['output'];
  postTaxPriceCents: Scalars['Int']['output'];
  preTaxPriceCents: Scalars['BigDecimal']['output'];
  previousCustomization?: Maybe<Scalars['String']['output']>;
  previousNapkins?: Maybe<Scalars['Boolean']['output']>;
  previousSelectionGroups?: Maybe<Array<PopupEventMenuItemPreviousSelection>>;
  previousSilverware?: Maybe<Scalars['Boolean']['output']>;
  /** Price type (per item, per ounce, per pound) */
  priceType: PriceTypeEnum;
  salesTaxCents: Scalars['BigDecimal']['output'];
  scannableId?: Maybe<Scalars['String']['output']>;
  selectionGroupPositions?: Maybe<Array<Scalars['ID']['output']>>;
  selectionGroups?: Maybe<Array<PopupEventMenuItemSelectionGroup>>;
  showOnMenu?: Maybe<Scalars['Boolean']['output']>;
  showOnPos: Scalars['Boolean']['output'];
  /** Subsidy for this menu item */
  subsidy?: Maybe<EventMenuItemSubsidizedPrice>;
  /** @deprecated Not used anymore */
  taxRules?: Maybe<Array<PopupEventMenuItemTaxRule>>;
};

/** Previously selected options for a selection group */
export type PopupEventMenuItemPreviousSelection = {
  __typename?: 'PopupEventMenuItemPreviousSelection';
  optionIds: Array<Scalars['ID']['output']>;
  selectionGroupId: Scalars['ID']['output'];
};

/** A selection group for a menu item, eg. 'Select Salsa' */
export type PopupEventMenuItemSelectionGroup = {
  __typename?: 'PopupEventMenuItemSelectionGroup';
  code: Scalars['String']['output'];
  defaultSelection?: Maybe<PopupEventMenuItemSelectionGroupOption>;
  id: Scalars['ID']['output'];
  itemPositions: Array<Scalars['ID']['output']>;
  maxSelections: Scalars['Int']['output'];
  minSelections: Scalars['Int']['output'];
  namePublic: Scalars['String']['output'];
  options: Array<PopupEventMenuItemSelectionGroupOption>;
  /** @deprecated Not used anymore */
  showOnPos?: Maybe<Scalars['Boolean']['output']>;
};

/** An option for a specific selection group, eg. 'Hot salsa' option for an 'Add salsa' selection group */
export type PopupEventMenuItemSelectionGroupOption = {
  __typename?: 'PopupEventMenuItemSelectionGroupOption';
  available: Scalars['Boolean']['output'];
  /**
   * Dietary Preferences and Allergens and Sensitivities of the option, same shape
   * as items. Modifier rows display only allergens with status CONTAINS; filter on status.
   */
  dietaryInfo: MenuItemDietaryInfo;
  foodaBarcodeNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  namePublic: Scalars['String']['output'];
  /** @deprecated Not used anymore */
  otherTaxCents: Scalars['BigDecimal']['output'];
  plu?: Maybe<Scalars['String']['output']>;
  postTaxPriceCents: Scalars['Int']['output'];
  preTaxPriceCents: Scalars['BigDecimal']['output'];
  salesTaxCents: Scalars['BigDecimal']['output'];
  /** @deprecated Not used anymore */
  showOnPos?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use upc or fooda_barcode_number */
  sku?: Maybe<Scalars['String']['output']>;
  /** Subsidy for this menu item */
  subsidy?: Maybe<EventMenuItemSubsidizedPrice>;
  /** @deprecated Not used anymore */
  taxRules?: Maybe<Array<PopupEventMenuItemTaxRule>>;
  upc?: Maybe<Scalars['String']['output']>;
};

/** A tax rule for a popup menu item. Contains the exact cents value of the tax applied to the item. */
export type PopupEventMenuItemTaxRule = {
  __typename?: 'PopupEventMenuItemTaxRule';
  cents: Scalars['BigDecimal']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rule: TaxRuleRule;
  /** A unique identifier for a type of tax rule. Can be used for grouping taxes across items. */
  taxRuleId: Scalars['ID']['output'];
};

export type PopupEventPublic = PublicEvent & {
  __typename?: 'PopupEventPublic';
  account: AccountPublic;
  endTime: Scalars['ISO8601DateTime']['output'];
  endTimeOffsetInDays: Scalars['Int']['output'];
  healthscoreLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRewardsEnabled: Scalars['Boolean']['output'];
  /** First location associated with the event, if any */
  location?: Maybe<LocationPublic>;
  /** All locations associated with the event, in creation order */
  locations: Array<LocationPublic>;
  mealPeriod?: Maybe<MealPeriodEnum>;
  restaurants: Array<PopupRestaurant>;
  startTime: Scalars['ISO8601DateTime']['output'];
  status: EventStatus;
  /**
   * IANA identifier, e.g. 'America/Chicago'. Start and end times already carry
   * this zone's offset; this names the zone so it can be shown alongside them
   */
  timezone: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Menu item details for a popup or cafe recommendation */
export type PopupEventRecommendationMenuItem = RecommendationMenuItem & {
  __typename?: 'PopupEventRecommendationMenuItem';
  description?: Maybe<Scalars['String']['output']>;
  /** Which restaurant or station menu the item belongs to. */
  eventVendorId: Scalars['ID']['output'];
  /** True when the item has options, so the options form is needed instead of adding directly. */
  hasOptions: Scalars['Boolean']['output'];
  /** True when the event's account hides prices, so the card must render none. */
  hidePrices: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  images: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Pre-subsidy price to strike through. Null unless the applied subsidy rule opts into showing it, matching the menu page. */
  originalPriceCents?: Maybe<Scalars['Int']['output']>;
  /** Price the user pays. Subsidy-aware where the product supports item-level subsidy. */
  priceCents: Scalars['Int']['output'];
  tags: Array<Scalars['String']['output']>;
};

export enum PopupEventStatusEnum {
  Active = 'ACTIVE',
  AutoCanceled = 'AUTO_CANCELED',
  AutoGenerated = 'AUTO_GENERATED',
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Final = 'FINAL',
  Proposed = 'PROPOSED',
  Scheduled = 'SCHEDULED',
  Undefined = 'UNDEFINED'
}

/** A vendor assigned to a popup event */
export type PopupEventVendor = EventVendor & {
  __typename?: 'PopupEventVendor';
  confirmed: Scalars['Boolean']['output'];
  eventLocation?: Maybe<PopupEventLocation>;
  /** @deprecated This field has been moved inside the sales field */
  gfsCents: Scalars['Int']['output'];
  historical?: Maybe<Array<PopupEventVendor>>;
  historicalMealsSoldFactors: Array<HistoricalMealsSoldFactor>;
  id: Scalars['ID']['output'];
  location: Location;
  mealPrep?: Maybe<MealPrep>;
  menuTemplate: PopupMenuTemplate;
  popupEvent: PopupEvent;
  posHidePrice: Scalars['Boolean']['output'];
  productType: EventProduct;
  sales?: Maybe<FinancialInfo>;
  siteDirectionsEmailSent: Scalars['Boolean']['output'];
  usesFoodaPos: Scalars['Boolean']['output'];
  vendor: Vendor;
};


/** A vendor assigned to a popup event */
export type PopupEventVendorHistoricalArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** A vendor's menu for a popup event. */
export type PopupEventVendorMenu = {
  __typename?: 'PopupEventVendorMenu';
  eventVendorId: Scalars['ID']['output'];
  /**
   * True when this vendor's published menu has an Express Checkout default item,
   * used to gate the POS Express Checkout Mode toggle
   */
  hasDefaultForExpressCheckoutItem: Scalars['Boolean']['output'];
  hidePrices: Scalars['Boolean']['output'];
  menuGroups: Array<PopupEventMenuCategoryGroup>;
};

export enum PopupEventVendorStatus {
  Active = 'ACTIVE',
  CanceledScheduleChange = 'CANCELED_SCHEDULE_CHANGE',
  CanceledVendorCancellation = 'CANCELED_VENDOR_CANCELLATION'
}

/** A feedback comment left by a popup customer */
export type PopupFeedbackComment = {
  __typename?: 'PopupFeedbackComment';
  createdAt: Scalars['ISO8601DateTime']['output'];
  popupEvent: PopupEvent;
  text: Scalars['String']['output'];
};

/** The connection type for PopupFeedbackComment. */
export type PopupFeedbackCommentConnection = {
  __typename?: 'PopupFeedbackCommentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PopupFeedbackCommentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PopupFeedbackComment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PopupFeedbackCommentEdge = {
  __typename?: 'PopupFeedbackCommentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PopupFeedbackComment>;
};

/** An inventory item including a product_type of :popup */
export type PopupInventoryItem = {
  __typename?: 'PopupInventoryItem';
  availableInPersonOnly: Scalars['Boolean']['output'];
  barcodeIdentifier?: Maybe<Barcode>;
  description?: Maybe<Scalars['String']['output']>;
  destroyable: Scalars['Boolean']['output'];
  /** Dietary Preferences and Allergens and Sensitivities of the item */
  dietaryInfo: MenuItemDietaryInfo;
  dietaryRestrictions: Array<InventoryItemDietaryRestrictions>;
  disallowWriteIn?: Maybe<Scalars['Boolean']['output']>;
  externalTags: Array<InventoryItemExternalTags>;
  foodaSku: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use image_url */
  image?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  mealType: InventoryItemMealType;
  menuTemplateInventoryItems: Array<PopupMenuTemplateInventoryItem>;
  nameForVendor: Scalars['String']['output'];
  namePublic: Scalars['String']['output'];
  otherTax: Scalars['BigDecimal']['output'];
  /** @deprecated Not used anymore */
  otherTaxCents: Scalars['BigDecimal']['output'];
  postTaxPrice: Scalars['BigDecimal']['output'];
  postTaxPriceCents: Scalars['Int']['output'];
  preTaxPrice: Scalars['BigDecimal']['output'];
  preTaxPriceCents: Scalars['BigDecimal']['output'];
  priceType: PriceTypeEnum;
  salesTax: Scalars['BigDecimal']['output'];
  salesTaxCents: Scalars['BigDecimal']['output'];
  showOnMenu: Scalars['Boolean']['output'];
  showOnPos: Scalars['Boolean']['output'];
  taxCategoryId?: Maybe<Scalars['Int']['output']>;
  taxRules: Array<TaxRule>;
};


/** An inventory item including a product_type of :popup */
export type PopupInventoryItemMenuTemplateInventoryItemsArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for PopupInventoryItem. */
export type PopupInventoryItemConnection = {
  __typename?: 'PopupInventoryItemConnection';
  currentPage: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PopupInventoryItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PopupInventoryItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PopupInventoryItemEdge = {
  __typename?: 'PopupInventoryItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PopupInventoryItem>;
};

/** Inventory items with filters and paging for a vendor */
export type PopupInventoryItemsForVendorType = {
  __typename?: 'PopupInventoryItemsForVendorType';
  mealTypes?: Maybe<Array<InventoryItemMealTypeFilter>>;
  popupInventoryItems?: Maybe<PopupInventoryItemConnection>;
};


/** Inventory items with filters and paging for a vendor */
export type PopupInventoryItemsForVendorTypePopupInventoryItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

/** A menu template for a popup */
export type PopupMenuTemplate = {
  __typename?: 'PopupMenuTemplate';
  allowAsapOrdering: Scalars['Boolean']['output'];
  asapMinutes?: Maybe<Scalars['Int']['output']>;
  categoryGroups: Array<PopupMenuTemplateCategoryGroup>;
  cuisines?: Maybe<Array<CuisineNames>>;
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  expectedPickupOrderPercentage?: Maybe<Scalars['Int']['output']>;
  hiddenFromCustomerCampaignsEmail: Scalars['Boolean']['output'];
  hiddenFromCustomerMenu: Scalars['Boolean']['output'];
  hiddenFromFfrMenu: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  mealPeriods?: Maybe<Array<MealPeriodEnum>>;
  name?: Maybe<Scalars['String']['output']>;
  overrideSpotLocationCapacity: Scalars['Boolean']['output'];
  residentVendorMenu: Scalars['Boolean']['output'];
  schedulerConfig?: Maybe<PopupMenuTemplateSchedulerConfig>;
  startDate: Scalars['ISO8601DateTime']['output'];
  state: MenuTemplateStateEnum;
};

export type PopupMenuTemplateAttributes = {
  allowAsapOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  asapMinutes?: InputMaybe<Scalars['Int']['input']>;
  cuisines: Array<CuisineNames>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  expectedPickupOrderPercentage?: InputMaybe<Scalars['Int']['input']>;
  hiddenFromCustomerCampaignsEmail: Scalars['Boolean']['input'];
  hiddenFromCustomerMenu: Scalars['Boolean']['input'];
  hiddenFromFfrMenu?: InputMaybe<Scalars['Boolean']['input']>;
  mealPeriods: Array<MealPeriodEnum>;
  name: Scalars['String']['input'];
  overrideSpotLocationCapacity?: InputMaybe<Scalars['Boolean']['input']>;
  residentVendorMenu?: InputMaybe<Scalars['Boolean']['input']>;
  schedulerConfig?: InputMaybe<PopupMenuTemplateSchedulerConfigInput>;
  startDate: Scalars['ISO8601DateTime']['input'];
  state: MenuTemplateStateEnum;
};

/** A group of menu template inventory items, i.e. Salads, Entrees, etc. */
export type PopupMenuTemplateCategoryGroup = {
  __typename?: 'PopupMenuTemplateCategoryGroup';
  id: Scalars['ID']['output'];
  menuTemplateInventoryItems?: Maybe<Array<PopupMenuTemplateInventoryItem>>;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
};

/** Popup types that will have a default menu template for the auto scheduler */
export type PopupMenuTemplateDefaultLocationTypes = {
  __typename?: 'PopupMenuTemplateDefaultLocationTypes';
  allPopups: Scalars['Boolean']['output'];
  channelPartnership: Scalars['Boolean']['output'];
  foodHall: Scalars['Boolean']['output'];
  prePaidPopup: Scalars['Boolean']['output'];
};

/** An item on the menu */
export type PopupMenuTemplateInventoryItem = {
  __typename?: 'PopupMenuTemplateInventoryItem';
  availableInPersonOnly: Scalars['Boolean']['output'];
  defaultForExpressCheckout: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dietaryRestrictions?: Maybe<Array<InventoryItemDietaryRestrictions>>;
  externalTags?: Maybe<Array<InventoryItemExternalTags>>;
  foodaBarcodeNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inventoryItem: PopupInventoryItem;
  menuTemplate?: Maybe<PopupMenuTemplate>;
  nameForVendor: Scalars['String']['output'];
  namePublic: Scalars['String']['output'];
  /** @deprecated Not used anymore */
  otherTax: Scalars['BigDecimal']['output'];
  /** @deprecated Not used anymore */
  otherTaxCents: Scalars['BigDecimal']['output'];
  plu?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  postTaxPrice: Scalars['BigDecimal']['output'];
  postTaxPriceCents: Scalars['Int']['output'];
  preTaxPrice: Scalars['BigDecimal']['output'];
  preTaxPriceCents: Scalars['BigDecimal']['output'];
  priceType: PriceTypeEnum;
  salesTax: Scalars['BigDecimal']['output'];
  salesTaxCents: Scalars['BigDecimal']['output'];
  selectionGroupPositions?: Maybe<Array<Scalars['ID']['output']>>;
  selectionGroups?: Maybe<Array<PopupMenuTemplateSelectionGroup>>;
  showOnMenu: Scalars['Boolean']['output'];
  showOnPos: Scalars['Boolean']['output'];
  /** @deprecated Use upc or fooda_barcode_number */
  sku?: Maybe<Scalars['String']['output']>;
  taxCategoryId?: Maybe<Scalars['Int']['output']>;
  taxRules: Array<TaxRule>;
  upc?: Maybe<Scalars['String']['output']>;
};

export type PopupMenuTemplateInventoryItemAttributes = {
  availableInPersonOnly?: InputMaybe<Scalars['Boolean']['input']>;
  defaultForExpressCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Ignored. The description is set on the inventory item and copied to its menu template items. */
  description?: InputMaybe<Scalars['String']['input']>;
  nameForVendor?: InputMaybe<Scalars['String']['input']>;
  namePublic?: InputMaybe<Scalars['String']['input']>;
  preTaxPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  priceType: PriceTypeEnum;
  showOnMenu?: InputMaybe<Scalars['Boolean']['input']>;
  showOnPos?: InputMaybe<Scalars['Boolean']['input']>;
  taxCategoryId?: InputMaybe<Scalars['Int']['input']>;
};

export type PopupMenuTemplateLocationPreferenceInput = {
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PopupMenuTemplateLocationTypesInput = {
  allPopups: Scalars['Boolean']['input'];
  channelPartnership: Scalars['Boolean']['input'];
  foodHall: Scalars['Boolean']['input'];
  prePaidPopup: Scalars['Boolean']['input'];
};

/** Settings for the auto scheduler */
export type PopupMenuTemplateSchedulerConfig = {
  __typename?: 'PopupMenuTemplateSchedulerConfig';
  locationPreferences: Array<Location>;
  locationTypes: PopupMenuTemplateDefaultLocationTypes;
};

export type PopupMenuTemplateSchedulerConfigInput = {
  locationPreferences: PopupMenuTemplateLocationPreferenceInput;
  locationTypes: PopupMenuTemplateLocationTypesInput;
};

/** A group of item options/modifiers for a menu template inventory item, i.e. Add Meat, Toppings, etc. */
export type PopupMenuTemplateSelectionGroup = {
  __typename?: 'PopupMenuTemplateSelectionGroup';
  defaultSelection?: Maybe<PopupMenuTemplateInventoryItem>;
  id: Scalars['ID']['output'];
  itemPositions: Array<Scalars['ID']['output']>;
  maxSelections: Scalars['Int']['output'];
  minSelections: Scalars['Int']['output'];
  nameForVendor: Scalars['String']['output'];
  namePublic: Scalars['String']['output'];
  options: Array<PopupMenuTemplateInventoryItem>;
  showOnMenu?: Maybe<Scalars['Boolean']['output']>;
  showOnPos?: Maybe<Scalars['Boolean']['output']>;
};

/** Brief details of a Popup Order for Activity Stream */
export type PopupOrder = {
  __typename?: 'PopupOrder';
  /** Feedback Requests outstanding for Order */
  feedbackRequested: Scalars['Boolean']['output'];
  /** Flag to hide prices */
  hidePrices: Scalars['Boolean']['output'];
  /** Names of items sold */
  itemNames: Array<Scalars['String']['output']>;
  /** ISO8601 DateTime of when order was placed */
  orderFulfilledTime: Scalars['ISO8601DateTime']['output'];
  /** Time order was placed in unix seconds format */
  orderFulfilledTimeUnix: Scalars['Int']['output'];
  /** Top level item names on an order (excludes modifiers) */
  parentItemNames: Array<Scalars['String']['output']>;
  /** Amount customer paid */
  paymentCents: Scalars['Int']['output'];
  /** Order payment method */
  paymentMethod?: Maybe<CustomerOrderPaymentMethodEnum>;
  /** Order payment state */
  paymentState: OrderRequestStateEnum;
  /** Pick up information for the order */
  pickupInfo?: Maybe<PopupUserOrderPickupInfo>;
  /** Unique ID of order */
  requestId: Scalars['ID']['output'];
  /** Rewards points earned from order */
  rewardsPoints: Scalars['Float']['output'];
  /** Names of vendors with sales on order */
  vendorNames: Array<Scalars['String']['output']>;
};

/** Full details of a pop up order */
export type PopupOrderDetails = {
  __typename?: 'PopupOrderDetails';
  accountName: Scalars['String']['output'];
  /** Discount refunds on order */
  discountRefunds: Array<DiscountRefundLineItem>;
  /** Discounts on order */
  discounts: Array<DiscountLineItem>;
  /** Feedback is requested */
  feedbackRequested: Scalars['Boolean']['output'];
  /** Fees on order */
  fees: Array<FeeLineItem>;
  /** Flag to hide prices */
  hidePrices: Scalars['Boolean']['output'];
  /** Food sold */
  items?: Maybe<Array<PopupOrderItem>>;
  /** Location of popup event */
  location?: Maybe<Location>;
  /** ISO8601 DateTime of when order was placed */
  orderFulfilledTime: Scalars['ISO8601DateTime']['output'];
  /** Time order was placed in unix seconds format */
  orderFulfilledTimeUnix: Scalars['Int']['output'];
  /** ISO8601 DateTime of when order was processed */
  orderTime: Scalars['ISO8601DateTime']['output'];
  /** Time order was processed in unix seconds format */
  orderTimeUnix: Scalars['Int']['output'];
  /** Refunds of payments on order */
  paymentRefunds: Array<PaymentRefundLineItem>;
  /** Details of card payments */
  paymentTransaction: Array<PaymentTransaction>;
  /** Payments on order */
  payments: Array<PaymentLineItem>;
  /** Mobile Ordering info */
  pickupInfo?: Maybe<PopupUserOrderPickupInfo>;
  /** State of the order */
  processState: PopupOrderProcessState;
  /** Unique ID of order */
  requestId: Scalars['ID']['output'];
  /** State of the order */
  requestState: PopupOrderRequestState;
  /** Order commission */
  restaurantCommissionAmountCents: Scalars['Int']['output'];
  /** Rewards points earned from order */
  rewardsPoints: Scalars['Float']['output'];
  /** Original order subtotal */
  subtotalAmountCents: Scalars['Int']['output'];
  /** Original order tax total */
  taxAmountCents: Scalars['Int']['output'];
  /** Paid order total */
  totalAmountCents: Scalars['Int']['output'];
  /** Original order other tax total */
  totalOtherTaxCents: Scalars['Int']['output'];
  /** Original order sales tax total */
  totalSalesTaxCents: Scalars['Int']['output'];
  /** Total other and sales tax refunded */
  totalTaxRefundCents: Scalars['Int']['output'];
  /** Price shown to user */
  userPrice: UserPrice;
  /** Vendors with food sales in order */
  vendors: Array<ConsumerVendor>;
};

/** Details of food sales on a popup order */
export type PopupOrderItem = {
  __typename?: 'PopupOrderItem';
  /** ID of the customer order the item belongs to */
  customerOrderId: Scalars['ID']['output'];
  customizationDescription?: Maybe<Scalars['String']['output']>;
  /** Selection group ID if item belongs to one */
  groupId?: Maybe<Scalars['ID']['output']>;
  /** ID of menu item */
  id: Scalars['ID']['output'];
  /** Name of item */
  name: Scalars['String']['output'];
  napkins?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No live data, but old app version shared type prior to Menu Mods is using it */
  options?: Maybe<Array<PopupOrderItem>>;
  /** Original price of item */
  priceCents: Scalars['Int']['output'];
  /** Quantity sold. Probably 1. */
  quantity: Scalars['Int']['output'];
  /** Flag of if item was refunded */
  refunded?: Maybe<Scalars['Boolean']['output']>;
  /** Modifier groups for order */
  selectionGroups?: Maybe<Array<PopupOrderItemSelectionGroup>>;
  silverware?: Maybe<Scalars['Boolean']['output']>;
  /**
   * DEPRECATED: Additions/exclusions for the item. Never used for Popup
   * @deprecated Never used, moving to single fields
   */
  specialInstructions?: Maybe<Scalars['String']['output']>;
  /** Original total tax amount of the item */
  taxAmountCents: Scalars['Int']['output'];
  /** Price shown to user */
  userPrice: UserPrice;
  /** ID of vendor of item */
  vendorId: Scalars['ID']['output'];
};

/** Details of a selection group of an item on a popup order */
export type PopupOrderItemSelectionGroup = {
  __typename?: 'PopupOrderItemSelectionGroup';
  /** Selection group ID */
  id: Scalars['ID']['output'];
  /** Public name of selection group */
  namePublic: Scalars['String']['output'];
  /** Modifiers selected for order */
  options?: Maybe<Array<PopupOrderItem>>;
};

/** Brief details of a Popup Order */
export type PopupOrderListItem = {
  __typename?: 'PopupOrderListItem';
  apiVersion?: Maybe<Scalars['ID']['output']>;
  apiVersionEnum?: Maybe<ApiVersion>;
  /** Flag to hide prices */
  hidePrices: Scalars['Boolean']['output'];
  /** Names of items sold */
  itemNames: Array<Scalars['String']['output']>;
  /** Last four of card used on order */
  lastFour?: Maybe<Scalars['String']['output']>;
  /** ISO8601 DateTime of when order was placed */
  orderFulfilledTime: Scalars['ISO8601DateTime']['output'];
  /** Time order was placed in unix seconds format */
  orderFulfilledTimeUnix: Scalars['Int']['output'];
  /** State of the popup order */
  orderState: Scalars['String']['output'];
  /** Total cost of the order */
  orderTotal: Scalars['Int']['output'];
  /** Top Level Items on an order. Ex. Burrito Bowl */
  parentItemNames: Array<Scalars['String']['output']>;
  /** Amount customer paid minus refunds */
  paymentCents: Scalars['Int']['output'];
  /** Cash / Credit / Discount */
  paymentMethods: Array<PaymentMethod>;
  /** Pick up information for the popup order */
  pickupInfo?: Maybe<PopupOrderPickupInfo>;
  /** Amount refunded to customer */
  refundCents: Scalars['Int']['output'];
  /** Unique ID of order */
  requestId: Scalars['ID']['output'];
  /** Names of vendors with sales on order */
  vendorNames: Array<Scalars['String']['output']>;
};

/** The connection type for PopupOrderListItem. */
export type PopupOrderListItemConnection = {
  __typename?: 'PopupOrderListItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PopupOrderListItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PopupOrderListItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PopupOrderListItemEdge = {
  __typename?: 'PopupOrderListItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PopupOrderListItem>;
};

export type PopupOrderPickupInfo = {
  __typename?: 'PopupOrderPickupInfo';
  pickupId: Scalars['ID']['output'];
  pickupTime: Scalars['ISO8601DateTime']['output'];
};

export enum PopupOrderProcessState {
  Processed = 'PROCESSED',
  Unprocessed = 'UNPROCESSED'
}

export enum PopupOrderRequestState {
  Aborted = 'ABORTED',
  AuthorizationFailed = 'AUTHORIZATION_FAILED',
  Authorized = 'AUTHORIZED',
  Canceled = 'CANCELED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  Unpaid = 'UNPAID'
}

export type PopupRestaurant = {
  __typename?: 'PopupRestaurant';
  cuisines?: Maybe<Array<Scalars['String']['output']>>;
  defaultCuisine?: Maybe<Scalars['String']['output']>;
  essenceImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  location: LocationPublic;
  logoUrl?: Maybe<Scalars['String']['output']>;
  mealPeriod?: Maybe<MealPeriodEnum>;
  /** Path of the customer menu page, filtered to this restaurant */
  menuUrl?: Maybe<Scalars['String']['output']>;
  mobileOrdering: MobileOrderingEventVendorInfo;
  name: Scalars['String']['output'];
  serviceEndTime: Scalars['ISO8601DateTime']['output'];
  serviceStartTime: Scalars['ISO8601DateTime']['output'];
  stationType?: Maybe<StationTypes>;
  vendorId: Scalars['ID']['output'];
};

export type PopupUserOrderPickupInfo = {
  __typename?: 'PopupUserOrderPickupInfo';
  canceledByUser: Scalars['Boolean']['output'];
  /** Time the pickup order was canceled by the restaurant. Only present if the order was actually canceled */
  canceledTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  pickupId: Scalars['ID']['output'];
  pickupTime: Scalars['ISO8601DateTime']['output'];
  state: MobileOrderingOrderStatus;
};

export type PopupVendorMenuItem = VendorMenuItem & {
  __typename?: 'PopupVendorMenuItem';
  category?: Maybe<VendorMenuCategory>;
  /** The id of the image the item shows, as the seen value of an image edit. Null for no image, and for non-delivery items. */
  currentImageRef?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Dietary restriction/allergen labels (e.g. Contains Nuts, Vegan). */
  dietaryRestrictions: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** All item image URLs, for the larger-format image modal. */
  images: Array<Scalars['String']['output']>;
  /** The item's type, as the seen value of an item type edit. Null for non-delivery items. */
  itemType?: Maybe<InventoryItemMealType>;
  nameForVendor: Scalars['String']['output'];
  namePublic: Scalars['String']['output'];
  optionGroups: Array<VendorMenuOptionGroup>;
  /**
   * The vendor's other delivery menus that carry this item, so an edit that
   * reaches them can be shown. Empty for non-delivery items.
   */
  otherMenus: Array<MenuChangeOtherMenu>;
  /** Restaurant pre-tax price in cents (may be sub-cent), resolved per product type. Null for menu-level priced catering. */
  preTaxPriceCents?: Maybe<Scalars['BigDecimal']['output']>;
  /** First image, or a placeholder when the item has no image. */
  primaryImageUrl: Scalars['String']['output'];
  /**
   * The tax category the item is charged under, as the seen value of a tax
   * category edit: its own, or the global default when it has none. Null for
   * non-delivery items.
   */
  taxCategoryId?: Maybe<Scalars['ID']['output']>;
  /** Whether the item can be used as an option, as the seen value of a usable-as-option edit. Null for non-delivery items. */
  usableAsOption?: Maybe<Scalars['Boolean']['output']>;
  /**
   * True when the item is also used on a non-draft, non-expired popup or catering
   * menu. FFR shows the item, its option groups and their options locked, and
   * edits to them are refused with ITEM_USED_OUTSIDE_DELIVERY; removing it from
   * this menu is still allowed. Null for non-delivery items.
   */
  usedOutsideDelivery?: Maybe<Scalars['Boolean']['output']>;
};

export type PopupVendorMenuOption = VendorMenuOption & {
  __typename?: 'PopupVendorMenuOption';
  /** Dietary restriction/allergen labels of the option's inventory item (e.g. Contains Soy). */
  dietaryRestrictions: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The option's item type, as the seen value of an item type edit. Null for popup options. */
  itemType?: Maybe<InventoryItemMealType>;
  nameForVendor: Scalars['String']['output'];
  namePublic: Scalars['String']['output'];
  /** Restaurant pre-tax incremental price for this option, in cents (may be sub-cent). */
  preTaxPriceCents?: Maybe<Scalars['BigDecimal']['output']>;
  /**
   * The tax category the option is charged under, as the seen value of a tax
   * category edit: its own, or the global default when it has none. Null for popup options.
   */
  taxCategoryId?: Maybe<Scalars['ID']['output']>;
  /** The number of option groups that use this option. Always 0 for popup options. */
  usedInGroupsCount: Scalars['Int']['output'];
  /**
   * True when the option is also used on a non-draft, non-expired popup or
   * catering menu. FFR shows it locked, and an edit to it is refused with
   * OPTION_USED_OUTSIDE_DELIVERY. Null for popup options.
   */
  usedOutsideDelivery?: Maybe<Scalars['Boolean']['output']>;
};

export type PopupVendorMenuTemplate = VendorMenuTemplate & {
  __typename?: 'PopupVendorMenuTemplate';
  /** Whether the signed-in manager can edit this menu in FFR. */
  canEditInFfr: Scalars['Boolean']['output'];
  categories: Array<VendorMenuCategory>;
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Why canEditInFfr is false, for the disabled "Edit menu" reason. Null when the menu can be edited. */
  ffrEditBlockedReason?: Maybe<MenuChangeEditBlockedReason>;
  id: Scalars['ID']['output'];
  /** Top-level menu items (options excluded), ordered by category then position; 25 per page. */
  items: VendorMenuItemConnection;
  mealPeriods: Array<MealPeriodEnum>;
  name?: Maybe<Scalars['String']['output']>;
  /** The menu change request waiting for a decision, which locks FFR submits to this template. */
  pendingChangeRequest?: Maybe<MenuChangeRequest>;
  productType: ProductEnum;
  /** True when the template or any of its items changed within the last 2 weeks. */
  recentlyUpdated: Scalars['Boolean']['output'];
  startDate: Scalars['ISO8601DateTime']['output'];
  state: MenuTemplateStateEnum;
  /** Latest of the template's own change and its items' changes. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type PopupVendorMenuTemplateItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum PriceTypeEnum {
  PerItem = 'PER_ITEM',
  /** @deprecated Price type 'per_ounce' is deprecated. Please use 'per_pound' instead. */
  PerOunce = 'PER_OUNCE',
  PerPound = 'PER_POUND'
}

export enum ProductEnum {
  Cafe = 'CAFE',
  Catering = 'CATERING',
  Delivery = 'DELIVERY',
  FoodaCard = 'FOODA_CARD',
  Foodsby = 'FOODSBY',
  Pantry = 'PANTRY',
  Popup = 'POPUP'
}

/** Resolver-based Prompt Configuration */
export type PromptConfig = {
  __typename?: 'PromptConfig';
  /** Whether this config uses resolver-based variables */
  hasVariables: Scalars['Boolean']['output'];
  /** Template string with {{PLACEHOLDER}} variables */
  masterTemplate: Scalars['String']['output'];
  /** JSON string of LLM model parameters (temperature, max_tokens, etc.) */
  modelParamsJson?: Maybe<Scalars['String']['output']>;
  /** JSON string of variable definitions with resolver configurations */
  variablesJson: Scalars['String']['output'];
};

/** Prompt configuration input */
export type PromptConfigInput = {
  /** Master template with {{VARIABLE}} placeholders */
  masterTemplate: Scalars['String']['input'];
  /** JSON string of model-specific parameters (temperature, max_tokens, etc.) */
  modelParamsJson?: InputMaybe<Scalars['String']['input']>;
  /** JSON string of variable definitions with resolvers and params */
  variablesJson?: InputMaybe<Scalars['String']['input']>;
};

/** Context input for prompt preview and testing */
export type PromptContextInput = {
  /** Event vendor IDs to scope available menu items (defaults to all vendors) */
  eventVendorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Maximum number of feedback records to include */
  feedbackLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Feedback action types to include (e.g., SHOWN, CLICKED) */
  feedbackTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Toggle to include feedback data */
  includeFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  /** Toggle to include order history data */
  includeOrderHistory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Toggle to include user profile data */
  includeProfile?: InputMaybe<Scalars['Boolean']['input']>;
  /** Item ID for UpSell selected item context preview */
  itemId?: InputMaybe<Scalars['ID']['input']>;
  /** Item IDs for CrossSell cart context preview */
  itemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Recommendation model ID to infer task/adaptor */
  modelId: Scalars['ID']['input'];
  /** User profile JSON to inject into prompt context */
  profileJson?: InputMaybe<Scalars['String']['input']>;
  /** Target ID */
  targetId: Scalars['ID']['input'];
  /** Target type (Event, SelectEvent, Popup::PopupEvent) */
  targetType: Scalars['String']['input'];
  /** User ID to pull real context (feedback, orders) */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type PublicEvent = {
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  healthscoreLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** All locations associated with the event */
  locations: Array<LocationPublic>;
  startTime: Scalars['ISO8601DateTime']['output'];
  status: EventStatus;
  url: Scalars['String']['output'];
};

/** The connection type for PublicEvent. */
export type PublicEventConnection = {
  __typename?: 'PublicEventConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PublicEventEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PublicEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PublicEventEdge = {
  __typename?: 'PublicEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PublicEvent>;
};

export type PublishMobileOrderingUpdate = {
  eventId: Scalars['ID']['input'];
  mobileOrder: MobileOrderingOrderInput;
  vendorId: Scalars['ID']['input'];
};

/** Autogenerated return type of PublishMobileOrderingUpdate. */
export type PublishMobileOrderingUpdatePayload = {
  __typename?: 'PublishMobileOrderingUpdatePayload';
  error?: Maybe<OperationError>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of PublishRecommendationsModel. */
export type PublishRecommendationsModelPayload = {
  __typename?: 'PublishRecommendationsModelPayload';
  error?: Maybe<OperationError>;
  modelConfig?: Maybe<ModelConfig>;
};

export enum PushNotificationProviders {
  Moengage = 'MOENGAGE'
}

/** An ephemeral key for push provisioning a card to a digital wallet */
export type PushProvisioningEphemeralKey = {
  __typename?: 'PushProvisioningEphemeralKey';
  /** When the key was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the key expires */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The ephemeral key ID */
  id: Scalars['String']['output'];
  /** The associated Issuing card ID */
  issuingCardId?: Maybe<Scalars['String']['output']>;
  /** Whether this key was created in live mode */
  livemode?: Maybe<Scalars['Boolean']['output']>;
  /** Full ephemeral key JSON for mobile SDK consumption */
  rawJson: Scalars['String']['output'];
  /** The ephemeral key secret for SDK use */
  secret: Scalars['String']['output'];
};

export enum QaToolsRequestTypeEnum {
  /** Run the QaTools::Scripts::AnyScript QA script */
  AnyScript = 'AnyScript',
  /** Run the QaTools::Scripts::AutomationScripts QA script */
  AutomationScripts = 'AutomationScripts',
  /** Run the QaTools::Scripts::GenerateBillingSummaryDocument QA script */
  GenerateBillingSummaryDocument = 'GenerateBillingSummaryDocument',
  /** Run the QaTools::Scripts::GeneratePdfConsolidatedInvoice QA script */
  GeneratePdfConsolidatedInvoice = 'GeneratePdfConsolidatedInvoice',
  /** Run the QaTools::Scripts::LockPopupCafeConsolidatedInvoice QA script */
  LockPopupCafeConsolidatedInvoice = 'LockPopupCafeConsolidatedInvoice',
  /** Run the QaTools::Scripts::ProcessConsumerDataRequests QA script */
  ProcessConsumerDataRequests = 'ProcessConsumerDataRequests',
  /** Run the QaTools::Scripts::PushDeliveryEventsToAvalara QA script */
  PushDeliveryEventsToAvalara = 'PushDeliveryEventsToAvalara',
  /** Run the QaTools::Scripts::RunScimUserExport QA script */
  RunScimUserExport = 'RunScimUserExport',
  /** Run the QaTools::Scripts::SettingMinimalVersionOnIosAndAndroid QA script */
  SettingMinimalVersionOnIosAndAndroid = 'SettingMinimalVersionOnIosAndAndroid',
  /** Run the QaTools::Scripts::SettleCronJobForCateringEvents QA script */
  SettleCronJobForCateringEvents = 'SettleCronJobForCateringEvents',
  /** Run the QaTools::Scripts::SimpleCalc QA script */
  SimpleCalc = 'SimpleCalc',
  /** Run the QaTools::Scripts::SyncUserToMoengage QA script */
  SyncUserToMoengage = 'SyncUserToMoengage',
  /** Run the QaTools::Scripts::TriggerEventCampaign QA script */
  TriggerEventCampaign = 'TriggerEventCampaign'
}

/** Path information */
export type QaScriptPath = {
  __typename?: 'QaScriptPath';
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

/** Namespace information */
export type QaScriptsNamespace = {
  __typename?: 'QaScriptsNamespace';
  namespace: Scalars['String']['output'];
  paths?: Maybe<Array<QaScriptPath>>;
};

/** QA Tools fields */
export type QaToolsField = {
  __typename?: 'QaToolsField';
  description?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  /**
   * Namespaces, only for input fields. e.g. [{namespace: 'migrations', paths:
   * [{path: 'migration/script_name.rb', name: 'script_name'}]}, ..]
   */
  namespaces?: Maybe<Array<QaScriptsNamespace>>;
  value?: Maybe<Scalars['String']['output']>;
};

export type QaToolsInput = {
  a?: InputMaybe<Scalars['String']['input']>;
  androidVersion?: InputMaybe<Scalars['String']['input']>;
  automationScriptParam?: InputMaybe<Scalars['String']['input']>;
  automationScriptPath?: InputMaybe<Scalars['String']['input']>;
  b?: InputMaybe<Scalars['String']['input']>;
  ciId?: InputMaybe<Scalars['String']['input']>;
  consolidatedInvoiceId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailType?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  eventsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  iosVersion?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['String']['input']>;
  scriptPath?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

/** QA Tools script */
export type QaToolsScript = {
  __typename?: 'QaToolsScript';
  averageTime: Scalars['String']['output'];
  endTime: Scalars['String']['output'];
  progress: Scalars['String']['output'];
  requestType: QaToolsRequestTypeEnum;
  requiredFields?: Maybe<Array<QaToolsField>>;
  responseFields?: Maybe<Array<QaToolsField>>;
  scriptName: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Calculate subsidies for an event */
  calculateEventSubsidies?: Maybe<CalculateEventSubsidiesPayload>;
  /** Calculate cart prices */
  calculateMobileOrderingCart?: Maybe<CalculateMobileOrderingCartPayload>;
  /** Calculate ScanToPay cart prices */
  calculateScanToPayCart?: Maybe<CalculateScanToPayCartPayload>;
  /** Check whether phone verification is in progress */
  checkPhoneVerification?: Maybe<CheckPhoneVerificationPayload>;
  /** Check if user needs to relogin */
  checkReloginQuery?: Maybe<CheckReloginQueryPayload>;
  effectiveConsentPreference?: Maybe<EffectiveConsentPreferencePayload>;
  /** Find an account by ID */
  getAccount?: Maybe<GetAccountQueryPayload>;
  /** Get domains associated with account */
  getAccountAuthenticationDomains?: Maybe<GetAccountAuthenticationDomainsPayload>;
  /** Account's delivery event members */
  getAccountDeliveryEventMembers?: Maybe<GetAccountDeliveryEventMembersPayload>;
  /** Get an account role and permissions */
  getAccountMembership?: Maybe<GetAccountMembershipPayload>;
  /** Get ownership records for an Accounting Site, newest Start Date first */
  getAccountingSiteOwners?: Maybe<GetAccountingSiteOwnersPayload>;
  /** Get Site Ownership Role Types; optionally include deactivated ones */
  getAccountingSiteRoleTypes?: Maybe<GetAccountingSiteRoleTypesPayload>;
  /** Get the catalog of Accounting Site Types */
  getAccountingSiteTypes?: Maybe<GetAccountingSiteTypesPayload>;
  /** Check if there is an active (running) backtest for the given model */
  getActiveBacktest?: Maybe<GetActiveBacktestPayload>;
  /** Get all app version policies */
  getAppVersionPolicies?: Maybe<GetAppVersionPoliciesPayload>;
  getAppVersionPolicy?: Maybe<GetAppVersionPolicyPayload>;
  /** Get authentication provider from the supplied email */
  getAuthProvider?: Maybe<GetAuthProviderPayload>;
  /** Get All Authentication Domains (admin view) */
  getAuthenticationDomains?: Maybe<GetAuthenticationDomainsPayload>;
  /** Get All Authentication Providers (admin view) */
  getAuthenticationProviders?: Maybe<GetAuthenticationProvidersPayload>;
  /** Poll backtest run results (Redis-first, DB fallback) */
  getBacktest?: Maybe<GetBacktestPayload>;
  /** Get Current Banners */
  getBanners?: Maybe<GetBannersPayload>;
  /** Get billing policy for a party and product */
  getBillingPolicy?: Maybe<GetBillingPolicyPayload>;
  getBraintreeToken?: Maybe<GetBraintreeTokenPayload>;
  /** Find cafe accounts for a user */
  getCafeAccountsForCurrentUser?: Maybe<GetCafeAccountsForCurrentUserPayload>;
  getCafeEvent?: Maybe<GetCafeEventPayload>;
  /** Find cafe event for a cafe location */
  getCafeEventForLocation?: Maybe<GetCafeEventForLocationPayload>;
  getCafeEventMenu?: Maybe<GetCafeEventMenuPayload>;
  getCafeEventSchedule?: Maybe<GetCafeEventSchedulePayload>;
  /** Find cafe events for an account */
  getCafeEventsForAccount?: Maybe<GetCafeEventsForAccountPayload>;
  /** Get a cafe location given its id */
  getCafeLocation?: Maybe<GetCafeLocationPayload>;
  /** Get cafes for an account */
  getCafeLocationsForAccount?: Maybe<GetCafeLocationsForAccountPayload>;
  /** Get Campaign Users */
  getCampaignUsers?: Maybe<GetCampaignUsersPayload>;
  /** Get Campaigns */
  getCampaigns?: Maybe<GetCampaignsPayload>;
  /** Get Catering Inventory Item */
  getCateringInventoryItem?: Maybe<GetCateringInventoryItemPayload>;
  /** Get Catering Inventory Items for a vendor */
  getCateringInventoryItemsForVendor?: Maybe<GetCateringInventoryItemsForVendorPayload>;
  /** Get Chat History API */
  getChatHistory?: Maybe<GetChatHistoryPayload>;
  getConfiguration?: Maybe<GetConfigurationPayload>;
  /** Get Consumer Data Requests */
  getConsumerDataRequests?: Maybe<GetConsumerDataRequestsPayload>;
  /** Get MobileOrdering orders for an event and vendor */
  getConsumerMobileOrderingOrderDetails?: Maybe<GetConsumerMobileOrderingOrderDetailsPayload>;
  /** Returns list of countries */
  getCountriesList?: Maybe<GetCountriesListPayload>;
  getCreateCardResult?: Maybe<GetCreateCardResultPayload>;
  /** Returns all cross-docks base on provided market */
  getCrossDocks?: Maybe<GetCrossDocksPayload>;
  /** Get cuisines */
  getCuisines?: Maybe<GetCuisinesPayload>;
  /** Products the members of a draft entity can be invoiced for, for the products selector */
  getCustomInvoiceAvailableProducts?: Maybe<GetCustomInvoiceAvailableProductsPayload>;
  /** Active entities a draft entity would collide with, for the form's conflict warning */
  getCustomInvoiceOverlaps?: Maybe<GetCustomInvoiceOverlapsPayload>;
  /** One page of custom invoice settings, with summary-only members */
  getCustomInvoiceSettings?: Maybe<GetCustomInvoiceSettingsPayload>;
  /** One custom invoice settings record with its full member list, for the edit modal */
  getCustomInvoiceSettingsById?: Maybe<GetCustomInvoiceSettingsByIdPayload>;
  /** Counts per split attribute type for a draft entity, for the composition picker */
  getCustomInvoiceSplitAttributeCounts?: Maybe<GetCustomInvoiceSplitAttributeCountsPayload>;
  /** Find Delivery Event Vendor by ID */
  getDeliveryEventVendor?: Maybe<GetDeliveryEventVendorPayload>;
  /** Customer menu for one restaurant at a delivery event */
  getDeliveryEventVendorMenu?: Maybe<GetDeliveryEventVendorMenuPayload>;
  /** Get Delivery Inventory Item */
  getDeliveryInventoryItem?: Maybe<GetDeliveryInventoryItemPayload>;
  /** Get Delivery Inventory Items for a vendor */
  getDeliveryInventoryItemsForVendor?: Maybe<GetDeliveryInventoryItemsForVendorPayload>;
  /** Delivery Order Details API */
  getDeliveryOrderDetails?: Maybe<GetDeliveryOrderDetailsPayload>;
  /** Get the total cost of ordered item of a particular delivery event vendor */
  getDeliveryOrderItemsTotalCostByEventVendor?: Maybe<GetDeliveryOrderItemsTotalCostByEventVendorPayload>;
  /** Get delivery schduling constraints */
  getDeliverySchedulingConstraints?: Maybe<GetDeliverySchedulingConstraintsPayload>;
  /** Get Delivery menu tempates of a vendor */
  getDeliveryVendorMenuTemplates?: Maybe<GetDeliveryVendorMenuTemplatesPayload>;
  /** Get the Dietary Preferences and Allergens and Sensitivities customers can filter menus by */
  getDietaryDefinitions?: Maybe<GetDietaryDefinitionsPayload>;
  /** Get the current user's email subscription preferences (per-category + global) */
  getEmailCategoryPreferences?: Maybe<GetEmailCategoryPreferencesPayload>;
  /** Get Event API */
  getEvent?: Maybe<GetEventQueryPayload>;
  /** Get Line Items for an event */
  getEventFinanceLineItems?: Maybe<GetEventFinanceLineItemsPayload>;
  /** Get active popup user subsidies for an event for current user */
  getEventSubsidies?: Maybe<GetEventSubsidiesPayload>;
  /** Get Event Vendors API */
  getEventVendors?: Maybe<GetEventVendorsQueryPayload>;
  /** Get all external tags */
  getExternalTags?: Maybe<GetExternalTagsPayload>;
  /** Fetch the current state (true/false) of a feature flag */
  getFeatureFlag?: Maybe<GetFeatureFlagPayload>;
  /** Get Feedback Requests API */
  getFeedbackRequests?: Maybe<GetFeedbackRequestsPayload>;
  /** Financal Info API */
  getFinancialInfoForVendorAtLocation?: Maybe<GetFinancialInfoForVendorAtLocationQueryPayload>;
  /** Get a FoodaCard membership for the current user */
  getFoodaCardMembership?: Maybe<GetFoodaCardMembershipPayload>;
  /** Fooda Card transaction details for order history */
  getFoodaCardOrderDetails?: Maybe<GetFoodaCardOrderDetailsPayload>;
  /** Get the Fooda Card overage the current user still owes, one entry per membership */
  getFoodaCardOutstandingBalances?: Maybe<GetFoodaCardOutstandingBalancesPayload>;
  /** Gets fooda employee options */
  getFoodaEmployeeOptions?: Maybe<GetFoodaEmployeeOptionsPayload>;
  /** Gross Food Sales calculation API */
  getGfsForVendors?: Maybe<GetGfsForVendorsQueryPayload>;
  /** Grouped User Cards, SnapPea-only */
  getGroupedUserCards?: Maybe<GetGroupedUserCardsQueryPayload>;
  /** Get InvoiceJobs status and statistics */
  getInvoiceJobs?: Maybe<GetInvoiceJobsPayload>;
  /** Get limits groups */
  getLimitsGroups?: Maybe<GetLimitsGroupsPayload>;
  /** Get list of Line Item Types - templates for creating autogenerated line items */
  getLineItemTypes?: Maybe<GetLineItemTypesQueryPayload>;
  /** Locations belonging to an account, for picker use. Excludes deleted locations. */
  getLocationsForAccount?: Maybe<GetLocationsForAccountPayload>;
  /** Get market */
  getMarket?: Maybe<GetMarketPayload>;
  /** Get markets */
  getMarketNames?: Maybe<GetMarketNamesPayload>;
  /** Returns list of markets */
  getMarketsList?: Maybe<GetMarketsListPayload>;
  /** Get all meal types */
  getMealTypes?: Maybe<GetMealTypesPayload>;
  /** Menu change requests submitted for a vendor, newest first */
  getMenuChangeRequests?: Maybe<GetMenuChangeRequestsPayload>;
  /** Get Order request */
  getMobileOrderingOrderRequest?: Maybe<GetMobileOrderingOrderRequestPayload>;
  /** Get MobileOrdering orders for an event and vendor */
  getMobileOrderingOrders?: Maybe<GetMobileOrderingOrdersPayload>;
  /** Popup Order Details API */
  getOrderRequestDetails?: Maybe<GetOrderRequestDetailsPayload>;
  /** Account parent companies, the same list the Parent field on the account Info page offers */
  getParentCompanies?: Maybe<GetParentCompaniesPayload>;
  /** Paypal Access Token API */
  getPaypalAccessToken?: Maybe<GetPaypalAccessTokenPayload>;
  /** Get physical security questions */
  getPhysicalSecurityQuestions?: Maybe<GetPhysicalSecurityQuestionsPayload>;
  /** Find a popup event vendor by ID */
  getPopupEventVendor?: Maybe<GetPopupEventVendorQueryPayload>;
  /** Get a vendor menu on a popup event */
  getPopupEventVendorMenu?: Maybe<GetPopupEventVendorMenuPayload>;
  /** Get Popup customer feedback */
  getPopupFeedbackForVendors?: Maybe<GetPopupFeedbackForVendorsPayload>;
  /** Get Popup Inventory Item */
  getPopupInventoryItem?: Maybe<GetPopupInventoryItemPayload>;
  /** Get Popup Inventory Items for a vendor */
  getPopupInventoryItemsForVendor?: Maybe<GetPopupInventoryItemsForVendorPayload>;
  /** Get popup menu template for vendor */
  getPopupMenuTemplate?: Maybe<GetPopupMenuTemplatePayload>;
  /** Get a popup menu template inventory item */
  getPopupMenuTemplateInventoryItem?: Maybe<GetPopupMenuTemplateInventoryItemPayload>;
  /** Popup Order Details API */
  getPopupOrderDetails?: Maybe<GetPopupOrderDetailsPayload>;
  /** Popup Orders List API */
  getPopupOrdersListForEventVendors?: Maybe<GetPopupOrdersListForEventVendorsPayload>;
  /** Get product types */
  getProductTypes?: Maybe<GetProductTypesQueryPayload>;
  /** Get an ephemeral key for push provisioning a Stripe Issuing card to a digital wallet (Apple Pay / Google Pay) */
  getPushProvisioningEphemeralKey?: Maybe<GetPushProvisioningEphemeralKeyPayload>;
  /** QA Tools API */
  getQaTools?: Maybe<GetQaToolsQueryPayload>;
  /** Get version history for a recommendation model */
  getRecommendationModelVersionHistory?: Maybe<GetRecommendationModelVersionHistoryPayload>;
  /** gets or requests recommendations */
  getRecommendations?: Maybe<GetRecommendationsQueryPayload>;
  /** Get available resolver types for prompt configuration */
  getRecommendationsAvailableResolvers?: Maybe<GetRecommendationsAvailableResolversPayload>;
  /** Get the current user's food preference tag selections and the available tag catalog */
  getRecommendationsCustomPreferences?: Maybe<GetRecommendationsCustomPreferencesPayload>;
  /** Get detailed feedback data for a recommendation model */
  getRecommendationsDetailedFeedback?: Maybe<GetRecommendationsDetailedFeedbackPayload>;
  /** Get entry points with their bucket configurations */
  getRecommendationsEntryPoints?: Maybe<GetRecommendationsEntryPointsPayload>;
  /** Get recommendation model configurations */
  getRecommendationsModelConfigs?: Maybe<GetRecommendationsModelConfigsPayload>;
  /** Get metrics for a recommendation model */
  getRecommendationsModelMetrics?: Maybe<GetRecommendationsModelMetricsPayload>;
  /** Get metrics for multiple recommendation models */
  getRecommendationsModelMetricsBatch?: Maybe<GetRecommendationsModelMetricsBatchPayload>;
  /** Preview a prompt configuration using live data */
  getRecommendationsPreviewPrompt?: Maybe<GetRecommendationsPreviewPromptPayload>;
  /** Get the tag group configuration, the item tag catalog, and its saved revisions */
  getRecommendationsTagGroups?: Maybe<GetRecommendationsTagGroupsPayload>;
  /** Reports Configurations */
  getReportsConfigurations?: Maybe<GetReportsConfigurationsQueryPayload>;
  /** Get resident vendors for account */
  getResidentVendorsForAccount?: Maybe<GetResidentVendorsForAccountPayload>;
  /** get all scoring event types */
  getScoringEventTypes?: Maybe<GetScoringEventTypesPayload>;
  /** Get list of vendors for a select event */
  getSelectEventVendors?: Maybe<GetSelectEventVendorsPayload>;
  /** get shadow and scoring events */
  getShadow?: Maybe<GetShadowPayload>;
  getSignupConfig?: Maybe<GetSignupConfigPayload>;
  /** SiteDirectionsToken API */
  getSiteDirectionsTokenForUser?: Maybe<GetSiteDirectionsTokenForUserQueryPayload>;
  /** Returns list of states for selected country */
  getStatesList?: Maybe<GetStatesListPayload>;
  /** Get all Stripe Connected Accounts */
  getStripeAccounts?: Maybe<GetStripeAccountsPayload>;
  /** Get Stripe Connected Accounts the current user has billing access to */
  getStripeAccountsForBillingAdmin?: Maybe<GetStripeAccountsForBillingAdminPayload>;
  /** Get an ephemeral key for displaying Stripe Issuing card details (PAN, CVV, expiry) via Issuing Elements */
  getStripeCardEphemeralKey?: Maybe<GetStripeCardEphemeralKeyPayload>;
  /** Create a Stripe Identity VerificationSession for government ID document verification */
  getStripeVerificationSession?: Maybe<GetStripeVerificationSessionPayload>;
  /** Returns list subsidy members */
  getSubsidyMembers?: Maybe<GetSubsidyMembersPayload>;
  /** Returns a signed URL for the subsidy members CSV export */
  getSubsidyMembersCsvDownloadUrl?: Maybe<GetSubsidyMembersCsvDownloadUrlPayload>;
  /** A subsidy program's change history, newest first */
  getSubsidyRuleHistory?: Maybe<GetSubsidyRuleHistoryPayload>;
  /** Get subsidy rules by account id */
  getSubsidyRules?: Maybe<GetSubsidyRulesQueryPayload>;
  /** Tableau token API */
  getTableauToken?: Maybe<GetTableauTokenQueryPayload>;
  /** Get tax categories */
  getTaxCategories?: Maybe<GetTaxCategoriesPayload>;
  /** Get tax category types */
  getTaxCategoryTypes?: Maybe<GetTaxCategoryTypesPayload>;
  /** Get tax category versions */
  getTaxCategoryVersions?: Maybe<GetTaxCategoryVersionsPayload>;
  /** Returns tax rates for provided list of tax categories at specified timestamp (default now) and address_id */
  getTaxRates?: Maybe<GetTaxRatesPayload>;
  /** Get available tax rules for vendor */
  getTaxRulesForVendor?: Maybe<GetTaxRulesForVendorPayload>;
  /** Get tender methods with optional filtering */
  getTenderMethods?: Maybe<GetTenderMethodsPayload>;
  /** FFR Today Delivery Manifests */
  getTodayDeliveryManifests?: Maybe<GetTodayDeliveryManifestsQueryPayload>;
  /** Get TodoTasks for vendors */
  getTodoTasksForVendors?: Maybe<GetTodoTasksForVendorsQueryPayload>;
  /** User API */
  getUser?: Maybe<GetUserQueryPayload>;
  /** Get Delivery Orders */
  getUserDeliveryOrders?: Maybe<GetUserDeliveryOrdersPayload>;
  /** Get Fooda Card transactions for a user */
  getUserFoodaCardOrders?: Maybe<GetUserFoodaCardOrdersPayload>;
  /** Get notes for a user */
  getUserNotes?: Maybe<GetUserNotesPayload>;
  /** Get invited, active and future subsidies for current user */
  getUserSubsidies?: Maybe<GetUserSubsidiesPayload>;
  /** get users */
  getUsers?: Maybe<GetUsersPayload>;
  /** FFR Vendor Availability Detail */
  getVendorAvailability?: Maybe<GetVendorAvailabilityPayload>;
  /** FFR Vendor Availability List */
  getVendorAvailabilityList?: Maybe<GetVendorAvailabilityListPayload>;
  /** Get a vendor role and corresponding permissions */
  getVendorMembership?: Maybe<GetVendorMembershipPayload>;
  /** A single vendor menu template with its content for restaurant-facing menu views */
  getVendorMenuTemplate?: Maybe<GetVendorMenuTemplatePayload>;
  /** List a vendor's menu templates for restaurant-facing menu views (cards + header) */
  getVendorMenuTemplates?: Maybe<GetVendorMenuTemplatesPayload>;
  /** Popup scheduling limits and shared capacity group for a vendor */
  getVendorPopupCapacity?: Maybe<GetVendorPopupCapacityQueryPayload>;
  /** List recent backtest runs for the given model */
  listBacktestRuns?: Maybe<ListBacktestRunsPayload>;
  /** The vendor's existing items a manager can pick when editing a menu */
  menuChangePickableItems?: Maybe<MenuChangePickableItemsPayload>;
  /** The vendor's items a manager can pick as options for an option group of the given type */
  menuChangePickableOptions?: Maybe<MenuChangePickableOptionsPayload>;
  /** The fields, item types and edit scopes a menu change request can use for a product type */
  menuChangeVocabulary?: Maybe<MenuChangeVocabularyPayload>;
  /** Ping API */
  ping?: Maybe<PingQueryPayload>;
  /** Ping QA Tools API */
  pingQaTools?: Maybe<PingQaToolsQueryPayload>;
  /** Search API */
  search?: Maybe<SearchQueryPayload>;
  /** Accounts matching a search, as picker options */
  searchAccountOptions?: Maybe<SearchAccountOptionsPayload>;
  /** Search for Account by name */
  searchAccountsQuery?: Maybe<SearchAccountsQueryPayload>;
  /** Building search, defaults to approved only */
  searchBuilding?: Maybe<SearchBuildingPayload>;
  /** Search event vendors API */
  searchEventVendors?: Maybe<SearchEventVendorsQueryPayload>;
  /** Popup event vendor search API */
  searchPopupEventVendors?: Maybe<SearchPopupEventVendorQueryPayload>;
  /** Search Popup Menu Items by Barcode and Popup Event ID */
  searchPopupMenuItem?: Maybe<SearchPopupMenuItemQueryPayload>;
  /** Get Events */
  searchPublicEvents?: Maybe<SearchPublicEventsPayload>;
  /** Search account-building locations for a user */
  searchUserAccountBuildings?: Maybe<SearchUserAccountBuildingsPayload>;
  /** Search for users */
  searchUsers?: Maybe<SearchUsersPayload>;
  /** Search vendors by name / internal name */
  searchVendors?: Maybe<SearchVendorsQueryPayload>;
  /** Update tax rates for buildings */
  updateTaxRatesForBuildings?: Maybe<UpdateTaxRatesForBuildingsQueryPayload>;
};


export type QueryCalculateEventSubsidiesArgs = {
  input: CalculateEventSubsidies;
};


export type QueryCalculateMobileOrderingCartArgs = {
  input: CalculateMobileOrderingCart;
};


export type QueryCalculateScanToPayCartArgs = {
  input: CalculateScanToPayCart;
};


export type QueryGetAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAccountAuthenticationDomainsArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryGetAccountDeliveryEventMembersArgs = {
  input: GetAccountDeliveryEventMembersInput;
};


export type QueryGetAccountMembershipArgs = {
  accountMembershipId: Scalars['ID']['input'];
};


export type QueryGetAccountingSiteOwnersArgs = {
  accountingSiteId: Scalars['ID']['input'];
};


export type QueryGetAccountingSiteRoleTypesArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetActiveBacktestArgs = {
  modelId: Scalars['String']['input'];
};


export type QueryGetAppVersionPolicyArgs = {
  platform: Scalars['String']['input'];
};


export type QueryGetAuthProviderArgs = {
  email: Scalars['String']['input'];
  sourceUri?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBacktestArgs = {
  backtestId: Scalars['String']['input'];
};


export type QueryGetBannersArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetBillingPolicyArgs = {
  input: GetBillingPolicy;
};


export type QueryGetCafeEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCafeEventForLocationArgs = {
  input: GetCafeEventForLocation;
};


export type QueryGetCafeEventMenuArgs = {
  input: GetCafeEventMenuInput;
};


export type QueryGetCafeEventScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCafeEventsForAccountArgs = {
  input: GetCafeEventsForAccount;
};


export type QueryGetCafeLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCafeLocationsForAccountArgs = {
  accountId: Scalars['ID']['input'];
  schedulableOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetCampaignUsersArgs = {
  input?: InputMaybe<GetCampaignUsers>;
};


export type QueryGetCateringInventoryItemArgs = {
  input: GetCateringInventoryItem;
};


export type QueryGetCateringInventoryItemsForVendorArgs = {
  input: GetCateringInventoryItemsForVendor;
};


export type QueryGetConsumerDataRequestsArgs = {
  input: GetConsumerDataRequests;
};


export type QueryGetConsumerMobileOrderingOrderDetailsArgs = {
  input: GetMobileOrderingOrderDetails;
};


export type QueryGetCreateCardResultArgs = {
  requestToken: Scalars['String']['input'];
};


export type QueryGetCrossDocksArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  marketId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetCustomInvoiceAvailableProductsArgs = {
  members: Array<CustomInvoiceSettingsMemberInput>;
};


export type QueryGetCustomInvoiceOverlapsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  members: Array<CustomInvoiceSettingsMemberInput>;
  products: Array<ProductEnum>;
};


export type QueryGetCustomInvoiceSettingsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCustomInvoiceSettingsByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCustomInvoiceSplitAttributeCountsArgs = {
  members: Array<CustomInvoiceSettingsMemberInput>;
  products: Array<ProductEnum>;
};


export type QueryGetDeliveryEventVendorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetDeliveryEventVendorMenuArgs = {
  input: GetDeliveryEventVendorMenu;
};


export type QueryGetDeliveryInventoryItemArgs = {
  input: GetDeliveryInventoryItem;
};


export type QueryGetDeliveryInventoryItemsForVendorArgs = {
  input: GetDeliveryInventoryItemsForVendor;
};


export type QueryGetDeliveryOrderDetailsArgs = {
  input: GetOrderDetails;
};


export type QueryGetDeliveryOrderItemsTotalCostByEventVendorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetDeliverySchedulingConstraintsArgs = {
  input: GetDeliverySchedulingConstraint;
};


export type QueryGetDeliveryVendorMenuTemplatesArgs = {
  input: GetDeliveryVendorMenuTemplates;
};


export type QueryGetEventArgs = {
  input: GetEventInput;
};


export type QueryGetEventFinanceLineItemsArgs = {
  eventId: Scalars['ID']['input'];
  eventType: Scalars['String']['input'];
};


export type QueryGetEventSubsidiesArgs = {
  input: GetEventSubsidies;
};


export type QueryGetEventVendorsArgs = {
  input: GetEventVendorsInput;
};


export type QueryGetFeatureFlagArgs = {
  input: GetFeatureFlag;
};


export type QueryGetFeedbackRequestsArgs = {
  input: GetFeedbackRequests;
};


export type QueryGetFinancialInfoForVendorAtLocationArgs = {
  input: GetFinancialInfoForVendorAtLocation;
};


export type QueryGetFoodaCardMembershipArgs = {
  membershipId: Scalars['ID']['input'];
};


export type QueryGetFoodaCardOrderDetailsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetFoodaEmployeeOptionsArgs = {
  includeUserId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetGfsForVendorsArgs = {
  input: GetGfsForVendors;
};


export type QueryGetGroupedUserCardsArgs = {
  input: GetGroupedUserCardsQueryInput;
};


export type QueryGetLocationsForAccountArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryGetMarketArgs = {
  input: GetMarket;
};


export type QueryGetMarketNamesArgs = {
  input: MarketScope;
};


export type QueryGetMealTypesArgs = {
  product?: InputMaybe<ProductEnum>;
};


export type QueryGetMenuChangeRequestsArgs = {
  input: GetMenuChangeRequestsInput;
};


export type QueryGetMobileOrderingOrderRequestArgs = {
  input: GetMobileOrderingOrderRequest;
};


export type QueryGetMobileOrderingOrdersArgs = {
  input: GetMobileOrderingOrders;
};


export type QueryGetOrderRequestDetailsArgs = {
  input: GetOrderDetails;
};


export type QueryGetParentCompaniesArgs = {
  searchInfo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPhysicalSecurityQuestionsArgs = {
  input: GetPhysicalSecurityQuestions;
};


export type QueryGetPopupEventVendorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPopupEventVendorMenuArgs = {
  input: GetPopupEventVendorMenu;
};


export type QueryGetPopupFeedbackForVendorsArgs = {
  input: GetPopupFeedbackForVendors;
};


export type QueryGetPopupInventoryItemArgs = {
  input: GetPopupInventoryItem;
};


export type QueryGetPopupInventoryItemsForVendorArgs = {
  input: GetPopupInventoryItemsForVendor;
};


export type QueryGetPopupMenuTemplateArgs = {
  input: GetPopupMenuTemplate;
};


export type QueryGetPopupMenuTemplateInventoryItemArgs = {
  input: GetPopupMenuTemplateInventoryItem;
};


export type QueryGetPopupOrderDetailsArgs = {
  input: GetOrderDetails;
};


export type QueryGetPopupOrdersListForEventVendorsArgs = {
  input: GetPopupOrdersListForEventVendors;
};


export type QueryGetPushProvisioningEphemeralKeyArgs = {
  apiVersion: Scalars['String']['input'];
  stripeCardId: Scalars['ID']['input'];
};


export type QueryGetQaToolsArgs = {
  input?: InputMaybe<QaToolsInput>;
  requestType: QaToolsRequestTypeEnum;
};


export type QueryGetRecommendationModelVersionHistoryArgs = {
  modelId: Scalars['ID']['input'];
};


export type QueryGetRecommendationsArgs = {
  input: GetRecommendationsInput;
};


export type QueryGetRecommendationsAvailableResolversArgs = {
  taskType?: InputMaybe<RecommendationRequestTypes>;
};


export type QueryGetRecommendationsDetailedFeedbackArgs = {
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  modelId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  taskFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRecommendationsModelMetricsArgs = {
  modelId: Scalars['ID']['input'];
};


export type QueryGetRecommendationsModelMetricsBatchArgs = {
  modelIds: Array<Scalars['ID']['input']>;
};


export type QueryGetRecommendationsPreviewPromptArgs = {
  context: PromptContextInput;
  promptConfig: PromptConfigInput;
};


export type QueryGetReportsConfigurationsArgs = {
  input?: InputMaybe<GetReportsConfigurationsQueryInput>;
};


export type QueryGetResidentVendorsForAccountArgs = {
  input: GetResidentVendorsForAccount;
};


export type QueryGetSelectEventVendorsArgs = {
  selectEventId: Scalars['ID']['input'];
};


export type QueryGetShadowArgs = {
  input: GetShadowInput;
};


export type QueryGetSignupConfigArgs = {
  email: Scalars['EmailAddress']['input'];
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSiteDirectionsTokenForUserArgs = {
  input: GetSiteDirectionsTokenForUser;
};


export type QueryGetStatesListArgs = {
  countryCode: Scalars['String']['input'];
};


export type QueryGetStripeCardEphemeralKeyArgs = {
  nonce: Scalars['String']['input'];
  stripeCardId: Scalars['ID']['input'];
};


export type QueryGetStripeVerificationSessionArgs = {
  membershipId: Scalars['ID']['input'];
};


export type QueryGetSubsidyMembersArgs = {
  input: GetSubsidyMembers;
};


export type QueryGetSubsidyMembersCsvDownloadUrlArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryGetSubsidyRuleHistoryArgs = {
  subsidyRuleId: Scalars['ID']['input'];
};


export type QueryGetSubsidyRulesArgs = {
  accountId: Scalars['ID']['input'];
  allSubsidies?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Array<SubsidyKind>>;
};


export type QueryGetTableauTokenArgs = {
  tableauDomain: TableauDomainEnum;
};


export type QueryGetTaxCategoryVersionsArgs = {
  input: GetTaxCategoryVersionsRequest;
};


export type QueryGetTaxRatesArgs = {
  input: GetTaxRatesInput;
};


export type QueryGetTaxRulesForVendorArgs = {
  input: GetTaxRulesForVendor;
};


export type QueryGetTenderMethodsArgs = {
  input?: InputMaybe<GetTenderMethods>;
};


export type QueryGetTodoTasksForVendorsArgs = {
  input: GetTodoTasksForVendors;
};


export type QueryGetUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetUserDeliveryOrdersArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetUserFoodaCardOrdersArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetUserNotesArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetUserSubsidiesArgs = {
  input: GetUserSubsidies;
};


export type QueryGetUsersArgs = {
  input: GetUsersInput;
};


export type QueryGetVendorAvailabilityArgs = {
  input: GetVendorAvailabilityInput;
};


export type QueryGetVendorMembershipArgs = {
  vendorMembershipId: Scalars['ID']['input'];
};


export type QueryGetVendorMenuTemplateArgs = {
  input: GetVendorMenuTemplate;
};


export type QueryGetVendorMenuTemplatesArgs = {
  input: GetVendorMenuTemplates;
};


export type QueryGetVendorPopupCapacityArgs = {
  vendorId: Scalars['ID']['input'];
};


export type QueryListBacktestRunsArgs = {
  modelId: Scalars['String']['input'];
};


export type QueryMenuChangePickableItemsArgs = {
  input: MenuChangePickerInput;
};


export type QueryMenuChangePickableOptionsArgs = {
  input: MenuChangeOptionPickerInput;
};


export type QueryMenuChangeVocabularyArgs = {
  input: MenuChangeVocabularyInput;
};


export type QueryPingArgs = {
  message: Scalars['String']['input'];
};


export type QuerySearchArgs = {
  input: SearchInput;
};


export type QuerySearchAccountOptionsArgs = {
  searchInfo: Scalars['String']['input'];
};


export type QuerySearchAccountsQueryArgs = {
  searchInfo: Scalars['String']['input'];
};


export type QuerySearchBuildingArgs = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  searchInfo: Scalars['String']['input'];
};


export type QuerySearchEventVendorsArgs = {
  input: SearchEventVendorsInput;
};


export type QuerySearchPopupEventVendorsArgs = {
  input: SearchPopupEventVendor;
};


export type QuerySearchPopupMenuItemArgs = {
  input: SearchPopupMenuItemInput;
};


export type QuerySearchPublicEventsArgs = {
  input: SearchPublicEvents;
};


export type QuerySearchUserAccountBuildingsArgs = {
  input: SearchUserAccountBuilding;
};


export type QuerySearchUsersArgs = {
  input: SearchUsers;
};


export type QuerySearchVendorsArgs = {
  input: SearchVendorsInput;
};

/** A receipt document of an event */
export type Receipt = {
  __typename?: 'Receipt';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Null when no document file has been generated */
  url?: Maybe<Scalars['String']['output']>;
};

/** A single recommendation */
export type Recommendation = {
  __typename?: 'Recommendation';
  /** Recommendation data (items, etc.) */
  data: Scalars['JSON']['output'];
  /** Order to display this recommendation */
  displayOrder?: Maybe<Scalars['Int']['output']>;
  /** Why this recommendation was made */
  justification?: Maybe<Scalars['String']['output']>;
  /** Menu item details. Resolved for delivery, popup and cafe targets; nil for any other. */
  menuItem?: Maybe<RecommendationMenuItem>;
  /** Unique identifier for the recommendation */
  uuid: Scalars['ID']['output'];
};

/** A group of recommendations */
export type RecommendationGroup = {
  __typename?: 'RecommendationGroup';
  /** External model identifier */
  externalId: Scalars['String']['output'];
  /** Model identifier */
  modelId: Scalars['ID']['output'];
  /** Individual recommendations in this group */
  recommendations: Array<Recommendation>;
  /** Unique identifier for the recommendation group */
  uuid: Scalars['ID']['output'];
};

/** A menu item for recommendations */
export type RecommendationItemInput = {
  /** Event vendor ID */
  eventVendorId: Scalars['ID']['input'];
  /** Menu item ID */
  id: Scalars['ID']['input'];
  /** Array of modifier IDs */
  modifiersIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Quantity of the item */
  quantity: Scalars['Float']['input'];
  /** Array of side item IDs */
  sidesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Menu item details for a recommendation, shared across products */
export type RecommendationMenuItem = {
  description?: Maybe<Scalars['String']['output']>;
  /** True when the item has options, so the options form is needed instead of adding directly. */
  hasOptions: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  images: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Price the user pays. Subsidy-aware where the product supports item-level subsidy. */
  priceCents: Scalars['Int']['output'];
  tags: Array<Scalars['String']['output']>;
};

export enum RecommendationRequestTypes {
  CrossSell = 'CROSS_SELL',
  FlavourMe = 'FLAVOUR_ME',
  UpSell = 'UP_SELL'
}

export enum RecommendationStatus {
  /** Request failed - stop polling */
  Error = 'ERROR',
  /** User reached limit - stop polling */
  LimitReached = 'LIMIT_REACHED',
  /** Still generating - continue polling */
  Pending = 'PENDING',
  /** Recommendations are available */
  Ready = 'READY'
}

export type RecommendationsCustomPreferenceInput = {
  tag: InventoryItemExternalTags;
  /** Like/dislike signal in [-1, 1]. Omit to record a like. */
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export enum RecommendationsFeedbackAction {
  CartAdded = 'CART_ADDED',
  CartRemoved = 'CART_REMOVED',
  Clicked = 'CLICKED',
  Dismissed = 'DISMISSED',
  Generated = 'GENERATED',
  Purchased = 'PURCHASED',
  Shown = 'SHOWN'
}

export enum RecommendationsFeedbackTarget {
  Recommendation = 'RECOMMENDATION',
  Session = 'SESSION'
}

export type RecommendationsTagGroupInput = {
  iconName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Tags in display order */
  tags: Array<InventoryItemExternalTags>;
};

/** Autogenerated return type of RecordConsentPreferenceEvent. */
export type RecordConsentPreferenceEventPayload = {
  __typename?: 'RecordConsentPreferenceEventPayload';
  created?: Maybe<Scalars['Boolean']['output']>;
  error?: Maybe<OperationError>;
  eventId?: Maybe<Scalars['ID']['output']>;
  recordedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type RecurrenceWeek = {
  __typename?: 'RecurrenceWeek';
  days: Array<Day>;
  weekNumber: Scalars['Int']['output'];
};

export type RecurrenceWeekInput = {
  days: Array<Day>;
  weekNumber: Scalars['Int']['input'];
};

export type RedemptionLevel = {
  __typename?: 'RedemptionLevel';
  amountCents: Scalars['Int']['output'];
  points: Scalars['Int']['output'];
};

export type ReferralAttributes = {
  code: Scalars['String']['input'];
};

/** Autogenerated return type of RefreshMarketingSegment. */
export type RefreshMarketingSegmentPayload = {
  __typename?: 'RefreshMarketingSegmentPayload';
  error?: Maybe<OperationError>;
  marketingSegment?: Maybe<MarketingSegment>;
};

export type RefundDeliveryOrder = {
  /** Required when refunding a whole order with DELIVERY_VENDOR at fault */
  deliveryVendorId?: InputMaybe<Scalars['ID']['input']>;
  /** Items to refund. Omit, or name every item on an order with no prior refunds, to refund the whole order */
  orderItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  partyAtFault: DeliveryRefundPartyAtFaultEnum;
  reason: DeliveryRefundReasonEnum;
  /** Delivery order uuid */
  requestId: Scalars['ID']['input'];
  /** Emails the customer an updated receipt */
  sendUpdatedReceipt?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of RefundDeliveryOrder. */
export type RefundDeliveryOrderPayload = {
  __typename?: 'RefundDeliveryOrderPayload';
  deliveryOrder?: Maybe<DeliveryOrderDetails>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of RefundOrderRequest. */
export type RefundOrderRequestPayload = {
  __typename?: 'RefundOrderRequestPayload';
  error?: Maybe<OperationError>;
  order?: Maybe<OrderRequestDetails>;
};

export type RegisterPosPaymentAttempt = {
  eventId: Scalars['ID']['input'];
  eventVendorIds: Array<Scalars['ID']['input']>;
  gatewayResponse?: InputMaybe<Scalars['String']['input']>;
  lookup: Scalars['Boolean']['input'];
  requestId: Scalars['UUID']['input'];
  success: Scalars['Boolean']['input'];
  transactionDate: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated return type of RegisterPosPaymentAttempt. */
export type RegisterPosPaymentAttemptPayload = {
  __typename?: 'RegisterPosPaymentAttemptPayload';
  error?: Maybe<OperationError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Remove a pull-funding bank account */
export type RemoveFoodaCardBankAccount = {
  bankAccountId: Scalars['ID']['input'];
  stripeAccountId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveFoodaCardBankAccount. */
export type RemoveFoodaCardBankAccountPayload = {
  __typename?: 'RemoveFoodaCardBankAccountPayload';
  bankAccount?: Maybe<FoodaCardBankAccount>;
  error?: Maybe<OperationError>;
};

/** Report Configuration History */
export type ReportConfigurationHistory = {
  __typename?: 'ReportConfigurationHistory';
  action: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  headline: Scalars['String']['output'];
  iconName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  menuTitle: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  reportType: ReportConfigurationTypeEnum;
  requiredRoles?: Maybe<Array<Scalars['String']['output']>>;
  subtitle: Scalars['String']['output'];
  tableauDesktopUrl: Scalars['String']['output'];
  tableauMobileUrl: Scalars['String']['output'];
  terms: Array<TermsWithDescription>;
};

export enum ReportConfigurationTypeEnum {
  FoodaForBusiness = 'FOODA_FOR_BUSINESS',
  FoodaForRestaurants = 'FOODA_FOR_RESTAURANTS'
}

/** Report Configuration */
export type ReportConfigurations = {
  __typename?: 'ReportConfigurations';
  active: Scalars['Boolean']['output'];
  headline: Scalars['String']['output'];
  history?: Maybe<Array<ReportConfigurationHistory>>;
  iconName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  menuTitle: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  reportType?: Maybe<ReportConfigurationTypeEnum>;
  requiredRoles?: Maybe<Array<Scalars['String']['output']>>;
  subtitle: Scalars['String']['output'];
  tableauDesktopUrl: Scalars['String']['output'];
  tableauMobileUrl: Scalars['String']['output'];
  terms?: Maybe<Array<TermsWithDescription>>;
};

/** Re-run all cases or only failed cases in a backtest */
export type RerunBacktestCasesInput = {
  /** UUID of the backtest to re-run */
  backtestId: Scalars['String']['input'];
  /** If true, re-run only failed cases. If false, re-run all cases. */
  failedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of RerunBacktestCases. */
export type RerunBacktestCasesPayload = {
  __typename?: 'RerunBacktestCasesPayload';
  /** UUID of the re-run backtest */
  backtestId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of ResendPhoneVerificationCode. */
export type ResendPhoneVerificationCodePayload = {
  __typename?: 'ResendPhoneVerificationCodePayload';
  error?: Maybe<OperationError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** A resident vendor */
export type ResidentVendor = {
  __typename?: 'ResidentVendor';
  /** The vendor's billing address */
  address?: Maybe<Address>;
  deliveryMenuTemplates?: Maybe<Array<MenuTemplate>>;
  id: Scalars['ID']['output'];
  internalName: Scalars['String']['output'];
  legalName?: Maybe<Scalars['String']['output']>;
  menuTemplates: Array<MenuTemplate>;
  name: Scalars['String']['output'];
  siteManagementFeeRecipientType: SiteManagementFeeRecipientEnum;
};

/** Metadata about an available resolver type */
export type ResolverMetadata = {
  __typename?: 'ResolverMetadata';
  /** Full Ruby class name for the resolver */
  className: Scalars['String']['output'];
  /** What this resolver does */
  description: Scalars['String']['output'];
  /** Human-readable name for UI display */
  displayName: Scalars['String']['output'];
  /** Example configuration for this resolver */
  example: Scalars['JSON']['output'];
  /** JSON schema defining required/optional params */
  paramsSchema: Scalars['JSON']['output'];
  /** Whether this resolver can contain other resolvers */
  supportsNesting: Scalars['Boolean']['output'];
};

/** Restaurant feedback factor type */
export type RestaurantFeedbackFactor = {
  __typename?: 'RestaurantFeedbackFactor';
  count: Scalars['Int']['output'];
  factor: FeedbackFactor;
};

/** Autogenerated return type of RestoreRecommendationsTagGroupsVersion. */
export type RestoreRecommendationsTagGroupsVersionPayload = {
  __typename?: 'RestoreRecommendationsTagGroupsVersionPayload';
  error?: Maybe<OperationError>;
  tagGroups?: Maybe<Array<TagGroup>>;
};

/** Autogenerated return type of RetrieveStripeAccountFunding. */
export type RetrieveStripeAccountFundingPayload = {
  __typename?: 'RetrieveStripeAccountFundingPayload';
  error?: Maybe<OperationError>;
  fundingOverview?: Maybe<FoodaCardFundingOverview>;
};

/** Autogenerated return type of RetrieveStripeAccountFundingTopups. */
export type RetrieveStripeAccountFundingTopupsPayload = {
  __typename?: 'RetrieveStripeAccountFundingTopupsPayload';
  error?: Maybe<OperationError>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  topups?: Maybe<Array<FoodaCardFundingTopup>>;
};

/** Feedback Review Options */
export type ReviewOption = {
  __typename?: 'ReviewOption';
  disposition: ReviewOptionDisposition;
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export enum ReviewOptionDisposition {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE'
}

export enum RewardsAction {
  AdminChange = 'ADMIN_CHANGE',
  CardRecognizedCustomerOrderPurchase = 'CARD_RECOGNIZED_CUSTOMER_ORDER_PURCHASE',
  CouponReward = 'COUPON_REWARD',
  CustomerOrderPurchase = 'CUSTOMER_ORDER_PURCHASE',
  CustomerOrderRefund = 'CUSTOMER_ORDER_REFUND',
  EnteredDigitsCustomerOrderPurchase = 'ENTERED_DIGITS_CUSTOMER_ORDER_PURCHASE',
  FoodaPaymentRecognizedCustomerOrderPurchase = 'FOODA_PAYMENT_RECOGNIZED_CUSTOMER_ORDER_PURCHASE',
  RewardsMemberCustomerOrderPurchase = 'REWARDS_MEMBER_CUSTOMER_ORDER_PURCHASE'
}

/** Brief details of a Rewards Points Entry for Activity Stream */
export type RewardsPointEntry = {
  __typename?: 'RewardsPointEntry';
  /** Type of rewards action */
  action: RewardsAction;
  /** Amount of voucher value for points redeemed */
  amountCents?: Maybe<Scalars['Int']['output']>;
  /** ISO8601 DateTime of points adjustment */
  orderFulfilledTime: Scalars['ISO8601DateTime']['output'];
  /** Time order was points were adjusted in unix seconds format */
  orderFulfilledTimeUnix: Scalars['Int']['output'];
  /** Unique ID of order */
  requestId: Scalars['ID']['output'];
  /** Amount of points change */
  rewardsPoints: Scalars['Float']['output'];
};

/** A sales optimizer tile */
export type SalesOptimizerTile = {
  __typename?: 'SalesOptimizerTile';
  position: Scalars['Int']['output'];
  recordedCategoryId?: Maybe<Scalars['Int']['output']>;
  station: EventScheduleStation;
};

export type ScanToPayCart = {
  __typename?: 'ScanToPayCart';
  couponDiscountCents: Scalars['Int']['output'];
  dueAmountCents: Scalars['Int']['output'];
  /** Total item level subsidy */
  itemSubsidyDiscountCents: Scalars['Int']['output'];
  /** Cart menu items */
  items: Array<ScanToPayCartItem>;
  restaurantCommissionCents?: Maybe<Scalars['Int']['output']>;
  /** Flag representing Rewards enable state for account */
  rewardsEnabled: Scalars['Boolean']['output'];
  /** Rewards points potentially earned from cart */
  rewardsPoints: Scalars['Float']['output'];
  /** Order level subsidy applied to this cart */
  subsidy?: Maybe<ScanToPaySubsidy>;
  /** Total order level subsidy */
  subsidyDiscountCents: Scalars['Int']['output'];
  subtotalCents: Scalars['Int']['output'];
  /** Subtotal after item level subsidy */
  subtotalPostSubsidyCents: Scalars['Int']['output'];
  taxCents: Scalars['Int']['output'];
  /** Tax after item level subsidy */
  taxPostSubsidyCents: Scalars['Int']['output'];
};

export type ScanToPayCartChildMenuItem = {
  __typename?: 'ScanToPayCartChildMenuItem';
  /** Code represents a selection group if item belongs to one */
  groupCode?: Maybe<Scalars['String']['output']>;
  /** Selection group ID if item belongs to one */
  groupId: Scalars['ID']['output'];
  /** menu item id (hybrid numeric/string) */
  id: Scalars['HybridId']['output'];
  name: Scalars['String']['output'];
  postTaxPriceCents: Scalars['Int']['output'];
  preTaxPriceCents: Scalars['BigDecimal']['output'];
  priceType: PriceTypeEnum;
  quantity: Scalars['BigDecimal']['output'];
  salesTaxCents: Scalars['BigDecimal']['output'];
  /** Subsidy for this option menu item */
  subsidy?: Maybe<EventMenuItemSubsidizedPrice>;
};

export type ScanToPayCartChildMenuItemInput = {
  groupCode: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type ScanToPayCartCustomItem = {
  __typename?: 'ScanToPayCartCustomItem';
  name: Scalars['String']['output'];
  postTaxPriceCents: Scalars['Int']['output'];
  preTaxPriceCents: Scalars['BigDecimal']['output'];
  salesTaxCents: Scalars['BigDecimal']['output'];
};

export type ScanToPayCartCustomItemInput = {
  name: Scalars['String']['input'];
  preTaxPriceCents: Scalars['Int']['input'];
  salesTaxCents: Scalars['Int']['input'];
  taxCategoryId?: InputMaybe<Scalars['ID']['input']>;
  taxRate?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export type ScanToPayCartItem = {
  __typename?: 'ScanToPayCartItem';
  customItem?: Maybe<ScanToPayCartCustomItem>;
  /** menu item id */
  eventVendorId: Scalars['ID']['output'];
  menuItem?: Maybe<ScanToPayCartMenuItem>;
  /** ticket id */
  ticketId?: Maybe<Scalars['ID']['output']>;
};

export type ScanToPayCartMenuItem = {
  __typename?: 'ScanToPayCartMenuItem';
  /** menu item id (hybrid numeric/string) */
  id: Scalars['HybridId']['output'];
  name: Scalars['String']['output'];
  /** Options selected for this cart menu item */
  options?: Maybe<Array<ScanToPayCartChildMenuItem>>;
  postTaxPriceCents: Scalars['Int']['output'];
  preTaxPriceCents: Scalars['BigDecimal']['output'];
  priceType: PriceTypeEnum;
  quantity: Scalars['BigDecimal']['output'];
  salesTaxCents: Scalars['BigDecimal']['output'];
  /** Subsidy for this menu item */
  subsidy?: Maybe<EventMenuItemSubsidizedPrice>;
};

export type ScanToPayCartMenuItemInput = {
  id: Scalars['ID']['input'];
  /** Options selected for this cart menu item */
  options?: InputMaybe<Array<ScanToPayCartChildMenuItemInput>>;
  /** Type of pricing applied, e.g. per item, per pound, etc */
  priceType: PriceTypeEnum;
  /** Amount of product if not priced per item, e.g. 0.35 (lb) */
  quantity: Scalars['BigDecimal']['input'];
};

export type ScanToPayCreateOrderRequest = {
  coupon?: InputMaybe<OrderRequestCoupon>;
  eventId: Scalars['ID']['input'];
  idempotencyKey: Scalars['UUID']['input'];
  items: Array<ScanToPayOrderItem>;
  payment?: InputMaybe<OrderRequestPayment>;
  receiptRequest?: InputMaybe<OrderReceiptRequest>;
  subsidy?: InputMaybe<OrderRequestSubsidy>;
};

export type ScanToPayInputCartItem = {
  customItem?: InputMaybe<ScanToPayCartCustomItemInput>;
  eventVendorId: Scalars['ID']['input'];
  menuItem?: InputMaybe<ScanToPayCartMenuItemInput>;
  ticketId?: InputMaybe<Scalars['ID']['input']>;
};

export type ScanToPayOrderItem = {
  customItem?: InputMaybe<OrderCustomItem>;
  eventVendorId: Scalars['ID']['input'];
  menuItem?: InputMaybe<OrderMenuItem>;
  ticketId: Scalars['ID']['input'];
};

export type ScanToPaySubsidy = {
  __typename?: 'ScanToPaySubsidy';
  amountCents: Scalars['Int']['output'];
  code: Scalars['String']['output'];
};

export type ScannedCustomItem = {
  __typename?: 'ScannedCustomItem';
  name: Scalars['String']['output'];
  postTaxPriceCents: Scalars['Int']['output'];
  preTaxPriceCents: Scalars['BigDecimal']['output'];
  salesTaxCents: Scalars['BigDecimal']['output'];
  taxCategoryId: Scalars['ID']['output'];
  taxRate: Scalars['Float']['output'];
};

export type ScannedMenuItem = {
  __typename?: 'ScannedMenuItem';
  /** menu item id */
  itemId: Scalars['ID']['output'];
  priceType: PriceTypeEnum;
  quantity: Scalars['Float']['output'];
};

export type ScannedMenuTemplateItem = {
  __typename?: 'ScannedMenuTemplateItem';
  customItem?: Maybe<ScannedCustomItem>;
  /** menu item id */
  eventVendorId: Scalars['ID']['output'];
  menuItem?: Maybe<ScannedMenuItem>;
};

export type ScheduleEmailConfiguration = {
  __typename?: 'ScheduleEmailConfiguration';
  sendDayOffset?: Maybe<Scalars['Int']['output']>;
  sendTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ScheduleFrequencyInput = {
  interval: Scalars['Int']['input'];
  monthlyByDates?: InputMaybe<Array<Scalars['Int']['input']>>;
  monthlyByDaysOfWeek?: InputMaybe<Array<RecurrenceWeekInput>>;
  ruleType: DateRecurrence;
  weeklyDays?: InputMaybe<Array<Day>>;
};

export type SchedulingAvailabilityRequirement = {
  __typename?: 'SchedulingAvailabilityRequirement';
  id: Scalars['ID']['output'];
  month: Scalars['Int']['output'];
  productType: ProductEnum;
  vendor: Vendor;
  year: Scalars['Int']['output'];
};

/** A scoring event */
export type ScoringEvent = {
  __typename?: 'ScoringEvent';
  correlationId?: Maybe<Scalars['String']['output']>;
  eventTypeCode: Scalars['String']['output'];
  eventTypeName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ignored: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  scoredAt: Scalars['ISO8601DateTime']['output'];
  shadowId: Scalars['ID']['output'];
};

/** The connection type for ScoringEvent. */
export type ScoringEventConnection = {
  __typename?: 'ScoringEventConnection';
  currentPage: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ScoringEventEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ScoringEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ScoringEventEdge = {
  __typename?: 'ScoringEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ScoringEvent>;
};

export type ScoringEventTypeAttributes = {
  id: Scalars['ID']['input'];
  slope: Scalars['BigDecimal']['input'];
  weight: Scalars['BigDecimal']['input'];
};

/** A scoring event type */
export type ScoringEventTypeDefinition = {
  __typename?: 'ScoringEventTypeDefinition';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  slope: Scalars['BigDecimal']['output'];
  weight: Scalars['BigDecimal']['output'];
};

/** Autogenerated return type of SearchAccountOptions. */
export type SearchAccountOptionsPayload = {
  __typename?: 'SearchAccountOptionsPayload';
  accounts?: Maybe<Array<AccountOption>>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of SearchAccountsQuery. */
export type SearchAccountsQueryPayload = {
  __typename?: 'SearchAccountsQueryPayload';
  accounts?: Maybe<Array<AccountPublic>>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of SearchBuilding. */
export type SearchBuildingPayload = {
  __typename?: 'SearchBuildingPayload';
  buildings?: Maybe<Array<Building>>;
  error?: Maybe<OperationError>;
};

export enum SearchDataSourcesEnum {
  Accounts = 'ACCOUNTS',
  ConsolidatedInvoices = 'CONSOLIDATED_INVOICES',
  Events = 'EVENTS',
  Invoices = 'INVOICES',
  Partners = 'PARTNERS',
  PopupEvents = 'POPUP_EVENTS',
  SelectEvents = 'SELECT_EVENTS',
  Vendors = 'VENDORS'
}

export type SearchEventVendorsInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /** Applies to popup/cafe event vendors */
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  endTimeAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  endTimeBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  eventStatuses?: InputMaybe<Array<EventStatus>>;
  /** When true, uses food_delivered attribute to determine delivery event vendor completion status */
  includeLiveDeliveryStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Apply different filters/sorting according to perspective */
  perspective?: InputMaybe<SearchPerspectiveEnum>;
  productTypes?: InputMaybe<Array<EventProduct>>;
  startTimeAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  startTimeBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  vendorIds: Array<Scalars['ID']['input']>;
  /** Applies to popup/cafe event vendors */
  vendorStatuses?: InputMaybe<Array<PopupEventVendorStatus>>;
};

/** Autogenerated return type of SearchEventVendorsQuery. */
export type SearchEventVendorsQueryPayload = {
  __typename?: 'SearchEventVendorsQueryPayload';
  error?: Maybe<OperationError>;
  eventVendors?: Maybe<EventVendorConnection>;
};


/** Autogenerated return type of SearchEventVendorsQuery. */
export type SearchEventVendorsQueryPayloadEventVendorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  dataSource?: InputMaybe<SearchDataSourcesEnum>;
  marketIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Number of results per data source */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  queryString: Scalars['String']['input'];
};

export enum SearchPerspectiveEnum {
  /**
   * Account/customer perspective. Uses standard event start/end times for all
   * products. Default behavior for customer-facing queries.
   */
  Account = 'ACCOUNT',
  /**
   * Restaurant/vendor perspective. Delivery events filtered by ordering window end
   * time (when prep starts) and delivery time instead of event start/end. Sorts by
   * product-appropriate times. Use for vendor-facing interfaces.
   */
  Restaurant = 'RESTAURANT'
}

export type SearchPopupEventVendor = {
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  endTimeAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  endTimeBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  eventStatuses?: InputMaybe<Array<PopupEventStatusEnum>>;
  limit: Scalars['Int']['input'];
  startTimeAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  startTimeBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  statuses?: InputMaybe<Array<PopupEventVendorStatus>>;
  vendors?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of SearchPopupEventVendorQuery. */
export type SearchPopupEventVendorQueryPayload = {
  __typename?: 'SearchPopupEventVendorQueryPayload';
  error?: Maybe<OperationError>;
  popupEventVendors?: Maybe<Array<PopupEventVendor>>;
};

export type SearchPopupMenuItemInput = {
  barcode: Scalars['String']['input'];
  popupEventId: Scalars['ID']['input'];
};

/** Autogenerated return type of SearchPopupMenuItemQuery. */
export type SearchPopupMenuItemQueryPayload = {
  __typename?: 'SearchPopupMenuItemQueryPayload';
  error?: Maybe<OperationError>;
  searchResult?: Maybe<ScannedMenuTemplateItem>;
};

export type SearchPublicEvents = {
  /** Defaults to every account of the signed-in user */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  buildingId?: InputMaybe<Scalars['ID']['input']>;
  endTimeAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  endTimeBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  productTypes?: InputMaybe<Array<EventProduct>>;
  startTimeAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  startTimeBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  statuses: Array<EventStatus>;
};

/** Autogenerated return type of SearchPublicEvents. */
export type SearchPublicEventsPayload = {
  __typename?: 'SearchPublicEventsPayload';
  error?: Maybe<OperationError>;
  events?: Maybe<PublicEventConnection>;
};


/** Autogenerated return type of SearchPublicEvents. */
export type SearchPublicEventsPayloadEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of SearchQuery. */
export type SearchQueryPayload = {
  __typename?: 'SearchQueryPayload';
  error?: Maybe<OperationError>;
  result?: Maybe<SearchResult>;
};

/** Search Result */
export type SearchResult = {
  __typename?: 'SearchResult';
  /** Accounts, applicable filters by market and status */
  accounts?: Maybe<Array<SearchResultItem>>;
  /** Consolidated Invoices, no filters */
  consolidatedInvoices?: Maybe<Array<SearchResultItem>>;
  /** Events, applicable filter by market */
  events?: Maybe<Array<SearchResultItem>>;
  /** Invoices, no filters */
  invoices?: Maybe<Array<SearchResultItem>>;
  /** Partners, applicable filter by market, all partners are active */
  partners?: Maybe<Array<SearchResultItem>>;
  /** Popup Events, applicable filter by market */
  popupEvents?: Maybe<Array<SearchResultItem>>;
  /** Select Events, applicable filter by market */
  selectEvents?: Maybe<Array<SearchResultItem>>;
  /** Vendors, applicable filters by market and status */
  vendors?: Maybe<Array<SearchResultItem>>;
};

/** Search Result Item */
export type SearchResultItem = {
  __typename?: 'SearchResultItem';
  /** Preview text of the item */
  description?: Maybe<Scalars['String']['output']>;
  /** ID of the item */
  id: Scalars['ID']['output'];
  /** Status of the item */
  status?: Maybe<Scalars['String']['output']>;
  /** Heading of the item */
  title?: Maybe<Scalars['String']['output']>;
  /** URL of the item */
  url?: Maybe<Scalars['String']['output']>;
};

export type SearchUserAccountBuilding = {
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SearchUserAccountBuildings. */
export type SearchUserAccountBuildingsPayload = {
  __typename?: 'SearchUserAccountBuildingsPayload';
  accountBuildings?: Maybe<Array<AccountBuilding>>;
  error?: Maybe<OperationError>;
};

export type SearchUsers = {
  legacyRole?: InputMaybe<UserLegacyRoles>;
  searchText: Scalars['String']['input'];
};

/** Autogenerated return type of SearchUsers. */
export type SearchUsersPayload = {
  __typename?: 'SearchUsersPayload';
  error?: Maybe<OperationError>;
  users?: Maybe<LightweightUserConnection>;
};


/** Autogenerated return type of SearchUsers. */
export type SearchUsersPayloadUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchVendorsInput = {
  /** Restrict results to the given markets */
  marketIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /** When given, only vendors active for this product are returned */
  product?: InputMaybe<EventProduct>;
  /** Matches vendor name / internal name (or id when numeric) */
  queryString: Scalars['String']['input'];
  /** Restrict results to these vendor states. When omitted or empty, vendors in every state are returned */
  states?: InputMaybe<Array<VendorState>>;
};

/** Autogenerated return type of SearchVendorsQuery. */
export type SearchVendorsQueryPayload = {
  __typename?: 'SearchVendorsQueryPayload';
  error?: Maybe<OperationError>;
  vendors?: Maybe<Array<PopupCapacityVendor>>;
};

/** Select Event */
export type SelectEvent = {
  __typename?: 'SelectEvent';
  /** Account ID */
  accountId?: Maybe<Scalars['ID']['output']>;
  /** Contact ID */
  contactId?: Maybe<Scalars['ID']['output']>;
  /** Delivery Time UTC */
  deliveryTimeUtc?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Event Owner ID */
  eventOwnerId?: Maybe<Scalars['ID']['output']>;
  /** ID of the Select Event */
  id: Scalars['ID']['output'];
  /** Location ID */
  locationId?: Maybe<Scalars['ID']['output']>;
  /** Meal Period */
  mealPeriod?: Maybe<Scalars['String']['output']>;
  /** Ordering Window End Time UTC */
  orderingWindowEndTimeUtc?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Ordering Window Start Time UTC */
  orderingWindowStartTimeUtc?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Published */
  published?: Maybe<Scalars['Boolean']['output']>;
  /** Select Event Vendors */
  selectEventVendors?: Maybe<Array<SelectEventVendor>>;
  /** Status */
  status?: Maybe<SelectEventStatusEnum>;
};

export enum SelectEventStatusEnum {
  Active = 'ACTIVE',
  AutoCanceled = 'AUTO_CANCELED',
  AutoGenerated = 'AUTO_GENERATED',
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Final = 'FINAL',
  InProgress = 'IN_PROGRESS',
  Proposed = 'PROPOSED',
  Scheduled = 'SCHEDULED'
}

/** Select Event Vendor */
export type SelectEventVendor = EventVendor & {
  __typename?: 'SelectEventVendor';
  /**
   * Stable key identifying the manifest bucket this vendor record derived from the
   * (vendor_id, manifest generate_at) tuple Snappea uses for SelectManifest. Does
   * not replace SelectManifest#id.
   */
  aggregateManifestKey: Scalars['String']['output'];
  /** Configured capacity from the vendor's capacity settings (null means no capacity restrictions). */
  configuredCapacity?: Maybe<Scalars['Int']['output']>;
  /** Created At Timestamp */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Credit Card Rate */
  creditCardRate: Scalars['BigDecimal']['output'];
  /** ID of the Cross Dock */
  crossDockId?: Maybe<Scalars['ID']['output']>;
  /** Taken capacity. */
  currentOrders: Scalars['Int']['output'];
  /** Default Tax Rate */
  defaultTaxRate: Scalars['BigDecimal']['output'];
  /** ID of the Delivery Vendor */
  deliveryVendorId?: Maybe<Scalars['ID']['output']>;
  /** Rolling projection of orders based on vendor prep commitments. */
  expectedOrders: Scalars['Int']['output'];
  /** Latest final manifest document for this vendor. */
  finalManifestDocument?: Maybe<VendorManifestDocument>;
  /** Whether food has been delivered (arrival notification sent or delivery time has passed). */
  foodDelivered: Scalars['Boolean']['output'];
  /** ID of the Select Event Vendor */
  id: Scalars['ID']['output'];
  /** Associated Menu Template */
  menuTemplate: MenuTemplate;
  /** ID of the Menu Template */
  menuTemplateId: Scalars['ID']['output'];
  menuUrl?: Maybe<Scalars['String']['output']>;
  /** Latest pre-manifest document for this vendor. */
  preManifestDocument?: Maybe<VendorManifestDocument>;
  /** Estimated Prep numbers */
  prepFor?: Maybe<Scalars['Int']['output']>;
  productType: EventProduct;
  /** Sales Tax Remitter */
  salesTaxRemitter: Scalars['String']['output'];
  /** Select Commission Rate */
  selectCommissionRate: Scalars['BigDecimal']['output'];
  /** Associated Select Event */
  selectEvent: DeliveryEventPublic;
  /** ID of the Select Event */
  selectEventId: Scalars['ID']['output'];
  /** Select Event Vendor Status */
  status: Scalars['String']['output'];
  /** Financial summary commission in cents. */
  summaryCommissionCents?: Maybe<Scalars['Int']['output']>;
  /** Financial summary food sales in cents. */
  summaryFoodSalesCents?: Maybe<Scalars['Int']['output']>;
  /** Financial summary item count. */
  summaryItemCount?: Maybe<Scalars['Int']['output']>;
  /** Financial summary order count. */
  summaryOrderCount?: Maybe<Scalars['Int']['output']>;
  /** Financial summary payment processing fees in cents. */
  summaryPpFeesCents?: Maybe<Scalars['Int']['output']>;
  /** Financial summary preliminary event total in cents. */
  summaryPreliminaryEventTotalCents?: Maybe<Scalars['Int']['output']>;
  /** Financial summary tax in cents. */
  summaryTaxCents?: Maybe<Scalars['Int']['output']>;
  /** Financial summary tax remitted by Fooda in cents. */
  summaryTaxRemittedByFoodaCents?: Maybe<Scalars['Int']['output']>;
  /** Swipe Fee Cents */
  swipeFeeCents: Scalars['BigDecimal']['output'];
  /** Top ordered inventory items (by quantity) for this event_vendor. */
  topOrderedItems?: Maybe<Array<SelectOrderedInventoryItem>>;
  /** Total number of ordered items for this event vendor. */
  totalOrderedItems?: Maybe<Scalars['Int']['output']>;
  /** Updated At Timestamp */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Associated vendor */
  vendor: Vendor;
  /** ID of the Vendor Billing Summary Document */
  vendorBillingSummaryDocumentId?: Maybe<Scalars['ID']['output']>;
  /** Auth Effective Date */
  vendorBillingSummarySentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of the Vendor */
  vendorId: Scalars['ID']['output'];
};


/** Select Event Vendor */
export type SelectEventVendorTopOrderedItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type SelectEventVendorWithOrderItemsTotal = {
  __typename?: 'SelectEventVendorWithOrderItemsTotal';
  deliveryOrdersCount: Scalars['Int']['output'];
  /** ID of the Select Event Vendor */
  id: Scalars['ID']['output'];
  /** ID of the Select Event */
  selectEventId: Scalars['ID']['output'];
  /** ID of the Vendor */
  vendorId: Scalars['ID']['output'];
};

/** Aggregate information about the most ordered inventory items for a Delivery EventVendor. */
export type SelectOrderedInventoryItem = {
  __typename?: 'SelectOrderedInventoryItem';
  inventoryItem: DeliveryInventoryItem;
  quantity: Scalars['Int']['output'];
};

export type SendChatMessage = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  parentMessageId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SendChatMessage. */
export type SendChatMessagePayload = {
  __typename?: 'SendChatMessagePayload';
  error?: Maybe<OperationError>;
  response?: Maybe<ChatResponse>;
};

export type SendResetPasswordEmail = {
  email: Scalars['String']['input'];
  template: Scalars['String']['input'];
};

/** Autogenerated return type of SendResetPasswordEmail. */
export type SendResetPasswordEmailPayload = {
  __typename?: 'SendResetPasswordEmailPayload';
  error?: Maybe<OperationError>;
  success: Scalars['Boolean']['output'];
};

export type SendSubsidyPasses = {
  accountId: Scalars['ID']['input'];
  destinations: Array<SubsidyPassDestination>;
  /** Defaults to GUEST_PASS */
  kind?: InputMaybe<SubsidyKind>;
  /** GUEST_PASS + SELECTED only */
  passIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  scope: SubsidyPassScope;
  subsidyRuleId?: InputMaybe<Scalars['ID']['input']>;
  /** MEMBER + SELECTED only */
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of SendSubsidyPasses. */
export type SendSubsidyPassesPayload = {
  __typename?: 'SendSubsidyPassesPayload';
  enqueued?: Maybe<Scalars['Boolean']['output']>;
  error?: Maybe<OperationError>;
  passDocumentJobIds?: Maybe<Array<Scalars['ID']['output']>>;
  queuedEmailCount?: Maybe<Scalars['Int']['output']>;
};

export type Session = {
  __typename?: 'Session';
  biometricsToken?: Maybe<Scalars['String']['output']>;
  firstTimeUserClientLogin: Scalars['Boolean']['output'];
  omniauthCallback?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  user: User;
  worldnetOperatorDetails?: Maybe<WorldnetOperatorDetails>;
};

export type SetCafeStationSiteDirection = {
  cafeStationId: Scalars['ID']['input'];
  siteDirection?: InputMaybe<SetCafeStationSiteDirectionAttributes>;
};

export type SetCafeStationSiteDirectionAttributes = {
  documentContentType: Scalars['String']['input'];
  documentFileName: Scalars['String']['input'];
  documentFileSize: Scalars['Int']['input'];
  uploadedFileKey: Scalars['String']['input'];
};

/** Autogenerated return type of SetCafeStationSiteDirection. */
export type SetCafeStationSiteDirectionPayload = {
  __typename?: 'SetCafeStationSiteDirectionPayload';
  cafeStationSiteDirection?: Maybe<CafeStationSiteDirectionDocument>;
  error?: Maybe<OperationError>;
};

export type SetNewPassword = {
  oldPassword?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SetNewPassword. */
export type SetNewPasswordPayload = {
  __typename?: 'SetNewPasswordPayload';
  error?: Maybe<OperationError>;
};

/** A scoring shadow */
export type Shadow = {
  __typename?: 'Shadow';
  falsePositiveCutoffAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  falsePositiveState: ShadowFalsePositiveModeEnum;
  id: Scalars['ID']['output'];
  score?: Maybe<Scalars['BigDecimal']['output']>;
  scoredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  shadowActions: ShadowActionConnection;
  shadowScoringEvents?: Maybe<ScoringEventConnection>;
};


/** A scoring shadow */
export type ShadowShadowActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A scoring shadow */
export type ShadowShadowScoringEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type ShadowAction = {
  __typename?: 'ShadowAction';
  actedAt: Scalars['ISO8601DateTime']['output'];
  action: Scalars['String']['output'];
  actor?: Maybe<ShadowActionActor>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  metadata: Scalars['JSON']['output'];
};

export type ShadowActionActor = {
  __typename?: 'ShadowActionActor';
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

/** The connection type for ShadowAction. */
export type ShadowActionConnection = {
  __typename?: 'ShadowActionConnection';
  currentPage: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ShadowActionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ShadowAction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ShadowActionEdge = {
  __typename?: 'ShadowActionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ShadowAction>;
};

export enum ShadowFalsePositiveModeEnum {
  None = 'NONE',
  Permanent = 'PERMANENT',
  Temporary = 'TEMPORARY'
}

/** ShipFromBuildingsPerState */
export type ShipFromBuildingsPerState = {
  __typename?: 'ShipFromBuildingsPerState';
  building: Building;
  countryCode: Scalars['String']['output'];
  enabledByUser: User;
  shipFromEnabledAt: Scalars['ISO8601DateTime']['output'];
  stateCode: Scalars['String']['output'];
};

/** A presigned upload link with expiration */
export type SignedUploadLink = {
  __typename?: 'SignedUploadLink';
  fields?: Maybe<UploadLinkFields>;
  maxBytes?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
};

export type SignupConfig = {
  __typename?: 'SignupConfig';
  defaultVerificationMethod: UserVerificationMethod;
  phoneRequired: Scalars['Boolean']['output'];
};

export type SiteDirectionsToken = {
  __typename?: 'SiteDirectionsToken';
  confirmed: Scalars['Boolean']['output'];
  digest: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  state: SiteDirectionsTokenStateEnum;
};

export enum SiteDirectionsTokenStateEnum {
  ConfirmedFromExpired = 'CONFIRMED_FROM_EXPIRED',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE',
  Opened = 'OPENED',
  Pending = 'PENDING',
  Retryable = 'RETRYABLE',
  Scheduled = 'SCHEDULED',
  Sending = 'SENDING',
  Sent = 'SENT'
}

export enum SiteManagementFee {
  FlatFee = 'FLAT_FEE',
  None = 'NONE',
  Percentage = 'PERCENTAGE'
}

export type SiteManagementFeeConfig = {
  __typename?: 'SiteManagementFeeConfig';
  siteManagementFeeCents?: Maybe<Scalars['Int']['output']>;
  siteManagementFeeRate?: Maybe<Scalars['Float']['output']>;
  siteManagementFeeRecipient?: Maybe<SiteManagementFeeRecipient>;
  siteManagementFeeType?: Maybe<SiteManagementFee>;
};

export type SiteManagementFeeConfigInput = {
  siteManagementFeeCents?: InputMaybe<Scalars['Int']['input']>;
  siteManagementFeeRate?: InputMaybe<Scalars['Float']['input']>;
  siteManagementFeeRecipientId?: InputMaybe<Scalars['ID']['input']>;
  siteManagementFeeRecipientType?: InputMaybe<SiteManagementFeeRecipientEnum>;
  siteManagementFeeType?: InputMaybe<SiteManagementFee>;
};

export type SiteManagementFeeRecipient = Agent | Partner | Vendor;

export enum SiteManagementFeeRecipientEnum {
  EventFinanceAgent = 'EVENT_FINANCE_AGENT',
  Partner = 'PARTNER',
  Vendor = 'VENDOR'
}

export enum SoldOutRestaurantEnum {
  Hide = 'HIDE',
  Show = 'SHOW'
}

/** Autogenerated return type of SortPopupMenuTemplateCategoryGroup. */
export type SortPopupMenuTemplateCategoryGroupPayload = {
  __typename?: 'SortPopupMenuTemplateCategoryGroupPayload';
  error?: Maybe<OperationError>;
  menuTemplateCategoryGroup?: Maybe<PopupMenuTemplateCategoryGroup>;
};

/** Discover eligible backtest cases from user order histories */
export type StartBacktestDiscoveryInput = {
  /** Maximum number of test cases to select */
  maxTestCases: Scalars['Int']['input'];
  /** ID of the recommendations model to backtest */
  modelId: Scalars['ID']['input'];
  /** List of user IDs to scan for eligible test cases */
  userIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of StartBacktestDiscovery. */
export type StartBacktestDiscoveryPayload = {
  __typename?: 'StartBacktestDiscoveryPayload';
  /** Result of the backtest discovery scan */
  discovery?: Maybe<DiscoveryResult>;
  error?: Maybe<OperationError>;
};

/** Start execution of a discovered backtest run */
export type StartBacktestRunInput = {
  /** UUID of the discovered backtest to execute */
  backtestId: Scalars['String']['input'];
  /** Evaluator strategy to use (e.g. accuracy) */
  evaluatorType: Scalars['String']['input'];
  /** Test case indices to exclude from execution */
  excludedIndices?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Autogenerated return type of StartBacktestRun. */
export type StartBacktestRunPayload = {
  __typename?: 'StartBacktestRunPayload';
  /** UUID of the started backtest run */
  backtestId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<OperationError>;
};

/** A state */
export type State = {
  __typename?: 'State';
  countryCode: Scalars['String']['output'];
  stateCode: Scalars['String']['output'];
  stateName: Scalars['String']['output'];
};

export enum StateEnum {
  /** canceled State */
  Canceled = 'canceled',
  /** complete State */
  Complete = 'complete',
  /** expired State */
  Expired = 'expired',
  /** incomplete State */
  Incomplete = 'incomplete'
}

/** A Cafe Station */
export type Station = {
  __typename?: 'Station';
  accountName?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  cafeLocation: CafeLocation;
  hideFromScheduling: Scalars['Boolean']['output'];
  hideFromSelfCheckout: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  menuType?: Maybe<Menu>;
  mobileOrderCapacityPercentage?: Maybe<Scalars['Int']['output']>;
  mobileOrderingDisabled: Scalars['Boolean']['output'];
  mobileOrderingExtended: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  siteDirectionDocuments?: Maybe<Array<CafeStationSiteDirectionDocument>>;
};

export enum StationTypes {
  Bar = 'BAR',
  Barista = 'BARISTA',
  Breakfast = 'BREAKFAST',
  BreakfastWeightedBar = 'BREAKFAST_WEIGHTED_BAR',
  Cantina = 'CANTINA',
  Deli = 'DELI',
  FeatureStation = 'FEATURE_STATION',
  GrabAndGo = 'GRAB_AND_GO',
  Grill = 'GRILL',
  MadeToOrderSalad = 'MADE_TO_ORDER_SALAD',
  MicroMarket = 'MICRO_MARKET',
  Pizza = 'PIZZA',
  Retail = 'RETAIL',
  RotatingPopup = 'ROTATING_POPUP',
  Smoothie = 'SMOOTHIE',
  Soup = 'SOUP',
  Sushi = 'SUSHI',
  WeightedHotBar = 'WEIGHTED_HOT_BAR',
  WeightedSaladBar = 'WEIGHTED_SALAD_BAR'
}

/** Possible disabled_reason values for a Stripe Issuing Cardholder */
export enum StripeCardholderDisabledReasonEnum {
  Listed = 'LISTED',
  RejectedListed = 'REJECTED_LISTED',
  RequirementsPastDue = 'REQUIREMENTS_PAST_DUE',
  UnderReview = 'UNDER_REVIEW'
}

/** Possible past_due requirement fields for a Stripe Issuing Cardholder */
export enum StripeCardholderRequirementEnum {
  CompanyTaxId = 'COMPANY_TAX_ID',
  IndividualCardIssuingUserTermsAcceptanceDate = 'INDIVIDUAL_CARD_ISSUING_USER_TERMS_ACCEPTANCE_DATE',
  IndividualCardIssuingUserTermsAcceptanceIp = 'INDIVIDUAL_CARD_ISSUING_USER_TERMS_ACCEPTANCE_IP',
  IndividualDobDay = 'INDIVIDUAL_DOB_DAY',
  IndividualDobMonth = 'INDIVIDUAL_DOB_MONTH',
  IndividualDobYear = 'INDIVIDUAL_DOB_YEAR',
  IndividualFirstName = 'INDIVIDUAL_FIRST_NAME',
  IndividualLastName = 'INDIVIDUAL_LAST_NAME',
  IndividualVerificationDocument = 'INDIVIDUAL_VERIFICATION_DOCUMENT'
}

/** Style for a banner */
export type Style = {
  __typename?: 'Style';
  bodyTextColor: Scalars['String']['output'];
  borderColor: Scalars['String']['output'];
  fillColor: Scalars['String']['output'];
  titleTextColor: Scalars['String']['output'];
};

/** A feedback subject */
export type Subject = {
  __typename?: 'Subject';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: SubjectKind;
  vendorName?: Maybe<Scalars['String']['output']>;
};

export enum SubjectKind {
  PopupEvent = 'POPUP_EVENT',
  PopupEventMenuItem = 'POPUP_EVENT_MENU_ITEM'
}

export enum SubmissionStatusEnum {
  /** No submission exists for this vendor+product+month */
  NotSubmitted = 'NOT_SUBMITTED',
  /** Availability has been submitted for this period */
  Submitted = 'SUBMITTED'
}

export type SubmitChatFeedback = {
  comment?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['String']['input'];
  messageCopiedAt?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  usefulness: Scalars['String']['input'];
};

/** Autogenerated return type of SubmitChatFeedback. */
export type SubmitChatFeedbackPayload = {
  __typename?: 'SubmitChatFeedbackPayload';
  error?: Maybe<OperationError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SubmitMenuChangeRequestInput = {
  idempotencyKey: Scalars['String']['input'];
  lines: Array<MenuChangeLineInput>;
  menuTemplateId: Scalars['ID']['input'];
};

/** Autogenerated return type of SubmitMenuChangeRequest. */
export type SubmitMenuChangeRequestPayload = {
  __typename?: 'SubmitMenuChangeRequestPayload';
  error?: Maybe<OperationError>;
  lineErrors: Array<MenuChangeLineError>;
  request?: Maybe<MenuChangeRequest>;
};

export type SubmitPhoneVerificationCode = {
  verificationCode: Scalars['String']['input'];
};

/** Autogenerated return type of SubmitPhoneVerificationCode. */
export type SubmitPhoneVerificationCodePayload = {
  __typename?: 'SubmitPhoneVerificationCodePayload';
  error?: Maybe<OperationError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Submit feedback for a recommendation or session */
export type SubmitRecommendationsFeedbackInput = {
  /** Type of feedback action */
  actionType: RecommendationsFeedbackAction;
  /** Optional notes or additional context */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Type of target */
  targetType: RecommendationsFeedbackTarget;
  /** UUID of the target (recommendation or session) */
  targetUuid: Scalars['ID']['input'];
};

/** Autogenerated return type of SubmitRecommendationsFeedbackMutation. */
export type SubmitRecommendationsFeedbackMutationPayload = {
  __typename?: 'SubmitRecommendationsFeedbackMutationPayload';
  error?: Maybe<OperationError>;
  success: Scalars['Boolean']['output'];
};

export type SubmitVendorAvailabilityInput = {
  cancellationAcknowledged: Scalars['Boolean']['input'];
  dates: Array<AvailabilityDateInput>;
  mealPeriods?: InputMaybe<MealPeriodsInput>;
  month: Scalars['Int']['input'];
  productType: ProductEnum;
  submissionVersion?: InputMaybe<Scalars['Int']['input']>;
  vendorId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

/** Autogenerated return type of SubmitVendorAvailability. */
export type SubmitVendorAvailabilityPayload = {
  __typename?: 'SubmitVendorAvailabilityPayload';
  error?: Maybe<OperationError>;
  submission?: Maybe<AvailabilitySubmissionMetadata>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SubmitVerificationCode = {
  tempUserId?: InputMaybe<Scalars['ID']['input']>;
  verificationCode: Scalars['String']['input'];
  verificationMethod?: InputMaybe<UserVerificationMethod>;
};

/** Autogenerated return type of SubmitVerificationCode. */
export type SubmitVerificationCodePayload = {
  __typename?: 'SubmitVerificationCodePayload';
  error?: Maybe<OperationError>;
  nonce?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Serves updates for MobileOrdering orders for a certain event and vendor */
  mobileOrderingOrderChanged: MobileOrderingOrderChangedPayload;
};


export type SubscriptionMobileOrderingOrderChangedArgs = {
  input: MobileOrderingOrderChanged;
};

/** A subsidy wallet for Android */
export type SubsidyAndroidWallet = {
  __typename?: 'SubsidyAndroidWallet';
  downloadLink?: Maybe<Scalars['String']['output']>;
  passes: Array<SubsidyAndroidWalletPass>;
};

/** A subsidy wallet pass for Android */
export type SubsidyAndroidWalletPass = {
  __typename?: 'SubsidyAndroidWalletPass';
  passTypeIdentifier: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
};

export enum SubsidyApproval {
  AutoApproval = 'AUTO_APPROVAL',
  DomainApproval = 'DOMAIN_APPROVAL',
  ManualApproval = 'MANUAL_APPROVAL'
}

export enum SubsidyApprovalAction {
  Add = 'ADD',
  Skip = 'SKIP'
}

/** A redeemable guest subsidy pass */
export type SubsidyGuestPass = {
  __typename?: 'SubsidyGuestPass';
  code: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Email of the FFB admin who expired the pass */
  expiredByEmail?: Maybe<Scalars['String']['output']>;
  /** Name of the FFB admin who expired the pass */
  expiredByName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  /** Sequential display number for the pass (shown on printed/QR passes). Not the redemption token. */
  passNumber?: Maybe<Scalars['Int']['output']>;
  /**
   * Raw persisted state, set only by explicit admin actions: active or expired.
   * Does not reflect the rule's schedule or end date — use `status` for the value
   * shown to users.
   */
  state: Scalars['String']['output'];
  /**
   * Effective status derived from `state` plus the rule's schedule/end date.
   * Reports :scheduled before the rule starts and :expired once the pass is
   * expired in FFB or the program end date has passed (even while `state` is still active).
   */
  status: SubsidyPassStatus;
};

/** A rule's guest passes grouped as a distribution batch */
export type SubsidyGuestPassBatch = {
  __typename?: 'SubsidyGuestPassBatch';
  distributionType?: Maybe<GuestPassDistribution>;
  passCount?: Maybe<Scalars['Int']['output']>;
  passes?: Maybe<Array<SubsidyGuestPass>>;
};

/** A subsidy wallet for iOS */
export type SubsidyIosWallet = {
  __typename?: 'SubsidyIosWallet';
  downloadLink?: Maybe<Scalars['String']['output']>;
  passes: Array<SubsidyIosWalletPass>;
};

/** A subsidy wallet pass for iOS */
export type SubsidyIosWalletPass = {
  __typename?: 'SubsidyIosWalletPass';
  passTypeIdentifier: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
};

export enum SubsidyKind {
  GuestPass = 'GUEST_PASS',
  Member = 'MEMBER',
  QuickAdd = 'QUICK_ADD'
}

export enum SubsidyLocationRestrictionEnum {
  Account = 'ACCOUNT',
  Everywhere = 'EVERYWHERE',
  Specific = 'SPECIFIC'
}

/** A subsidy member */
export type SubsidyMember = {
  __typename?: 'SubsidyMember';
  /** Indicates if the user is disabled */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Most recent redemption date across all of this member's redemptions, or null if never redeemed */
  lastRedemptionDate?: Maybe<Scalars['ISO8601Date']['output']>;
  rules: Array<SubsidyMemberRule>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userId: Scalars['ID']['output'];
};

export type SubsidyMemberAttributes = {
  ruleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** The connection type for SubsidyMember. */
export type SubsidyMemberConnection = {
  __typename?: 'SubsidyMemberConnection';
  currentPage: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubsidyMemberEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SubsidyMember>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SubsidyMemberEdge = {
  __typename?: 'SubsidyMemberEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SubsidyMember>;
};

/** A subsidy program present among the members on a GetSubsidyMembers tab, for use as a filter option */
export type SubsidyMemberProgramOption = {
  __typename?: 'SubsidyMemberProgramOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /**
   * Scheduled/Active/Expired via calendar-date comparison
   * (Subsidies::Rule#program_date_status) -- date-derived, not the rule's
   * persisted state (never :revoked).
   */
  status: SubsidyPassStatus;
};

/** A subsidy member rule */
export type SubsidyMemberRule = {
  __typename?: 'SubsidyMemberRule';
  hasFoodaCardProgram: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  state?: Maybe<SubsidyRuleState>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export enum SubsidyMemberSortingField {
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  LastRedemptionDateAsc = 'LAST_REDEMPTION_DATE_ASC',
  LastRedemptionDateDesc = 'LAST_REDEMPTION_DATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum SubsidyMemberState {
  Active = 'ACTIVE',
  Denied = 'DENIED',
  Invited = 'INVITED',
  Pending = 'PENDING',
  Resend = 'RESEND',
  Revoked = 'REVOKED'
}

export enum SubsidyNotificationFrequency {
  Daily = 'DAILY',
  PerRequest = 'PER_REQUEST'
}

export enum SubsidyPassDestination {
  /** Email a passes-PDF receipt to the requester */
  CopyToMe = 'COPY_TO_ME',
  /** Email each pass to its recipient's address */
  EachRecipientEmail = 'EACH_RECIPIENT_EMAIL'
}

export enum SubsidyPassScope {
  /** All non-revoked guest passes across the account, spanning every program */
  AllActive = 'ALL_ACTIVE',
  /** All non-revoked passes in the given program (rule) */
  AllInProgram = 'ALL_IN_PROGRAM',
  /** Only the passes named in pass_ids */
  Selected = 'SELECTED'
}

export enum SubsidyPassStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED',
  Scheduled = 'SCHEDULED'
}

/** A subsidy rule */
export type SubsidyRule = {
  __typename?: 'SubsidyRule';
  account: AccountPublic;
  accountRedemptionCode?: Maybe<Scalars['String']['output']>;
  accountWhitelistAccounts?: Maybe<Array<Account>>;
  accountWhitelistIds?: Maybe<Array<Scalars['Int']['output']>>;
  autoApply: Scalars['Boolean']['output'];
  availableProducts: Array<EventProduct>;
  canDelete: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  coverageDescriptionOverride?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<LightweightUser>;
  dailyMaxCents?: Maybe<Scalars['Int']['output']>;
  daysAvailable: Array<Day>;
  description?: Maybe<Scalars['String']['output']>;
  displayPreSubsidyPrice: Scalars['Boolean']['output'];
  displayableProduct: Scalars['String']['output'];
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  eventMaxCents?: Maybe<Scalars['Int']['output']>;
  /** Human labels for `external_tags`; an empty list means no tag restriction. */
  externalTagLabels: Array<Scalars['String']['output']>;
  externalTags?: Maybe<Array<InventoryItemExternalTags>>;
  foodaCardProgram?: Maybe<FoodaCardProgram>;
  /**
   * The program structure rendered as copy, ignoring
   * `coverage_description_override` (unlike `description`, which returns the
   * override once one is set).
   */
  generatedDescription: Scalars['String']['output'];
  guestPasses?: Maybe<SubsidyGuestPassBatch>;
  humanReadableRecurrence?: Maybe<Scalars['String']['output']>;
  /** Subsidy rule id */
  id: Scalars['ID']['output'];
  /** @deprecated This becomes event_max_cents */
  maxInstanceCents: Scalars['Int']['output'];
  /** @deprecated There is not a specific offline config, it will converge to event_max_cents */
  maxOfflineCents: Scalars['Int']['output'];
  /** Human labels for `meal_types`; an empty list means every item type. */
  mealTypeLabels: Array<Scalars['String']['output']>;
  mealTypes?: Maybe<Array<InventoryItemMealType>>;
  minOrderCents: Scalars['Int']['output'];
  monthlyMaxCents?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  noQr: Scalars['Boolean']['output'];
  percentageCap: Scalars['BigDecimal']['output'];
  preTaxEmployeeContribution: Scalars['Boolean']['output'];
  product: SubsidyRuleProduct;
  /**
   * Lifetime declining balance, Order-level programs only. Scoped per user on a QR
   * member program; per pass on a guest-pass batch ("Max $ per pass total"). Not
   * supported for No QR / quick-add programs.
   */
  programMaxCents?: Maybe<Scalars['Int']['output']>;
  /**
   * Scheduled/Active/Expired computed by calendar-date comparison in the rule's
   * own time zone (never :revoked - that value is per-pass only). A guest-pass
   * program is Expired as soon as its end time passes, including when it ended
   * early because its last active pass was expired. Distinct from a guest pass's
   * own `status`, which also reflects persisted per-pass state.
   */
  programStatus: SubsidyPassStatus;
  recurrence: Scalars['String']['output'];
  redemptionsPerDay?: Maybe<Scalars['Int']['output']>;
  ruleType: SubsidyRuleTypeEnum;
  scheduleDays?: Maybe<Array<Scalars['String']['output']>>;
  skipEmailVerification: Scalars['Boolean']['output'];
  startsAt: Scalars['ISO8601DateTime']['output'];
  state: SubsidyRuleState;
  subsidyType: SubsidyTypeEnum;
  supportedMealPeriods?: Maybe<Array<MealPeriodEnum>>;
  timeZone: SubsidyTimezone;
  timeZoneLabel: Scalars['String']['output'];
  /**
   * Full ActiveSupport zone name, e.g. "Central Time (US & Canada)". Distinct from
   * `time_zone_label`, which is the short enum description.
   */
  timeZoneName: Scalars['String']['output'];
  /** @deprecated Old set of types: percentage, fixed_off, fixed_value, key_in */
  type: SubsidyRuleRule;
  /** When the program last changed, from its newest version */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Who last changed the program; null for system changes and for viewers without SnapPea read access */
  updatedBy?: Maybe<LightweightUser>;
  /** updatedBy's email, or "administrator", "system" or "-" (see Subsidies::RuleHistory.updated_by_label) */
  updatedByLabel?: Maybe<Scalars['String']['output']>;
  validAt?: Maybe<Scalars['String']['output']>;
  validEverywhere: Scalars['Boolean']['output'];
  /** @deprecated Old concept of rule value, depends on type for its meaning */
  value: Scalars['Float']['output'];
  /** Vendors an item-level rule is limited to; an empty list means every vendor. */
  vendors: Array<Vendor>;
  weeklyMaxCents?: Maybe<Scalars['Int']['output']>;
  weeklyRecurrence: Scalars['Int']['output'];
};

export type SubsidyRuleAttributes = {
  dailyMaxCents?: InputMaybe<Scalars['Int']['input']>;
  daysAvailable: Array<Day>;
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  product: SubsidyRuleProduct;
  programMaxCents?: InputMaybe<Scalars['Int']['input']>;
  startsAt: Scalars['ISO8601DateTime']['input'];
  timeZone: SubsidyTimezone;
  weeklyRecurrence: Scalars['Int']['input'];
};

/** What a subsidy program history entry records */
export enum SubsidyRuleChangeEvent {
  Activated = 'ACTIVATED',
  Created = 'CREATED',
  Deactivated = 'DEACTIVATED',
  Deleted = 'DELETED',
  /** Oldest version on record, taken after the program was created (versions from before events were recorded) */
  FirstRecorded = 'FIRST_RECORDED',
  Updated = 'UPDATED'
}

/** One field changed in a subsidy program history entry, as display text */
export type SubsidyRuleFieldChange = {
  __typename?: 'SubsidyRuleFieldChange';
  /** Subsidy rule attribute name */
  field: Scalars['String']['output'];
  from?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  to?: Maybe<Scalars['String']['output']>;
};

/** One change to a subsidy program, built from its rule versions (see Subsidies::RuleHistory) */
export type SubsidyRuleHistoryEntry = {
  __typename?: 'SubsidyRuleHistoryEntry';
  changedAt: Scalars['ISO8601DateTime']['output'];
  /** Empty for CREATED, FIRST_RECORDED and DELETED */
  changes: Array<SubsidyRuleFieldChange>;
  event: SubsidyRuleChangeEvent;
  /** Subsidy rule version id */
  id: Scalars['ID']['output'];
  /** User who made the change; null for system changes and for viewers without SnapPea read access */
  updatedBy?: Maybe<LightweightUser>;
  /** updatedBy's email, or "administrator", "system" or "-" (see Subsidies::RuleHistory.updated_by_label) */
  updatedByLabel: Scalars['String']['output'];
};

export enum SubsidyRuleProduct {
  AllProducts = 'ALL_PRODUCTS',
  Delivery = 'DELIVERY',
  Popup = 'POPUP'
}

export enum SubsidyRuleRule {
  Calculated = 'CALCULATED',
  FixedOff = 'FIXED_OFF',
  FixedValue = 'FIXED_VALUE',
  KeyIn = 'KEY_IN',
  PercentageOff = 'PERCENTAGE_OFF'
}

export enum SubsidyRuleState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum SubsidyRuleTypeEnum {
  Calculated = 'CALCULATED',
  KeyIn = 'KEY_IN'
}

export enum SubsidyStateEnum {
  SubsidyChecked = 'SUBSIDY_CHECKED',
  SubsidyDenied = 'SUBSIDY_DENIED',
  SubsidyPending = 'SUBSIDY_PENDING'
}

export enum SubsidyTimezone {
  AlaskaTimeZone = 'ALASKA_TIME_ZONE',
  AmsterdamTimeZone = 'AMSTERDAM_TIME_ZONE',
  ArizonaTimeZone = 'ARIZONA_TIME_ZONE',
  CentralTimeZone = 'CENTRAL_TIME_ZONE',
  EasternTimeZone = 'EASTERN_TIME_ZONE',
  HawaiiTimeZone = 'HAWAII_TIME_ZONE',
  IndianaTimeZone = 'INDIANA_TIME_ZONE',
  LondonTimeZone = 'LONDON_TIME_ZONE',
  MountainTimeZone = 'MOUNTAIN_TIME_ZONE',
  PacificTimeZone = 'PACIFIC_TIME_ZONE'
}

export enum SubsidyTypeEnum {
  ItemLevel = 'ITEM_LEVEL',
  OrderLevel = 'ORDER_LEVEL'
}

/** A subsidy wallet */
export type SubsidyWallet = {
  __typename?: 'SubsidyWallet';
  android?: Maybe<SubsidyAndroidWallet>;
  ios?: Maybe<SubsidyIosWallet>;
};

export type SyncPaidOrderRequest = {
  paymentGatewayInfo?: InputMaybe<PaymentGatewayInfo>;
  /** DEPRECATED: End of support in 2023 */
  paypalResponse?: InputMaybe<PaypalResponse>;
  requestId: Scalars['UUID']['input'];
};

/** Autogenerated return type of SyncPaidOrderRequest. */
export type SyncPaidOrderRequestPayload = {
  __typename?: 'SyncPaidOrderRequestPayload';
  error?: Maybe<OperationError>;
  orderRequest?: Maybe<OrderRequest>;
};

export type SyncUnpaidOrderRequest = {
  paymentGatewayInfo?: InputMaybe<UnpaidPaymentGatewayInfo>;
  /** DEPRECATED: End of support in 2023 */
  paypalResponse?: InputMaybe<UnpaidPaypalResponse>;
  requestId: Scalars['UUID']['input'];
};

/** Autogenerated return type of SyncUnpaidOrderRequest. */
export type SyncUnpaidOrderRequestPayload = {
  __typename?: 'SyncUnpaidOrderRequestPayload';
  error?: Maybe<OperationError>;
  orderRequest?: Maybe<OrderRequest>;
};

export enum TableauDomainEnum {
  AccountReportFfb = 'AccountReportFFB',
  AccountReportSnapPea = 'AccountReportSnapPea',
  VendorReportFfr = 'VendorReportFFR'
}

/** A group of item tags offered in the Customize Recommendations UI */
export type TagGroup = {
  __typename?: 'TagGroup';
  /** Tabler icon name, e.g. IconBarbell */
  iconName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Ordered tags in this group */
  tags: Array<KeyValuePair>;
};

/** One saved revision of the tag group configuration */
export type TagGroupVersion = {
  __typename?: 'TagGroupVersion';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Admin who saved it, or System for the initial seed */
  createdBy: Scalars['String']['output'];
  groupsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  snapshot: Scalars['JSON']['output'];
  tagsCount: Scalars['Int']['output'];
};

/** Tax Category */
export type TaxCategory = {
  __typename?: 'TaxCategory';
  categoryType: TaxCategoryTypeEnum;
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isSync: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
};

/** A tax category rate */
export type TaxCategoryRate = {
  __typename?: 'TaxCategoryRate';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
};

export enum TaxCategoryTypeEnum {
  /** Client charges */
  ClientCharges = 'client_charges',
  /** Client Fee */
  ClientFee = 'client_fee',
  /** Food */
  Food = 'food',
  /** Goods */
  Goods = 'goods',
  /** Misc adjustments */
  MiscAdjustments = 'misc_adjustments',
  /** Payment methods */
  PaymentMethods = 'payment_methods',
  /** Payment processing fee */
  PaymentProcessingFee = 'payment_processing_fee',
  /** Restaurant Charges */
  RestaurantCharges = 'restaurant_charges',
  /** Services */
  Services = 'services',
  /** Tax */
  Tax = 'tax',
  /** Vouchers */
  Vouchers = 'vouchers'
}

/** Tax Category Version */
export type TaxCategoryVersion = {
  __typename?: 'TaxCategoryVersion';
  categoryType: TaxCategoryTypeEnum;
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isSync: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  taxCategoryId: Scalars['ID']['output'];
  /** ISO8601 DateTime of when tax category version is created */
  validFrom: Scalars['ISO8601DateTime']['output'];
  /** ISO8601 DateTime of when tax category version is ended */
  validTo?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Tax rate */
export type TaxRate = {
  __typename?: 'TaxRate';
  addressId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  refreshedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  taxCategoryId: Scalars['ID']['output'];
  taxRate: Scalars['BigDecimal']['output'];
  validFrom: Scalars['ISO8601DateTime']['output'];
  validTo?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum TaxRemitter {
  Fooda = 'FOODA',
  Restaurant = 'RESTAURANT'
}

/** A tax rule present on an item */
export type TaxRule = {
  __typename?: 'TaxRule';
  amount: Scalars['Int']['output'];
  areaDescription: Scalars['String']['output'];
  displayTaxCollector?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemsCovered?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  rule: TaxRuleRule;
  state: TaxRuleState;
};

export enum TaxRuleRule {
  Exempt = 'EXEMPT',
  Fixed = 'FIXED',
  Manual = 'MANUAL',
  Percentage = 'PERCENTAGE'
}

export enum TaxRuleState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** A tender method (payroll deduction) configuration */
export type TenderMethod = {
  __typename?: 'TenderMethod';
  /** Account IDs that can use this tender method */
  accountIds: Array<Scalars['ID']['output']>;
  /** Accounts that can use this tender method */
  accounts?: Maybe<Array<AccountPublic>>;
  /** Whether the tender method is available today */
  availableToday: Scalars['Boolean']['output'];
  /** Whether the tender method can be deleted */
  canDelete: Scalars['Boolean']['output'];
  /** Days of the week when tender method is available */
  daysAvailable: Array<Day>;
  /** End date for the tender method */
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** External system identifier */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Tender method ID */
  id: Scalars['ID']['output'];
  /** Name of the tender method program */
  name: Scalars['String']['output'];
  /** Product type this tender method applies to */
  productType: ProductEnum;
  /** Start date for the tender method */
  startDate: Scalars['ISO8601Date']['output'];
  /** Current state of the tender method */
  state: TenderMethodStateEnum;
  /** Timezone for the tender method schedule */
  timezone: Timezone;
};

/** The connection type for TenderMethod. */
export type TenderMethodConnection = {
  __typename?: 'TenderMethodConnection';
  currentPage: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TenderMethodEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TenderMethod>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TenderMethodEdge = {
  __typename?: 'TenderMethodEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TenderMethod>;
};

/** States for Tender Method */
export enum TenderMethodStateEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Scheduled = 'SCHEDULED'
}

/** Term and description */
export type TermsWithDescription = {
  __typename?: 'TermsWithDescription';
  description: Scalars['String']['output'];
  term: Scalars['String']['output'];
};

/** Term and description input */
export type TermsWithDescriptionInput = {
  description: Scalars['String']['input'];
  term: Scalars['String']['input'];
};

/** Preview of a single backtest test case */
export type TestCasePreview = {
  __typename?: 'TestCasePreview';
  eventId: Scalars['ID']['output'];
  eventType: Scalars['String']['output'];
  historySize: Scalars['Int']['output'];
  index: Scalars['Int']['output'];
  itemsOrdered: Scalars['Int']['output'];
  targetDate: Scalars['String']['output'];
};

/** Result of testing a recommendations prompt against OpenAI */
export type TestPromptResult = {
  __typename?: 'TestPromptResult';
  /** Number of cached prompt tokens (reduced cost) */
  cachedTokens?: Maybe<Scalars['Int']['output']>;
  /** Number of tokens in the completion */
  completionTokens?: Maybe<Scalars['Int']['output']>;
  /** Estimated cost in cents */
  costCents?: Maybe<Scalars['Float']['output']>;
  /** Execution time in milliseconds */
  durationMs?: Maybe<Scalars['Int']['output']>;
  /** Error message if the test failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The OpenAI model that was used */
  modelUsed?: Maybe<Scalars['String']['output']>;
  /** Number of tokens in the prompt */
  promptTokens?: Maybe<Scalars['Int']['output']>;
  /** Number of reasoning tokens (for o1 models) */
  reasoningTokens?: Maybe<Scalars['Int']['output']>;
  /** Raw JSON response content from OpenAI */
  responseJson?: Maybe<Scalars['String']['output']>;
  /** Whether the test executed successfully */
  success: Scalars['Boolean']['output'];
  /** Total tokens used (prompt + completion) */
  totalTokens?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated return type of TestRecommendationsPrompt. */
export type TestRecommendationsPromptPayload = {
  __typename?: 'TestRecommendationsPromptPayload';
  error?: Maybe<OperationError>;
  /** The result of the prompt test execution */
  testResult?: Maybe<TestPromptResult>;
};

export type TimeSeriesDataPoint = {
  __typename?: 'TimeSeriesDataPoint';
  clickThroughRate: Scalars['Float']['output'];
  clickedCount: Scalars['Int']['output'];
  conversionRate: Scalars['Float']['output'];
  dismissedCount: Scalars['Int']['output'];
  purchasedCount: Scalars['Int']['output'];
  shownCount: Scalars['Int']['output'];
  timestamp: Scalars['ISO8601DateTime']['output'];
};

/** Supported Timezones */
export enum Timezone {
  /** Alaska Time */
  AlaskaTimeZone = 'ALASKA_TIME_ZONE',
  /** Amsterdam Time */
  AmsterdamTimeZone = 'AMSTERDAM_TIME_ZONE',
  /** Arizona Time */
  ArizonaTimeZone = 'ARIZONA_TIME_ZONE',
  /** Central Time */
  CentralTimeZone = 'CENTRAL_TIME_ZONE',
  /** Eastern Time */
  EasternTimeZone = 'EASTERN_TIME_ZONE',
  /** Hawaii Time */
  HawaiiTimeZone = 'HAWAII_TIME_ZONE',
  /** Indiana Time */
  IndianaTimeZone = 'INDIANA_TIME_ZONE',
  /** London Time */
  LondonTimeZone = 'LONDON_TIME_ZONE',
  /** Mountain Time */
  MountainTimeZone = 'MOUNTAIN_TIME_ZONE',
  /** Pacific Time */
  PacificTimeZone = 'PACIFIC_TIME_ZONE'
}

export type TodoTask = {
  __typename?: 'TodoTask';
  action: Scalars['String']['output'];
  dueAt: Scalars['ISO8601DateTime']['output'];
  expiresAt: Scalars['ISO8601DateTime']['output'];
  grouping: GroupingEnum;
  id: Scalars['ID']['output'];
  ownerId: Scalars['ID']['output'];
  ownerType: OwnerTypeEnum;
  /** @deprecated Use workItems instead */
  popupEventVendors?: Maybe<Array<PopupEventVendor>>;
  state: StateEnum;
  workItems: Array<TodoTaskWorkItem>;
};

export type TodoTaskWorkItem = PopupEventVendor | SchedulingAvailabilityRequirement;

/** Autogenerated return type of UnenrollUserFromAccountBuilding. */
export type UnenrollUserFromAccountBuildingPayload = {
  __typename?: 'UnenrollUserFromAccountBuildingPayload';
  error?: Maybe<OperationError>;
  subscribedAccountBuildings?: Maybe<Array<UserSubscribedAccountBuilding>>;
};

/** Arguments to remove a user from a vendor */
export type UnenrollUserFromVendor = {
  vendorMembershipId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnenrollUserFromVendor. */
export type UnenrollUserFromVendorPayload = {
  __typename?: 'UnenrollUserFromVendorPayload';
  error?: Maybe<OperationError>;
  vendorMembership?: Maybe<VendorMembership>;
};

export type UnpaidPaymentGatewayInfo = {
  paymentGateway: PaymentGateway;
  response: UnpaidPaymentResponse;
};

export type UnpaidPaymentResponse = {
  /** The amount authorized by the payment processor */
  authorizedAmount: Scalars['Int']['input'];
  /** Derived WorldNet order id to search by */
  orderId?: InputMaybe<Scalars['String']['input']>;
  /** Payment response code */
  responseCode?: InputMaybe<Scalars['String']['input']>;
  responseMessage?: InputMaybe<Scalars['String']['input']>;
  /** WorldNet terminal the charge was sent to */
  terminal?: InputMaybe<Scalars['String']['input']>;
  /** Unique payment reference */
  uniqueReference?: InputMaybe<Scalars['String']['input']>;
};

export type UnpaidPaypalResponse = {
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  captureId?: InputMaybe<Scalars['String']['input']>;
  cardIssuer?: InputMaybe<CardIssuer>;
  cardholderName?: InputMaybe<Scalars['String']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  lastFour?: InputMaybe<Scalars['String']['input']>;
  receiptPreferenceToken?: InputMaybe<Scalars['String']['input']>;
  responseCode?: InputMaybe<Scalars['Int']['input']>;
  transactionHandle?: InputMaybe<Scalars['String']['input']>;
  transactionNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Up Sell recommendation request */
export type UpSellRequestInput = {
  /** Menu item for up-sell recommendations */
  item: RecommendationItemInput;
};

/** Arguments to update an account membership */
export type UpdateAccountMembership = {
  id: Scalars['ID']['input'];
  permissions: Array<AccountPermission>;
  role?: InputMaybe<AccountRoleEnum>;
};

/** Autogenerated return type of UpdateAccountMembership. */
export type UpdateAccountMembershipPayload = {
  __typename?: 'UpdateAccountMembershipPayload';
  accountMembership?: Maybe<AccountMembership>;
  error?: Maybe<OperationError>;
};

/** Input for updating account subsidy settings */
export type UpdateAccountSubsidySettings = {
  accountId: Scalars['ID']['input'];
  approvalAction?: InputMaybe<SubsidyApprovalAction>;
  approvalType?: InputMaybe<SubsidyApproval>;
  defaultRuleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  notificationFrequency?: InputMaybe<SubsidyNotificationFrequency>;
  rulePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmailNotification?: InputMaybe<Scalars['Boolean']['input']>;
  whiteListedDomains?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of UpdateAccountSubsidySettings. */
export type UpdateAccountSubsidySettingsPayload = {
  __typename?: 'UpdateAccountSubsidySettingsPayload';
  accountSettings?: Maybe<AccountSubsidySettings>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of UpdateAccountingSiteOwner. */
export type UpdateAccountingSiteOwnerPayload = {
  __typename?: 'UpdateAccountingSiteOwnerPayload';
  error?: Maybe<OperationError>;
  owner?: Maybe<AccountingSiteOwner>;
};

/** Autogenerated return type of UpdateAccountingSiteRole. */
export type UpdateAccountingSiteRolePayload = {
  __typename?: 'UpdateAccountingSiteRolePayload';
  error?: Maybe<OperationError>;
  roleType?: Maybe<AccountingSiteRoleType>;
};

/** Autogenerated return type of UpdateAccountingSite. */
export type UpdateAccountingSiteTypePayload = {
  __typename?: 'UpdateAccountingSiteTypePayload';
  error?: Maybe<OperationError>;
  siteType?: Maybe<AccountingSiteType>;
};

/** Autogenerated return type of UpdateAppVersionPolicy. */
export type UpdateAppVersionPolicyPayload = {
  __typename?: 'UpdateAppVersionPolicyPayload';
  error?: Maybe<OperationError>;
  policy?: Maybe<AppVersionPolicy>;
};

export type UpdateAuthenticationDomain = {
  accountsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  authenticationProviderId: Scalars['ID']['input'];
  connectionId?: InputMaybe<Scalars['String']['input']>;
  domainName: Scalars['String']['input'];
  effectiveDate: Scalars['ISO8601DateTime']['input'];
  id: Scalars['ID']['input'];
  listOfUsers?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileSessionExpiration?: InputMaybe<Scalars['Int']['input']>;
  mobileSessionTimeout?: InputMaybe<Scalars['Int']['input']>;
  organization: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  scimEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  testMode?: InputMaybe<Scalars['Boolean']['input']>;
  useLoginHint?: InputMaybe<Scalars['Boolean']['input']>;
  webSessionExpiration?: InputMaybe<Scalars['Int']['input']>;
  webSessionTimeout?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateAuthenticationDomain. */
export type UpdateAuthenticationDomainPayload = {
  __typename?: 'UpdateAuthenticationDomainPayload';
  authenticationDomain?: Maybe<AuthenticationDomain>;
  error?: Maybe<OperationError>;
};

export type UpdateBanner = {
  content?: InputMaybe<Scalars['String']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  /** Banner id to be updated */
  id: Scalars['ID']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<BannerPlatform>;
  style?: InputMaybe<UpdateStyle>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateBanner. */
export type UpdateBannerPayload = {
  __typename?: 'UpdateBannerPayload';
  banner?: Maybe<Banner>;
  error?: Maybe<OperationError>;
};

export type UpdateCafeEventMenuTileConfigurationInput = {
  cafeEventId: Scalars['ID']['input'];
  /** Menu Tiles to be updated */
  menuTiles: Array<CafeEventMenuTileInput>;
};

/** Autogenerated return type of UpdateCafeEventMenuTileConfiguration. */
export type UpdateCafeEventMenuTileConfigurationPayload = {
  __typename?: 'UpdateCafeEventMenuTileConfigurationPayload';
  cafeEvent?: Maybe<CafeEvent>;
  error?: Maybe<OperationError>;
};

export type UpdateCafeEventSchedule = {
  attributes: UpdateCafeEventScheduleAttributes;
  cafeEventScheduleId: Scalars['ID']['input'];
};

export type UpdateCafeEventScheduleAttributes = {
  emailListId?: InputMaybe<Scalars['String']['input']>;
  eventEndTime?: InputMaybe<Scalars['Time']['input']>;
  eventEndTimeOffsetInDays?: InputMaybe<Scalars['Int']['input']>;
  eventScheduleOwnerId?: InputMaybe<Scalars['ID']['input']>;
  eventStartTime?: InputMaybe<Scalars['Time']['input']>;
  finalEmail?: InputMaybe<EmailConfigurationInput>;
  fixedPricePerConsumerCents?: InputMaybe<Scalars['Int']['input']>;
  introductionEmail?: InputMaybe<EmailConfigurationInput>;
  minSalesGuaranteeCents?: InputMaybe<Scalars['Int']['input']>;
  pauseEndDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  pauseStartDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  scheduleEndDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  scheduleFrequency?: InputMaybe<ScheduleFrequencyInput>;
  scheduleStartDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  siteManagementFeeConfig?: InputMaybe<SiteManagementFeeConfigInput>;
};

export type UpdateCafeEventScheduleMenuTiles = {
  cafeEventScheduleId: Scalars['ID']['input'];
  menuTiles: Array<CafeScheduleMenuTile>;
};

/** Autogenerated return type of UpdateCafeEventScheduleMenuTiles. */
export type UpdateCafeEventScheduleMenuTilesPayload = {
  __typename?: 'UpdateCafeEventScheduleMenuTilesPayload';
  cafeEventSchedule?: Maybe<EventSchedule>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of UpdateCafeEventSchedule. */
export type UpdateCafeEventSchedulePayload = {
  __typename?: 'UpdateCafeEventSchedulePayload';
  cafeEventSchedule?: Maybe<EventSchedule>;
  error?: Maybe<OperationError>;
};

export type UpdateCafeEventScheduleStation = {
  attributes: UpdateCafeEventScheduleStationAttributes;
  cafeEventScheduleStationId: Scalars['ID']['input'];
};

export type UpdateCafeEventScheduleStationAttributes = {
  endTime?: InputMaybe<Scalars['Time']['input']>;
  endTimeOffsetInDays?: InputMaybe<Scalars['Int']['input']>;
  mealPeriod?: InputMaybe<MealPeriodEnum>;
  menuTemplateId?: InputMaybe<Scalars['ID']['input']>;
  pickupOrderingWindows?: InputMaybe<Array<PickupOrderingWindowInput>>;
  prepFor?: InputMaybe<Scalars['Int']['input']>;
  setupTimeMinutes?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
  stationType?: InputMaybe<StationTypes>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateCafeEventScheduleStation. */
export type UpdateCafeEventScheduleStationPayload = {
  __typename?: 'UpdateCafeEventScheduleStationPayload';
  cafeEventScheduleStation?: Maybe<EventScheduleStation>;
  error?: Maybe<OperationError>;
};

export type UpdateCafeEventStation = {
  cafeEventStationAttributes: UpdateCafeEventStationAttributes;
  id: Scalars['ID']['input'];
};

export type UpdateCafeEventStationAttributes = {
  menuTemplateId?: InputMaybe<Scalars['ID']['input']>;
  prepFor?: InputMaybe<Scalars['Int']['input']>;
  prepForCalculated?: InputMaybe<Scalars['Int']['input']>;
  siteFeeCents?: InputMaybe<Scalars['Int']['input']>;
  vendorId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateCafeEventStation. */
export type UpdateCafeEventStationPayload = {
  __typename?: 'UpdateCafeEventStationPayload';
  cafeEventStation?: Maybe<EventStation>;
  error?: Maybe<OperationError>;
};

export type UpdateCafeLocation = {
  cafeLocationAttributes: UpdateCafeLocationAttributes;
  id: Scalars['ID']['input'];
};

export type UpdateCafeLocationAttributes = {
  accessibleToPublic?: InputMaybe<Scalars['Boolean']['input']>;
  audienceSize?: InputMaybe<Scalars['Int']['input']>;
  buildingId?: InputMaybe<Scalars['ID']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  hideFromScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromSearch?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateCafeLocation. */
export type UpdateCafeLocationPayload = {
  __typename?: 'UpdateCafeLocationPayload';
  cafeLocation?: Maybe<CafeLocation>;
  error?: Maybe<OperationError>;
};

export type UpdateCafeStation = {
  attributes?: InputMaybe<UpdateCafeStationAttributes>;
  cafeStationId: Scalars['ID']['input'];
};

export type UpdateCafeStationAttributes = {
  hideFromScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromSelfCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  menuType?: InputMaybe<Menu>;
  mobileOrderCapacityPercentage?: InputMaybe<Scalars['Int']['input']>;
  mobileOrderingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  mobileOrderingExtended?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateCafeStation. */
export type UpdateCafeStationPayload = {
  __typename?: 'UpdateCafeStationPayload';
  cafeStation?: Maybe<Station>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of UpdateCafeTemperatureLog. */
export type UpdateCafeTemperatureLogPayload = {
  __typename?: 'UpdateCafeTemperatureLogPayload';
  error?: Maybe<OperationError>;
  temperatureLog?: Maybe<CafeTemperatureLogType>;
};

export type UpdateCampaign = {
  bannerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  category?: InputMaybe<CampaignCategory>;
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  id: Scalars['ID']['input'];
  startsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  strategy?: InputMaybe<CampaignStrategy>;
};

/** Autogenerated return type of UpdateCampaign. */
export type UpdateCampaignPayload = {
  __typename?: 'UpdateCampaignPayload';
  campaign?: Maybe<Campaign>;
  error?: Maybe<OperationError>;
};

/** Arguments to update a card */
export type UpdateCard = {
  cardId: Scalars['ID']['input'];
  makeDefaultDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  nickname?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateCard. */
export type UpdateCardPayload = {
  __typename?: 'UpdateCardPayload';
  card?: Maybe<Card>;
  error?: Maybe<OperationError>;
};

export type UpdateCateringInventoryItem = {
  attributes?: InputMaybe<UpdateCateringInventoryItemAttributes>;
  dietaryInfo?: InputMaybe<InventoryItemDietaryInfoInput>;
  id: Scalars['ID']['input'];
};

export type UpdateCateringInventoryItemAttributes = {
  cogs?: InputMaybe<Scalars['BigDecimal']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dietaryRestrictions?: InputMaybe<Array<InventoryItemDietaryRestrictions>>;
  eligibleForAddOns?: InputMaybe<Scalars['Boolean']['input']>;
  externalTags?: InputMaybe<Array<InventoryItemExternalTags>>;
  feedsMax?: InputMaybe<Scalars['Int']['input']>;
  feedsMin?: InputMaybe<Scalars['Int']['input']>;
  foodaSku?: InputMaybe<Scalars['String']['input']>;
  internalTags?: InputMaybe<Array<InventoryItemInternalTags>>;
  mealType?: InputMaybe<InventoryItemMealType>;
  minSelfServiceQuantity?: InputMaybe<Scalars['Int']['input']>;
  nameForVendor?: InputMaybe<Scalars['String']['input']>;
  namePublic?: InputMaybe<Scalars['String']['input']>;
  packagingDetails?: InputMaybe<CateringPackagingDetails>;
  premiumCogs?: InputMaybe<Scalars['BigDecimal']['input']>;
  premiumSellPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  retailPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  sellPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  taxCategoryId?: InputMaybe<Scalars['Int']['input']>;
  useAsInventoryItemOption?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateCateringInventoryItem. */
export type UpdateCateringInventoryItemPayload = {
  __typename?: 'UpdateCateringInventoryItemPayload';
  cateringInventoryItem?: Maybe<CateringInventoryItem>;
  error?: Maybe<OperationError>;
};

/** Arguments to update a cross-dock */
export type UpdateCrossDock = {
  address?: InputMaybe<AddressInput>;
  crossDockId: Scalars['ID']['input'];
  dropOffInstruction?: InputMaybe<Scalars['String']['input']>;
  marketIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickupInstruction?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CrossDockStatus>;
};

/** Autogenerated return type of UpdateCrossDock. */
export type UpdateCrossDockPayload = {
  __typename?: 'UpdateCrossDockPayload';
  crossDock?: Maybe<CrossDock>;
  error?: Maybe<OperationError>;
};

/** Autogenerated return type of UpdateCustomInvoice. */
export type UpdateCustomInvoicePayload = {
  __typename?: 'UpdateCustomInvoicePayload';
  customInvoice?: Maybe<CustomInvoice>;
  error?: Maybe<OperationError>;
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of UpdateCustomInvoicePoSetup. */
export type UpdateCustomInvoicePoSetupPayload = {
  __typename?: 'UpdateCustomInvoicePoSetupPayload';
  error?: Maybe<OperationError>;
  settings?: Maybe<CustomInvoiceSettings>;
};

/** Autogenerated return type of UpdateCustomInvoiceSettings. */
export type UpdateCustomInvoiceSettingsPayload = {
  __typename?: 'UpdateCustomInvoiceSettingsPayload';
  error?: Maybe<OperationError>;
  settings?: Maybe<CustomInvoiceSettings>;
};

export type UpdateDeliveryInventoryItem = {
  attributes?: InputMaybe<UpdateDeliveryInventoryItemAttributes>;
  dietaryInfo?: InputMaybe<InventoryItemDietaryInfoInput>;
  id: Scalars['ID']['input'];
};

export type UpdateDeliveryInventoryItemAttributes = {
  capacityExempt?: InputMaybe<Scalars['Boolean']['input']>;
  cogs?: InputMaybe<Scalars['BigDecimal']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dietaryRestrictions?: InputMaybe<Array<InventoryItemDietaryRestrictions>>;
  disallowWriteIn?: InputMaybe<Scalars['Boolean']['input']>;
  eligibleForAddOns?: InputMaybe<Scalars['Boolean']['input']>;
  externalTags?: InputMaybe<Array<InventoryItemExternalTags>>;
  foodaSku?: InputMaybe<Scalars['String']['input']>;
  internalTags?: InputMaybe<Array<InventoryItemInternalTags>>;
  mealType?: InputMaybe<InventoryItemMealType>;
  nameForVendor?: InputMaybe<Scalars['String']['input']>;
  namePublic?: InputMaybe<Scalars['String']['input']>;
  premiumSellPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  prepLine?: InputMaybe<Scalars['Int']['input']>;
  sellPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  showOnMenu?: InputMaybe<Scalars['Boolean']['input']>;
  signatureItem?: InputMaybe<Scalars['Boolean']['input']>;
  taxCategoryId?: InputMaybe<Scalars['Int']['input']>;
  temperatureClassification?: InputMaybe<InventoryItemTemperatureClassification>;
  useAsInventoryItemOption?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateDeliveryInventoryItem. */
export type UpdateDeliveryInventoryItemPayload = {
  __typename?: 'UpdateDeliveryInventoryItemPayload';
  deliveryInventoryItem?: Maybe<DeliveryInventoryItem>;
  error?: Maybe<OperationError>;
};

export type UpdateDeliverySchedulingConstraint = {
  id: Scalars['ID']['input'];
  minManifestPerMonth: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdateDeliverySchedulingConstraint. */
export type UpdateDeliverySchedulingConstraintPayload = {
  __typename?: 'UpdateDeliverySchedulingConstraintPayload';
  error?: Maybe<OperationError>;
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateDeliveryVendorMarketCapacity = {
  capacity: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateDeliveryVendorMarketCapacity. */
export type UpdateDeliveryVendorMarketCapacityPayload = {
  __typename?: 'UpdateDeliveryVendorMarketCapacityPayload';
  error?: Maybe<OperationError>;
  marketManifestCapacity?: Maybe<MarketManifestCapacity>;
};

/** Autogenerated return type of UpdateEmailCategoryPreferences. */
export type UpdateEmailCategoryPreferencesPayload = {
  __typename?: 'UpdateEmailCategoryPreferencesPayload';
  error?: Maybe<OperationError>;
  requestId?: Maybe<Scalars['String']['output']>;
};

export type UpdateFeedbackRequest = {
  feedbackRequestId: Scalars['ID']['input'];
  viewed: Scalars['Boolean']['input'];
};

/** Autogenerated return type of UpdateFeedbackRequest. */
export type UpdateFeedbackRequestPayload = {
  __typename?: 'UpdateFeedbackRequestPayload';
  error?: Maybe<OperationError>;
  feedbackRequest?: Maybe<FeedbackRequest>;
};

/** Create or update the auto-topup configuration for a connected account */
export type UpdateFoodaCardAutoTopupSettings = {
  bankAccountId?: InputMaybe<Scalars['ID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  stripeAccountId: Scalars['ID']['input'];
  thresholdCents?: InputMaybe<Scalars['Int']['input']>;
  topupAmountCents?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateFoodaCardAutoTopupSettings. */
export type UpdateFoodaCardAutoTopupSettingsPayload = {
  __typename?: 'UpdateFoodaCardAutoTopupSettingsPayload';
  autoTopupSettings?: Maybe<FoodaCardAutoTopupSettings>;
  error?: Maybe<OperationError>;
};

export type UpdateFoodaCardMembershipBackupCard = {
  /** The backup card (from Card model) to set */
  cardId: Scalars['ID']['input'];
  /** The membership to update */
  foodaCardMembershipId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateFoodaCardMembershipBackupCard. */
export type UpdateFoodaCardMembershipBackupCardPayload = {
  __typename?: 'UpdateFoodaCardMembershipBackupCardPayload';
  error?: Maybe<OperationError>;
  foodaCardMembership?: Maybe<FoodaCardMembership>;
};

export type UpdateFoodaCardMembershipRequirements = {
  /** City */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country code */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Day of birth (1-31) */
  dobDay?: InputMaybe<Scalars['Int']['input']>;
  /** Month of birth (1-12) */
  dobMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Year of birth */
  dobYear?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the Fooda Card Membership */
  foodaCardMembershipId: Scalars['ID']['input'];
  /** Street address */
  line1?: InputMaybe<Scalars['String']['input']>;
  /** Apartment/unit */
  line2?: InputMaybe<Scalars['String']['input']>;
  /** Phone number in E.164 format */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Zip/postal code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** State/Province */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Unix timestamp when user accepted terms */
  termsAcceptedAt?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateFoodaCardMembershipRequirements. */
export type UpdateFoodaCardMembershipRequirementsPayload = {
  __typename?: 'UpdateFoodaCardMembershipRequirementsPayload';
  error?: Maybe<OperationError>;
  foodaCardMembership?: Maybe<FoodaCardMembership>;
};

/** Arguments to update a FoodaCard program */
export type UpdateFoodaCardProgram = {
  foodaCardProgramAttributes: FoodaCardProgramAttributes;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateFoodaCardProgram. */
export type UpdateFoodaCardProgramPayload = {
  __typename?: 'UpdateFoodaCardProgramPayload';
  error?: Maybe<OperationError>;
  foodaCardProgram?: Maybe<FoodaCardProgram>;
};

export type UpdateHistoricalMealsSoldFactors = {
  endedEarlyFactor?: InputMaybe<EndedEarlyInput>;
  entreeSoldOutFactor?: InputMaybe<EntreeSoldOutInput>;
  popupEventVendorId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateHistoricalMealsSoldFactors. */
export type UpdateHistoricalMealsSoldFactorsPayload = {
  __typename?: 'UpdateHistoricalMealsSoldFactorsPayload';
  error?: Maybe<OperationError>;
  popupEventVendor?: Maybe<PopupEventVendor>;
};

/** Update Limits Group */
export type UpdateLimitsGroup = {
  deletedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  id: Scalars['ID']['input'];
  maxDailyCostCents?: InputMaybe<Scalars['Int']['input']>;
  maxMonthlyCostCents?: InputMaybe<Scalars['Int']['input']>;
  maxSessionCostCents?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Update Line Item Type */
export type UpdateLineItem = {
  eventFinanceLineItemType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isAvailableForUser?: InputMaybe<Scalars['Boolean']['input']>;
  lineItemSubType?: InputMaybe<Scalars['String']['input']>;
  lineItemType?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  taxCategoryId?: InputMaybe<Scalars['Int']['input']>;
  taxCategoryType?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateLineItem. */
export type UpdateLineItemPayload = {
  __typename?: 'UpdateLineItemPayload';
  error?: Maybe<OperationError>;
  lineItemType?: Maybe<LineItemType>;
};

export type UpdateMarket = {
  accountingMarketName?: InputMaybe<Scalars['String']['input']>;
  active: Scalars['Boolean']['input'];
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  checkAverage?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  defaultAccountantId: Scalars['ID']['input'];
  defaultCrossDockId?: InputMaybe<Scalars['ID']['input']>;
  defaultOperationEmail?: InputMaybe<Scalars['String']['input']>;
  defaultTaxRate?: InputMaybe<Scalars['Float']['input']>;
  defaultTaxRemitter?: InputMaybe<TaxRemitter>;
  deliverySupportPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  directorId?: InputMaybe<Scalars['ID']['input']>;
  displayCommission: Scalars['Boolean']['input'];
  healthDepartmentJurisdictions?: InputMaybe<Array<HealthDepartmentJurisdictionInput>>;
  id: Scalars['ID']['input'];
  marketCohortName?: InputMaybe<Scalars['String']['input']>;
  marketManifestTime?: InputMaybe<MarketManifestTimeInput>;
  name: Scalars['String']['input'];
  noDefaultCrossDock?: InputMaybe<Scalars['Boolean']['input']>;
  officeDefaultEmail?: InputMaybe<Scalars['String']['input']>;
  officeDefaultFax?: InputMaybe<Scalars['String']['input']>;
  officeDefaultPhone?: InputMaybe<Scalars['String']['input']>;
  officeDefaultSms?: InputMaybe<Scalars['String']['input']>;
  popupSupportPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
  zipCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of UpdateMarket. */
export type UpdateMarketPayload = {
  __typename?: 'UpdateMarketPayload';
  error?: Maybe<OperationError>;
  market?: Maybe<Market>;
};

export type UpdateMenuTemplateCategoryGroupAttributes = {
  name?: InputMaybe<Scalars['String']['input']>;
  selectedInventoryItems: Array<MenuTemplateInventoryItemAttributes>;
};

/** Update Model Configuration */
export type UpdateModelConfig = {
  id: Scalars['ID']['input'];
  /** Resolver-based prompt configuration with master_template, variables, model_params */
  promptConfig?: InputMaybe<PromptConfigInput>;
};

export type UpdatePartyBillingPolicy = {
  allowBillingEmails?: InputMaybe<Scalars['Boolean']['input']>;
  billingPatternClass?: InputMaybe<Scalars['String']['input']>;
  bufferDays?: InputMaybe<Scalars['Int']['input']>;
  checkbox?: InputMaybe<Scalars['Boolean']['input']>;
  customInvoiceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  invoiceCoverOnly?: InputMaybe<Scalars['Boolean']['input']>;
  invoicingNoteContent?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  paymentTerms?: InputMaybe<PaymentTermEnum>;
};

/** Autogenerated return type of UpdatePartyBillingPolicy. */
export type UpdatePartyBillingPolicyPayload = {
  __typename?: 'UpdatePartyBillingPolicyPayload';
  billingPolicy?: Maybe<BillingPolicy>;
  error?: Maybe<OperationError>;
};

export type UpdatePopupInventoryItem = {
  attributes?: InputMaybe<UpdatePopupInventoryItemAttributes>;
  dietaryInfo?: InputMaybe<InventoryItemDietaryInfoInput>;
  id: Scalars['ID']['input'];
  taxRuleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdatePopupInventoryItemAttributes = {
  availableInPersonOnly?: InputMaybe<Scalars['Boolean']['input']>;
  barcodeIdentifier?: InputMaybe<BarcodeInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  dietaryRestrictions?: InputMaybe<Array<InventoryItemDietaryRestrictions>>;
  disallowWriteIn?: InputMaybe<Scalars['Boolean']['input']>;
  externalTags?: InputMaybe<Array<InventoryItemExternalTags>>;
  foodaSku?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  mealType?: InputMaybe<InventoryItemMealType>;
  nameForVendor?: InputMaybe<Scalars['String']['input']>;
  namePublic?: InputMaybe<Scalars['String']['input']>;
  preTaxPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  priceType: PriceTypeEnum;
  showOnMenu?: InputMaybe<Scalars['Boolean']['input']>;
  showOnPos?: InputMaybe<Scalars['Boolean']['input']>;
  taxCategoryId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdatePopupInventoryItem. */
export type UpdatePopupInventoryItemPayload = {
  __typename?: 'UpdatePopupInventoryItemPayload';
  error?: Maybe<OperationError>;
  popupInventoryItem?: Maybe<PopupInventoryItem>;
};

export type UpdatePopupMenuItemsAvailablity = {
  ids: Array<Scalars['ID']['input']>;
};

export type UpdatePopupMenuTemplate = {
  id: Scalars['ID']['input'];
  popupMenuTemplateAttributes: UpdatePopupMenuTemplateAttributes;
};

export type UpdatePopupMenuTemplateAttributes = {
  allowAsapOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  asapMinutes?: InputMaybe<Scalars['Int']['input']>;
  cuisines?: InputMaybe<Array<CuisineNames>>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  expectedPickupOrderPercentage?: InputMaybe<Scalars['Int']['input']>;
  hiddenFromCustomerCampaignsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenFromCustomerMenu?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenFromFfrMenu?: InputMaybe<Scalars['Boolean']['input']>;
  mealPeriods?: InputMaybe<Array<MealPeriodEnum>>;
  name?: InputMaybe<Scalars['String']['input']>;
  overrideSpotLocationCapacity?: InputMaybe<Scalars['Boolean']['input']>;
  residentVendorMenu?: InputMaybe<Scalars['Boolean']['input']>;
  schedulerConfig?: InputMaybe<PopupMenuTemplateSchedulerConfigInput>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  state?: InputMaybe<MenuTemplateStateEnum>;
};

export type UpdatePopupMenuTemplateCategoryGroup = {
  menuTemplateCategoryGroupAttributes: UpdateMenuTemplateCategoryGroupAttributes;
  menuTemplateGroupId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdatePopupMenuTemplateCategoryGroup. */
export type UpdatePopupMenuTemplateCategoryGroupPayload = {
  __typename?: 'UpdatePopupMenuTemplateCategoryGroupPayload';
  error?: Maybe<OperationError>;
  menuTemplateCategoryGroup?: Maybe<PopupMenuTemplateCategoryGroup>;
};

export type UpdatePopupMenuTemplateInventoryItem = {
  attributes?: InputMaybe<PopupMenuTemplateInventoryItemAttributes>;
  id: Scalars['ID']['input'];
  taxRuleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of UpdatePopupMenuTemplateInventoryItem. */
export type UpdatePopupMenuTemplateInventoryItemPayload = {
  __typename?: 'UpdatePopupMenuTemplateInventoryItemPayload';
  error?: Maybe<OperationError>;
  popupMenuTemplateInventoryItem?: Maybe<PopupMenuTemplateInventoryItem>;
};

/** Autogenerated return type of UpdatePopupMenuTemplate. */
export type UpdatePopupMenuTemplatePayload = {
  __typename?: 'UpdatePopupMenuTemplatePayload';
  error?: Maybe<OperationError>;
  popupMenuTemplate?: Maybe<PopupMenuTemplate>;
};

export type UpdatePopupMenuTemplateSelectionGroup = {
  defaultSelectionInventoryItemId?: InputMaybe<Scalars['ID']['input']>;
  maxSelections: Scalars['Int']['input'];
  minSelections: Scalars['Int']['input'];
  nameForVendor: Scalars['String']['input'];
  namePublic: Scalars['String']['input'];
  selectedInventoryItems: Array<MenuTemplateSelectionGroupItemAttributes>;
  selectionGroupId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdatePopupMenuTemplateSelectionGroup. */
export type UpdatePopupMenuTemplateSelectionGroupPayload = {
  __typename?: 'UpdatePopupMenuTemplateSelectionGroupPayload';
  error?: Maybe<OperationError>;
  menuTemplateSelectionGroup?: Maybe<PopupMenuTemplateSelectionGroup>;
};

/** Autogenerated return type of UpdateRecommendationsCustomPreferences. */
export type UpdateRecommendationsCustomPreferencesPayload = {
  __typename?: 'UpdateRecommendationsCustomPreferencesPayload';
  error?: Maybe<OperationError>;
  preferences?: Maybe<Array<CustomPreference>>;
  /**
   * Digest of the stored selection set after the write; nil when cleared. Differs
   * from the value the client last read only when the selection actually changed,
   * so clients can use it to decide whether to refresh recommendations. Opaque —
   * do not parse or send back.
   */
  preferencesVersion?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateRecommendationsLimitsGroup. */
export type UpdateRecommendationsLimitsGroupPayload = {
  __typename?: 'UpdateRecommendationsLimitsGroupPayload';
  error?: Maybe<OperationError>;
  limitsGroup?: Maybe<LimitsGroup>;
};

/** Autogenerated return type of UpdateRecommendationsModelConfig. */
export type UpdateRecommendationsModelConfigPayload = {
  __typename?: 'UpdateRecommendationsModelConfigPayload';
  error?: Maybe<OperationError>;
  modelConfig?: Maybe<ModelConfig>;
};

/** Autogenerated return type of UpdateRecommendationsTagGroups. */
export type UpdateRecommendationsTagGroupsPayload = {
  __typename?: 'UpdateRecommendationsTagGroupsPayload';
  error?: Maybe<OperationError>;
  tagGroups?: Maybe<Array<TagGroup>>;
};

/** Update Report Configuration input */
export type UpdateReportConfigurationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  iconName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  menuTitle?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  reportType?: InputMaybe<ReportConfigurationTypeEnum>;
  requiredRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  tableauDesktopUrl?: InputMaybe<Scalars['String']['input']>;
  tableauMobileUrl?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Array<TermsWithDescriptionInput>>;
};

/** Autogenerated return type of UpdateReportConfigurationQuery. */
export type UpdateReportConfigurationQueryPayload = {
  __typename?: 'UpdateReportConfigurationQueryPayload';
  error?: Maybe<OperationError>;
  reportConfiguration?: Maybe<ReportConfigurations>;
};

/** Update Report Configuration order input */
export type UpdateReportsConfigurationsOrderQueryInput = {
  /** Menu titles of Reports Configurations in new order */
  menuTitles: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateReportsConfigurationsOrderQuery. */
export type UpdateReportsConfigurationsOrderQueryPayload = {
  __typename?: 'UpdateReportsConfigurationsOrderQueryPayload';
  error?: Maybe<OperationError>;
  reportsConfigurations?: Maybe<Array<ReportConfigurations>>;
};

export type UpdateScoringEventInput = {
  id: Scalars['ID']['input'];
  ignored: Scalars['Boolean']['input'];
};

export type UpdateScoringEventTypes = {
  scoringEventTypes: Array<ScoringEventTypeAttributes>;
};

/** Autogenerated return type of UpdateScoringEventTypes. */
export type UpdateScoringEventTypesPayload = {
  __typename?: 'UpdateScoringEventTypesPayload';
  error?: Maybe<OperationError>;
  scoringEventTypes?: Maybe<Array<ScoringEventTypeDefinition>>;
};

/** Autogenerated return type of UpdateScoringEventsBatch. */
export type UpdateScoringEventsBatchPayload = {
  __typename?: 'UpdateScoringEventsBatchPayload';
  error?: Maybe<OperationError>;
  scoringEvents?: Maybe<Array<ScoringEvent>>;
};

export type UpdateSelectEventStatusInput = {
  id: Scalars['ID']['input'];
  status: SelectEventStatusEnum;
};

/** Autogenerated return type of UpdateSelectEventStatus. */
export type UpdateSelectEventStatusPayload = {
  __typename?: 'UpdateSelectEventStatusPayload';
  error?: Maybe<OperationError>;
  selectEvent?: Maybe<SelectEvent>;
};

export type UpdateSelectEventVendor = {
  selectEventVendorAttributes: UpdateSelectEventVendorAttributes;
  selectEventVendorId: Scalars['ID']['input'];
};

export type UpdateSelectEventVendorAttributes = {
  cancelationRequestor?: InputMaybe<Scalars['String']['input']>;
  crossDockId?: InputMaybe<Scalars['ID']['input']>;
  deliveryVendorId?: InputMaybe<Scalars['ID']['input']>;
  menuTemplateId?: InputMaybe<Scalars['ID']['input']>;
  prepFor?: InputMaybe<Scalars['Int']['input']>;
  sendReceiptOnCancel?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateSelectEventVendor. */
export type UpdateSelectEventVendorPayload = {
  __typename?: 'UpdateSelectEventVendorPayload';
  error?: Maybe<OperationError>;
  selectEventVendor?: Maybe<SelectEventVendor>;
};

/** Update UpdateShipFromBuildingsPerState */
export type UpdateShipFromBuildingsPerState = {
  buildingId?: InputMaybe<Scalars['ID']['input']>;
  countryCode: Scalars['String']['input'];
  stateCode: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateShipFromBuildingsPerState. */
export type UpdateShipFromBuildingsPerStatePayload = {
  __typename?: 'UpdateShipFromBuildingsPerStatePayload';
  error?: Maybe<OperationError>;
  shipFromBuildingsPerState?: Maybe<ShipFromBuildingsPerState>;
};

/** Arguments to update vendor employee */
export type UpdateSiteDirectionsNotificationsForVendorMembership = {
  siteDirectionsNotifications: Scalars['Boolean']['input'];
  vendorMembershipId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateSiteDirectionsNotificationsForVendorMembership. */
export type UpdateSiteDirectionsNotificationsForVendorMembershipPayload = {
  __typename?: 'UpdateSiteDirectionsNotificationsForVendorMembershipPayload';
  error?: Maybe<OperationError>;
  vendorMembership?: Maybe<VendorMembership>;
};

export type UpdateStyle = {
  bodyTextColor?: InputMaybe<Scalars['String']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  fillColor?: InputMaybe<Scalars['String']['input']>;
  titleTextColor?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubsidyMember = {
  accountId: Scalars['ID']['input'];
  members: Array<SubsidyMemberAttributes>;
  state: SubsidyMemberState;
};

/** Autogenerated return type of UpdateSubsidyMember. */
export type UpdateSubsidyMemberPayload = {
  __typename?: 'UpdateSubsidyMemberPayload';
  error?: Maybe<OperationError>;
  subsidyMembers?: Maybe<Array<SubsidyMember>>;
};

export type UpdateSubsidyRule = {
  autoApply?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Send null explicitly to clear the override and revert to auto-generated
   * description. Omitting this field leaves the existing value unchanged.
   */
  coverageDescriptionOverride?: InputMaybe<Scalars['String']['input']>;
  dailyMaxCents?: InputMaybe<Scalars['Int']['input']>;
  daysAvailable?: InputMaybe<Array<Day>>;
  displayPreSubsidyPrice: Scalars['Boolean']['input'];
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  eventMaxCents?: InputMaybe<Scalars['Int']['input']>;
  externalTags?: InputMaybe<Array<InventoryItemExternalTags>>;
  hasFoodaCardProgram?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  locationRestriction?: InputMaybe<SubsidyLocationRestrictionEnum>;
  mealTypes?: InputMaybe<Array<InventoryItemMealType>>;
  minOrderCents?: InputMaybe<Scalars['Int']['input']>;
  monthlyMaxCents?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentageCap?: InputMaybe<Scalars['BigDecimal']['input']>;
  /**
   * Item-level only: when true, min_order_cents and event_max_cents are
   * interpreted as pre-tax. Omit to leave the existing value unchanged.
   */
  preTaxEmployeeContribution?: InputMaybe<Scalars['Boolean']['input']>;
  product?: InputMaybe<SubsidyRuleProduct>;
  /**
   * Max $ per user for the whole program (declining balance). Send null explicitly
   * to remove the cap; omitting this field leaves the existing value unchanged.
   */
  programMaxCents?: InputMaybe<Scalars['Int']['input']>;
  redemptionsPerDay?: InputMaybe<Scalars['Int']['input']>;
  ruleType?: InputMaybe<SubsidyRuleTypeEnum>;
  /**
   * Order-level QR member programs only: when true, members added to or joining
   * this program get an active subsidy without confirming their email first. Omit
   * to leave the existing value unchanged.
   */
  skipEmailVerification?: InputMaybe<Scalars['Boolean']['input']>;
  specificAccountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  startsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  subsidyType?: InputMaybe<SubsidyTypeEnum>;
  supportedMealPeriods?: InputMaybe<Array<MealPeriodEnum>>;
  timeZone?: InputMaybe<SubsidyTimezone>;
  validEverywhere?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Item-level only: limit the subsidy to items from these vendors. Empty means
   * every vendor; omitting it on update leaves the existing value unchanged.
   */
  vendorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  weeklyMaxCents?: InputMaybe<Scalars['Int']['input']>;
  weeklyRecurrence?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateSubsidyRule. */
export type UpdateSubsidyRulePayload = {
  __typename?: 'UpdateSubsidyRulePayload';
  error?: Maybe<OperationError>;
  rule?: Maybe<SubsidyRule>;
};

/** Update Tax Category */
export type UpdateTaxCategory = {
  categoryType?: InputMaybe<TaxCategoryTypeEnum>;
  code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isSync?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateTaxCategory. */
export type UpdateTaxCategoryPayload = {
  __typename?: 'UpdateTaxCategoryPayload';
  error?: Maybe<OperationError>;
  taxCategory?: Maybe<TaxCategory>;
};

/** Autogenerated return type of UpdateTaxRatesForBuildingsQuery. */
export type UpdateTaxRatesForBuildingsQueryPayload = {
  __typename?: 'UpdateTaxRatesForBuildingsQueryPayload';
  error?: Maybe<OperationError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateTemperatureLog = {
  cloudinaryResponse: CloudinaryResponseAttributes;
  temperatureLogId: Scalars['ID']['input'];
};

export type UpdateTenderMethodInput = {
  /** Account IDs that can use this tender method */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Days of the week when tender method is available */
  daysAvailable?: InputMaybe<Array<Day>>;
  /** End date for the tender method */
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** External system identifier */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the tender method to update */
  id: Scalars['ID']['input'];
  /** Name of the tender method program */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Start date for the tender method */
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Timezone for the tender method */
  timezone?: InputMaybe<Timezone>;
};

/** Autogenerated return type of UpdateTenderMethod. */
export type UpdateTenderMethodPayload = {
  __typename?: 'UpdateTenderMethodPayload';
  error?: Maybe<OperationError>;
  tenderMethod?: Maybe<TenderMethod>;
};

export type UpdateUser = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  optOutOfRewards?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserNote = {
  id: Scalars['ID']['input'];
  note: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateUserNote. */
export type UpdateUserNotePayload = {
  __typename?: 'UpdateUserNotePayload';
  error?: Maybe<OperationError>;
  userNote?: Maybe<UserNote>;
};

export type UpdateUserNotificationDetails = {
  deviceId: Scalars['ID']['input'];
  pushId: Scalars['String']['input'];
  pushProviderId?: InputMaybe<Scalars['String']['input']>;
  pushProviderName?: InputMaybe<PushNotificationProviders>;
};

/** Autogenerated return type of UpdateUserNotificationDetails. */
export type UpdateUserNotificationDetailsPayload = {
  __typename?: 'UpdateUserNotificationDetailsPayload';
  error?: Maybe<OperationError>;
  user?: Maybe<User>;
};

/** Autogenerated return type of UpdateUser. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  error?: Maybe<OperationError>;
  user?: Maybe<User>;
};

export type UpdateUserPhoneNumber = {
  digits: Scalars['String']['input'];
  verificationMethod: PhoneVerificationMethod;
};

/** Autogenerated return type of UpdateUserPhoneNumber. */
export type UpdateUserPhoneNumberPayload = {
  __typename?: 'UpdateUserPhoneNumberPayload';
  error?: Maybe<OperationError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Arguments to update a vendor employee permissions */
export type UpdateVendorEmployeePermissions = {
  employeePermissions: Array<EmployeePermission>;
  userId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateVendorEmployeePermissions. */
export type UpdateVendorEmployeePermissionsPayload = {
  __typename?: 'UpdateVendorEmployeePermissionsPayload';
  error?: Maybe<OperationError>;
  vendorMembership?: Maybe<VendorMembership>;
};

export type UpdateVendorPopupCapacity = {
  /** Stored on the vendor's popup scheduling constraint */
  maxEventsPerDay?: InputMaybe<Scalars['Int']['input']>;
  /** Stored on the vendor's popup scheduling constraint */
  maxEventsPerWeek?: InputMaybe<Scalars['Int']['input']>;
  /** Other vendors sharing scheduling capacity with this vendor; empty removes it from any group */
  sharedCapacityVendorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The vendor whose Popup Capacity block is being saved */
  vendorId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateVendorPopupCapacity. */
export type UpdateVendorPopupCapacityPayload = {
  __typename?: 'UpdateVendorPopupCapacityPayload';
  error?: Maybe<OperationError>;
  vendor?: Maybe<PopupCapacityVendor>;
};

export enum UploadLinkDocument {
  SiteDirections = 'SITE_DIRECTIONS'
}

/** Fields required to upload file */
export type UploadLinkFields = {
  __typename?: 'UploadLinkFields';
  algorithm: Scalars['String']['output'];
  credential: Scalars['String']['output'];
  date: Scalars['String']['output'];
  key: Scalars['String']['output'];
  policy: Scalars['String']['output'];
  signature: Scalars['String']['output'];
  successActionStatus: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  activeCampaigns?: Maybe<Array<Campaign>>;
  activities?: Maybe<ActivityConnection>;
  banners?: Maybe<Array<Banner>>;
  braintreeTokenizationKey: Scalars['String']['output'];
  campaigns?: Maybe<Array<Campaign>>;
  cardpointeUrlPrefix?: Maybe<Scalars['String']['output']>;
  cards: Array<Card>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  featureFlags: UserFeatureFlags;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastLogins?: Maybe<Array<UserLoginRecord>>;
  lastName?: Maybe<Scalars['String']['output']>;
  optOutOfRewards: Scalars['Boolean']['output'];
  permissions?: Maybe<Array<PermissionDomain>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  rewardsMembership?: Maybe<Membership>;
  rewardsPhoneNumber?: Maybe<PhoneNumber>;
  subscribedAccountBuildings: Array<UserSubscribedAccountBuilding>;
  todoTasks?: Maybe<Array<TodoTask>>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userInformationChangePolicy: UserInformationChangePolicy;
  uuid: Scalars['ID']['output'];
  vendors?: Maybe<Array<Vendor>>;
};


export type UserActivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserPermissionsArgs = {
  domains?: InputMaybe<Array<DomainEnum>>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Type of user making request to API */
export enum UserContext {
  Customer = 'CUSTOMER',
  Vendor = 'VENDOR'
}

export type UserFeatureFlags = {
  __typename?: 'UserFeatureFlags';
  couponsEnabled: Scalars['Boolean']['output'];
  ffbPiiEnabled: Scalars['Boolean']['output'];
  mobileOrderingEnabled: Scalars['Boolean']['output'];
  mobilePayEnabled: Scalars['Boolean']['output'];
  nearbyPopupsEnabled: Scalars['Boolean']['output'];
  referralsEnabled: Scalars['Boolean']['output'];
  rewardsEnabled: Scalars['Boolean']['output'];
  scanToPayEnabled: Scalars['Boolean']['output'];
  sendGridEnabled: Scalars['Boolean']['output'];
  subsidyEnabled: Scalars['Boolean']['output'];
};

/** Input for identifying a rewards user */
export type UserIdentifier =
  { phoneNumber: Scalars['PhoneNumberDigits']['input']; rewardsCode?: never; }
  |  { phoneNumber?: never; rewardsCode: Scalars['RewardsCode']['input']; };

/** A state */
export type UserInformationChangePolicy = {
  __typename?: 'UserInformationChangePolicy';
  canChangeEmail: Scalars['Boolean']['output'];
  canChangeFirstName: Scalars['Boolean']['output'];
  canChangeLastName: Scalars['Boolean']['output'];
  canChangePosition: Scalars['Boolean']['output'];
};

export enum UserLegacyRoles {
  Accounting = 'ACCOUNTING',
  CateringFoodizen = 'CATERING_FOODIZEN',
  FoodaEmployee = 'FOODA_EMPLOYEE',
  Foodizen = 'FOODIZEN',
  Restaurant = 'RESTAURANT',
  RoleAssignment = 'ROLE_ASSIGNMENT',
  SuperAdmin = 'SUPER_ADMIN'
}

export type UserLoginRecord = {
  __typename?: 'UserLoginRecord';
  client: ApiClient;
  time: Scalars['ISO8601DateTime']['output'];
};

/** A note about a user */
export type UserNote = {
  __typename?: 'UserNote';
  /** user who created the note */
  author: User;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** User note id */
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for UserNote. */
export type UserNoteConnection = {
  __typename?: 'UserNoteConnection';
  currentPage: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserNoteEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<UserNote>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserNoteEdge = {
  __typename?: 'UserNoteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserNote>;
};

/** Per-user backtest discovery preview */
export type UserPreview = {
  __typename?: 'UserPreview';
  selectedCount: Scalars['Int']['output'];
  testCases: Array<TestCasePreview>;
  totalOrders: Scalars['Int']['output'];
  userId: Scalars['ID']['output'];
};

/** A user price */
export type UserPrice = {
  __typename?: 'UserPrice';
  subtotalCents: Scalars['Int']['output'];
  taxCents: Scalars['Int']['output'];
  totalCents: Scalars['Int']['output'];
};

export enum UserRoleScope {
  Accounting = 'ACCOUNTING',
  All = 'ALL'
}

/** An account building subscription */
export type UserSubscribedAccountBuilding = {
  __typename?: 'UserSubscribedAccountBuilding';
  account: AccountPublic;
  building: Building;
  healthscoreLink?: Maybe<Scalars['String']['output']>;
  locations: Array<Location>;
};

/** An instance of subsidy for a user */
export type UserSubsidyMembership = {
  __typename?: 'UserSubsidyMembership';
  accountName: Scalars['String']['output'];
  code: Scalars['String']['output'];
  coverage: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  foodaCardMembership?: Maybe<FoodaCardMembership>;
  isQuickAdd: Scalars['Boolean']['output'];
  /**
   * Whether this membership itself is active. Named to distinguish it from
   * `state`, which is the rule's state, not the membership's.
   */
  membershipActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  product: SubsidyRuleProduct;
  qrInfo: Scalars['String']['output'];
  redemptionMessage?: Maybe<Scalars['String']['output']>;
  redemptionsPerDay?: Maybe<Scalars['Int']['output']>;
  startOn?: Maybe<Scalars['String']['output']>;
  state: SubsidyRuleState;
  validAt: Scalars['String']['output'];
  walletInfo?: Maybe<SubsidyWallet>;
};

export enum UserVerificationMethod {
  Email = 'EMAIL',
  None = 'NONE',
  Phone = 'PHONE'
}

/** A vendor */
export type Vendor = {
  __typename?: 'Vendor';
  /** The vendor's billing address */
  address?: Maybe<Address>;
  deliveryMenuTemplates?: Maybe<Array<MenuTemplate>>;
  id: Scalars['ID']['output'];
  internalName: Scalars['String']['output'];
  legalName?: Maybe<Scalars['String']['output']>;
  menuTemplates: Array<MenuTemplate>;
  name: Scalars['String']['output'];
  siteManagementFeeRecipientType: SiteManagementFeeRecipientEnum;
};

export type VendorAvailabilityDetail = {
  __typename?: 'VendorAvailabilityDetail';
  dates: Array<AvailabilityDate>;
  deadlineDate?: Maybe<Scalars['ISO8601Date']['output']>;
  eligibleMealPeriods?: Maybe<AvailabilityMealPeriods>;
  mealPeriods?: Maybe<AvailabilityMealPeriods>;
  requiresSubmission: Scalars['Boolean']['output'];
  submission?: Maybe<AvailabilitySubmissionMetadata>;
  submissionStatus: SubmissionStatusEnum;
  windowStatus: WindowStatusEnum;
};

export type VendorAvailabilityListItem = {
  __typename?: 'VendorAvailabilityListItem';
  availabilityStatus: AvailabilityStatusEnum;
  deadlineDate?: Maybe<Scalars['ISO8601Date']['output']>;
  internalName: Scalars['String']['output'];
  /** @deprecated Use `markets` instead, which returns all markets the vendor serves. */
  market: Scalars['String']['output'];
  markets: Array<Scalars['String']['output']>;
  productType: ProductEnum;
  requiresSubmission: Scalars['Boolean']['output'];
  submission?: Maybe<AvailabilitySubmissionMetadata>;
  submissionStatus: SubmissionStatusEnum;
  vendorId: Scalars['ID']['output'];
  windowStatus: WindowStatusEnum;
};

/** The connection type for Vendor. */
export type VendorConnection = {
  __typename?: 'VendorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<VendorEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Vendor>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type VendorEdge = {
  __typename?: 'VendorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Vendor>;
};

export enum VendorEmployeePermission {
  AvailabilitySubmission = 'AVAILABILITY_SUBMISSION',
  Cashier = 'CASHIER',
  CrewMember = 'CREW_MEMBER',
  Manager = 'MANAGER',
  PantryManager = 'PANTRY_MANAGER'
}

/** Delivery EventVendor manifest document */
export type VendorManifestDocument = {
  __typename?: 'VendorManifestDocument';
  /** Token required when confirming the manifest. */
  confirmationToken?: Maybe<Scalars['String']['output']>;
  /** URL that vendors can follow to confirm the manifest. */
  confirmationUrl?: Maybe<Scalars['String']['output']>;
  documentType: Scalars['String']['output'];
  /** Download URL for the generated manifest PDF. */
  documentUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Timestamp the manifest is generated for (localized to the manifest timezone). */
  manifestDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Current confirmation status (Unconfirmed or Confirmed). */
  status: Scalars['String']['output'];
};

/** Represents a user's membership at the vendor */
export type VendorMembership = {
  __typename?: 'VendorMembership';
  /** @deprecated Use roles */
  employeePermissions: Array<VendorEmployeePermission>;
  id: Scalars['ID']['output'];
  roles: Array<VendorEmployeePermission>;
  siteDirectionsNotifications: Scalars['Boolean']['output'];
  user: User;
  vendor: Vendor;
};

/** A category/section within a vendor menu template (e.g. Entrees, Sides) */
export type VendorMenuCategory = {
  __typename?: 'VendorMenuCategory';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
};

/** An item on a vendor menu template, for restaurant-facing menu views */
export type VendorMenuItem = {
  category?: Maybe<VendorMenuCategory>;
  /** The id of the image the item shows, as the seen value of an image edit. Null for no image, and for non-delivery items. */
  currentImageRef?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Dietary restriction/allergen labels (e.g. Contains Nuts, Vegan). */
  dietaryRestrictions: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** All item image URLs, for the larger-format image modal. */
  images: Array<Scalars['String']['output']>;
  /** The item's type, as the seen value of an item type edit. Null for non-delivery items. */
  itemType?: Maybe<InventoryItemMealType>;
  nameForVendor: Scalars['String']['output'];
  namePublic: Scalars['String']['output'];
  optionGroups: Array<VendorMenuOptionGroup>;
  /**
   * The vendor's other delivery menus that carry this item, so an edit that
   * reaches them can be shown. Empty for non-delivery items.
   */
  otherMenus: Array<MenuChangeOtherMenu>;
  /** Restaurant pre-tax price in cents (may be sub-cent), resolved per product type. Null for menu-level priced catering. */
  preTaxPriceCents?: Maybe<Scalars['BigDecimal']['output']>;
  /** First image, or a placeholder when the item has no image. */
  primaryImageUrl: Scalars['String']['output'];
  /**
   * The tax category the item is charged under, as the seen value of a tax
   * category edit: its own, or the global default when it has none. Null for
   * non-delivery items.
   */
  taxCategoryId?: Maybe<Scalars['ID']['output']>;
  /** Whether the item can be used as an option, as the seen value of a usable-as-option edit. Null for non-delivery items. */
  usableAsOption?: Maybe<Scalars['Boolean']['output']>;
  /**
   * True when the item is also used on a non-draft, non-expired popup or catering
   * menu. FFR shows the item, its option groups and their options locked, and
   * edits to them are refused with ITEM_USED_OUTSIDE_DELIVERY; removing it from
   * this menu is still allowed. Null for non-delivery items.
   */
  usedOutsideDelivery?: Maybe<Scalars['Boolean']['output']>;
};

/** The connection type for VendorMenuItem. */
export type VendorMenuItemConnection = {
  __typename?: 'VendorMenuItemConnection';
  currentPage: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<VendorMenuItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<VendorMenuItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type VendorMenuItemEdge = {
  __typename?: 'VendorMenuItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<VendorMenuItem>;
};

/** A selectable option within a vendor menu option group (e.g. a dressing choice) */
export type VendorMenuOption = {
  /** Dietary restriction/allergen labels of the option's inventory item (e.g. Contains Soy). */
  dietaryRestrictions: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The option's item type, as the seen value of an item type edit. Null for popup options. */
  itemType?: Maybe<InventoryItemMealType>;
  nameForVendor: Scalars['String']['output'];
  namePublic: Scalars['String']['output'];
  /** Restaurant pre-tax incremental price for this option, in cents (may be sub-cent). */
  preTaxPriceCents?: Maybe<Scalars['BigDecimal']['output']>;
  /**
   * The tax category the option is charged under, as the seen value of a tax
   * category edit: its own, or the global default when it has none. Null for popup options.
   */
  taxCategoryId?: Maybe<Scalars['ID']['output']>;
  /** The number of option groups that use this option. Always 0 for popup options. */
  usedInGroupsCount: Scalars['Int']['output'];
  /**
   * True when the option is also used on a non-draft, non-expired popup or
   * catering menu. FFR shows it locked, and an edit to it is refused with
   * OPTION_USED_OUTSIDE_DELIVERY. Null for popup options.
   */
  usedOutsideDelivery?: Maybe<Scalars['Boolean']['output']>;
};

/** A group of options/modifiers for a vendor menu item (e.g. Select Dressing) */
export type VendorMenuOptionGroup = {
  __typename?: 'VendorMenuOptionGroup';
  /** Whether the group holds ingredients or sides. Null for popup groups, and for a delivery group that is empty or mixes both. */
  groupType?: Maybe<MenuChangeOptionGroupType>;
  id: Scalars['ID']['output'];
  maxSelections: Scalars['Int']['output'];
  minSelections: Scalars['Int']['output'];
  nameForVendor: Scalars['String']['output'];
  namePublic: Scalars['String']['output'];
  options: Array<VendorMenuOption>;
};

/** A vendor menu template with its content, for restaurant-facing menu views */
export type VendorMenuTemplate = {
  /** Whether the signed-in manager can edit this menu in FFR. */
  canEditInFfr: Scalars['Boolean']['output'];
  categories: Array<VendorMenuCategory>;
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Why canEditInFfr is false, for the disabled "Edit menu" reason. Null when the menu can be edited. */
  ffrEditBlockedReason?: Maybe<MenuChangeEditBlockedReason>;
  id: Scalars['ID']['output'];
  /** Top-level menu items (options excluded), ordered by category then position; 25 per page. */
  items: VendorMenuItemConnection;
  mealPeriods: Array<MealPeriodEnum>;
  name?: Maybe<Scalars['String']['output']>;
  /** The menu change request waiting for a decision, which locks FFR submits to this template. */
  pendingChangeRequest?: Maybe<MenuChangeRequest>;
  productType: ProductEnum;
  /** True when the template or any of its items changed within the last 2 weeks. */
  recentlyUpdated: Scalars['Boolean']['output'];
  startDate: Scalars['ISO8601DateTime']['output'];
  state: MenuTemplateStateEnum;
  /** Latest of the template's own change and its items' changes. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** A vendor menu template with its content, for restaurant-facing menu views */
export type VendorMenuTemplateItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

/** A vendor's lifecycle state */
export enum VendorState {
  Active = 'active',
  Inactive = 'inactive',
  Onboarding = 'onboarding'
}

/** Popup customer feedback */
export type VendorsPopupFeedback = {
  __typename?: 'VendorsPopupFeedback';
  comments: PopupFeedbackCommentConnection;
  popupExperienceFeedback?: Maybe<Array<ExperienceFeedback>>;
};


/** Popup customer feedback */
export type VendorsPopupFeedbackCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Complete microdeposit verification by submitting the two deposit amounts (in cents) */
export type VerifyFoodaCardBankAccount = {
  amounts: Array<Scalars['Int']['input']>;
  bankAccountId: Scalars['ID']['input'];
  stripeAccountId: Scalars['ID']['input'];
};

/** Autogenerated return type of VerifyFoodaCardBankAccount. */
export type VerifyFoodaCardBankAccountPayload = {
  __typename?: 'VerifyFoodaCardBankAccountPayload';
  bankAccount?: Maybe<FoodaCardBankAccount>;
  error?: Maybe<OperationError>;
};

export type VersionHistoryEntry = {
  __typename?: 'VersionHistoryEntry';
  baseVersion?: Maybe<VersionHistoryEntry>;
  baseVersionId?: Maybe<Scalars['ID']['output']>;
  changeNotes?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  masterTemplate: Scalars['String']['output'];
  modelId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  version: Scalars['String']['output'];
  versionAncestry: Array<VersionHistoryEntry>;
};

/** Fooda rewards wallet */
export type Wallet = {
  __typename?: 'Wallet';
  android?: Maybe<AndroidWallet>;
  ios?: Maybe<IosWallet>;
};

export type WeeklyFrequency = {
  __typename?: 'WeeklyFrequency';
  days: Array<Day>;
  interval: Scalars['Int']['output'];
};

export enum WindowStatusEnum {
  /** Edit window has closed */
  Locked = 'LOCKED',
  /** Edit window is currently open */
  Open = 'OPEN'
}

export type WorldnetOperatorDetails = {
  __typename?: 'WorldnetOperatorDetails';
  apiKey: Scalars['String']['output'];
  terminalId: Scalars['ID']['output'];
};

export type WorldnetResponse = {
  /** The amount authorized by the payment processor */
  authorizedAmount: Scalars['Int']['input'];
  cardIssuer?: InputMaybe<Scalars['String']['input']>;
  cardholderName?: InputMaybe<Scalars['String']['input']>;
  /** Worldnet payment device serial number */
  deviceSerialNumber?: InputMaybe<Scalars['String']['input']>;
  /** The card's expiration date in the format MMYY */
  expiryDate?: InputMaybe<Scalars['String']['input']>;
  /** The card number masked with the character * */
  maskedPan?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  /** Transaction date and time */
  processingDateTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Transaction input method */
  processingMethod?: InputMaybe<Scalars['String']['input']>;
  /** Transaction result code */
  resultCode: Scalars['String']['input'];
  /** Worldnet per card unique reference */
  secureCardReference?: InputMaybe<Scalars['String']['input']>;
  /** The terminal number assigned by the gateway */
  terminal: Scalars['String']['input'];
  /** Unique payment reference limited by 10 characters */
  uniqueReference: Scalars['String']['input'];
};

export type YearlyFrequency = {
  __typename?: 'YearlyFrequency';
  interval: Scalars['Int']['output'];
};

export type CreateAccountAuthenticationDomainAssociationMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  domainName: Scalars['String']['input'];
}>;


export type CreateAccountAuthenticationDomainAssociationMutation = { __typename?: 'Mutation', createAccountAuthenticationDomainAssociation?: { __typename?: 'CreateAccountAuthenticationDomainAssociationPayload', authenticationDomain?: { __typename?: 'AuthenticationDomain', id: string } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type DeleteAccountAuthenticationDomainAssociationMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  domainId: Scalars['ID']['input'];
}>;


export type DeleteAccountAuthenticationDomainAssociationMutation = { __typename?: 'Mutation', deleteAccountAuthenticationDomainAssociation?: { __typename?: 'DeleteAccountAuthenticationDomainAssociationPayload', result?: boolean | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetAccountAuthenticationDomainsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetAccountAuthenticationDomainsQuery = { __typename?: 'Query', getAccountAuthenticationDomains?: { __typename?: 'GetAccountAuthenticationDomainsPayload', authenticationDomains?: Array<{ __typename?: 'AuthenticationDomain', domainName: string, id: string, authenticationProviderId: string }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null, getAuthenticationProviders?: { __typename?: 'GetAuthenticationProvidersPayload', authenticationProviders?: Array<{ __typename?: 'AuthenticationProvider', id: string, name: string, isDefault: boolean }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null, getAuthenticationDomains?: { __typename?: 'GetAuthenticationDomainsPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, authenticationDomains?: Array<{ __typename?: 'AuthenticationDomain', id: string, domainName: string, authenticationProviderId: string }> | null } | null };

export type GetAccountMarketingSegmentsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetAccountMarketingSegmentsQuery = { __typename?: 'Query', getAccount?: { __typename?: 'GetAccountQueryPayload', account?: { __typename?: 'Account', id: string, marketingSegments?: Array<{ __typename?: 'MarketingSegment', id: string, name: string, externalId?: string | null, state: MarketingSegmentStateEnum, segmentType: MarketingSegmentTypeEnum, providerName: MarketingSegmentProviderEnum }> | null } | null } | null };

export type GetInternalNotesQueryQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetInternalNotesQueryQuery = { __typename?: 'Query', data?: { __typename?: 'GetAccountQueryPayload', account?: { __typename?: 'Account', accountInfoNotes?: Array<{ __typename?: 'AccountNote', createdAt: any, id: string, note: string, updatedAt: any, user: { __typename?: 'User', id: string, fullName?: string | null } }> | null } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type RefreshMarketingSegmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RefreshMarketingSegmentMutation = { __typename?: 'Mutation', refreshMarketingSegment?: { __typename?: 'RefreshMarketingSegmentPayload', marketingSegment?: { __typename?: 'MarketingSegment', id: string, state: MarketingSegmentStateEnum } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type SearchAccountQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type SearchAccountQuery = { __typename?: 'Query', searchAccountsQuery?: { __typename?: 'SearchAccountsQueryPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, accounts?: Array<{ __typename?: 'AccountPublic', id: string, name: string }> | null } | null };

export type SearchAccountOptionsQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type SearchAccountOptionsQuery = { __typename?: 'Query', searchAccountOptions?: { __typename?: 'SearchAccountOptionsPayload', accounts?: Array<{ __typename?: 'AccountOption', id: string, name: string, parentCompany?: { __typename?: 'ParentCompanyOption', id: string, displayName: string } | null }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type CreateAccountingSiteOwnerMutationVariables = Exact<{
  accountingSiteId: Scalars['ID']['input'];
  input: AccountingSiteOwnerInput;
}>;


export type CreateAccountingSiteOwnerMutation = { __typename?: 'Mutation', createAccountingSiteOwner?: { __typename?: 'CreateAccountingSiteOwnerPayload', owner?: { __typename?: 'AccountingSiteOwner', id: string, userId: number, userName?: string | null, effectiveStart: any, effectiveEnd?: any | null, roleTypeIds: Array<string>, roleTypeNames: Array<string>, past: boolean } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type DestroyAccountingSiteOwnerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DestroyAccountingSiteOwnerMutation = { __typename?: 'Mutation', destroyAccountingSiteOwner?: { __typename?: 'DestroyAccountingSiteOwnerPayload', id?: string | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetAccountingSiteOwnersQueryVariables = Exact<{
  accountingSiteId: Scalars['ID']['input'];
}>;


export type GetAccountingSiteOwnersQuery = { __typename?: 'Query', getAccountingSiteOwners?: { __typename?: 'GetAccountingSiteOwnersPayload', accountingSiteId?: string | null, owners?: Array<{ __typename?: 'AccountingSiteOwner', id: string, accountingSiteId: number, userId: number, userName?: string | null, effectiveStart: any, effectiveEnd?: any | null, roleTypeIds: Array<string>, roleTypeNames: Array<string>, past: boolean }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetFoodaEmployeeOptionsQueryVariables = Exact<{
  includeUserId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetFoodaEmployeeOptionsQuery = { __typename?: 'Query', getFoodaEmployeeOptions?: { __typename?: 'GetFoodaEmployeeOptionsPayload', users?: Array<{ __typename?: 'LightweightUser', id: string, firstName?: string | null, lastName?: string | null, email?: string | null }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type UpdateAccountingSiteOwnerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: AccountingSiteOwnerInput;
}>;


export type UpdateAccountingSiteOwnerMutation = { __typename?: 'Mutation', updateAccountingSiteOwner?: { __typename?: 'UpdateAccountingSiteOwnerPayload', owner?: { __typename?: 'AccountingSiteOwner', id: string, userId: number, userName?: string | null, effectiveStart: any, effectiveEnd?: any | null, roleTypeIds: Array<string>, roleTypeNames: Array<string>, past: boolean } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type CreateAccountingSiteRoleTypeMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateAccountingSiteRoleTypeMutation = { __typename?: 'Mutation', createAccountingSiteRoleType?: { __typename?: 'CreateAccountingSiteRolePayload', roleType?: { __typename?: 'AccountingSiteRoleType', id: string, name: string, deletedAt?: any | null, active: boolean } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type DeactivateAccountingSiteRoleTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeactivateAccountingSiteRoleTypeMutation = { __typename?: 'Mutation', deactivateAccountingSiteRoleType?: { __typename?: 'DeactivateAccountingSiteRolePayload', roleType?: { __typename?: 'AccountingSiteRoleType', id: string, name: string, deletedAt?: any | null, active: boolean } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetAccountingSiteRoleTypesQueryVariables = Exact<{
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAccountingSiteRoleTypesQuery = { __typename?: 'Query', getAccountingSiteRoleTypes?: { __typename?: 'GetAccountingSiteRoleTypesPayload', roleTypes?: Array<{ __typename?: 'AccountingSiteRoleType', id: string, name: string, deletedAt?: any | null, active: boolean }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type UpdateAccountingSiteRoleTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateAccountingSiteRoleTypeMutation = { __typename?: 'Mutation', updateAccountingSiteRoleType?: { __typename?: 'UpdateAccountingSiteRolePayload', roleType?: { __typename?: 'AccountingSiteRoleType', id: string, name: string, deletedAt?: any | null, active: boolean } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type CreateAccountingSiteTypeMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateAccountingSiteTypeMutation = { __typename?: 'Mutation', createAccountingSiteType?: { __typename?: 'CreateAccountingSiteTypePayload', siteType?: { __typename?: 'AccountingSiteType', id: string, name: string } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetAccountingSiteTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountingSiteTypesQuery = { __typename?: 'Query', getAccountingSiteTypes?: { __typename?: 'GetAccountingSiteTypesPayload', siteTypes?: Array<{ __typename?: 'AccountingSiteType', id: string, name: string }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type UpdateAccountingSiteTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateAccountingSiteTypeMutation = { __typename?: 'Mutation', updateAccountingSiteType?: { __typename?: 'UpdateAccountingSiteTypePayload', siteType?: { __typename?: 'AccountingSiteType', id: string, name: string } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetCountriesListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesListQuery = { __typename?: 'Query', data?: { __typename?: 'GetCountriesListPayload', countries: Array<{ __typename?: 'Country', countryName: string, countryCode: string }>, error?: { __typename?: 'OperationError', message: string, code: number, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null };

export type GetStatesListQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
}>;


export type GetStatesListQuery = { __typename?: 'Query', data?: { __typename?: 'GetStatesListPayload', states?: Array<{ __typename?: 'State', countryCode: string, stateCode: string, stateName: string }> | null, error?: { __typename?: 'OperationError', message: string, code: number, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null };

export type CalculateEventSubsidiesQueryVariables = Exact<{
  input: CalculateEventSubsidies;
}>;


export type CalculateEventSubsidiesQuery = { __typename?: 'Query', calculateEventSubsidies?: { __typename?: 'CalculateEventSubsidiesPayload', subsidies?: Array<{ __typename?: 'CalculatedSubsidyMembership', code: string, availableCents: number, redeemableCents: number }> | null } | null };

export type CalculateMobileOrderingCartQueryVariables = Exact<{
  input: CalculateMobileOrderingCart;
}>;


export type CalculateMobileOrderingCartQuery = { __typename?: 'Query', calculateMobileOrderingCart?: { __typename?: 'CalculateMobileOrderingCartPayload', cart?: { __typename?: 'MobileOrderingCart', couponDiscountCents: number, dueAmountCents: number, restaurantCommissionCents?: number | null, subsidyDiscountCents: number, subtotalCents: number, taxCents: number, rewardsPoints: number, subtotalPostSubsidyCents: number, taxPostSubsidyCents: number, subsidy?: { __typename?: 'MobileOrderingSubsidy', amountCents: number, code: string } | null, items: Array<{ __typename?: 'MobileOrderingCartMenuItem', id: any, rules?: Array<{ __typename?: 'EventMenuItemSubsidy', versionId: string, redeemableCents: number }> | null }>, pickupTimeSlots: Array<{ __typename?: 'MobileOrderingPickupTimeSlot', time: any }> } | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', codeAsString: string, message: string } | { __typename?: 'CreateUserAccountErrorDetail', codeAsString: string, message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', codeAsString: string, message: string } | { __typename?: 'MenuChangeRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestBlobErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestErrorDetail', codeAsString: string, message: string }> | null } | null } | null };

export type CancelDeliveryOrderMutationVariables = Exact<{
  input: CancelDeliveryOrder;
}>;


export type CancelDeliveryOrderMutation = { __typename?: 'Mutation', cancelDeliveryOrder?: { __typename?: 'CancelDeliveryOrderPayload', deliveryOrder?: { __typename?: 'DeliveryOrderDetails', requestId: string } | null, error?: { __typename?: 'OperationError', message: string } | null } | null };

export type CreateCateringUserAccountMutationVariables = Exact<{
  input: CreateCateringUserAccount;
}>;


export type CreateCateringUserAccountMutation = { __typename?: 'Mutation', createCateringUserAccount?: { __typename?: 'CreateCateringUserAccountPayload', destination?: string | null, errors?: Array<string> | null, omniauthCallback?: string | null, sessionToken?: string | null, uuid?: string | null, result?: { __typename?: 'CateringUserAccount', userId: string } | null, error?: { __typename?: 'OperationError', message: string } | null } | null };

export type CreateMobileOrderingOrderRequestMutationVariables = Exact<{
  input: CreateMobileOrderingOrderRequest;
}>;


export type CreateMobileOrderingOrderRequestMutation = { __typename?: 'Mutation', createMobileOrderingOrderRequest?: { __typename?: 'CreateMobileOrderingOrderRequestPayload', orderRequest?: { __typename?: 'MobileOrderingOrderRequest', id: string, state: MobileOrderingOrderRequestState, order?: { __typename?: 'ConsumerMobileOrderingOrderDetails', id: string, pickupInfo: { __typename?: 'MobileOrderingPickupInfo', pickupId: string, pickupTime: any } } | null } | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', itemIds: Array<string>, codeAsString: string, message: string } | { __typename?: 'CreateUserAccountErrorDetail', codeAsString: string, message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', codeAsString: string, message: string } | { __typename?: 'MenuChangeRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestBlobErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestErrorDetail', codeAsString: string, message: string }> | null } | null } | null };

export type CreateSessionMutationVariables = Exact<{
  input: CreateSession;
}>;


export type CreateSessionMutation = { __typename?: 'Mutation', createSession?: { __typename?: 'CreateSessionPayload', session?: { __typename?: 'Session', token: string, omniauthCallback?: string | null, user: { __typename?: 'User', id: string, uuid: string } } | null, error?: { __typename?: 'OperationError', message: string } | null } | null };

export type CreateUserMutationVariables = Exact<{
  input: CreateUser;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'CreateUserPayload', omniauthCallback?: string | null, sessionToken?: string | null, user?: { __typename?: 'User', uuid: string, email?: string | null } | null, error?: { __typename?: 'OperationError', message: string, code: number, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null };

export type GetAuthProviderQueryVariables = Exact<{
  email: Scalars['String']['input'];
  sourceUri?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAuthProviderQuery = { __typename?: 'Query', data?: { __typename?: 'GetAuthProviderPayload', providerUrl?: string | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetAuthenticationDomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthenticationDomainsQuery = { __typename?: 'Query', data?: { __typename?: 'GetAuthenticationDomainsPayload', authenticationDomains?: Array<{ __typename?: 'AuthenticationDomain', id: string, organization: string, organizationName: string, domainName: string, effectiveDate: any, authenticationProviderId: string, createdAt: any, updatedAt: any, useLoginHint: boolean, scimEnabled: boolean, mobileSessionTimeout?: number | null, mobileSessionExpiration?: number | null, webSessionTimeout?: number | null, webSessionExpiration?: number | null, accounts?: Array<{ __typename?: 'AccountPublic', id: string, name: string }> | null }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetAuthenticationProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthenticationProvidersQuery = { __typename?: 'Query', data?: { __typename?: 'GetAuthenticationProvidersPayload', authenticationProviders?: Array<{ __typename?: 'AuthenticationProvider', id: string, isDefault: boolean, machineName: string, name: string, urlSuffix: string, createdAt: any, updatedAt: any }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetDeliveryEventVendorMenuQueryVariables = Exact<{
  input: GetDeliveryEventVendorMenu;
}>;


export type GetDeliveryEventVendorMenuQuery = { __typename?: 'Query', getDeliveryEventVendorMenu?: { __typename?: 'GetDeliveryEventVendorMenuPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, vendorMenu?: { __typename?: 'DeliveryEventVendorMenu', eventVendorId: string, soldOutState?: SoldOutRestaurantEnum | null, menuGroups: Array<{ __typename?: 'DeliveryEventMenuCategoryGroup', id: string, name: string, position?: number | null, items: Array<{ __typename?: 'DeliveryEventMenuItem', id: string, menuItemId: string, name: string, description?: string | null, images: Array<string>, position?: number | null, preTaxPriceCents: any, dietaryRestrictions: Array<string> }> }> } | null } | null };

export type GetEventSubsidiesQueryVariables = Exact<{
  input: GetEventSubsidies;
}>;


export type GetEventSubsidiesQuery = { __typename?: 'Query', getEventSubsidies?: { __typename?: 'GetEventSubsidiesPayload', subsidies?: Array<{ __typename?: 'EventSubsidyMembership', accountName: string, isDefault: boolean, code: string, coverage: string, isQuickAdd: boolean, name: string, product: SubsidyRuleProduct, expiresAt?: any | null, startOn?: string | null, state: SubsidyRuleState, validAt: string, redemptionMessage?: string | null }> | null } | null };

export type GetMobileOrderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMobileOrderQuery = { __typename?: 'Query', request?: { __typename?: 'GetMobileOrderingOrderRequestPayload', orderRequest?: { __typename?: 'MobileOrderingOrderRequest', state: MobileOrderingOrderRequestState, paymentGatewayError?: string | null, order?: { __typename?: 'ConsumerMobileOrderingOrderDetails', id: string, state: MobileOrderingOrderStatus, couponDiscountCents: number, subsidyDiscountCents: number, subtotalCents: number, taxCents: number, totalPaidCents: number, items: Array<{ __typename?: 'ConsumerMobileOrderingOrderItemDetails', id: string, name: string, customizationDescription?: string | null, napkins: boolean, silverware: boolean, selectionGroups?: Array<{ __typename?: 'ConsumerMobileOrderingOrderSelectionGroupDetails', namePublic: string, options?: Array<{ __typename?: 'ConsumerMobileOrderingOrderOptionItemDetails', name: string, userPrice: { __typename?: 'UserPrice', taxCents: number, subtotalCents: number, totalCents: number } }> | null }> | null, userPrice: { __typename?: 'UserPrice', taxCents: number, subtotalCents: number, totalCents: number } }>, location?: { __typename?: 'Location', accountName?: string | null, name: string, building: { __typename?: 'Building', name: string, address: { __typename?: 'Address', address1: string } } } | null, cardDetails?: { __typename?: 'CardPaymentInfo', cardType?: CardIssuer | null, last4: number } | null, pickupInfo: { __typename?: 'MobileOrderingPickupInfo', pickupId: string, pickupTime: any }, userPrice: { __typename?: 'UserPrice', taxCents: number, subtotalCents: number, totalCents: number } } | null } | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', codeAsString: string, message: string } | { __typename?: 'CreateUserAccountErrorDetail', codeAsString: string, message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', codeAsString: string, message: string } | { __typename?: 'MenuChangeRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestBlobErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestErrorDetail', codeAsString: string, message: string }> | null } | null } | null };

export type GetMobileOrderDetailsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetMobileOrderDetailsQuery = { __typename?: 'Query', getConsumerMobileOrderingOrderDetails?: { __typename?: 'GetConsumerMobileOrderingOrderDetailsPayload', orders?: Array<{ __typename?: 'ConsumerMobileOrderingOrderDetails', id: string, eventId: string, eventType: EventProduct, requestId: string, state: MobileOrderingOrderStatus, vendorName: string, couponDiscountCents: number, subsidyDiscountCents: number, subtotalCents: number, taxCents: number, totalPaidCents: number, account: { __typename?: 'AccountPublic', id: string, name: string }, cardDetails?: { __typename?: 'CardPaymentInfo', id: string, last4: number, cardType?: CardIssuer | null } | null, items: Array<{ __typename?: 'ConsumerMobileOrderingOrderItemDetails', id: string, customizationDescription?: string | null, napkins: boolean, name: string, silverware: boolean, preTaxCents: number, taxCents: number, postTaxCents: number, selectionGroups?: Array<{ __typename?: 'ConsumerMobileOrderingOrderSelectionGroupDetails', id: string, namePublic: string, options?: Array<{ __typename?: 'ConsumerMobileOrderingOrderOptionItemDetails', id: string, name: string, preTaxCents: number, taxCents: number, postTaxCents: number }> | null }> | null }>, location?: { __typename?: 'Location', id: string, name: string, accountName?: string | null, building: { __typename?: 'Building', name: string, address: { __typename?: 'Address', address1: string, address2?: string | null, city: string, zipCode: string } } } | null, pickupInfo: { __typename?: 'MobileOrderingPickupInfo', pickupId: string, pickupTime: any }, user?: { __typename?: 'OrderRequestUser', id: string, firstName?: string | null, lastName?: string | null } | null }> | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', codeAsString: string, message: string } | { __typename?: 'CreateUserAccountErrorDetail', codeAsString: string, message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', codeAsString: string, message: string } | { __typename?: 'MenuChangeRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestBlobErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestErrorDetail', codeAsString: string, message: string }> | null } | null } | null };

export type GetOrderRefundsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrderRefundsQuery = { __typename?: 'Query', getOrderRequestDetails?: { __typename?: 'GetOrderRequestDetailsPayload', order?: { __typename?: 'OrderRequestDetails', paymentRefunds: Array<{ __typename?: 'PaymentRefundLineItem', amountCents: number, createdAt?: any | null, displayAmount: any, displayAmountCents: number, displayName: string, lineItemType: PaymentRefundLineItemTypeEnum }> } | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', codeAsString: string, message: string } | { __typename?: 'CreateUserAccountErrorDetail', codeAsString: string, message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', codeAsString: string, message: string } | { __typename?: 'MenuChangeRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestBlobErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestErrorDetail', codeAsString: string, message: string }> | null } | null } | null };

export type GetPopupEventVendorMenuQueryVariables = Exact<{
  input: GetPopupEventVendorMenu;
}>;


export type GetPopupEventVendorMenuQuery = { __typename?: 'Query', multipleSubsidyFlag?: { __typename?: 'GetFeatureFlagPayload', featureFlag?: { __typename?: 'FeatureFlag', enabled: boolean, name: string } | null } | null, getPopupEventVendorMenu?: { __typename?: 'GetPopupEventVendorMenuPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, vendorMenu?: { __typename?: 'PopupEventVendorMenu', hidePrices: boolean, menuGroups: Array<{ __typename?: 'PopupEventMenuCategoryGroup', isCustom: boolean, name: string, position: number, items: Array<{ __typename?: 'PopupEventMenuItem', id: string, name: string, description?: string | null, image?: string | null, otherTaxCents: any, salesTaxCents: any, preTaxPriceCents: any, postTaxPriceCents: number, position: number, showOnMenu?: boolean | null, isCustom: boolean, available: boolean, availableInPersonOnly: boolean, selectionGroupPositions?: Array<string> | null, disallowWriteIn?: boolean | null, dietaryRestrictions?: Array<InventoryItemDietaryRestrictions> | null, subsidy?: { __typename?: 'EventMenuItemSubsidizedPrice', postSubsidyPreTaxCents: number, postSubsidyPostTaxCents: number, postSubsidySalesTaxCents: number, rules: Array<{ __typename?: 'EventMenuItemSubsidy', name: string, redeemableCents: number, versionId: string, displayPreSubsidyPrice: boolean }> } | null, selectionGroups?: Array<{ __typename?: 'PopupEventMenuItemSelectionGroup', id: string, itemPositions: Array<string>, maxSelections: number, minSelections: number, namePublic: string, defaultSelection?: { __typename?: 'PopupEventMenuItemSelectionGroupOption', available: boolean, foodaBarcodeNumber?: string | null, id: string, image?: string | null, namePublic: string, otherTaxCents: any, postTaxPriceCents: number, preTaxPriceCents: any, salesTaxCents: any, showOnPos?: boolean | null, upc?: string | null, subsidy?: { __typename?: 'EventMenuItemSubsidizedPrice', postSubsidyPreTaxCents: number, postSubsidyPostTaxCents: number, postSubsidySalesTaxCents: number, rules: Array<{ __typename?: 'EventMenuItemSubsidy', name: string, redeemableCents: number, versionId: string, displayPreSubsidyPrice: boolean }> } | null } | null, options: Array<{ __typename?: 'PopupEventMenuItemSelectionGroupOption', available: boolean, foodaBarcodeNumber?: string | null, id: string, image?: string | null, namePublic: string, otherTaxCents: any, postTaxPriceCents: number, preTaxPriceCents: any, salesTaxCents: any, showOnPos?: boolean | null, upc?: string | null, subsidy?: { __typename?: 'EventMenuItemSubsidizedPrice', postSubsidyPreTaxCents: number, postSubsidyPostTaxCents: number, postSubsidySalesTaxCents: number, rules: Array<{ __typename?: 'EventMenuItemSubsidy', name: string, redeemableCents: number, versionId: string, displayPreSubsidyPrice: boolean }> } | null }> }> | null }> }> } | null } | null };

export type GetPopupRecommendationsQueryVariables = Exact<{
  input: GetRecommendationsInput;
}>;


export type GetPopupRecommendationsQuery = { __typename?: 'Query', getRecommendations?: { __typename?: 'GetRecommendationsQueryPayload', recommendations?: { __typename?: 'GetRecommendationsPayload', sessionUuid?: string | null, status?: RecommendationStatus | null, recommendationsGroup?: { __typename?: 'RecommendationGroup', uuid: string, recommendations: Array<{ __typename?: 'Recommendation', uuid: string, data: any, justification?: string | null }> } | null } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetQaToolsQueryVariables = Exact<{
  input?: InputMaybe<QaToolsInput>;
  requestType: QaToolsRequestTypeEnum;
}>;


export type GetQaToolsQuery = { __typename?: 'Query', getQaTools?: { __typename?: 'GetQaToolsQueryPayload', scriptInfo?: Array<{ __typename?: 'QaToolsScript', averageTime: string, endTime: string, progress: string, requestType: QaToolsRequestTypeEnum, scriptName: string, startTime: string, status: string, requiredFields?: Array<{ __typename?: 'QaToolsField', description?: string | null, field: string, namespaces?: Array<{ __typename?: 'QaScriptsNamespace', namespace: string, paths?: Array<{ __typename?: 'QaScriptPath', path: string, name: string }> | null }> | null }> | null, responseFields?: Array<{ __typename?: 'QaToolsField', description?: string | null, field: string, value?: string | null }> | null }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetRecommendationsWithItemQueryVariables = Exact<{
  input: GetRecommendationsInput;
}>;


export type GetRecommendationsWithItemQuery = { __typename?: 'Query', getRecommendations?: { __typename?: 'GetRecommendationsQueryPayload', recommendations?: { __typename?: 'GetRecommendationsPayload', sessionUuid?: string | null, status?: RecommendationStatus | null, recommendationsGroup?: { __typename?: 'RecommendationGroup', uuid: string, recommendations: Array<{ __typename?: 'Recommendation', uuid: string, data: any, justification?: string | null, menuItem?: { __typename: 'DeliveryEventRecommendationMenuItem', deliveryEventMenuItemId: string, id: string, name: string, description?: string | null, priceCents: number, images: Array<string>, tags: Array<string>, hasOptions: boolean } | { __typename: 'PopupEventRecommendationMenuItem', eventVendorId: string, originalPriceCents?: number | null, hidePrices: boolean, id: string, name: string, description?: string | null, priceCents: number, images: Array<string>, tags: Array<string>, hasOptions: boolean } | null }> } | null } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetStripeVerificationSessionQueryVariables = Exact<{
  membershipId: Scalars['ID']['input'];
}>;


export type GetStripeVerificationSessionQuery = { __typename?: 'Query', getStripeVerificationSession?: { __typename?: 'GetStripeVerificationSessionPayload', clientSecret?: string | null, error?: { __typename?: 'OperationError', message: string } | null } | null };

export type GetUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', getUser?: { __typename?: 'GetUserQueryPayload', user?: { __typename?: 'User', id: string, fullName?: string | null, email?: string | null } | null, error?: { __typename?: 'OperationError', message: string, code: number, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null };

export type GetUserOrdersQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetUserOrdersQuery = { __typename?: 'Query', getUser?: { __typename?: 'GetUserQueryPayload', user?: { __typename?: 'User', activities?: { __typename?: 'ActivityConnection', nodes?: Array<{ __typename?: 'DeliveryOrder' } | { __typename?: 'FoodaCardActivity' } | { __typename?: 'PopupOrder', itemNames: Array<string>, paymentState: OrderRequestStateEnum, requestId: string, orderFulfilledTime: any, hidePrices: boolean, pickupInfo?: { __typename?: 'PopupUserOrderPickupInfo', pickupId: string, pickupTime: any, state: MobileOrderingOrderStatus } | null } | { __typename?: 'RewardsPointEntry' } | null> | null } | null } | null, error?: { __typename?: 'OperationError', message: string, code: number, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null };

export type GetUserRewardsPhoneNumberQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetUserRewardsPhoneNumberQuery = { __typename?: 'Query', getUser?: { __typename?: 'GetUserQueryPayload', user?: { __typename?: 'User', id: string, uuid: string, optOutOfRewards: boolean, rewardsPhoneNumber?: { __typename?: 'PhoneNumber', digits?: string | null, state?: string | null } | null } | null, error?: { __typename?: 'OperationError', message: string, code: number, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null };

export type GetUserSubsidiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserSubsidiesQuery = { __typename?: 'Query', getUserSubsidies?: { __typename?: 'GetUserSubsidiesPayload', subsidies?: Array<{ __typename?: 'UserSubsidyMembership', accountName: string, qrInfo: string, code: string, coverage: string, isQuickAdd: boolean, name: string, product: SubsidyRuleProduct, expiresAt?: any | null, startOn?: string | null, state: SubsidyRuleState, validAt: string, redemptionsPerDay?: number | null, redemptionMessage?: string | null, membershipActive: boolean, foodaCardMembership?: { __typename?: 'FoodaCardMembership', id: string, status: FoodaCardMembershipStatusEnum, needsSetup: boolean, stripeCardholderPastDueRequirements?: Array<StripeCardholderRequirementEnum> | null, stripeCardholderDisabledReason?: StripeCardholderDisabledReasonEnum | null, stripeCardholderPhoneNumber?: string | null, stripeCard?: { __typename?: 'FoodaCardStripeCard', id: string, stripeCardId: string, last4: string, status: string } | null, stripeBillingAddress?: { __typename?: 'BillingAddress', address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: string | null } | null, backupCard?: { __typename?: 'Card', id: string, last4: number, cardType?: CardIssuer | null, imageUrl?: string | null } | null, subsidyRule: { __typename?: 'SubsidyRule', id: string, name: string, timeZone: SubsidyTimezone, timeZoneLabel: string, foodaCardProgram?: { __typename?: 'FoodaCardProgram', allowedHourRanges?: any | null, allowedMerchantNames?: Array<string> | null, blockedMerchantNames?: Array<string> | null, allowedZipCodes?: Array<string> | null, stripeAccount?: { __typename?: 'FoodaCardStripeAccount', stripeAccountId: string } | null } | null } } | null }> | null } | null };

export type PingQaToolsQueryVariables = Exact<{ [key: string]: never; }>;


export type PingQaToolsQuery = { __typename?: 'Query', pingQaTools?: { __typename?: 'PingQaToolsQueryPayload', scriptInfo?: Array<{ __typename?: 'QaToolsScript', averageTime: string, endTime: string, progress: string, requestType: QaToolsRequestTypeEnum, scriptName: string, startTime: string, status: string, requiredFields?: Array<{ __typename?: 'QaToolsField', description?: string | null, field: string, namespaces?: Array<{ __typename?: 'QaScriptsNamespace', namespace: string, paths?: Array<{ __typename?: 'QaScriptPath', path: string, name: string }> | null }> | null }> | null, responseFields?: Array<{ __typename?: 'QaToolsField', description?: string | null, field: string, value?: string | null }> | null }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type SearchEventsQueryVariables = Exact<{
  input: SearchPublicEvents;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchEventsQuery = { __typename?: 'Query', data?: { __typename?: 'SearchPublicEventsPayload', events?: { __typename?: 'PublicEventConnection', edges?: Array<{ __typename?: 'PublicEventEdge', cursor: string, node?: { __typename?: 'CafeEventPublic', cafeName: string, id: string, endTime: any, startTime: any, url: string, status: EventStatus, restaurants: Array<{ __typename?: 'CafeRestaurant', id: string, name: string, serviceStartTime: any, serviceEndTime: any, stationType: StationTypes, essenceImageUrl: string, defaultCuisine?: string | null, mealPeriod?: MealPeriodEnum | null, mobileOrdering: { __typename?: 'MobileOrderingEventVendorInfo', enabled: boolean, orderingWindowStartTime: any, orderingWindowEndTime: any, orderingCloseTime: any } }> } | { __typename?: 'CateringEventPublic', id: string, endTime?: any | null, startTime: any, url: string, status: EventStatus } | { __typename?: 'DeliveryEventPublic', mealPeriod: MealPeriodEnum, id: string, endTime: any, startTime: any, url: string, status: EventStatus, restaurants: Array<{ __typename?: 'DeliveryRestaurant', name: string, defaultCuisine?: string | null, essenceImageUrl: string }>, deliveryWindow: { __typename?: 'DeliveryWindow', startTime: any, endTime: any } } | { __typename?: 'PopupEventPublic', id: string, endTime: any, startTime: any, url: string, status: EventStatus, restaurants: Array<{ __typename?: 'PopupRestaurant', id: string, name: string, mealPeriod?: MealPeriodEnum | null, essenceImageUrl: string, defaultCuisine?: string | null, location: { __typename?: 'LocationPublic', name: string }, mobileOrdering: { __typename?: 'MobileOrderingEventVendorInfo', enabled: boolean, orderingWindowStartTime: any, orderingWindowEndTime: any, orderingCloseTime: any } }> } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null, error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type SearchPublicEventsQueryVariables = Exact<{
  input: SearchPublicEvents;
}>;


export type SearchPublicEventsQuery = { __typename?: 'Query', searchPublicEvents?: { __typename?: 'SearchPublicEventsPayload', events?: { __typename?: 'PublicEventConnection', nodes?: Array<{ __typename: 'CafeEventPublic', cafeName: string, healthscoreLink?: string | null, id: string, endTime: any, startTime: any, url: string, status: EventStatus, restaurants: Array<{ __typename?: 'CafeRestaurant', id: string, vendorId: string, cuisines?: Array<string> | null, name: string, serviceStartTime: any, serviceEndTime: any, stationType: StationTypes, essenceImageUrl: string, defaultCuisine?: string | null, mealPeriod?: MealPeriodEnum | null, mobileOrdering: { __typename?: 'MobileOrderingEventVendorInfo', enabled: boolean, orderingWindowStartTime: any, orderingWindowEndTime: any, mobileOrderingAvailable: boolean, mobileOrderingUnavailableReason?: MobileOrderingUnavailableReason | null, orderingCloseTime: any } }> } | { __typename: 'CateringEventPublic', healthscoreLink?: string | null, mealPeriod: MealPeriodEnum, menuImages: Array<string | null>, id: string, endTime?: any | null, startTime: any, url: string, status: EventStatus } | { __typename: 'DeliveryEventPublic', healthscoreLink?: string | null, mealPeriod: MealPeriodEnum, defaultTileImageUrl: string, id: string, endTime: any, startTime: any, url: string, status: EventStatus, restaurants: Array<{ __typename?: 'DeliveryRestaurant', id: string, vendorId: string, name: string, defaultCuisine?: string | null, essenceImageUrl: string, cuisines?: Array<string> | null, soldOutState?: SoldOutRestaurantEnum | null }>, deliveryWindow: { __typename?: 'DeliveryWindow', startTime: any, endTime: any } } | { __typename: 'PopupEventPublic', healthscoreLink?: string | null, id: string, endTime: any, startTime: any, url: string, status: EventStatus, restaurants: Array<{ __typename?: 'PopupRestaurant', id: string, vendorId: string, name: string, mealPeriod?: MealPeriodEnum | null, essenceImageUrl: string, defaultCuisine?: string | null, cuisines?: Array<string> | null, serviceStartTime: any, serviceEndTime: any, location: { __typename?: 'LocationPublic', name: string }, mobileOrdering: { __typename?: 'MobileOrderingEventVendorInfo', enabled: boolean, orderingWindowStartTime: any, orderingWindowEndTime: any, mobileOrderingAvailable: boolean, mobileOrderingUnavailableReason?: MobileOrderingUnavailableReason | null, orderingCloseTime: any } }> } | null> | null } | null, error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type SubmitRecommendationsFeedbackMutationVariables = Exact<{
  input: SubmitRecommendationsFeedbackInput;
}>;


export type SubmitRecommendationsFeedbackMutation = { __typename?: 'Mutation', submitRecommendationsFeedback?: { __typename?: 'SubmitRecommendationsFeedbackMutationPayload', success: boolean, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUser;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UpdateUserPayload', user?: { __typename?: 'User', id: string, optOutOfRewards: boolean, rewardsPhoneNumber?: { __typename?: 'PhoneNumber', id: string, digits?: string | null, state?: string | null } | null } | null, error?: { __typename?: 'OperationError', message: string, code: number, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null };

export type GetAppVersionPoliciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppVersionPoliciesQuery = { __typename?: 'Query', getAppVersionPolicies?: { __typename?: 'GetAppVersionPoliciesPayload', policies?: Array<{ __typename?: 'AppVersionPolicy', platform: string, minVersion: string, nextMinVersion?: string | null, nextMinVersionDate?: any | null, forceVersions?: Array<string> | null }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type UpdateAppVersionPolicyMutationVariables = Exact<{
  input: AppVersionPolicyInput;
}>;


export type UpdateAppVersionPolicyMutation = { __typename?: 'Mutation', updateAppVersionPolicy?: { __typename?: 'UpdateAppVersionPolicyPayload', policy?: { __typename?: 'AppVersionPolicy', platform: string, minVersion: string, nextMinVersion?: string | null, nextMinVersionDate?: any | null, forceVersions?: Array<string> | null } | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string } | { __typename?: 'OrderRequestErrorDetail', message: string }> | null } | null } | null };

export type CreateTempUserMutationVariables = Exact<{
  input: CreateTempUser;
}>;


export type CreateTempUserMutation = { __typename?: 'Mutation', createTempUser?: { __typename?: 'CreateTempUserPayload', tempUserId?: string | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string } | { __typename?: 'OrderRequestErrorDetail', message: string }> | null } | null } | null };

export type CreateVerificationRequestMutationVariables = Exact<{
  input: CreateVerificationRequest;
}>;


export type CreateVerificationRequestMutation = { __typename?: 'Mutation', createVerificationRequest?: { __typename?: 'CreateVerificationRequestPayload', success?: boolean | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string } | { __typename?: 'OrderRequestErrorDetail', message: string }> | null } | null } | null };

export type EnrollUserInAccountBuildingMutationVariables = Exact<{
  input: Array<AccountBuildingInput> | AccountBuildingInput;
}>;


export type EnrollUserInAccountBuildingMutation = { __typename?: 'Mutation', enrollUserInAccountBuilding?: { __typename?: 'EnrollUserInAccountBuildingPayload', error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string } | { __typename?: 'OrderRequestErrorDetail', message: string }> | null } | null } | null };

export type GetSignupConfigQueryVariables = Exact<{
  email: Scalars['EmailAddress']['input'];
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSignupConfigQuery = { __typename?: 'Query', getSignupConfig?: { __typename?: 'GetSignupConfigPayload', domain: string, present: boolean, providerName: string, initiationUrl?: string | null, error?: { __typename?: 'OperationError', code: number, message: string } | null, signupConfig: { __typename?: 'SignupConfig', defaultVerificationMethod: UserVerificationMethod, phoneRequired: boolean } } | null };

export type GetSubscribedAccountBuildingsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetSubscribedAccountBuildingsQuery = { __typename?: 'Query', getUser?: { __typename?: 'GetUserQueryPayload', user?: { __typename?: 'User', subscribedAccountBuildings: Array<{ __typename?: 'UserSubscribedAccountBuilding', account: { __typename?: 'AccountPublic', id: string, name: string }, building: { __typename?: 'Building', id: string, name: string, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, country?: string | null, state: string, zipCode: string } }, locations: Array<{ __typename?: 'Location', id: string, hideFromSearch: boolean }> }> } | null, error?: { __typename?: 'OperationError', message: string, code: number, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null };

export type SearchUserAccountBuildingsQueryVariables = Exact<{
  input: SearchUserAccountBuilding;
}>;


export type SearchUserAccountBuildingsQuery = { __typename?: 'Query', searchUserAccountBuildings?: { __typename?: 'SearchUserAccountBuildingsPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, accountBuildings?: Array<{ __typename?: 'AccountBuilding', account: { __typename?: 'AccountPublic', name: string, id: string }, building: { __typename?: 'Building', id: string, name: string, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, country?: string | null, state: string, zipCode: string } } }> | null } | null };

export type SubmitVerificationCodeMutationVariables = Exact<{
  input: SubmitVerificationCode;
}>;


export type SubmitVerificationCodeMutation = { __typename?: 'Mutation', submitVerificationCode?: { __typename?: 'SubmitVerificationCodePayload', nonce?: string | null, success?: boolean | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string } | { __typename?: 'OrderRequestErrorDetail', message: string }> | null } | null } | null };

export type UnenrollUserFromAccountBuildingMutationVariables = Exact<{
  input: Array<AccountBuildingInput> | AccountBuildingInput;
}>;


export type UnenrollUserFromAccountBuildingMutation = { __typename?: 'Mutation', unenrollUserFromAccountBuilding?: { __typename?: 'UnenrollUserFromAccountBuildingPayload', error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string } | { __typename?: 'OrderRequestErrorDetail', message: string }> | null } | null } | null };

export type CreateCardMutationVariables = Exact<{
  input: CreateCard;
}>;


export type CreateCardMutation = { __typename?: 'Mutation', data?: { __typename?: 'CreateCardPayload', card?: { __typename?: 'Card', id: string, cardholderName?: string | null, cardType?: CardIssuer | null, last4: number, expirationMonth: number, expirationYear: number, token: string, isDefault: boolean, nickname?: string | null } | null, error?: { __typename?: 'OperationError', message: string, code: number, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string } | { __typename?: 'OrderRequestErrorDetail', message: string }> | null } | null } | null };

export type CreateCardAsyncMutationVariables = Exact<{
  input: CreateCard;
}>;


export type CreateCardAsyncMutation = { __typename?: 'Mutation', createCardAsync?: { __typename?: 'CreateCardAsyncPayload', requestToken?: string | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string } | { __typename?: 'OrderRequestErrorDetail', message: string }> | null } | null } | null };

export type DeleteCardMutationVariables = Exact<{
  input: DeleteCard;
}>;


export type DeleteCardMutation = { __typename?: 'Mutation', data?: { __typename?: 'DeleteCardPayload', error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type GetCreateCardResultQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetCreateCardResultQuery = { __typename?: 'Query', getCreateCardResult?: { __typename?: 'GetCreateCardResultPayload', card?: { __typename?: 'Card', id: string, cardholderName?: string | null, cardType?: CardIssuer | null, last4: number, expirationMonth: number, expirationYear: number, token: string, isDefault: boolean, isDefaultDelivery: boolean, nickname?: string | null, imageUrl?: string | null } | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string } | { __typename?: 'OrderRequestErrorDetail', message: string }> | null } | null } | null };

export type GetGroupedUserCardsQueryVariables = Exact<{
  input: GetGroupedUserCardsQueryInput;
}>;


export type GetGroupedUserCardsQuery = { __typename?: 'Query', data?: { __typename?: 'GetGroupedUserCardsQueryPayload', totalGroupedCards: number, groupedUserCards?: Array<{ __typename?: 'GroupedUserCards', parentCardId: string, cards?: Array<{ __typename?: 'Card', cardholderName?: string | null, cardTypeHumanized?: string | null, last4: number, expirationMonth: number, expirationYear: number, nickname?: string | null, processor?: string | null, gatewayProfileUrl?: string | null, createdAt?: any | null, deletedAt?: any | null }> | null }> | null, error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type GetUserCardsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetUserCardsQuery = { __typename?: 'Query', data?: { __typename?: 'GetUserQueryPayload', user?: { __typename?: 'User', cards: Array<{ __typename?: 'Card', id: string, last4: number, cardholderName?: string | null, cardType?: CardIssuer | null, nickname?: string | null, expirationMonth: number, expirationYear: number, isDefault: boolean, isDefaultDelivery: boolean, imageUrl?: string | null, processor?: string | null }> } | null, error?: { __typename?: 'OperationError', message: string, code: number, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null };

export type ClearChatHistoryMutationVariables = Exact<{
  input: ClearChatHistory;
}>;


export type ClearChatHistoryMutation = { __typename?: 'Mutation', clearChatHistory?: { __typename?: 'ClearChatHistoryPayload', success?: boolean | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', codeAsString: string, message: string } | { __typename?: 'CreateUserAccountErrorDetail', codeAsString: string, message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', codeAsString: string, message: string } | { __typename?: 'MenuChangeRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestBlobErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestErrorDetail', codeAsString: string, message: string }> | null } | null } | null };

export type GetChatHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChatHistoryQuery = { __typename?: 'Query', getChatHistory?: { __typename?: 'GetChatHistoryPayload', history: { __typename?: 'ChatHistory', conversationId?: string | null, messages?: Array<{ __typename?: 'ChatMessage', role: string, content: string, messageId?: string | null, feedbackGiven?: string | null, sources?: Array<{ __typename?: 'ChatMessageSource', title: string, url: string }> | null }> | null }, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', codeAsString: string, message: string } | { __typename?: 'CreateUserAccountErrorDetail', codeAsString: string, message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', codeAsString: string, message: string } | { __typename?: 'MenuChangeRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestBlobErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestErrorDetail', codeAsString: string, message: string }> | null } | null } | null };

export type SendChatMessageMutationVariables = Exact<{
  input: SendChatMessage;
}>;


export type SendChatMessageMutation = { __typename?: 'Mutation', sendChatMessage?: { __typename?: 'SendChatMessagePayload', response?: { __typename?: 'ChatResponse', content: string, messageId: string, conversationId: string, sources?: Array<{ __typename?: 'ChatMessageSource', title: string, url: string }> | null } | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', codeAsString: string, message: string } | { __typename?: 'CreateUserAccountErrorDetail', codeAsString: string, message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', codeAsString: string, message: string } | { __typename?: 'MenuChangeRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestBlobErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestErrorDetail', codeAsString: string, message: string }> | null } | null } | null };

export type SubmitChatFeedbackMutationVariables = Exact<{
  input: SubmitChatFeedback;
}>;


export type SubmitChatFeedbackMutation = { __typename?: 'Mutation', submitChatFeedback?: { __typename?: 'SubmitChatFeedbackPayload', success?: boolean | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', codeAsString: string, message: string } | { __typename?: 'CreateUserAccountErrorDetail', codeAsString: string, message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', codeAsString: string, message: string } | { __typename?: 'MenuChangeRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestBlobErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestErrorDetail', codeAsString: string, message: string }> | null } | null } | null };

export type EffectiveConsentPreferenceQueryVariables = Exact<{ [key: string]: never; }>;


export type EffectiveConsentPreferenceQuery = { __typename?: 'Query', data?: { __typename?: 'EffectiveConsentPreferencePayload', preference?: { __typename?: 'ConsentPreferenceSnapshot', consentGivenAt: any, preferences: Array<{ __typename?: 'ConsentPurposePreference', purpose: string, value: ConsentPreferenceValue }> } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type RecordConsentPreferenceEventMutationVariables = Exact<{
  input: ConsentPreferenceEventInput;
}>;


export type RecordConsentPreferenceEventMutation = { __typename?: 'Mutation', data?: { __typename?: 'RecordConsentPreferenceEventPayload', eventId?: string | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type CreateCrossDockMutationVariables = Exact<{
  input: CreateCrossDock;
}>;


export type CreateCrossDockMutation = { __typename?: 'Mutation', data?: { __typename?: 'CreateCrossDockPayload', crossDock?: { __typename?: 'CrossDock', dropOffInstruction?: string | null, merchantId: string, name: string, phoneNumber: string, pickupInstruction?: string | null, status: CrossDockStatus, address: { __typename?: 'Address', address1: string, address2?: string | null, city: string, country?: string | null, state: string, zipCode: string }, markets?: Array<{ __typename?: 'Market', id: string }> | null } | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null };

export type GetCrossDocksQueryVariables = Exact<{
  marketId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetCrossDocksQuery = { __typename?: 'Query', data?: { __typename?: 'GetCrossDocksPayload', defaultCrossDockId?: string | null, crossDocks?: Array<{ __typename?: 'CrossDock', id: string, merchantId: string, name: string, phoneNumber: string, pickupInstruction?: string | null, dropOffInstruction?: string | null, status: CrossDockStatus, address: { __typename?: 'Address', address1: string, address2?: string | null, city: string, country?: string | null, id: string, state: string, zipCode: string }, markets?: Array<{ __typename?: 'Market', id: string, name: string }> | null }> | null, error?: { __typename?: 'OperationError', message: string, code: number, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null };

export type UpdateCrossDockMutationVariables = Exact<{
  input: UpdateCrossDock;
}>;


export type UpdateCrossDockMutation = { __typename?: 'Mutation', data?: { __typename?: 'UpdateCrossDockPayload', crossDock?: { __typename?: 'CrossDock', dropOffInstruction?: string | null, id: string, merchantId: string, name: string, phoneNumber: string, pickupInstruction?: string | null, status: CrossDockStatus, address: { __typename?: 'Address', address1: string, address2?: string | null, city: string, country?: string | null, state: string, zipCode: string }, markets?: Array<{ __typename?: 'Market', id: string }> | null } | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null };

export type CreateCustomInvoiceSettingsMutationVariables = Exact<{
  input: CustomInvoiceSettingsInput;
}>;


export type CreateCustomInvoiceSettingsMutation = { __typename?: 'Mutation', createCustomInvoiceSettings?: { __typename?: 'CreateCustomInvoiceSettingsPayload', settings?: { __typename?: 'CustomInvoiceSettings', id: string, name: string } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetCustomInvoiceAvailableProductsQueryVariables = Exact<{
  members: Array<CustomInvoiceSettingsMemberInput> | CustomInvoiceSettingsMemberInput;
}>;


export type GetCustomInvoiceAvailableProductsQuery = { __typename?: 'Query', getCustomInvoiceAvailableProducts?: { __typename?: 'GetCustomInvoiceAvailableProductsPayload', products?: Array<ProductEnum> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetCustomInvoiceOverlapsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  members: Array<CustomInvoiceSettingsMemberInput> | CustomInvoiceSettingsMemberInput;
  products: Array<ProductEnum> | ProductEnum;
}>;


export type GetCustomInvoiceOverlapsQuery = { __typename?: 'Query', getCustomInvoiceOverlaps?: { __typename?: 'GetCustomInvoiceOverlapsPayload', conflicts?: Array<{ __typename?: 'CustomInvoiceOverlap', id: string, name: string, accountIds: Array<number>, products: Array<ProductEnum>, memberIndexes: Array<number>, preExisting: boolean }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetCustomInvoiceSettingsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCustomInvoiceSettingsQuery = { __typename?: 'Query', getCustomInvoiceSettings?: { __typename?: 'GetCustomInvoiceSettingsPayload', totalCount?: number | null, settings?: Array<{ __typename?: 'CustomInvoiceSettings', id: string, name: string, description?: string | null, products: Array<ProductEnum>, updatedAt: any, updatedByName?: string | null, members: Array<{ __typename?: 'CustomInvoiceSettingsMember', id: string, memberType: CustomInvoiceMemberTypeEnum, displayName: string, inactive: boolean }>, splitAttributes: Array<{ __typename?: 'CustomInvoiceSplitAttribute', type: CustomInvoiceSplitAttributeTypeEnum, value?: string | null }> }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetCustomInvoiceSettingsByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCustomInvoiceSettingsByIdQuery = { __typename?: 'Query', getCustomInvoiceSettingsById?: { __typename?: 'GetCustomInvoiceSettingsByIdPayload', settings?: { __typename?: 'CustomInvoiceSettings', id: string, name: string, description?: string | null, products: Array<ProductEnum>, poFallback: string, poUpdatedByName?: string | null, poUpdatedAt?: any | null, createdByName?: string | null, createdAt: any, updatedByName?: string | null, updatedAt: any, members: Array<{ __typename?: 'CustomInvoiceSettingsMember', id: string, memberType: CustomInvoiceMemberTypeEnum, displayName: string, secondaryLine?: string | null, accountId?: string | null, locationId?: string | null, parentCompanyId?: string | null, inactive: boolean, poValue?: string | null, account?: { __typename?: 'AccountOption', id: string, parentCompany?: { __typename?: 'ParentCompanyOption', id: string } | null } | null }>, splitAttributes: Array<{ __typename?: 'CustomInvoiceSplitAttribute', type: CustomInvoiceSplitAttributeTypeEnum, value?: string | null }>, poRules: Array<{ __typename: 'CustomInvoicePoByDayAndFeeTypeRule', feeTypes: Array<CustomInvoicePoFeeTypeEnum>, dayGroups: Array<{ __typename?: 'CustomInvoicePoDayGroupWithFeeShare', days: Array<CustomInvoicePoDayEnum>, poValue?: string | null, feeShare: any }> } | { __typename: 'CustomInvoicePoByDayRule', dayGroups: Array<{ __typename?: 'CustomInvoicePoDayGroup', days: Array<CustomInvoicePoDayEnum>, poValue?: string | null }> }> } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetCustomInvoiceSplitAttributeCountsQueryVariables = Exact<{
  members: Array<CustomInvoiceSettingsMemberInput> | CustomInvoiceSettingsMemberInput;
  products: Array<ProductEnum> | ProductEnum;
}>;


export type GetCustomInvoiceSplitAttributeCountsQuery = { __typename?: 'Query', getCustomInvoiceSplitAttributeCounts?: { __typename?: 'GetCustomInvoiceSplitAttributeCountsPayload', counts?: Array<{ __typename?: 'CustomInvoiceSplitAttributeCount', attributeType: CustomInvoiceSplitAttributeTypeEnum, count?: number | null, quality: CustomInvoiceSplitAttributeCountQualityEnum, blankGroup: boolean }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type UpdateCustomInvoicePoSetupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CustomInvoicePoSetupInput;
}>;


export type UpdateCustomInvoicePoSetupMutation = { __typename?: 'Mutation', updateCustomInvoicePoSetup?: { __typename?: 'UpdateCustomInvoicePoSetupPayload', settings?: { __typename?: 'CustomInvoiceSettings', id: string } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type UpdateCustomInvoiceSettingsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CustomInvoiceSettingsInput;
}>;


export type UpdateCustomInvoiceSettingsMutation = { __typename?: 'Mutation', updateCustomInvoiceSettings?: { __typename?: 'UpdateCustomInvoiceSettingsPayload', settings?: { __typename?: 'CustomInvoiceSettings', id: string, name: string } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetDeliveryEventVendorQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDeliveryEventVendorQuery = { __typename?: 'Query', getDeliveryEventVendor?: { __typename?: 'GetDeliveryEventVendorPayload', deliveryEventVendor?: { __typename?: 'SelectEventVendor', crossDockId?: string | null, id: string, menuTemplateId: string, status: string, vendorId: string } | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', codeAsString: string, message: string } | { __typename?: 'CreateUserAccountErrorDetail', codeAsString: string, message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', codeAsString: string, message: string } | { __typename?: 'MenuChangeRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestBlobErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestErrorDetail', codeAsString: string, message: string }> | null } | null } | null };

export type GetDeliveryOrderItemsTotalCostByEventVendorQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDeliveryOrderItemsTotalCostByEventVendorQuery = { __typename?: 'Query', getDeliveryOrderItemsTotalCostByEventVendor?: { __typename?: 'GetDeliveryOrderItemsTotalCostByEventVendorPayload', error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', codeAsString: string, message: string } | { __typename?: 'CreateUserAccountErrorDetail', codeAsString: string, message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', codeAsString: string, message: string } | { __typename?: 'MenuChangeRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestBlobErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestErrorDetail', codeAsString: string, message: string }> | null } | null, deliveryEventVendor?: { __typename?: 'SelectEventVendorWithOrderItemsTotal', id: string, deliveryOrdersCount: number } | null } | null };

export type GetDeliveryVendorMenuTemplatesQueryVariables = Exact<{
  input: GetDeliveryVendorMenuTemplates;
}>;


export type GetDeliveryVendorMenuTemplatesQuery = { __typename?: 'Query', getDeliveryVendorMenuTemplates?: { __typename?: 'GetDeliveryVendorMenuTemplatesPayload', deliveryMenuTemplates?: Array<{ __typename?: 'MenuTemplate', id: string, name: string }> | null, error?: { __typename?: 'OperationError', message: string } | null } | null };

export type GetSelectEventCrossDocksQueryVariables = Exact<{
  marketId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
}>;


export type GetSelectEventCrossDocksQuery = { __typename?: 'Query', getCrossDocks?: { __typename?: 'GetCrossDocksPayload', crossDocks?: Array<{ __typename?: 'CrossDock', id: string, name: string }> | null, error?: { __typename?: 'OperationError', message: string, code: number, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null };

export type UpdateSelectEventVendorMutationVariables = Exact<{
  input: UpdateSelectEventVendor;
}>;


export type UpdateSelectEventVendorMutation = { __typename?: 'Mutation', updateSelectEventVendor?: { __typename?: 'UpdateSelectEventVendorPayload', selectEventVendor?: { __typename?: 'SelectEventVendor', id: string } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type CreateDeliveryVendorMarketCapacityMutationVariables = Exact<{
  input: CreateDeliveryVendorMarketCapacity;
}>;


export type CreateDeliveryVendorMarketCapacityMutation = { __typename?: 'Mutation', createDeliveryVendorMarketCapacity?: { __typename?: 'CreateDeliveryVendorMarketCapacityPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, marketManifestCapacity?: { __typename?: 'MarketManifestCapacity', id?: string | null, capacity: number, time: string, marketManifestTimeId?: string | null, market: string, vendorConstraintId?: string | null, valid: boolean } | null } | null };

export type DeleteDeliveryVendorMarketCapacityMutationVariables = Exact<{
  input: Scalars['ID']['input'];
}>;


export type DeleteDeliveryVendorMarketCapacityMutation = { __typename?: 'Mutation', deleteDeliveryVendorMarketCapacity?: { __typename?: 'DeleteDeliveryVendorMarketCapacityPayload', result?: boolean | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetDeliverySchedulingConstraintsQueryVariables = Exact<{
  input: GetDeliverySchedulingConstraint;
}>;


export type GetDeliverySchedulingConstraintsQuery = { __typename?: 'Query', data?: { __typename?: 'GetDeliverySchedulingConstraintsPayload', constraints?: Array<{ __typename?: 'DeliverySchedulingConstraint', id: string, markets: Array<string>, minManifestPerMonth: number, vendorId: string, vendor: string, marketManifestTime: { __typename?: 'MarketManifestTimeCapacity', breakfast?: Array<{ __typename?: 'MarketManifestCapacity', capacity: number, id?: string | null, market: string, marketManifestTimeId?: string | null, vendorConstraintId?: string | null, time: string, valid: boolean }> | null, lunch?: Array<{ __typename?: 'MarketManifestCapacity', capacity: number, id?: string | null, market: string, marketManifestTimeId?: string | null, vendorConstraintId?: string | null, time: string, valid: boolean }> | null, dinner?: Array<{ __typename?: 'MarketManifestCapacity', capacity: number, id?: string | null, market: string, marketManifestTimeId?: string | null, vendorConstraintId?: string | null, time: string, valid: boolean }> | null } }> | null, error?: { __typename?: 'OperationError', message: string, code: number, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null };

export type UpdateDeliverySchedulingConstraintMutationVariables = Exact<{
  input: UpdateDeliverySchedulingConstraint;
}>;


export type UpdateDeliverySchedulingConstraintMutation = { __typename?: 'Mutation', updateDeliverySchedulingConstraint?: { __typename?: 'UpdateDeliverySchedulingConstraintPayload', result?: boolean | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type UpdateDeliveryVendorMarketCapacityMutationVariables = Exact<{
  input: UpdateDeliveryVendorMarketCapacity;
}>;


export type UpdateDeliveryVendorMarketCapacityMutation = { __typename?: 'Mutation', updateDeliveryVendorMarketCapacity?: { __typename?: 'UpdateDeliveryVendorMarketCapacityPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, marketManifestCapacity?: { __typename?: 'MarketManifestCapacity', id?: string | null, capacity: number, time: string, marketManifestTimeId?: string | null, market: string, vendorConstraintId?: string | null, valid: boolean } | null } | null };

export type CreateStripeAccountMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateStripeAccountMutation = { __typename?: 'Mutation', data?: { __typename?: 'CreateStripeAccountPayload', stripeAccount?: { __typename?: 'FoodaCardStripeAccount', id: string, name: string, stripeAccountId: string, state: string } | null, error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type GetFoodaCardMembershipQueryVariables = Exact<{
  membershipId: Scalars['ID']['input'];
}>;


export type GetFoodaCardMembershipQuery = { __typename?: 'Query', getFoodaCardMembership?: { __typename?: 'GetFoodaCardMembershipPayload', foodaCardMembership?: { __typename?: 'FoodaCardMembership', id: string, status: FoodaCardMembershipStatusEnum, needsSetup: boolean, stripeCardholderPastDueRequirements?: Array<StripeCardholderRequirementEnum> | null, stripeCardholderDisabledReason?: StripeCardholderDisabledReasonEnum | null, stripeBillingAddress?: { __typename?: 'BillingAddress', address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: string | null } | null, subsidyRule: { __typename?: 'SubsidyRule', id: string, name: string, timeZone: SubsidyTimezone, timeZoneLabel: string } } | null, error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type GetFoodaCardOutstandingBalancesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFoodaCardOutstandingBalancesQuery = { __typename?: 'Query', getFoodaCardOutstandingBalances?: { __typename?: 'GetFoodaCardOutstandingBalancesPayload', balances?: Array<{ __typename?: 'FoodaCardOutstandingBalance', foodaCardMembershipId: string, amountCents: number, lastFailedAt?: any | null }> | null, error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type GetStripeAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStripeAccountsQuery = { __typename?: 'Query', stripeAccounts?: { __typename?: 'GetStripeAccountsPayload', stripeAccounts: Array<{ __typename?: 'FoodaCardStripeAccount', id: string, name: string, stripeAccountId: string, state: string, subsidyRules: Array<{ __typename?: 'SubsidyRule', id: string, name: string, account: { __typename?: 'AccountPublic', id: string, name: string } }> }>, error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type GetStripeCardEphemeralKeyQueryVariables = Exact<{
  stripeCardId: Scalars['ID']['input'];
  nonce: Scalars['String']['input'];
}>;


export type GetStripeCardEphemeralKeyQuery = { __typename?: 'Query', getStripeCardEphemeralKey?: { __typename?: 'GetStripeCardEphemeralKeyPayload', ephemeralKey?: string | null, error?: { __typename?: 'OperationError', message: string } | null } | null };

export type UpdateFoodaCardMembershipBackupCardMutationVariables = Exact<{
  input: UpdateFoodaCardMembershipBackupCard;
}>;


export type UpdateFoodaCardMembershipBackupCardMutation = { __typename?: 'Mutation', updateFoodaCardMembershipBackupCard?: { __typename?: 'UpdateFoodaCardMembershipBackupCardPayload', foodaCardMembership?: { __typename?: 'FoodaCardMembership', id: string, status: FoodaCardMembershipStatusEnum, needsSetup: boolean, backupCard?: { __typename?: 'Card', id: string, last4: number } | null } | null, error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type UpdateFoodaCardMembershipRequirementsMutationVariables = Exact<{
  input: UpdateFoodaCardMembershipRequirements;
}>;


export type UpdateFoodaCardMembershipRequirementsMutation = { __typename?: 'Mutation', updateFoodaCardMembershipRequirements?: { __typename?: 'UpdateFoodaCardMembershipRequirementsPayload', foodaCardMembership?: { __typename?: 'FoodaCardMembership', id: string, needsSetup: boolean, stripeBillingAddress?: { __typename?: 'BillingAddress', address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: string | null } | null } | null, error?: { __typename?: 'OperationError', message: string } | null } | null };

export type CreateReportConfigurationMutationVariables = Exact<{
  input: CreateReportConfigurationInput;
}>;


export type CreateReportConfigurationMutation = { __typename?: 'Mutation', createReportConfiguration?: { __typename?: 'CreateReportConfigurationQueryPayload', error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type DeleteReportConfigurationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteReportConfigurationMutation = { __typename?: 'Mutation', deleteReportConfiguration?: { __typename?: 'DeleteReportConfigurationQueryPayload', error?: { __typename?: 'OperationError', message: string, code: number, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string } | { __typename?: 'OrderRequestErrorDetail', message: string }> | null } | null } | null };

export type GetFfbRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFfbRolesQuery = { __typename?: 'Query', getReportsConfigurations?: { __typename?: 'GetReportsConfigurationsQueryPayload', allRequirableRoles?: Array<string> | null } | null };

export type GetFfrRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFfrRolesQuery = { __typename?: 'Query', getReportsConfigurations?: { __typename?: 'GetReportsConfigurationsQueryPayload', allRequirableRoles?: Array<string> | null } | null };

export type GetReportsConfigurationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportsConfigurationsQuery = { __typename?: 'Query', getReportsConfigurations?: { __typename?: 'GetReportsConfigurationsQueryPayload', reportsConfigurations?: Array<{ __typename?: 'ReportConfigurations', headline: string, iconName: string, id: string, reportType?: ReportConfigurationTypeEnum | null, active: boolean, position: number, menuTitle: string, subtitle: string, tableauDesktopUrl: string, tableauMobileUrl: string, requiredRoles?: Array<string> | null, terms?: Array<{ __typename?: 'TermsWithDescription', description: string, term: string }> | null }> | null } | null };

export type ReorderReportConfigurationMutationVariables = Exact<{
  input: UpdateReportsConfigurationsOrderQueryInput;
}>;


export type ReorderReportConfigurationMutation = { __typename?: 'Mutation', updateReportsConfigurationsOrder?: { __typename?: 'UpdateReportsConfigurationsOrderQueryPayload', error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type UpdateReportConfigurationMutationVariables = Exact<{
  input: UpdateReportConfigurationInput;
}>;


export type UpdateReportConfigurationMutation = { __typename?: 'Mutation', updateReportConfiguration?: { __typename?: 'UpdateReportConfigurationQueryPayload', error?: { __typename?: 'OperationError', message: string, code: number, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string } | { __typename?: 'OrderRequestErrorDetail', message: string }> | null } | null } | null };

export type GetLocationsForAccountQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetLocationsForAccountQuery = { __typename?: 'Query', getLocationsForAccount?: { __typename?: 'GetLocationsForAccountPayload', locations?: Array<{ __typename?: 'LocationOption', id: string, name: string, secondaryLine?: string | null }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type CreateMarketMutationVariables = Exact<{
  input: CreateMarket;
}>;


export type CreateMarketMutation = { __typename?: 'Mutation', createMarket?: { __typename?: 'CreateMarketPayload', error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type GetCrossDocksForSelectQueryVariables = Exact<{
  marketId: Scalars['ID']['input'];
}>;


export type GetCrossDocksForSelectQuery = { __typename?: 'Query', getCrossDocks?: { __typename?: 'GetCrossDocksPayload', defaultCrossDockId?: string | null, crossDocks?: Array<{ __typename?: 'CrossDock', id: string, name: string }> | null, error?: { __typename?: 'OperationError', message: string } | null } | null };

export type GetMarketQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMarketQuery = { __typename?: 'Query', getMarket?: { __typename?: 'GetMarketPayload', market?: { __typename?: 'Market', name: string, active: boolean, accountingMarketName?: string | null, address1?: string | null, address2?: string | null, city?: string | null, defaultAccountantId: string, defaultTaxRate: number, defaultTaxRemitter: TaxRemitter, defaultOperationEmail: string, checkAverage?: number | null, directorId?: string | null, displayCommission: boolean, defaultCrossDockId?: string | null, marketCohortName?: string | null, officeDefaultEmail?: string | null, officeDefaultSms?: string | null, officeDefaultFax?: string | null, officeDefaultPhone?: string | null, popupSupportPhoneNumber?: string | null, deliverySupportPhoneNumber?: string | null, state?: string | null, zipCodes?: Array<string> | null, vendorId?: string | null, deliveryDocks?: Array<{ __typename?: 'CrossDock', name: string }> | null, healthDepartmentJurisdictions?: Array<{ __typename?: 'HealthDepartmentJurisdiction', id: string, name: string }> | null, marketManifestTime?: { __typename?: 'MarketManifestTime', breakfast?: Array<string> | null, dinner?: Array<string> | null, lunch?: Array<string> | null } | null } | null, error?: { __typename?: 'OperationError', code: number } | null } | null };

export type GetMarketFormQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMarketFormQuery = { __typename?: 'Query', getAccountingMarkets?: { __typename?: 'GetMarketNamesPayload', markets?: Array<string> | null } | null, getCohortMarkets?: { __typename?: 'GetMarketNamesPayload', markets?: Array<string> | null } | null, getAccountants?: { __typename?: 'GetUsersPayload', users?: Array<{ __typename?: 'User', id: string, fullName?: string | null }> | null } | null };

export type GetMarketsListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMarketsListQuery = { __typename?: 'Query', data?: { __typename?: 'GetMarketsListPayload', markets?: Array<{ __typename?: 'Market', id: string, name: string }> | null, error?: { __typename?: 'OperationError', message: string, code: number, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null };

export type UpdateMarketMutationVariables = Exact<{
  input: UpdateMarket;
}>;


export type UpdateMarketMutation = { __typename?: 'Mutation', updateMarket?: { __typename?: 'UpdateMarketPayload', error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type GetParentCompaniesQueryVariables = Exact<{
  searchInfo?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetParentCompaniesQuery = { __typename?: 'Query', getParentCompanies?: { __typename?: 'GetParentCompaniesPayload', parentCompanies?: Array<{ __typename?: 'ParentCompanyOption', id: string, displayName: string }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type ArchiveRecommendationsModelMutationVariables = Exact<{
  modelId: Scalars['ID']['input'];
}>;


export type ArchiveRecommendationsModelMutation = { __typename?: 'Mutation', archiveRecommendationsModel?: { __typename?: 'ArchiveRecommendationsModelPayload', modelConfig?: { __typename?: 'ModelConfig', id: string, name: string, version: string, status: string } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type CreateRecommendationsLimitsGroupMutationVariables = Exact<{
  input: CreateLimitsGroup;
}>;


export type CreateRecommendationsLimitsGroupMutation = { __typename?: 'Mutation', createRecommendationsLimitsGroup?: { __typename?: 'CreateRecommendationsLimitsGroupPayload', limitsGroup?: { __typename?: 'LimitsGroup', id: string, name: string, maxSessionCostCents?: number | null, maxDailyCostCents?: number | null, maxMonthlyCostCents?: number | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type CreateRecommendationsModelVersionMutationVariables = Exact<{
  input: CreateModelVersionInput;
}>;


export type CreateRecommendationsModelVersionMutation = { __typename?: 'Mutation', createRecommendationsModelVersion?: { __typename?: 'CreateRecommendationsModelVersionPayload', modelConfig?: { __typename?: 'ModelConfig', id: string, name: string, version: string, status: string, modelType: string, task: RecommendationRequestTypes, primary: boolean, createdAt: any, updatedAt: any, promptConfig?: { __typename?: 'PromptConfig', masterTemplate: string, variablesJson: string, modelParamsJson?: string | null, hasVariables: boolean } | null } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetActiveBacktestQueryVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type GetActiveBacktestQuery = { __typename?: 'Query', getActiveBacktest?: { __typename?: 'GetActiveBacktestPayload', backtestId?: string | null, error?: { __typename?: 'OperationError', message: string } | null } | null };

export type GetRecommendationsAvailableResolversQueryVariables = Exact<{
  taskType?: InputMaybe<RecommendationRequestTypes>;
}>;


export type GetRecommendationsAvailableResolversQuery = { __typename?: 'Query', getRecommendationsAvailableResolvers?: { __typename?: 'GetRecommendationsAvailableResolversPayload', resolvers: Array<{ __typename?: 'ResolverMetadata', className: string, displayName: string, description: string, paramsSchema: any, supportsNesting: boolean, example: any }>, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetBacktestQueryVariables = Exact<{
  backtestId: Scalars['String']['input'];
}>;


export type GetBacktestQuery = { __typename?: 'Query', getBacktest?: { __typename?: 'GetBacktestPayload', getBacktest?: { __typename?: 'GetBacktest', backtestId: string, status: string, totalCases: number, completedCases: number, failedCases: number, results: Array<{ __typename?: 'BacktestResult', testCaseIndex: number, userId: string, status: string, errorMessage?: string | null, baseData?: { __typename?: 'BacktestBaseData', cost?: number | null, durationMs?: number | null, promptTokens?: number | null, completionTokens?: number | null, totalTokens?: number | null, triggerPriceCents?: number | null, triggerTags?: Array<string> | null, recommendations: Array<{ __typename?: 'BacktestRecommendation', name: string, reasoning?: string | null, tags: Array<string>, hitType?: string | null }> } | null, evaluation?: { __typename?: 'BacktestEvaluation', directHits?: number | null, directTotal?: number | null, futureHits?: number | null, futureTotal?: number | null, tagMatches?: number | null, tagTotal?: number | null, dietaryAligned?: boolean | null, priceAlignmentPct?: number | null } | null, metadata: { __typename?: 'BacktestMetadata', eventId?: string | null, eventType?: string | null, targetDate?: string | null, vendorId?: string | null, itemsOrdered?: number | null, historySize?: number | null, groundTruth?: string | null, futureOrders?: string | null, remainingCartItems?: string | null, triggerItem?: string | null } }>, aggregates?: { __typename?: 'BacktestAggregates', directMatchRate?: number | null, futureMatchRate?: number | null, hitRate?: number | null, nearMissRate?: number | null, dietaryViolationRate?: number | null, avgPriceAlignmentPct?: number | null, totalCost?: number | null, totalDurationMs?: number | null, passedCount?: number | null, failedCount?: number | null } | null } | null, error?: { __typename?: 'OperationError', message: string } | null } | null };

export type GetRecommendationsEntryPointsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecommendationsEntryPointsQuery = { __typename?: 'Query', getRecommendationsEntryPoints?: { __typename?: 'GetRecommendationsEntryPointsPayload', entryPoints?: Array<{ __typename?: 'EntryPoint', id: string, name: string, description: string, bucketConfigurations: Array<{ __typename?: 'BucketConfiguration', id: string, bucketName: string, recommendationModelName: string, recommendationModelVersion: string, allocationPercentage: number, priority: number, active: boolean, entryPointId: string }> }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetLimitsGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLimitsGroupsQuery = { __typename?: 'Query', getLimitsGroups?: { __typename?: 'GetLimitsGroupsPayload', limitsGroups?: Array<{ __typename?: 'LimitsGroup', id: string, name: string, maxSessionCostCents?: number | null, maxDailyCostCents?: number | null, maxMonthlyCostCents?: number | null, createdAt: any, updatedAt: any, deletedAt?: any | null }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetRecommendationsModelConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecommendationsModelConfigsQuery = { __typename?: 'Query', getRecommendationsModelConfigs?: { __typename?: 'GetRecommendationsModelConfigsPayload', modelConfigs?: Array<{ __typename?: 'ModelConfig', id: string, name: string, version: string, modelType: string, task: RecommendationRequestTypes, primary: boolean, status: string, createdAt: any, updatedAt: any, baseVersionId?: string | null, promptConfig?: { __typename?: 'PromptConfig', masterTemplate: string, variablesJson: string, modelParamsJson?: string | null, hasVariables: boolean } | null, baseVersion?: { __typename?: 'ModelConfig', id: string, version: string } | null, versionAncestry: Array<{ __typename?: 'ModelConfig', id: string, version: string, promptConfig?: { __typename?: 'PromptConfig', masterTemplate: string, variablesJson: string, modelParamsJson?: string | null } | null }> }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetRecommendationsModelMetricsQueryVariables = Exact<{
  modelId: Scalars['ID']['input'];
}>;


export type GetRecommendationsModelMetricsQuery = { __typename?: 'Query', getRecommendationsModelMetrics?: { __typename?: 'GetRecommendationsModelMetricsPayload', metrics?: { __typename?: 'ModelMetrics', modelId: string, totalRequests: number, totalShown: number, totalClicked: number, totalPurchased: number, totalDismissed: number, clickThroughRate: number, conversionRate: number, last24hRequests: number, last7dRequests: number } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetRecommendationsModelMetricsBatchQueryVariables = Exact<{
  modelIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetRecommendationsModelMetricsBatchQuery = { __typename?: 'Query', getRecommendationsModelMetricsBatch?: { __typename?: 'GetRecommendationsModelMetricsBatchPayload', metrics?: Array<{ __typename?: 'ModelMetrics', modelId: string, totalRequests: number, totalShown: number, totalClicked: number, totalPurchased: number, totalDismissed: number, clickThroughRate: number, conversionRate: number, last24hRequests: number, last7dRequests: number }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetRecommendationModelVersionHistoryQueryVariables = Exact<{
  modelId: Scalars['ID']['input'];
}>;


export type GetRecommendationModelVersionHistoryQuery = { __typename?: 'Query', getRecommendationModelVersionHistory?: { __typename?: 'GetRecommendationModelVersionHistoryPayload', versionHistory: Array<{ __typename?: 'VersionHistoryEntry', id: string, modelId: string, version: string, status: string, masterTemplate: string, createdBy: string, createdAt: any, changeNotes?: string | null, baseVersionId?: string | null, baseVersion?: { __typename?: 'VersionHistoryEntry', id: string, version: string } | null, versionAncestry: Array<{ __typename?: 'VersionHistoryEntry', id: string, version: string, changeNotes?: string | null, masterTemplate: string }> }> } | null };

export type GetRecommendationsCustomPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecommendationsCustomPreferencesQuery = { __typename?: 'Query', getRecommendationsCustomPreferences?: { __typename?: 'GetRecommendationsCustomPreferencesPayload', preferencesVersion?: string | null, tagGroups?: Array<{ __typename?: 'TagGroup', id: string, name: string, iconName?: string | null, tags: Array<{ __typename?: 'KeyValuePair', key: string, value: string }> }> | null, preferences?: Array<{ __typename?: 'CustomPreference', name: string, tag: InventoryItemExternalTags, weight: number }> | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null };

export type GetRecommendationsDetailedFeedbackQueryVariables = Exact<{
  modelId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  taskFilter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRecommendationsDetailedFeedbackQuery = { __typename?: 'Query', getRecommendationsDetailedFeedback?: { __typename?: 'GetRecommendationsDetailedFeedbackPayload', detailedFeedback?: { __typename?: 'DetailedFeedback', modelId: string, totalInteractions: number, timeSeriesData: Array<{ __typename?: 'TimeSeriesDataPoint', timestamp: any, shownCount: number, clickedCount: number, purchasedCount: number, dismissedCount: number, clickThroughRate: number, conversionRate: number }>, actionBreakdown: Array<{ __typename?: 'ActionBreakdown', action: string, count: number, percentage: number }> } | null } | null };

export type GetRecommendationsPreviewPromptQueryVariables = Exact<{
  promptConfig: PromptConfigInput;
  context: PromptContextInput;
}>;


export type GetRecommendationsPreviewPromptQuery = { __typename?: 'Query', getRecommendationsPreviewPrompt?: { __typename?: 'GetRecommendationsPreviewPromptPayload', previewText: string, profileJson?: string | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetRecommendationsTagGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecommendationsTagGroupsQuery = { __typename?: 'Query', getRecommendationsTagGroups?: { __typename?: 'GetRecommendationsTagGroupsPayload', staleTags?: Array<string> | null, tagGroups?: Array<{ __typename?: 'TagGroup', id: string, name: string, iconName?: string | null, tags: Array<{ __typename?: 'KeyValuePair', key: string, value: string }> }> | null, availableTags?: Array<{ __typename?: 'KeyValuePair', key: string, value: string }> | null, versions?: Array<{ __typename?: 'TagGroupVersion', id: string, createdAt: any, createdBy: string, groupsCount: number, tagsCount: number }> | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null };

export type ListBacktestRunsQueryVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type ListBacktestRunsQuery = { __typename?: 'Query', listBacktestRuns?: { __typename?: 'ListBacktestRunsPayload', runs?: Array<{ __typename?: 'BacktestRunSummary', id: number, backtestId: string, status: string, evaluatorType?: string | null, task?: RecommendationRequestTypes | null, totalCases: number, completedCases: number, failedCases: number, directMatchRate?: number | null, futureMatchRate?: number | null, avgPriceAlignmentPct?: number | null, createdAt: any }> | null, error?: { __typename?: 'OperationError', message: string } | null } | null };

export type PublishRecommendationsModelMutationVariables = Exact<{
  modelId: Scalars['ID']['input'];
  bucketConfigurationIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PublishRecommendationsModelMutation = { __typename?: 'Mutation', publishRecommendationsModel?: { __typename?: 'PublishRecommendationsModelPayload', modelConfig?: { __typename?: 'ModelConfig', id: string, name: string, version: string, status: string } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type RerunBacktestCasesMutationVariables = Exact<{
  input: RerunBacktestCasesInput;
}>;


export type RerunBacktestCasesMutation = { __typename?: 'Mutation', rerunBacktestCases?: { __typename?: 'RerunBacktestCasesPayload', backtestId?: string | null, error?: { __typename?: 'OperationError', message: string } | null } | null };

export type RestoreRecommendationsTagGroupsVersionMutationVariables = Exact<{
  versionId: Scalars['ID']['input'];
}>;


export type RestoreRecommendationsTagGroupsVersionMutation = { __typename?: 'Mutation', restoreRecommendationsTagGroupsVersion?: { __typename?: 'RestoreRecommendationsTagGroupsVersionPayload', tagGroups?: Array<{ __typename?: 'TagGroup', id: string }> | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null };

export type StartBacktestDiscoveryMutationVariables = Exact<{
  input: StartBacktestDiscoveryInput;
}>;


export type StartBacktestDiscoveryMutation = { __typename?: 'Mutation', startBacktestDiscovery?: { __typename?: 'StartBacktestDiscoveryPayload', discovery?: { __typename?: 'DiscoveryResult', backtestId: string, eligibleUserCount: number, selectedCount: number, ineligibleUsers: Array<{ __typename?: 'IneligibleUser', userId: string, reason: string }>, perUser: Array<{ __typename?: 'UserPreview', userId: string, totalOrders: number, selectedCount: number, testCases: Array<{ __typename?: 'TestCasePreview', index: number, eventId: string, eventType: string, targetDate: string, itemsOrdered: number, historySize: number }> }> } | null, error?: { __typename?: 'OperationError', message: string } | null } | null };

export type StartBacktestRunMutationVariables = Exact<{
  input: StartBacktestRunInput;
}>;


export type StartBacktestRunMutation = { __typename?: 'Mutation', startBacktestRun?: { __typename?: 'StartBacktestRunPayload', backtestId?: string | null, error?: { __typename?: 'OperationError', message: string } | null } | null };

export type TestRecommendationsPromptMutationVariables = Exact<{
  promptConfig: PromptConfigInput;
  context: PromptContextInput;
}>;


export type TestRecommendationsPromptMutation = { __typename?: 'Mutation', testRecommendationsPrompt?: { __typename?: 'TestRecommendationsPromptPayload', testResult?: { __typename?: 'TestPromptResult', success: boolean, errorMessage?: string | null, responseJson?: string | null, modelUsed?: string | null, durationMs?: number | null, promptTokens?: number | null, completionTokens?: number | null, totalTokens?: number | null, cachedTokens?: number | null, reasoningTokens?: number | null, costCents?: number | null } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type UpdateRecommendationsLimitsGroupMutationVariables = Exact<{
  input: UpdateLimitsGroup;
}>;


export type UpdateRecommendationsLimitsGroupMutation = { __typename?: 'Mutation', updateRecommendationsLimitsGroup?: { __typename?: 'UpdateRecommendationsLimitsGroupPayload', limitsGroup?: { __typename?: 'LimitsGroup', id: string, name: string, maxSessionCostCents?: number | null, maxDailyCostCents?: number | null, maxMonthlyCostCents?: number | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type UpdateRecommendationsModelConfigMutationVariables = Exact<{
  input: UpdateModelConfig;
}>;


export type UpdateRecommendationsModelConfigMutation = { __typename?: 'Mutation', updateRecommendationsModelConfig?: { __typename?: 'UpdateRecommendationsModelConfigPayload', modelConfig?: { __typename?: 'ModelConfig', id: string, name: string, version: string, modelType: string, task: RecommendationRequestTypes, primary: boolean, createdAt: any, updatedAt: any, promptConfig?: { __typename?: 'PromptConfig', masterTemplate: string, variablesJson: string, modelParamsJson?: string | null, hasVariables: boolean } | null } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type UpdateRecommendationsCustomPreferencesMutationVariables = Exact<{
  preferences: Array<RecommendationsCustomPreferenceInput> | RecommendationsCustomPreferenceInput;
}>;


export type UpdateRecommendationsCustomPreferencesMutation = { __typename?: 'Mutation', updateRecommendationsCustomPreferences?: { __typename?: 'UpdateRecommendationsCustomPreferencesPayload', preferencesVersion?: string | null, preferences?: Array<{ __typename?: 'CustomPreference', name: string, tag: InventoryItemExternalTags, weight: number }> | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null };

export type UpdateRecommendationsTagGroupsMutationVariables = Exact<{
  groups: Array<RecommendationsTagGroupInput> | RecommendationsTagGroupInput;
}>;


export type UpdateRecommendationsTagGroupsMutation = { __typename?: 'Mutation', updateRecommendationsTagGroups?: { __typename?: 'UpdateRecommendationsTagGroupsPayload', tagGroups?: Array<{ __typename?: 'TagGroup', id: string }> | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null };

export type GetScoringEventTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetScoringEventTypesQuery = { __typename?: 'Query', getScoringEventTypes?: { __typename?: 'GetScoringEventTypesPayload', error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', codeAsString: string, message: string } | { __typename?: 'CreateUserAccountErrorDetail', codeAsString: string, message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', codeAsString: string, message: string } | { __typename?: 'MenuChangeRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestBlobErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestErrorDetail', codeAsString: string, message: string }> | null } | null, scoringEventTypes?: Array<{ __typename?: 'ScoringEventTypeDefinition', id: string, code: string, description: string, slope: any, weight: any }> | null } | null };

export type UpdateScoringEventTypesMutationVariables = Exact<{
  input: UpdateScoringEventTypes;
}>;


export type UpdateScoringEventTypesMutation = { __typename?: 'Mutation', updateScoringEventTypes?: { __typename?: 'UpdateScoringEventTypesPayload', error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', codeAsString: string, message: string } | { __typename?: 'CreateUserAccountErrorDetail', codeAsString: string, message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', codeAsString: string, message: string } | { __typename?: 'MenuChangeRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestBlobErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestErrorDetail', codeAsString: string, message: string }> | null } | null, scoringEventTypes?: Array<{ __typename?: 'ScoringEventTypeDefinition', id: string, code: string, description: string, slope: any, weight: any }> | null } | null };

export type SearchQueryVariables = Exact<{
  input: SearchInput;
}>;


export type SearchQuery = { __typename?: 'Query', search?: { __typename?: 'SearchQueryPayload', result?: { __typename?: 'SearchResult', accounts?: Array<{ __typename?: 'SearchResultItem', id: string, title?: string | null, status?: string | null, url?: string | null, description?: string | null }> | null, vendors?: Array<{ __typename?: 'SearchResultItem', id: string, title?: string | null, status?: string | null, url?: string | null, description?: string | null }> | null, events?: Array<{ __typename?: 'SearchResultItem', id: string, title?: string | null, status?: string | null, url?: string | null, description?: string | null }> | null, popupEvents?: Array<{ __typename?: 'SearchResultItem', id: string, title?: string | null, status?: string | null, url?: string | null, description?: string | null }> | null, selectEvents?: Array<{ __typename?: 'SearchResultItem', id: string, title?: string | null, status?: string | null, url?: string | null, description?: string | null }> | null, invoices?: Array<{ __typename?: 'SearchResultItem', id: string, title?: string | null, status?: string | null, url?: string | null, description?: string | null }> | null, consolidatedInvoices?: Array<{ __typename?: 'SearchResultItem', id: string, title?: string | null, status?: string | null, url?: string | null, description?: string | null }> | null, partners?: Array<{ __typename?: 'SearchResultItem', id: string, title?: string | null, status?: string | null, url?: string | null, description?: string | null }> | null } | null } | null };

export type GetShadowQueryVariables = Exact<{
  input: GetShadowInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetShadowQuery = { __typename?: 'Query', getShadow?: { __typename?: 'GetShadowPayload', error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', codeAsString: string, message: string } | { __typename?: 'CreateUserAccountErrorDetail', codeAsString: string, message: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', codeAsString: string, message: string } | { __typename?: 'MenuChangeRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestBlobErrorDetail', codeAsString: string, message: string } | { __typename?: 'OrderRequestErrorDetail', codeAsString: string, message: string }> | null } | null, shadow?: { __typename?: 'Shadow', id: string, score?: any | null, scoredAt?: any | null, falsePositiveState: ShadowFalsePositiveModeEnum, falsePositiveCutoffAt?: any | null, shadowActions: { __typename?: 'ShadowActionConnection', totalCount: number, nodes?: Array<{ __typename?: 'ShadowAction', id: string, action: string, actedAt: any, metadata: any, createdAt: any, actor?: { __typename?: 'ShadowActionActor', id?: string | null, fullName?: string | null, email?: string | null } | null } | null> | null }, shadowScoringEvents?: { __typename?: 'ScoringEventConnection', totalCount: number, currentPage: number, nodes?: Array<{ __typename?: 'ScoringEvent', id: string, shadowId: string, eventTypeCode: string, eventTypeName: string, correlationId?: string | null, metadata?: string | null, scoredAt: any, ignored: boolean } | null> | null } | null } | null } | null };

export type MarkShadowFalsePositiveMutationVariables = Exact<{
  input: MarkShadowFalsePositiveInput;
}>;


export type MarkShadowFalsePositiveMutation = { __typename?: 'Mutation', markShadowFalsePositive?: { __typename?: 'MarkShadowFalsePositivePayload', shadow?: { __typename?: 'Shadow', id: string, falsePositiveState: ShadowFalsePositiveModeEnum, falsePositiveCutoffAt?: any | null } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type UpdateScoringEventsBatchMutationVariables = Exact<{
  inputs: Array<UpdateScoringEventInput> | UpdateScoringEventInput;
}>;


export type UpdateScoringEventsBatchMutation = { __typename?: 'Mutation', updateScoringEventsBatch?: { __typename?: 'UpdateScoringEventsBatchPayload', scoringEvents?: Array<{ __typename?: 'ScoringEvent', id: string, ignored: boolean }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type CreateSubsidyRuleMutationVariables = Exact<{
  input: CreateSubsidyRule;
}>;


export type CreateSubsidyRuleMutation = { __typename?: 'Mutation', data?: { __typename?: 'CreateSubsidyRulePayload', rule?: { __typename?: 'SubsidyRule', id: string } | null, error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type DeleteSubsidyRuleMutationVariables = Exact<{
  input: DeleteSubsidyRule;
}>;


export type DeleteSubsidyRuleMutation = { __typename?: 'Mutation', data?: { __typename?: 'DeleteSubsidyRulePayload', error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type GetExternalTagsMealTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExternalTagsMealTypesQuery = { __typename?: 'Query', getMealTypes?: { __typename?: 'GetMealTypesPayload', mealTypes?: Array<{ __typename?: 'KeyValuePair', key: string, value: string }> | null } | null, getExternalTags?: { __typename?: 'GetExternalTagsPayload', externalTags?: Array<{ __typename?: 'KeyValuePair', key: string, value: string }> | null } | null };

export type GetGuestPassProgramsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetGuestPassProgramsQuery = { __typename?: 'Query', rules?: { __typename?: 'GetSubsidyRulesQueryPayload', subsidyRules?: Array<{ __typename?: 'SubsidyRule', id: string, name: string, description?: string | null, availableProducts: Array<EventProduct>, programStatus: SubsidyPassStatus, startsAt: any, endsAt?: any | null, daysAvailable: Array<Day>, timeZone: SubsidyTimezone, createdBy?: { __typename?: 'LightweightUser', id: string, firstName?: string | null, lastName?: string | null } | null, guestPasses?: { __typename?: 'SubsidyGuestPassBatch', passCount?: number | null, passes?: Array<{ __typename?: 'SubsidyGuestPass', id: string, email?: string | null, passNumber?: number | null, code: string, status: SubsidyPassStatus }> | null } | null }> | null, error?: { __typename?: 'OperationError', message: string, code: number, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null };

export type GetSubsidyRuleHistoryQueryVariables = Exact<{
  subsidyRuleId: Scalars['ID']['input'];
}>;


export type GetSubsidyRuleHistoryQuery = { __typename?: 'Query', ruleHistory?: { __typename?: 'GetSubsidyRuleHistoryPayload', history?: Array<{ __typename?: 'SubsidyRuleHistoryEntry', id: string, event: SubsidyRuleChangeEvent, changedAt: any, updatedByLabel: string, updatedBy?: { __typename?: 'LightweightUser', id: string } | null, changes: Array<{ __typename?: 'SubsidyRuleFieldChange', field: string, label: string, from?: string | null, to?: string | null }> }> | null, error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type GetSubsidyRulesQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  kind?: InputMaybe<Array<SubsidyKind> | SubsidyKind>;
}>;


export type GetSubsidyRulesQuery = { __typename?: 'Query', rules?: { __typename?: 'GetSubsidyRulesQueryPayload', subsidyRules?: Array<{ __typename?: 'SubsidyRule', id: string, autoApply: boolean, dailyMaxCents?: number | null, daysAvailable: Array<Day>, endsAt?: any | null, eventMaxCents?: number | null, minOrderCents: number, monthlyMaxCents?: number | null, name: string, noQr: boolean, percentageCap: any, product: SubsidyRuleProduct, programMaxCents?: number | null, ruleType: SubsidyRuleTypeEnum, startsAt: any, timeZone: SubsidyTimezone, validEverywhere: boolean, accountWhitelistIds?: Array<number> | null, weeklyMaxCents?: number | null, weeklyRecurrence: number, state: SubsidyRuleState, canDelete: boolean, subsidyType: SubsidyTypeEnum, mealTypes?: Array<InventoryItemMealType> | null, externalTags?: Array<InventoryItemExternalTags> | null, mealTypeLabels: Array<string>, externalTagLabels: Array<string>, supportedMealPeriods?: Array<MealPeriodEnum> | null, redemptionsPerDay?: number | null, displayPreSubsidyPrice: boolean, preTaxEmployeeContribution: boolean, skipEmailVerification: boolean, coverageDescriptionOverride?: string | null, generatedDescription: string, timeZoneName: string, updatedAt?: any | null, updatedByLabel?: string | null, accountWhitelistAccounts?: Array<{ __typename?: 'Account', id: string, name: string }> | null, vendors: Array<{ __typename?: 'Vendor', id: string, internalName: string }>, updatedBy?: { __typename?: 'LightweightUser', id: string } | null, foodaCardProgram?: { __typename?: 'FoodaCardProgram', status: FoodaCardProgramStatusEnum, allowedHourRanges?: any | null, allowedMerchantCategoryIds?: Array<string> | null, blockedMerchantCategoryIds?: Array<string> | null, allowedMerchantNames?: Array<string> | null, blockedMerchantNames?: Array<string> | null, allowedZipCodes?: Array<string> | null, allowedMerchantCategories: Array<{ __typename?: 'FoodaCardMerchantCategory', code: string, category?: string | null }>, blockedMerchantCategories: Array<{ __typename?: 'FoodaCardMerchantCategory', code: string, category?: string | null }>, stripeAccount?: { __typename?: 'FoodaCardStripeAccount', id: string, name: string, stripeAccountId: string } | null } | null }> | null, subsidyAdmins?: Array<{ __typename?: 'User', id: string, fullName?: string | null, createdAt: any }> | null, error?: { __typename?: 'OperationError', message: string, code: number, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null, mealPeriodFeatureFlag?: { __typename?: 'GetFeatureFlagPayload', featureFlag?: { __typename?: 'FeatureFlag', enabled: boolean, name: string } | null } | null, travelFeatureFlag?: { __typename?: 'GetFeatureFlagPayload', featureFlag?: { __typename?: 'FeatureFlag', enabled: boolean, name: string } | null } | null };

export type SearchSubsidyVendorsQueryVariables = Exact<{
  input: SearchVendorsInput;
}>;


export type SearchSubsidyVendorsQuery = { __typename?: 'Query', searchVendors?: { __typename?: 'SearchVendorsQueryPayload', vendors?: Array<{ __typename?: 'PopupCapacityVendor', id: string, internalName: string }> | null } | null };

export type UpdateSubsidyRuleMutationVariables = Exact<{
  input: UpdateSubsidyRule;
}>;


export type UpdateSubsidyRuleMutation = { __typename?: 'Mutation', data?: { __typename?: 'UpdateSubsidyRulePayload', rule?: { __typename?: 'SubsidyRule', id: string } | null, error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type CreateTaxCategoryMutationVariables = Exact<{
  input: CreateTaxCategory;
}>;


export type CreateTaxCategoryMutation = { __typename?: 'Mutation', data?: { __typename?: 'CreateTaxCategoryPayload', taxCategory?: { __typename?: 'TaxCategory', id: string, name: string, code: string, categoryType: TaxCategoryTypeEnum, notes?: string | null, isSync: boolean } | null, error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type GetLineItemTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLineItemTemplatesQuery = { __typename?: 'Query', data?: { __typename?: 'GetLineItemTypesQueryPayload', lineItemTypes?: Array<{ __typename?: 'LineItemType', id: number, lineItemType?: string | null, lineItemSubType?: string | null, sku?: string | null, eventFinanceLineItemType?: string | null, taxCategoryId?: number | null, taxCategoryType?: string | null, isAvailableForUser: boolean, createdAt?: any | null, updatedAt?: any | null, productType: string }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetProductTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductTypesQuery = { __typename?: 'Query', data?: { __typename?: 'GetProductTypesQueryPayload', productTypes: Array<string>, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetTaxCategoriesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxCategoriesQueryQuery = { __typename?: 'Query', data?: { __typename?: 'GetTaxCategoriesPayload', taxCategories?: Array<{ __typename?: 'TaxCategory', id: string, name: string, code: string, categoryType: TaxCategoryTypeEnum, notes?: string | null, isSync: boolean }> | null, error?: { __typename?: 'OperationError', code: number, message: string, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null };

export type GetTaxCategoryTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxCategoryTypesQuery = { __typename?: 'Query', data?: { __typename?: 'GetTaxCategoryTypesPayload', types: Array<{ __typename?: 'KeyValuePair', key: string, value: string }>, error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type GetTaxCategoryVersionsQueryVariables = Exact<{
  input: GetTaxCategoryVersionsRequest;
}>;


export type GetTaxCategoryVersionsQuery = { __typename?: 'Query', data?: { __typename?: 'GetTaxCategoryVersionsPayload', versions?: Array<{ __typename?: 'TaxCategoryVersion', id: string, taxCategoryId: string, code: string, name: string, categoryType: TaxCategoryTypeEnum, validFrom: any, validTo?: any | null, isSync: boolean }> | null, error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type GetTaxRatesQueryQueryVariables = Exact<{
  getTaxRatesInput: GetTaxRatesInput;
}>;


export type GetTaxRatesQueryQuery = { __typename?: 'Query', data?: { __typename?: 'GetTaxRatesPayload', taxRates?: Array<{ __typename?: 'TaxRate', id: string, taxRate: any, validFrom: any, validTo?: any | null, refreshedAt?: any | null, addressId: string, taxCategoryId: string }> | null, error?: { __typename?: 'OperationError', message: string, code: number, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null } | null };

export type UpdateTaxRatesForBuildingsQueryVariables = Exact<{ [key: string]: never; }>;


export type UpdateTaxRatesForBuildingsQuery = { __typename?: 'Query', data?: { __typename?: 'UpdateTaxRatesForBuildingsQueryPayload', success?: boolean | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type UpdateLineItemTypeMutationVariables = Exact<{
  input: UpdateLineItem;
}>;


export type UpdateLineItemTypeMutation = { __typename?: 'Mutation', data?: { __typename?: 'UpdateLineItemPayload', lineItemType?: { __typename?: 'LineItemType', id: number, lineItemType?: string | null, lineItemSubType?: string | null, taxCategoryId?: number | null, taxCategoryType?: string | null, sku?: string | null, eventFinanceLineItemType?: string | null, productType: string, isAvailableForUser: boolean, createdAt?: any | null, updatedAt?: any | null } | null, error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type UpdateTaxCategoryMutationVariables = Exact<{
  input: UpdateTaxCategory;
}>;


export type UpdateTaxCategoryMutation = { __typename?: 'Mutation', data?: { __typename?: 'UpdateTaxCategoryPayload', taxCategory?: { __typename?: 'TaxCategory', id: string, name: string, code: string, categoryType: TaxCategoryTypeEnum, notes?: string | null, isSync: boolean } | null, error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type CreateTenderMethodMutationVariables = Exact<{
  input: CreateTenderMethodInput;
}>;


export type CreateTenderMethodMutation = { __typename?: 'Mutation', data?: { __typename?: 'CreateTenderMethodPayload', error?: { __typename?: 'OperationError', message: string, code: number, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null, tenderMethod?: { __typename?: 'TenderMethod', id: string, name: string, state: TenderMethodStateEnum, timezone: Timezone, productType: ProductEnum, startDate: any, endDate?: any | null, daysAvailable: Array<Day>, accountIds: Array<string>, externalId?: string | null } | null } | null };

export type GetTenderMethodsQueryVariables = Exact<{
  input?: InputMaybe<GetTenderMethods>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTenderMethodsQuery = { __typename?: 'Query', methods?: { __typename?: 'GetTenderMethodsPayload', error?: { __typename?: 'OperationError', message: string, code: number, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null, tenderMethods?: { __typename?: 'TenderMethodConnection', edges?: Array<{ __typename?: 'TenderMethodEdge', node?: { __typename?: 'TenderMethod', id: string, name: string, state: TenderMethodStateEnum, timezone: Timezone, productType: ProductEnum, startDate: any, endDate?: any | null, daysAvailable: Array<Day>, accountIds: Array<string>, externalId?: string | null, availableToday: boolean, canDelete: boolean, accounts?: Array<{ __typename?: 'AccountPublic', id: string, name: string }> | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null };

export type UpdateTenderMethodMutationVariables = Exact<{
  input: UpdateTenderMethodInput;
}>;


export type UpdateTenderMethodMutation = { __typename?: 'Mutation', data?: { __typename?: 'UpdateTenderMethodPayload', error?: { __typename?: 'OperationError', message: string, code: number, details?: Array<{ __typename?: 'CreateOrderItemsUnavailableErrorDetail', message: string, codeAsString: string } | { __typename?: 'CreateUserAccountErrorDetail', message: string, codeAsString: string } | { __typename?: 'FoodaCardBankAccountVerifyErrorDetail', message: string, codeAsString: string } | { __typename?: 'MenuChangeRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'MobileOrderingOrderRequestErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestBlobErrorDetail', message: string, codeAsString: string } | { __typename?: 'OrderRequestErrorDetail', message: string, codeAsString: string }> | null } | null, tenderMethod?: { __typename?: 'TenderMethod', id: string, name: string, state: TenderMethodStateEnum, timezone: Timezone, productType: ProductEnum, startDate: any, endDate?: any | null, daysAvailable: Array<Day>, accountIds: Array<string>, externalId?: string | null, availableToday: boolean, canDelete: boolean, accounts?: Array<{ __typename?: 'AccountPublic', id: string, name: string }> | null } | null } | null };

export type CreateAuthenticationDomainMutationVariables = Exact<{
  input: CreateAuthenticationDomain;
}>;


export type CreateAuthenticationDomainMutation = { __typename?: 'Mutation', createAuthenticationDomain?: { __typename?: 'CreateAuthenticationDomainPayload', authenticationDomain?: { __typename?: 'AuthenticationDomain', id: string, organization: string, organizationName: string, domainName: string, effectiveDate: any, authenticationProviderId: string, useLoginHint: boolean, scimEnabled: boolean, connectionId?: string | null, mobileSessionTimeout?: number | null, mobileSessionExpiration?: number | null, webSessionTimeout?: number | null, webSessionExpiration?: number | null, testMode: boolean, listOfUsers?: Array<string> | null } | null, error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type GetUserAuthenticationDomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAuthenticationDomainsQuery = { __typename?: 'Query', getAuthenticationDomains?: { __typename?: 'GetAuthenticationDomainsPayload', authenticationDomains?: Array<{ __typename?: 'AuthenticationDomain', id: string, organization: string, organizationName: string, domainName: string, effectiveDate: any, authenticationProviderId: string, createdAt: any, updatedAt: any, useLoginHint: boolean, scimEnabled: boolean, connectionId?: string | null, webSessionExpiration?: number | null, webSessionTimeout?: number | null, mobileSessionExpiration?: number | null, mobileSessionTimeout?: number | null, testMode: boolean, listOfUsers?: Array<string> | null, accounts?: Array<{ __typename?: 'AccountPublic', id: string, name: string }> | null }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null, getAuthenticationProviders?: { __typename?: 'GetAuthenticationProvidersPayload', authenticationProviders?: Array<{ __typename?: 'AuthenticationProvider', id: string, isDefault: boolean, machineName: string, name: string, urlSuffix: string, createdAt: any, updatedAt: any }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type UpdateAuthenticationDomainMutationVariables = Exact<{
  input: UpdateAuthenticationDomain;
}>;


export type UpdateAuthenticationDomainMutation = { __typename?: 'Mutation', updateAuthenticationDomain?: { __typename?: 'UpdateAuthenticationDomainPayload', authenticationDomain?: { __typename?: 'AuthenticationDomain', id: string, organization: string, organizationName: string, domainName: string, effectiveDate: any, authenticationProviderId: string, useLoginHint: boolean, scimEnabled: boolean, connectionId?: string | null, mobileSessionTimeout?: number | null, mobileSessionExpiration?: number | null, webSessionTimeout?: number | null, webSessionExpiration?: number | null, testMode: boolean, listOfUsers?: Array<string> | null } | null, error?: { __typename?: 'OperationError', message: string, code: number } | null } | null };

export type CreateUserNoteMutationVariables = Exact<{
  input: CreateUserNote;
}>;


export type CreateUserNoteMutation = { __typename?: 'Mutation', createUserNote?: { __typename?: 'CreateUserNotePayload', userNote?: { __typename?: 'UserNote', id: string, note: string, createdAt: any, updatedAt: any, author: { __typename?: 'User', id: string, email?: string | null } } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type DeleteUserNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUserNoteMutation = { __typename?: 'Mutation', deleteUserNote?: { __typename?: 'DeleteUserNotePayload', success?: boolean | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetUserNotesQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUserNotesQuery = { __typename?: 'Query', getUserNotes?: { __typename?: 'GetUserNotesPayload', userNotes?: { __typename?: 'UserNoteConnection', totalCount: number, nodes?: Array<{ __typename?: 'UserNote', id: string, note: string, createdAt: any, updatedAt: any, author: { __typename?: 'User', id: string, email?: string | null } } | null> | null } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type UpdateUserNoteMutationVariables = Exact<{
  input: UpdateUserNote;
}>;


export type UpdateUserNoteMutation = { __typename?: 'Mutation', updateUserNote?: { __typename?: 'UpdateUserNotePayload', userNote?: { __typename?: 'UserNote', id: string, note: string, createdAt: any, updatedAt: any, author: { __typename?: 'User', id: string, email?: string | null } } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type GetUserFoodaCardOrdersQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUserFoodaCardOrdersQuery = { __typename?: 'Query', getUserFoodaCardOrders?: { __typename?: 'GetUserFoodaCardOrdersPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, orders?: { __typename?: 'FoodaCardOrderConnection', totalCount: number, currentPage: number, nodes?: Array<{ __typename?: 'FoodaCardOrder', id: string, status: string, currency: string, declineReason?: string | null, subtotalAmountCents: number, subsidyAmountCents?: number | null, overageAmountCents?: number | null, actionRequired: boolean, purchaseDate: any, stripeDashboardUrl?: string | null, merchant?: { __typename?: 'FoodaCardMerchant', name?: string | null, category?: string | null, categoryCode?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null, stripeCard?: { __typename?: 'FoodaCardStripeCard', id: string, cardType: string, last4: string, status: string, currency: string, activatedAt?: any | null } | null, overagePaymentMethod?: { __typename?: 'Card', id: string, cardTypeHumanized?: string | null, last4: number, processor?: string | null } | null, duePaymentMethod?: { __typename?: 'Card', id: string, cardTypeHumanized?: string | null, last4: number, processor?: string | null } | null, subsidyRule?: { __typename?: 'SubsidyRule', id: string, name: string, account: { __typename?: 'AccountPublic', id: string } } | null } | null> | null } | null } | null };

export type GetUserDeliveryOrdersQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserDeliveryOrdersQuery = { __typename?: 'Query', getUserDeliveryOrders?: { __typename?: 'GetUserDeliveryOrdersPayload', error?: { __typename?: 'OperationError', code: number, message: string } | null, orders?: { __typename?: 'DeliveryOrderDetailsConnection', totalCount: number, currentPage: number, nodes?: Array<{ __typename?: 'DeliveryOrderDetails', prettyId?: string | null, orderPath?: string | null, eventPrettyId?: string | null, eventPath?: string | null, eventDropOffTime?: any | null, userFacingStatus?: string | null, totalAmountCents: number, vendors: Array<{ __typename?: 'Vendor', name: string }>, items?: Array<{ __typename?: 'DeliveryOrderItem', name: string }> | null, paymentTransaction: Array<{ __typename?: 'PaymentTransaction', amountCents: number, ccLast4: string, cardType?: string | null, transactedAt: any }> } | null> | null } | null } | null };

export type GetVendorPopupCapacityQueryVariables = Exact<{
  vendorId: Scalars['ID']['input'];
}>;


export type GetVendorPopupCapacityQuery = { __typename?: 'Query', getVendorPopupCapacity?: { __typename?: 'GetVendorPopupCapacityQueryPayload', maxEventsPerDay?: number | null, maxEventsPerWeek?: number | null, vendor?: { __typename?: 'PopupCapacityVendor', id: string, name: string, popupCapacityGroup?: { __typename?: 'PopupCapacityGroup', id: string, members: Array<{ __typename?: 'PopupCapacityGroupMembership', id: string, vendor: { __typename?: 'Vendor', id: string, name: string, internalName: string } }> } | null } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type SearchPopupCapacityVendorsQueryVariables = Exact<{
  input: SearchVendorsInput;
}>;


export type SearchPopupCapacityVendorsQuery = { __typename?: 'Query', searchVendors?: { __typename?: 'SearchVendorsQueryPayload', vendors?: Array<{ __typename?: 'PopupCapacityVendor', id: string, name: string, internalName: string, state?: VendorState | null, popupCapacityGroup?: { __typename?: 'PopupCapacityGroup', id: string } | null }> | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };

export type UpdateVendorPopupCapacityMutationVariables = Exact<{
  input: UpdateVendorPopupCapacity;
}>;


export type UpdateVendorPopupCapacityMutation = { __typename?: 'Mutation', updateVendorPopupCapacity?: { __typename?: 'UpdateVendorPopupCapacityPayload', vendor?: { __typename?: 'PopupCapacityVendor', id: string } | null, error?: { __typename?: 'OperationError', code: number, message: string } | null } | null };


export const CreateAccountAuthenticationDomainAssociationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAccountAuthenticationDomainAssociation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"domainName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAccountAuthenticationDomainAssociation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"domainName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"domainName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authenticationDomain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateAccountAuthenticationDomainAssociationMutation, CreateAccountAuthenticationDomainAssociationMutationVariables>;
export const DeleteAccountAuthenticationDomainAssociationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteAccountAuthenticationDomainAssociation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"domainId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAccountAuthenticationDomainAssociation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"domainId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"domainId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteAccountAuthenticationDomainAssociationMutation, DeleteAccountAuthenticationDomainAssociationMutationVariables>;
export const GetAccountAuthenticationDomainsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAccountAuthenticationDomains"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAccountAuthenticationDomains"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authenticationDomains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"authenticationProviderId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"getAuthenticationProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authenticationProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"getAuthenticationDomains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authenticationDomains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"authenticationProviderId"}}]}}]}}]}}]} as unknown as DocumentNode<GetAccountAuthenticationDomainsQuery, GetAccountAuthenticationDomainsQueryVariables>;
export const GetAccountMarketingSegmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAccountMarketingSegments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"marketingSegments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"segmentType"}},{"kind":"Field","name":{"kind":"Name","value":"providerName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAccountMarketingSegmentsQuery, GetAccountMarketingSegmentsQueryVariables>;
export const GetInternalNotesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInternalNotesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"getAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountInfoNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetInternalNotesQueryQuery, GetInternalNotesQueryQueryVariables>;
export const RefreshMarketingSegmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"refreshMarketingSegment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshMarketingSegment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingSegment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<RefreshMarketingSegmentMutation, RefreshMarketingSegmentMutationVariables>;
export const SearchAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchAccountsQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"searchInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<SearchAccountQuery, SearchAccountQueryVariables>;
export const SearchAccountOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchAccountOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchAccountOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"searchInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentCompany"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SearchAccountOptionsQuery, SearchAccountOptionsQueryVariables>;
export const CreateAccountingSiteOwnerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAccountingSiteOwner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountingSiteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountingSiteOwnerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAccountingSiteOwner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountingSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountingSiteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveStart"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveEnd"}},{"kind":"Field","name":{"kind":"Name","value":"roleTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"roleTypeNames"}},{"kind":"Field","name":{"kind":"Name","value":"past"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateAccountingSiteOwnerMutation, CreateAccountingSiteOwnerMutationVariables>;
export const DestroyAccountingSiteOwnerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"destroyAccountingSiteOwner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"destroyAccountingSiteOwner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DestroyAccountingSiteOwnerMutation, DestroyAccountingSiteOwnerMutationVariables>;
export const GetAccountingSiteOwnersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAccountingSiteOwners"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountingSiteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAccountingSiteOwners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountingSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountingSiteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountingSiteId"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountingSiteId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveStart"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveEnd"}},{"kind":"Field","name":{"kind":"Name","value":"roleTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"roleTypeNames"}},{"kind":"Field","name":{"kind":"Name","value":"past"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetAccountingSiteOwnersQuery, GetAccountingSiteOwnersQueryVariables>;
export const GetFoodaEmployeeOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFoodaEmployeeOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeUserId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFoodaEmployeeOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeUserId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetFoodaEmployeeOptionsQuery, GetFoodaEmployeeOptionsQueryVariables>;
export const UpdateAccountingSiteOwnerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAccountingSiteOwner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountingSiteOwnerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccountingSiteOwner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveStart"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveEnd"}},{"kind":"Field","name":{"kind":"Name","value":"roleTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"roleTypeNames"}},{"kind":"Field","name":{"kind":"Name","value":"past"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAccountingSiteOwnerMutation, UpdateAccountingSiteOwnerMutationVariables>;
export const CreateAccountingSiteRoleTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAccountingSiteRoleType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAccountingSiteRoleType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateAccountingSiteRoleTypeMutation, CreateAccountingSiteRoleTypeMutationVariables>;
export const DeactivateAccountingSiteRoleTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deactivateAccountingSiteRoleType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deactivateAccountingSiteRoleType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DeactivateAccountingSiteRoleTypeMutation, DeactivateAccountingSiteRoleTypeMutationVariables>;
export const GetAccountingSiteRoleTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAccountingSiteRoleTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDeleted"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAccountingSiteRoleTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeDeleted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDeleted"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roleTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetAccountingSiteRoleTypesQuery, GetAccountingSiteRoleTypesQueryVariables>;
export const UpdateAccountingSiteRoleTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAccountingSiteRoleType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccountingSiteRoleType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAccountingSiteRoleTypeMutation, UpdateAccountingSiteRoleTypeMutationVariables>;
export const CreateAccountingSiteTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAccountingSiteType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAccountingSiteType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateAccountingSiteTypeMutation, CreateAccountingSiteTypeMutationVariables>;
export const GetAccountingSiteTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAccountingSiteTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAccountingSiteTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetAccountingSiteTypesQuery, GetAccountingSiteTypesQueryVariables>;
export const UpdateAccountingSiteTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAccountingSiteType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccountingSiteType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAccountingSiteTypeMutation, UpdateAccountingSiteTypeMutationVariables>;
export const GetCountriesListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCountriesList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"getCountriesList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryName"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCountriesListQuery, GetCountriesListQueryVariables>;
export const GetStatesListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStatesList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"getStatesList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"states"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"stateCode"}},{"kind":"Field","name":{"kind":"Name","value":"stateName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetStatesListQuery, GetStatesListQueryVariables>;
export const CalculateEventSubsidiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"calculateEventSubsidies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CalculateEventSubsidies"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculateEventSubsidies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subsidies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"availableCents"}},{"kind":"Field","name":{"kind":"Name","value":"redeemableCents"}}]}}]}}]}}]} as unknown as DocumentNode<CalculateEventSubsidiesQuery, CalculateEventSubsidiesQueryVariables>;
export const CalculateMobileOrderingCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CalculateMobileOrderingCart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CalculateMobileOrderingCart"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculateMobileOrderingCart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"couponDiscountCents"}},{"kind":"Field","name":{"kind":"Name","value":"dueAmountCents"}},{"kind":"Field","name":{"kind":"Name","value":"restaurantCommissionCents"}},{"kind":"Field","name":{"kind":"Name","value":"subsidy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountCents"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"versionId"}},{"kind":"Field","name":{"kind":"Name","value":"redeemableCents"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subsidyDiscountCents"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalCents"}},{"kind":"Field","name":{"kind":"Name","value":"taxCents"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsPoints"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalPostSubsidyCents"}},{"kind":"Field","name":{"kind":"Name","value":"taxPostSubsidyCents"}},{"kind":"Field","name":{"kind":"Name","value":"pickupTimeSlots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CalculateMobileOrderingCartQuery, CalculateMobileOrderingCartQueryVariables>;
export const CancelDeliveryOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cancelDeliveryOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CancelDeliveryOrder"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelDeliveryOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CancelDeliveryOrderMutation, CancelDeliveryOrderMutationVariables>;
export const CreateCateringUserAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCateringUserAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCateringUserAccount"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCateringUserAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"destination"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"omniauthCallback"}},{"kind":"Field","name":{"kind":"Name","value":"sessionToken"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCateringUserAccountMutation, CreateCateringUserAccountMutationVariables>;
export const CreateMobileOrderingOrderRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMobileOrderingOrderRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMobileOrderingOrderRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMobileOrderingOrderRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pickupInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pickupId"}},{"kind":"Field","name":{"kind":"Name","value":"pickupTime"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrderItemsUnavailableErrorDetail"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemIds"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateMobileOrderingOrderRequestMutation, CreateMobileOrderingOrderRequestMutationVariables>;
export const CreateSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSession"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"omniauthCallback"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateSessionMutation, CreateSessionMutationVariables>;
export const CreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUser"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"omniauthCallback"}},{"kind":"Field","name":{"kind":"Name","value":"sessionToken"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const GetAuthProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAuthProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceUri"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"getAuthProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceUri"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceUri"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerUrl"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetAuthProviderQuery, GetAuthProviderQueryVariables>;
export const GetAuthenticationDomainsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAuthenticationDomains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"getAuthenticationDomains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authenticationDomains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"authenticationProviderId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"useLoginHint"}},{"kind":"Field","name":{"kind":"Name","value":"scimEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"mobileSessionTimeout"}},{"kind":"Field","name":{"kind":"Name","value":"mobileSessionExpiration"}},{"kind":"Field","name":{"kind":"Name","value":"webSessionTimeout"}},{"kind":"Field","name":{"kind":"Name","value":"webSessionExpiration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetAuthenticationDomainsQuery, GetAuthenticationDomainsQueryVariables>;
export const GetAuthenticationProvidersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAuthenticationProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"getAuthenticationProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authenticationProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"machineName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"urlSuffix"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetAuthenticationProvidersQuery, GetAuthenticationProvidersQueryVariables>;
export const GetDeliveryEventVendorMenuDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDeliveryEventVendorMenu"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetDeliveryEventVendorMenu"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDeliveryEventVendorMenu"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorMenu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventVendorId"}},{"kind":"Field","name":{"kind":"Name","value":"soldOutState"}},{"kind":"Field","name":{"kind":"Name","value":"menuGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"menuItemId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"preTaxPriceCents"}},{"kind":"Field","name":{"kind":"Name","value":"dietaryRestrictions"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDeliveryEventVendorMenuQuery, GetDeliveryEventVendorMenuQueryVariables>;
export const GetEventSubsidiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEventSubsidies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetEventSubsidies"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEventSubsidies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subsidies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"coverage"}},{"kind":"Field","name":{"kind":"Name","value":"isQuickAdd"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"startOn"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"validAt"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionMessage"}}]}}]}}]}}]} as unknown as DocumentNode<GetEventSubsidiesQuery, GetEventSubsidiesQueryVariables>;
export const GetMobileOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMobileOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"request"},"name":{"kind":"Name","value":"getMobileOrderingOrderRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"paymentGatewayError"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"customizationDescription"}},{"kind":"Field","name":{"kind":"Name","value":"napkins"}},{"kind":"Field","name":{"kind":"Name","value":"silverware"}},{"kind":"Field","name":{"kind":"Name","value":"selectionGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namePublic"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"userPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxCents"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalCents"}},{"kind":"Field","name":{"kind":"Name","value":"totalCents"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxCents"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalCents"}},{"kind":"Field","name":{"kind":"Name","value":"totalCents"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address1"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cardDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardType"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pickupInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pickupId"}},{"kind":"Field","name":{"kind":"Name","value":"pickupTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxCents"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalCents"}},{"kind":"Field","name":{"kind":"Name","value":"totalCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"couponDiscountCents"}},{"kind":"Field","name":{"kind":"Name","value":"subsidyDiscountCents"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalCents"}},{"kind":"Field","name":{"kind":"Name","value":"taxCents"}},{"kind":"Field","name":{"kind":"Name","value":"totalPaidCents"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMobileOrderQuery, GetMobileOrderQueryVariables>;
export const GetMobileOrderDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMobileOrderDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getConsumerMobileOrderingOrderDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cardDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"cardType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customizationDescription"}},{"kind":"Field","name":{"kind":"Name","value":"napkins"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"silverware"}},{"kind":"Field","name":{"kind":"Name","value":"preTaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"taxCents"}},{"kind":"Field","name":{"kind":"Name","value":"postTaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"selectionGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"namePublic"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"preTaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"taxCents"}},{"kind":"Field","name":{"kind":"Name","value":"postTaxCents"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pickupInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pickupId"}},{"kind":"Field","name":{"kind":"Name","value":"pickupTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorName"}},{"kind":"Field","name":{"kind":"Name","value":"couponDiscountCents"}},{"kind":"Field","name":{"kind":"Name","value":"subsidyDiscountCents"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalCents"}},{"kind":"Field","name":{"kind":"Name","value":"taxCents"}},{"kind":"Field","name":{"kind":"Name","value":"totalPaidCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMobileOrderDetailsQuery, GetMobileOrderDetailsQueryVariables>;
export const GetOrderRefundsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOrderRefunds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrderRequestDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"requestId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRefunds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountCents"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"displayAmount"}},{"kind":"Field","name":{"kind":"Name","value":"displayAmountCents"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOrderRefundsQuery, GetOrderRefundsQueryVariables>;
export const GetPopupEventVendorMenuDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPopupEventVendorMenu"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetPopupEventVendorMenu"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"multipleSubsidyFlag"},"name":{"kind":"Name","value":"getFeatureFlag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"use_multiple_subsidy","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureFlag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"getPopupEventVendorMenu"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorMenu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hidePrices"}},{"kind":"Field","name":{"kind":"Name","value":"menuGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isCustom"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"otherTaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"salesTaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"preTaxPriceCents"}},{"kind":"Field","name":{"kind":"Name","value":"postTaxPriceCents"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"showOnMenu"}},{"kind":"Field","name":{"kind":"Name","value":"isCustom"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"availableInPersonOnly"}},{"kind":"Field","name":{"kind":"Name","value":"selectionGroupPositions"}},{"kind":"Field","name":{"kind":"Name","value":"disallowWriteIn"}},{"kind":"Field","name":{"kind":"Name","value":"dietaryRestrictions"}},{"kind":"Field","name":{"kind":"Name","value":"subsidy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postSubsidyPreTaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"postSubsidyPostTaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"postSubsidySalesTaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"redeemableCents"}},{"kind":"Field","name":{"kind":"Name","value":"versionId"}},{"kind":"Field","name":{"kind":"Name","value":"displayPreSubsidyPrice"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectionGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultSelection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"foodaBarcodeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"namePublic"}},{"kind":"Field","name":{"kind":"Name","value":"otherTaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"postTaxPriceCents"}},{"kind":"Field","name":{"kind":"Name","value":"preTaxPriceCents"}},{"kind":"Field","name":{"kind":"Name","value":"salesTaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"showOnPos"}},{"kind":"Field","name":{"kind":"Name","value":"upc"}},{"kind":"Field","name":{"kind":"Name","value":"subsidy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postSubsidyPreTaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"postSubsidyPostTaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"postSubsidySalesTaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"redeemableCents"}},{"kind":"Field","name":{"kind":"Name","value":"versionId"}},{"kind":"Field","name":{"kind":"Name","value":"displayPreSubsidyPrice"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"itemPositions"}},{"kind":"Field","name":{"kind":"Name","value":"maxSelections"}},{"kind":"Field","name":{"kind":"Name","value":"minSelections"}},{"kind":"Field","name":{"kind":"Name","value":"namePublic"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"foodaBarcodeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"namePublic"}},{"kind":"Field","name":{"kind":"Name","value":"otherTaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"postTaxPriceCents"}},{"kind":"Field","name":{"kind":"Name","value":"preTaxPriceCents"}},{"kind":"Field","name":{"kind":"Name","value":"salesTaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"showOnPos"}},{"kind":"Field","name":{"kind":"Name","value":"upc"}},{"kind":"Field","name":{"kind":"Name","value":"subsidy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postSubsidyPreTaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"postSubsidyPostTaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"postSubsidySalesTaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"redeemableCents"}},{"kind":"Field","name":{"kind":"Name","value":"versionId"}},{"kind":"Field","name":{"kind":"Name","value":"displayPreSubsidyPrice"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPopupEventVendorMenuQuery, GetPopupEventVendorMenuQueryVariables>;
export const GetPopupRecommendationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPopupRecommendations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetRecommendationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRecommendations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recommendations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionUuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"recommendationsGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"recommendations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetPopupRecommendationsQuery, GetPopupRecommendationsQueryVariables>;
export const GetQaToolsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetQATools"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QaToolsInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QAToolsRequestTypeEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getQaTools"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"requestType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scriptInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"averageTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"requestType"}},{"kind":"Field","name":{"kind":"Name","value":"scriptName"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"requiredFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"namespaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespace"}},{"kind":"Field","name":{"kind":"Name","value":"paths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"responseFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetQaToolsQuery, GetQaToolsQueryVariables>;
export const GetRecommendationsWithItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRecommendationsWithItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetRecommendationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRecommendations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recommendations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionUuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"recommendationsGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"recommendations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"menuItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"priceCents"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"hasOptions"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryEventRecommendationMenuItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryEventMenuItemId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PopupEventRecommendationMenuItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventVendorId"}},{"kind":"Field","name":{"kind":"Name","value":"originalPriceCents"}},{"kind":"Field","name":{"kind":"Name","value":"hidePrices"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetRecommendationsWithItemQuery, GetRecommendationsWithItemQueryVariables>;
export const GetStripeVerificationSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStripeVerificationSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"membershipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getStripeVerificationSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"membershipId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"membershipId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetStripeVerificationSessionQuery, GetStripeVerificationSessionQueryVariables>;
export const GetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const GetUserOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PopupOrder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemNames"}},{"kind":"Field","name":{"kind":"Name","value":"paymentState"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}},{"kind":"Field","name":{"kind":"Name","value":"orderFulfilledTime"}},{"kind":"Field","name":{"kind":"Name","value":"hidePrices"}},{"kind":"Field","name":{"kind":"Name","value":"pickupInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pickupId"}},{"kind":"Field","name":{"kind":"Name","value":"pickupTime"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserOrdersQuery, GetUserOrdersQueryVariables>;
export const GetUserRewardsPhoneNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserRewardsPhoneNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"digits"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"optOutOfRewards"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserRewardsPhoneNumberQuery, GetUserRewardsPhoneNumberQueryVariables>;
export const GetUserSubsidiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserSubsidies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserSubsidies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product"},"value":{"kind":"EnumValue","value":"ALL_PRODUCTS"}},{"kind":"ObjectField","name":{"kind":"Name","value":"states"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ACTIVE"},{"kind":"EnumValue","value":"INACTIVE"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subsidies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"qrInfo"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"coverage"}},{"kind":"Field","name":{"kind":"Name","value":"isQuickAdd"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"startOn"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"validAt"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionMessage"}},{"kind":"Field","name":{"kind":"Name","value":"membershipActive"}},{"kind":"Field","name":{"kind":"Name","value":"foodaCardMembership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"needsSetup"}},{"kind":"Field","name":{"kind":"Name","value":"stripeCardholderPastDueRequirements"}},{"kind":"Field","name":{"kind":"Name","value":"stripeCardholderDisabledReason"}},{"kind":"Field","name":{"kind":"Name","value":"stripeCardholderPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"stripeCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stripeCardId"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripeBillingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backupCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"cardType"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subsidyRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"timeZoneLabel"}},{"kind":"Field","name":{"kind":"Name","value":"foodaCardProgram"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowedHourRanges"}},{"kind":"Field","name":{"kind":"Name","value":"allowedMerchantNames"}},{"kind":"Field","name":{"kind":"Name","value":"blockedMerchantNames"}},{"kind":"Field","name":{"kind":"Name","value":"allowedZipCodes"}},{"kind":"Field","name":{"kind":"Name","value":"stripeAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeAccountId"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserSubsidiesQuery, GetUserSubsidiesQueryVariables>;
export const PingQaToolsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PingQaTools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pingQaTools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scriptInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"averageTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"requestType"}},{"kind":"Field","name":{"kind":"Name","value":"scriptName"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"requiredFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"namespaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespace"}},{"kind":"Field","name":{"kind":"Name","value":"paths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"responseFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<PingQaToolsQuery, PingQaToolsQueryVariables>;
export const SearchEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchPublicEvents"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"searchPublicEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CafeEventPublic"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cafeName"}},{"kind":"Field","name":{"kind":"Name","value":"restaurants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"serviceStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"serviceEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"stationType"}},{"kind":"Field","name":{"kind":"Name","value":"essenceImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"defaultCuisine"}},{"kind":"Field","name":{"kind":"Name","value":"mealPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"mobileOrdering"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"orderingWindowStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"orderingWindowEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"orderingCloseTime"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PopupEventPublic"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restaurants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mealPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"essenceImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"defaultCuisine"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mobileOrdering"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"orderingWindowStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"orderingWindowEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"orderingCloseTime"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryEventPublic"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mealPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"restaurants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"defaultCuisine"}},{"kind":"Field","name":{"kind":"Name","value":"essenceImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<SearchEventsQuery, SearchEventsQueryVariables>;
export const SearchPublicEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchPublicEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchPublicEvents"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchPublicEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CafeEventPublic"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cafeName"}},{"kind":"Field","name":{"kind":"Name","value":"healthscoreLink"}},{"kind":"Field","name":{"kind":"Name","value":"restaurants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendorId"}},{"kind":"Field","name":{"kind":"Name","value":"cuisines"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"serviceStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"serviceEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"stationType"}},{"kind":"Field","name":{"kind":"Name","value":"essenceImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"defaultCuisine"}},{"kind":"Field","name":{"kind":"Name","value":"mealPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"mobileOrdering"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"orderingWindowStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"orderingWindowEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"mobileOrderingAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"mobileOrderingUnavailableReason"}},{"kind":"Field","name":{"kind":"Name","value":"orderingCloseTime"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PopupEventPublic"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"healthscoreLink"}},{"kind":"Field","name":{"kind":"Name","value":"restaurants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendorId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mealPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"essenceImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"defaultCuisine"}},{"kind":"Field","name":{"kind":"Name","value":"cuisines"}},{"kind":"Field","name":{"kind":"Name","value":"serviceStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"serviceEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mobileOrdering"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"orderingWindowStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"orderingWindowEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"mobileOrderingAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"mobileOrderingUnavailableReason"}},{"kind":"Field","name":{"kind":"Name","value":"orderingCloseTime"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryEventPublic"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"healthscoreLink"}},{"kind":"Field","name":{"kind":"Name","value":"mealPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"defaultTileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"restaurants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendorId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"defaultCuisine"}},{"kind":"Field","name":{"kind":"Name","value":"essenceImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"cuisines"}},{"kind":"Field","name":{"kind":"Name","value":"soldOutState"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CateringEventPublic"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"healthscoreLink"}},{"kind":"Field","name":{"kind":"Name","value":"mealPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"menuImages"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<SearchPublicEventsQuery, SearchPublicEventsQueryVariables>;
export const SubmitRecommendationsFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitRecommendationsFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitRecommendationsFeedbackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitRecommendationsFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SubmitRecommendationsFeedbackMutation, SubmitRecommendationsFeedbackMutationVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUser"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"optOutOfRewards"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"digits"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const GetAppVersionPoliciesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAppVersionPolicies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppVersionPolicies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"policies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"platform"}},{"kind":"Field","name":{"kind":"Name","value":"minVersion"}},{"kind":"Field","name":{"kind":"Name","value":"nextMinVersion"}},{"kind":"Field","name":{"kind":"Name","value":"nextMinVersionDate"}},{"kind":"Field","name":{"kind":"Name","value":"forceVersions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetAppVersionPoliciesQuery, GetAppVersionPoliciesQueryVariables>;
export const UpdateAppVersionPolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAppVersionPolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AppVersionPolicyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAppVersionPolicy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"platform"}},{"kind":"Field","name":{"kind":"Name","value":"minVersion"}},{"kind":"Field","name":{"kind":"Name","value":"nextMinVersion"}},{"kind":"Field","name":{"kind":"Name","value":"nextMinVersionDate"}},{"kind":"Field","name":{"kind":"Name","value":"forceVersions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAppVersionPolicyMutation, UpdateAppVersionPolicyMutationVariables>;
export const CreateTempUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTempUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTempUser"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTempUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tempUserId"}}]}}]}}]} as unknown as DocumentNode<CreateTempUserMutation, CreateTempUserMutationVariables>;
export const CreateVerificationRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createVerificationRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateVerificationRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createVerificationRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CreateVerificationRequestMutation, CreateVerificationRequestMutationVariables>;
export const EnrollUserInAccountBuildingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"enrollUserInAccountBuilding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountBuildingInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enrollUserInAccountBuilding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EnrollUserInAccountBuildingMutation, EnrollUserInAccountBuildingMutationVariables>;
export const GetSignupConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSignupConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailAddress"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resetPasswordToken"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSignupConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"resetPasswordToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resetPasswordToken"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"present"}},{"kind":"Field","name":{"kind":"Name","value":"providerName"}},{"kind":"Field","name":{"kind":"Name","value":"signupConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultVerificationMethod"}},{"kind":"Field","name":{"kind":"Name","value":"phoneRequired"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiationUrl"}}]}}]}}]} as unknown as DocumentNode<GetSignupConfigQuery, GetSignupConfigQueryVariables>;
export const GetSubscribedAccountBuildingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSubscribedAccountBuildings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscribedAccountBuildings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hideFromSearch"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSubscribedAccountBuildingsQuery, GetSubscribedAccountBuildingsQueryVariables>;
export const SearchUserAccountBuildingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchUserAccountBuildings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchUserAccountBuilding"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchUserAccountBuildings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountBuildings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"building"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchUserAccountBuildingsQuery, SearchUserAccountBuildingsQueryVariables>;
export const SubmitVerificationCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"submitVerificationCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitVerificationCode"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitVerificationCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nonce"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<SubmitVerificationCodeMutation, SubmitVerificationCodeMutationVariables>;
export const UnenrollUserFromAccountBuildingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"unenrollUserFromAccountBuilding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountBuildingInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unenrollUserFromAccountBuilding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UnenrollUserFromAccountBuildingMutation, UnenrollUserFromAccountBuildingMutationVariables>;
export const CreateCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCard"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"createCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cardholderName"}},{"kind":"Field","name":{"kind":"Name","value":"cardType"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"expirationMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expirationYear"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"cardType"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateCardMutation, CreateCardMutationVariables>;
export const CreateCardAsyncDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCardAsync"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCard"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCardAsync"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestToken"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateCardAsyncMutation, CreateCardAsyncMutationVariables>;
export const DeleteCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteCard"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"deleteCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteCardMutation, DeleteCardMutationVariables>;
export const GetCreateCardResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCreateCardResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCreateCardResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"requestToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cardholderName"}},{"kind":"Field","name":{"kind":"Name","value":"cardType"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"expirationMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expirationYear"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultDelivery"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCreateCardResultQuery, GetCreateCardResultQueryVariables>;
export const GetGroupedUserCardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getGroupedUserCards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetGroupedUserCardsQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"getGroupedUserCards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedUserCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parentCardId"}},{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardholderName"}},{"kind":"Field","name":{"kind":"Name","value":"cardTypeHumanized"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"expirationMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expirationYear"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"processor"}},{"kind":"Field","name":{"kind":"Name","value":"gatewayProfileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalGroupedCards"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<GetGroupedUserCardsQuery, GetGroupedUserCardsQueryVariables>;
export const GetUserCardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserCards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"getUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"cardholderName"}},{"kind":"Field","name":{"kind":"Name","value":"cardType"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"expirationMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expirationYear"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultDelivery"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"processor"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserCardsQuery, GetUserCardsQueryVariables>;
export const ClearChatHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"clearChatHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClearChatHistory"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clearChatHistory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ClearChatHistoryMutation, ClearChatHistoryMutationVariables>;
export const GetChatHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getChatHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getChatHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"sources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"messageId"}},{"kind":"Field","name":{"kind":"Name","value":"feedbackGiven"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetChatHistoryQuery, GetChatHistoryQueryVariables>;
export const SendChatMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendChatMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendChatMessage"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendChatMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"response"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"messageId"}},{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"sources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SendChatMessageMutation, SendChatMessageMutationVariables>;
export const SubmitChatFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"submitChatFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitChatFeedback"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitChatFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SubmitChatFeedbackMutation, SubmitChatFeedbackMutationVariables>;
export const EffectiveConsentPreferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"effectiveConsentPreference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"effectiveConsentPreference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consentGivenAt"}},{"kind":"Field","name":{"kind":"Name","value":"preferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purpose"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<EffectiveConsentPreferenceQuery, EffectiveConsentPreferenceQueryVariables>;
export const RecordConsentPreferenceEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"recordConsentPreferenceEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConsentPreferenceEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"recordConsentPreferenceEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<RecordConsentPreferenceEventMutation, RecordConsentPreferenceEventMutationVariables>;
export const CreateCrossDockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCrossDock"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCrossDock"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"createCrossDock"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crossDock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dropOffInstruction"}},{"kind":"Field","name":{"kind":"Name","value":"markets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchantId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pickupInstruction"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCrossDockMutation, CreateCrossDockMutationVariables>;
export const GetCrossDocksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCrossDocks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"getCrossDocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultCrossDockId"}},{"kind":"Field","name":{"kind":"Name","value":"crossDocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"merchantId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pickupInstruction"}},{"kind":"Field","name":{"kind":"Name","value":"dropOffInstruction"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"markets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCrossDocksQuery, GetCrossDocksQueryVariables>;
export const UpdateCrossDockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCrossDock"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCrossDock"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"updateCrossDock"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crossDock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dropOffInstruction"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchantId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pickupInstruction"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCrossDockMutation, UpdateCrossDockMutationVariables>;
export const CreateCustomInvoiceSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCustomInvoiceSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomInvoiceSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCustomInvoiceSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCustomInvoiceSettingsMutation, CreateCustomInvoiceSettingsMutationVariables>;
export const GetCustomInvoiceAvailableProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomInvoiceAvailableProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"members"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomInvoiceSettingsMemberInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCustomInvoiceAvailableProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"members"},"value":{"kind":"Variable","name":{"kind":"Name","value":"members"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetCustomInvoiceAvailableProductsQuery, GetCustomInvoiceAvailableProductsQueryVariables>;
export const GetCustomInvoiceOverlapsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomInvoiceOverlaps"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"members"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomInvoiceSettingsMemberInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"products"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductEnum"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCustomInvoiceOverlaps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"members"},"value":{"kind":"Variable","name":{"kind":"Name","value":"members"}}},{"kind":"Argument","name":{"kind":"Name","value":"products"},"value":{"kind":"Variable","name":{"kind":"Name","value":"products"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conflicts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accountIds"}},{"kind":"Field","name":{"kind":"Name","value":"products"}},{"kind":"Field","name":{"kind":"Name","value":"memberIndexes"}},{"kind":"Field","name":{"kind":"Name","value":"preExisting"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetCustomInvoiceOverlapsQuery, GetCustomInvoiceOverlapsQueryVariables>;
export const GetCustomInvoiceSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomInvoiceSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCustomInvoiceSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"products"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberType"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"inactive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"splitAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedByName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetCustomInvoiceSettingsQuery, GetCustomInvoiceSettingsQueryVariables>;
export const GetCustomInvoiceSettingsByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomInvoiceSettingsById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCustomInvoiceSettingsById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"products"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberType"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryLine"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"parentCompanyId"}},{"kind":"Field","name":{"kind":"Name","value":"inactive"}},{"kind":"Field","name":{"kind":"Name","value":"poValue"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parentCompany"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"splitAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"poFallback"}},{"kind":"Field","name":{"kind":"Name","value":"poRules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomInvoicePoByDayRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"poValue"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomInvoicePoByDayAndFeeTypeRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeTypes"}},{"kind":"Field","name":{"kind":"Name","value":"dayGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"poValue"}},{"kind":"Field","name":{"kind":"Name","value":"feeShare"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"poUpdatedByName"}},{"kind":"Field","name":{"kind":"Name","value":"poUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdByName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedByName"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetCustomInvoiceSettingsByIdQuery, GetCustomInvoiceSettingsByIdQueryVariables>;
export const GetCustomInvoiceSplitAttributeCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomInvoiceSplitAttributeCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"members"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomInvoiceSettingsMemberInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"products"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductEnum"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCustomInvoiceSplitAttributeCounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"members"},"value":{"kind":"Variable","name":{"kind":"Name","value":"members"}}},{"kind":"Argument","name":{"kind":"Name","value":"products"},"value":{"kind":"Variable","name":{"kind":"Name","value":"products"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"counts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributeType"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"quality"}},{"kind":"Field","name":{"kind":"Name","value":"blankGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetCustomInvoiceSplitAttributeCountsQuery, GetCustomInvoiceSplitAttributeCountsQueryVariables>;
export const UpdateCustomInvoicePoSetupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCustomInvoicePoSetup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomInvoicePoSetupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomInvoicePoSetup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCustomInvoicePoSetupMutation, UpdateCustomInvoicePoSetupMutationVariables>;
export const UpdateCustomInvoiceSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCustomInvoiceSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomInvoiceSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomInvoiceSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCustomInvoiceSettingsMutation, UpdateCustomInvoiceSettingsMutationVariables>;
export const GetDeliveryEventVendorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDeliveryEventVendor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDeliveryEventVendor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryEventVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crossDockId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"menuTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"vendorId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetDeliveryEventVendorQuery, GetDeliveryEventVendorQueryVariables>;
export const GetDeliveryOrderItemsTotalCostByEventVendorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDeliveryOrderItemsTotalCostByEventVendor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDeliveryOrderItemsTotalCostByEventVendor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEventVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryOrdersCount"}}]}}]}}]}}]} as unknown as DocumentNode<GetDeliveryOrderItemsTotalCostByEventVendorQuery, GetDeliveryOrderItemsTotalCostByEventVendorQueryVariables>;
export const GetDeliveryVendorMenuTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDeliveryVendorMenuTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetDeliveryVendorMenuTemplates"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDeliveryVendorMenuTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryMenuTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetDeliveryVendorMenuTemplatesQuery, GetDeliveryVendorMenuTemplatesQueryVariables>;
export const GetSelectEventCrossDocksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSelectEventCrossDocks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCrossDocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crossDocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSelectEventCrossDocksQuery, GetSelectEventCrossDocksQueryVariables>;
export const UpdateSelectEventVendorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSelectEventVendor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSelectEventVendor"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSelectEventVendor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"selectEventVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSelectEventVendorMutation, UpdateSelectEventVendorMutationVariables>;
export const CreateDeliveryVendorMarketCapacityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createDeliveryVendorMarketCapacity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateDeliveryVendorMarketCapacity"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDeliveryVendorMarketCapacity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketManifestCapacity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"marketManifestTimeId"}},{"kind":"Field","name":{"kind":"Name","value":"market"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConstraintId"}},{"kind":"Field","name":{"kind":"Name","value":"valid"}}]}}]}}]}}]} as unknown as DocumentNode<CreateDeliveryVendorMarketCapacityMutation, CreateDeliveryVendorMarketCapacityMutationVariables>;
export const DeleteDeliveryVendorMarketCapacityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteDeliveryVendorMarketCapacity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDeliveryVendorMarketCapacity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<DeleteDeliveryVendorMarketCapacityMutation, DeleteDeliveryVendorMarketCapacityMutationVariables>;
export const GetDeliverySchedulingConstraintsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDeliverySchedulingConstraints"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetDeliverySchedulingConstraint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"getDeliverySchedulingConstraints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constraints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"marketManifestTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"breakfast"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"market"}},{"kind":"Field","name":{"kind":"Name","value":"marketManifestTimeId"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConstraintId"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"valid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lunch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"market"}},{"kind":"Field","name":{"kind":"Name","value":"marketManifestTimeId"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConstraintId"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"valid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dinner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"market"}},{"kind":"Field","name":{"kind":"Name","value":"marketManifestTimeId"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConstraintId"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"valid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"markets"}},{"kind":"Field","name":{"kind":"Name","value":"minManifestPerMonth"}},{"kind":"Field","name":{"kind":"Name","value":"vendorId"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDeliverySchedulingConstraintsQuery, GetDeliverySchedulingConstraintsQueryVariables>;
export const UpdateDeliverySchedulingConstraintDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDeliverySchedulingConstraint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDeliverySchedulingConstraint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDeliverySchedulingConstraint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<UpdateDeliverySchedulingConstraintMutation, UpdateDeliverySchedulingConstraintMutationVariables>;
export const UpdateDeliveryVendorMarketCapacityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDeliveryVendorMarketCapacity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDeliveryVendorMarketCapacity"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDeliveryVendorMarketCapacity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketManifestCapacity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"marketManifestTimeId"}},{"kind":"Field","name":{"kind":"Name","value":"market"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConstraintId"}},{"kind":"Field","name":{"kind":"Name","value":"valid"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateDeliveryVendorMarketCapacityMutation, UpdateDeliveryVendorMarketCapacityMutationVariables>;
export const CreateStripeAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createStripeAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"createStripeAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"stripeAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<CreateStripeAccountMutation, CreateStripeAccountMutationVariables>;
export const GetFoodaCardMembershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFoodaCardMembership"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"membershipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFoodaCardMembership"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"membershipId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"membershipId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"foodaCardMembership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"needsSetup"}},{"kind":"Field","name":{"kind":"Name","value":"stripeCardholderPastDueRequirements"}},{"kind":"Field","name":{"kind":"Name","value":"stripeCardholderDisabledReason"}},{"kind":"Field","name":{"kind":"Name","value":"stripeBillingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subsidyRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"timeZoneLabel"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<GetFoodaCardMembershipQuery, GetFoodaCardMembershipQueryVariables>;
export const GetFoodaCardOutstandingBalancesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFoodaCardOutstandingBalances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFoodaCardOutstandingBalances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"foodaCardMembershipId"}},{"kind":"Field","name":{"kind":"Name","value":"amountCents"}},{"kind":"Field","name":{"kind":"Name","value":"lastFailedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<GetFoodaCardOutstandingBalancesQuery, GetFoodaCardOutstandingBalancesQueryVariables>;
export const GetStripeAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStripeAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"stripeAccounts"},"name":{"kind":"Name","value":"getStripeAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"stripeAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"subsidyRules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<GetStripeAccountsQuery, GetStripeAccountsQueryVariables>;
export const GetStripeCardEphemeralKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStripeCardEphemeralKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stripeCardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nonce"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getStripeCardEphemeralKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"stripeCardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stripeCardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"nonce"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nonce"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ephemeralKey"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetStripeCardEphemeralKeyQuery, GetStripeCardEphemeralKeyQueryVariables>;
export const UpdateFoodaCardMembershipBackupCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateFoodaCardMembershipBackupCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateFoodaCardMembershipBackupCard"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFoodaCardMembershipBackupCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"foodaCardMembership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"needsSetup"}},{"kind":"Field","name":{"kind":"Name","value":"backupCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateFoodaCardMembershipBackupCardMutation, UpdateFoodaCardMembershipBackupCardMutationVariables>;
export const UpdateFoodaCardMembershipRequirementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateFoodaCardMembershipRequirements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateFoodaCardMembershipRequirements"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFoodaCardMembershipRequirements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"foodaCardMembership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"needsSetup"}},{"kind":"Field","name":{"kind":"Name","value":"stripeBillingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateFoodaCardMembershipRequirementsMutation, UpdateFoodaCardMembershipRequirementsMutationVariables>;
export const CreateReportConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createReportConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateReportConfigurationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createReportConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<CreateReportConfigurationMutation, CreateReportConfigurationMutationVariables>;
export const DeleteReportConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteReportConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteReportConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteReportConfigurationMutation, DeleteReportConfigurationMutationVariables>;
export const GetFfbRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFfbRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReportsConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reportsTypes"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"FOODA_FOR_BUSINESS"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allRequirableRoles"}}]}}]}}]} as unknown as DocumentNode<GetFfbRolesQuery, GetFfbRolesQueryVariables>;
export const GetFfrRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFfrRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReportsConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reportsTypes"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"FOODA_FOR_RESTAURANTS"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allRequirableRoles"}}]}}]}}]} as unknown as DocumentNode<GetFfrRolesQuery, GetFfrRolesQueryVariables>;
export const GetReportsConfigurationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getReportsConfigurations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReportsConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reportsTypes"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"FOODA_FOR_BUSINESS"},{"kind":"EnumValue","value":"FOODA_FOR_RESTAURANTS"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportsConfigurations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reportType"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"menuTitle"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"tableauDesktopUrl"}},{"kind":"Field","name":{"kind":"Name","value":"tableauMobileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"terms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"term"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiredRoles"}}]}}]}}]}}]} as unknown as DocumentNode<GetReportsConfigurationsQuery, GetReportsConfigurationsQueryVariables>;
export const ReorderReportConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"reorderReportConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateReportsConfigurationsOrderQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateReportsConfigurationsOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<ReorderReportConfigurationMutation, ReorderReportConfigurationMutationVariables>;
export const UpdateReportConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateReportConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateReportConfigurationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateReportConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateReportConfigurationMutation, UpdateReportConfigurationMutationVariables>;
export const GetLocationsForAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLocationsForAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLocationsForAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetLocationsForAccountQuery, GetLocationsForAccountQueryVariables>;
export const CreateMarketDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createMarket"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMarket"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMarket"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<CreateMarketMutation, CreateMarketMutationVariables>;
export const GetCrossDocksForSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCrossDocksForSelect"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCrossDocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultCrossDockId"}},{"kind":"Field","name":{"kind":"Name","value":"crossDocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetCrossDocksForSelectQuery, GetCrossDocksForSelectQueryVariables>;
export const GetMarketDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMarket"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMarket"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"market"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"accountingMarketName"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAccountantId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultTaxRate"}},{"kind":"Field","name":{"kind":"Name","value":"defaultTaxRemitter"}},{"kind":"Field","name":{"kind":"Name","value":"defaultOperationEmail"}},{"kind":"Field","name":{"kind":"Name","value":"checkAverage"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryDocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"directorId"}},{"kind":"Field","name":{"kind":"Name","value":"displayCommission"}},{"kind":"Field","name":{"kind":"Name","value":"defaultCrossDockId"}},{"kind":"Field","name":{"kind":"Name","value":"healthDepartmentJurisdictions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketCohortName"}},{"kind":"Field","name":{"kind":"Name","value":"marketManifestTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"breakfast"}},{"kind":"Field","name":{"kind":"Name","value":"dinner"}},{"kind":"Field","name":{"kind":"Name","value":"lunch"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"officeDefaultEmail"}},{"kind":"Field","name":{"kind":"Name","value":"officeDefaultSms"}},{"kind":"Field","name":{"kind":"Name","value":"officeDefaultFax"}},{"kind":"Field","name":{"kind":"Name","value":"officeDefaultPhone"}},{"kind":"Field","name":{"kind":"Name","value":"popupSupportPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"deliverySupportPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCodes"}},{"kind":"Field","name":{"kind":"Name","value":"vendorId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<GetMarketQuery, GetMarketQueryVariables>;
export const GetMarketFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMarketForm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"getAccountingMarkets"},"name":{"kind":"Name","value":"getMarketNames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"EnumValue","value":"ALL_ACCOUNTING_MARKET_NAMES"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markets"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"getCohortMarkets"},"name":{"kind":"Name","value":"getMarketNames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"EnumValue","value":"ALL_COHORT_NAMES"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markets"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"getAccountants"},"name":{"kind":"Name","value":"getUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roleScope"},"value":{"kind":"EnumValue","value":"ACCOUNTING"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<GetMarketFormQuery, GetMarketFormQueryVariables>;
export const GetMarketsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMarketsList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"getMarketsList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMarketsListQuery, GetMarketsListQueryVariables>;
export const UpdateMarketDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateMarket"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateMarket"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMarket"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateMarketMutation, UpdateMarketMutationVariables>;
export const GetParentCompaniesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getParentCompanies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchInfo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getParentCompanies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"searchInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchInfo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parentCompanies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetParentCompaniesQuery, GetParentCompaniesQueryVariables>;
export const ArchiveRecommendationsModelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"archiveRecommendationsModel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archiveRecommendationsModel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"modelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modelId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modelConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ArchiveRecommendationsModelMutation, ArchiveRecommendationsModelMutationVariables>;
export const CreateRecommendationsLimitsGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRecommendationsLimitsGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateLimitsGroup"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRecommendationsLimitsGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limitsGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"maxSessionCostCents"}},{"kind":"Field","name":{"kind":"Name","value":"maxDailyCostCents"}},{"kind":"Field","name":{"kind":"Name","value":"maxMonthlyCostCents"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateRecommendationsLimitsGroupMutation, CreateRecommendationsLimitsGroupMutationVariables>;
export const CreateRecommendationsModelVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRecommendationsModelVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateModelVersionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRecommendationsModelVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modelConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"modelType"}},{"kind":"Field","name":{"kind":"Name","value":"task"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"promptConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"masterTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"variablesJson"}},{"kind":"Field","name":{"kind":"Name","value":"modelParamsJson"}},{"kind":"Field","name":{"kind":"Name","value":"hasVariables"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateRecommendationsModelVersionMutation, CreateRecommendationsModelVersionMutationVariables>;
export const GetActiveBacktestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActiveBacktest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActiveBacktest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"modelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modelId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backtestId"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetActiveBacktestQuery, GetActiveBacktestQueryVariables>;
export const GetRecommendationsAvailableResolversDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRecommendationsAvailableResolvers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RecommendationRequestTypes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRecommendationsAvailableResolvers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"taskType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolvers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"className"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"paramsSchema"}},{"kind":"Field","name":{"kind":"Name","value":"supportsNesting"}},{"kind":"Field","name":{"kind":"Name","value":"example"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetRecommendationsAvailableResolversQuery, GetRecommendationsAvailableResolversQueryVariables>;
export const GetBacktestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBacktest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"backtestId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBacktest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"backtestId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"backtestId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBacktest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backtestId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalCases"}},{"kind":"Field","name":{"kind":"Name","value":"completedCases"}},{"kind":"Field","name":{"kind":"Name","value":"failedCases"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"testCaseIndex"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"baseData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recommendations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"reasoning"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"hitType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"durationMs"}},{"kind":"Field","name":{"kind":"Name","value":"promptTokens"}},{"kind":"Field","name":{"kind":"Name","value":"completionTokens"}},{"kind":"Field","name":{"kind":"Name","value":"totalTokens"}},{"kind":"Field","name":{"kind":"Name","value":"triggerPriceCents"}},{"kind":"Field","name":{"kind":"Name","value":"triggerTags"}}]}},{"kind":"Field","name":{"kind":"Name","value":"evaluation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directHits"}},{"kind":"Field","name":{"kind":"Name","value":"directTotal"}},{"kind":"Field","name":{"kind":"Name","value":"futureHits"}},{"kind":"Field","name":{"kind":"Name","value":"futureTotal"}},{"kind":"Field","name":{"kind":"Name","value":"tagMatches"}},{"kind":"Field","name":{"kind":"Name","value":"tagTotal"}},{"kind":"Field","name":{"kind":"Name","value":"dietaryAligned"}},{"kind":"Field","name":{"kind":"Name","value":"priceAlignmentPct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"targetDate"}},{"kind":"Field","name":{"kind":"Name","value":"vendorId"}},{"kind":"Field","name":{"kind":"Name","value":"itemsOrdered"}},{"kind":"Field","name":{"kind":"Name","value":"historySize"}},{"kind":"Field","name":{"kind":"Name","value":"groundTruth"}},{"kind":"Field","name":{"kind":"Name","value":"futureOrders"}},{"kind":"Field","name":{"kind":"Name","value":"remainingCartItems"}},{"kind":"Field","name":{"kind":"Name","value":"triggerItem"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directMatchRate"}},{"kind":"Field","name":{"kind":"Name","value":"futureMatchRate"}},{"kind":"Field","name":{"kind":"Name","value":"hitRate"}},{"kind":"Field","name":{"kind":"Name","value":"nearMissRate"}},{"kind":"Field","name":{"kind":"Name","value":"dietaryViolationRate"}},{"kind":"Field","name":{"kind":"Name","value":"avgPriceAlignmentPct"}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalDurationMs"}},{"kind":"Field","name":{"kind":"Name","value":"passedCount"}},{"kind":"Field","name":{"kind":"Name","value":"failedCount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetBacktestQuery, GetBacktestQueryVariables>;
export const GetRecommendationsEntryPointsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRecommendationsEntryPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRecommendationsEntryPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entryPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"bucketConfigurations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucketName"}},{"kind":"Field","name":{"kind":"Name","value":"recommendationModelName"}},{"kind":"Field","name":{"kind":"Name","value":"recommendationModelVersion"}},{"kind":"Field","name":{"kind":"Name","value":"allocationPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"entryPointId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetRecommendationsEntryPointsQuery, GetRecommendationsEntryPointsQueryVariables>;
export const GetLimitsGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLimitsGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLimitsGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limitsGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"maxSessionCostCents"}},{"kind":"Field","name":{"kind":"Name","value":"maxDailyCostCents"}},{"kind":"Field","name":{"kind":"Name","value":"maxMonthlyCostCents"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetLimitsGroupsQuery, GetLimitsGroupsQueryVariables>;
export const GetRecommendationsModelConfigsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRecommendationsModelConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRecommendationsModelConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modelConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"modelType"}},{"kind":"Field","name":{"kind":"Name","value":"task"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"promptConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"masterTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"variablesJson"}},{"kind":"Field","name":{"kind":"Name","value":"modelParamsJson"}},{"kind":"Field","name":{"kind":"Name","value":"hasVariables"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"baseVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"baseVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"versionAncestry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"promptConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"masterTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"variablesJson"}},{"kind":"Field","name":{"kind":"Name","value":"modelParamsJson"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetRecommendationsModelConfigsQuery, GetRecommendationsModelConfigsQueryVariables>;
export const GetRecommendationsModelMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRecommendationsModelMetrics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRecommendationsModelMetrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"modelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modelId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modelId"}},{"kind":"Field","name":{"kind":"Name","value":"totalRequests"}},{"kind":"Field","name":{"kind":"Name","value":"totalShown"}},{"kind":"Field","name":{"kind":"Name","value":"totalClicked"}},{"kind":"Field","name":{"kind":"Name","value":"totalPurchased"}},{"kind":"Field","name":{"kind":"Name","value":"totalDismissed"}},{"kind":"Field","name":{"kind":"Name","value":"clickThroughRate"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRate"}},{"kind":"Field","name":{"kind":"Name","value":"last24hRequests"}},{"kind":"Field","name":{"kind":"Name","value":"last7dRequests"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetRecommendationsModelMetricsQuery, GetRecommendationsModelMetricsQueryVariables>;
export const GetRecommendationsModelMetricsBatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRecommendationsModelMetricsBatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modelIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRecommendationsModelMetricsBatch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"modelIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modelIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modelId"}},{"kind":"Field","name":{"kind":"Name","value":"totalRequests"}},{"kind":"Field","name":{"kind":"Name","value":"totalShown"}},{"kind":"Field","name":{"kind":"Name","value":"totalClicked"}},{"kind":"Field","name":{"kind":"Name","value":"totalPurchased"}},{"kind":"Field","name":{"kind":"Name","value":"totalDismissed"}},{"kind":"Field","name":{"kind":"Name","value":"clickThroughRate"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRate"}},{"kind":"Field","name":{"kind":"Name","value":"last24hRequests"}},{"kind":"Field","name":{"kind":"Name","value":"last7dRequests"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetRecommendationsModelMetricsBatchQuery, GetRecommendationsModelMetricsBatchQueryVariables>;
export const GetRecommendationModelVersionHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRecommendationModelVersionHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRecommendationModelVersionHistory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"modelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modelId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"versionHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"modelId"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"masterTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"changeNotes"}},{"kind":"Field","name":{"kind":"Name","value":"baseVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"baseVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"versionAncestry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"changeNotes"}},{"kind":"Field","name":{"kind":"Name","value":"masterTemplate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRecommendationModelVersionHistoryQuery, GetRecommendationModelVersionHistoryQueryVariables>;
export const GetRecommendationsCustomPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRecommendationsCustomPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRecommendationsCustomPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferencesVersion"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRecommendationsCustomPreferencesQuery, GetRecommendationsCustomPreferencesQueryVariables>;
export const GetRecommendationsDetailedFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRecommendationsDetailedFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRecommendationsDetailedFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"modelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modelId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"taskFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"detailedFeedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modelId"}},{"kind":"Field","name":{"kind":"Name","value":"totalInteractions"}},{"kind":"Field","name":{"kind":"Name","value":"timeSeriesData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"shownCount"}},{"kind":"Field","name":{"kind":"Name","value":"clickedCount"}},{"kind":"Field","name":{"kind":"Name","value":"purchasedCount"}},{"kind":"Field","name":{"kind":"Name","value":"dismissedCount"}},{"kind":"Field","name":{"kind":"Name","value":"clickThroughRate"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRecommendationsDetailedFeedbackQuery, GetRecommendationsDetailedFeedbackQueryVariables>;
export const GetRecommendationsPreviewPromptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRecommendationsPreviewPrompt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"promptConfig"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PromptConfigInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"context"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PromptContextInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRecommendationsPreviewPrompt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"promptConfig"},"value":{"kind":"Variable","name":{"kind":"Name","value":"promptConfig"}}},{"kind":"Argument","name":{"kind":"Name","value":"context"},"value":{"kind":"Variable","name":{"kind":"Name","value":"context"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewText"}},{"kind":"Field","name":{"kind":"Name","value":"profileJson"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetRecommendationsPreviewPromptQuery, GetRecommendationsPreviewPromptQueryVariables>;
export const GetRecommendationsTagGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRecommendationsTagGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRecommendationsTagGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"staleTags"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"groupsCount"}},{"kind":"Field","name":{"kind":"Name","value":"tagsCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRecommendationsTagGroupsQuery, GetRecommendationsTagGroupsQueryVariables>;
export const ListBacktestRunsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListBacktestRuns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listBacktestRuns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"modelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modelId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"runs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"backtestId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"evaluatorType"}},{"kind":"Field","name":{"kind":"Name","value":"task"}},{"kind":"Field","name":{"kind":"Name","value":"totalCases"}},{"kind":"Field","name":{"kind":"Name","value":"completedCases"}},{"kind":"Field","name":{"kind":"Name","value":"failedCases"}},{"kind":"Field","name":{"kind":"Name","value":"directMatchRate"}},{"kind":"Field","name":{"kind":"Name","value":"futureMatchRate"}},{"kind":"Field","name":{"kind":"Name","value":"avgPriceAlignmentPct"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ListBacktestRunsQuery, ListBacktestRunsQueryVariables>;
export const PublishRecommendationsModelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"publishRecommendationsModel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bucketConfigurationIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishRecommendationsModel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"modelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modelId"}}},{"kind":"Argument","name":{"kind":"Name","value":"bucketConfigurationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bucketConfigurationIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modelConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<PublishRecommendationsModelMutation, PublishRecommendationsModelMutationVariables>;
export const RerunBacktestCasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RerunBacktestCases"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RerunBacktestCasesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rerunBacktestCases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backtestId"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<RerunBacktestCasesMutation, RerunBacktestCasesMutationVariables>;
export const RestoreRecommendationsTagGroupsVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"restoreRecommendationsTagGroupsVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"versionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restoreRecommendationsTagGroupsVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"versionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"versionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RestoreRecommendationsTagGroupsVersionMutation, RestoreRecommendationsTagGroupsVersionMutationVariables>;
export const StartBacktestDiscoveryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartBacktestDiscovery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StartBacktestDiscoveryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startBacktestDiscovery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discovery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backtestId"}},{"kind":"Field","name":{"kind":"Name","value":"eligibleUserCount"}},{"kind":"Field","name":{"kind":"Name","value":"selectedCount"}},{"kind":"Field","name":{"kind":"Name","value":"ineligibleUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"perUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"totalOrders"}},{"kind":"Field","name":{"kind":"Name","value":"selectedCount"}},{"kind":"Field","name":{"kind":"Name","value":"testCases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"targetDate"}},{"kind":"Field","name":{"kind":"Name","value":"itemsOrdered"}},{"kind":"Field","name":{"kind":"Name","value":"historySize"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<StartBacktestDiscoveryMutation, StartBacktestDiscoveryMutationVariables>;
export const StartBacktestRunDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartBacktestRun"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StartBacktestRunInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startBacktestRun"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backtestId"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<StartBacktestRunMutation, StartBacktestRunMutationVariables>;
export const TestRecommendationsPromptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"testRecommendationsPrompt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"promptConfig"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PromptConfigInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"context"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PromptContextInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"testRecommendationsPrompt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"promptConfig"},"value":{"kind":"Variable","name":{"kind":"Name","value":"promptConfig"}}},{"kind":"Argument","name":{"kind":"Name","value":"context"},"value":{"kind":"Variable","name":{"kind":"Name","value":"context"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"testResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"responseJson"}},{"kind":"Field","name":{"kind":"Name","value":"modelUsed"}},{"kind":"Field","name":{"kind":"Name","value":"durationMs"}},{"kind":"Field","name":{"kind":"Name","value":"promptTokens"}},{"kind":"Field","name":{"kind":"Name","value":"completionTokens"}},{"kind":"Field","name":{"kind":"Name","value":"totalTokens"}},{"kind":"Field","name":{"kind":"Name","value":"cachedTokens"}},{"kind":"Field","name":{"kind":"Name","value":"reasoningTokens"}},{"kind":"Field","name":{"kind":"Name","value":"costCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<TestRecommendationsPromptMutation, TestRecommendationsPromptMutationVariables>;
export const UpdateRecommendationsLimitsGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRecommendationsLimitsGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLimitsGroup"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRecommendationsLimitsGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limitsGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"maxSessionCostCents"}},{"kind":"Field","name":{"kind":"Name","value":"maxDailyCostCents"}},{"kind":"Field","name":{"kind":"Name","value":"maxMonthlyCostCents"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRecommendationsLimitsGroupMutation, UpdateRecommendationsLimitsGroupMutationVariables>;
export const UpdateRecommendationsModelConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRecommendationsModelConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateModelConfig"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRecommendationsModelConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modelConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"modelType"}},{"kind":"Field","name":{"kind":"Name","value":"task"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"promptConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"masterTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"variablesJson"}},{"kind":"Field","name":{"kind":"Name","value":"modelParamsJson"}},{"kind":"Field","name":{"kind":"Name","value":"hasVariables"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRecommendationsModelConfigMutation, UpdateRecommendationsModelConfigMutationVariables>;
export const UpdateRecommendationsCustomPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRecommendationsCustomPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preferences"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecommendationsCustomPreferenceInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRecommendationsCustomPreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preferences"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preferences"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferencesVersion"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRecommendationsCustomPreferencesMutation, UpdateRecommendationsCustomPreferencesMutationVariables>;
export const UpdateRecommendationsTagGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRecommendationsTagGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groups"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecommendationsTagGroupInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRecommendationsTagGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groups"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRecommendationsTagGroupsMutation, UpdateRecommendationsTagGroupsMutationVariables>;
export const GetScoringEventTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getScoringEventTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getScoringEventTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scoringEventTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slope"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}}]}}]}}]}}]} as unknown as DocumentNode<GetScoringEventTypesQuery, GetScoringEventTypesQueryVariables>;
export const UpdateScoringEventTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateScoringEventTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateScoringEventTypes"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScoringEventTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scoringEventTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slope"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateScoringEventTypesMutation, UpdateScoringEventTypesMutationVariables>;
export const SearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Search"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"popupEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consolidatedInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchQuery, SearchQueryVariables>;
export const GetShadowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getShadow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetShadowInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getShadow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shadow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"scoredAt"}},{"kind":"Field","name":{"kind":"Name","value":"falsePositiveState"}},{"kind":"Field","name":{"kind":"Name","value":"falsePositiveCutoffAt"}},{"kind":"Field","name":{"kind":"Name","value":"shadowActions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"actedAt"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"actor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shadowScoringEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"StringValue","value":"scored_at desc","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shadowId"}},{"kind":"Field","name":{"kind":"Name","value":"eventTypeCode"}},{"kind":"Field","name":{"kind":"Name","value":"eventTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"scoredAt"}},{"kind":"Field","name":{"kind":"Name","value":"ignored"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"currentPage"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetShadowQuery, GetShadowQueryVariables>;
export const MarkShadowFalsePositiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"markShadowFalsePositive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarkShadowFalsePositiveInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markShadowFalsePositive"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shadow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"falsePositiveState"}},{"kind":"Field","name":{"kind":"Name","value":"falsePositiveCutoffAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<MarkShadowFalsePositiveMutation, MarkShadowFalsePositiveMutationVariables>;
export const UpdateScoringEventsBatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateScoringEventsBatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateScoringEventInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScoringEventsBatch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scoringEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ignored"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateScoringEventsBatchMutation, UpdateScoringEventsBatchMutationVariables>;
export const CreateSubsidyRuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createSubsidyRule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSubsidyRule"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"createSubsidyRule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<CreateSubsidyRuleMutation, CreateSubsidyRuleMutationVariables>;
export const DeleteSubsidyRuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteSubsidyRule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteSubsidyRule"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"deleteSubsidyRule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteSubsidyRuleMutation, DeleteSubsidyRuleMutationVariables>;
export const GetExternalTagsMealTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getExternalTagsMealTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMealTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mealTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"getExternalTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<GetExternalTagsMealTypesQuery, GetExternalTagsMealTypesQueryVariables>;
export const GetGuestPassProgramsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getGuestPassPrograms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"rules"},"name":{"kind":"Name","value":"getSubsidyRules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"kind"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"GUEST_PASS"}]}},{"kind":"Argument","name":{"kind":"Name","value":"allSubsidies"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subsidyRules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"availableProducts"}},{"kind":"Field","name":{"kind":"Name","value":"programStatus"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"daysAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"guestPasses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"passCount"}},{"kind":"Field","name":{"kind":"Name","value":"passes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"passNumber"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetGuestPassProgramsQuery, GetGuestPassProgramsQueryVariables>;
export const GetSubsidyRuleHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSubsidyRuleHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subsidyRuleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ruleHistory"},"name":{"kind":"Name","value":"getSubsidyRuleHistory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subsidyRuleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subsidyRuleId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"changedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedByLabel"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<GetSubsidyRuleHistoryQuery, GetSubsidyRuleHistoryQueryVariables>;
export const GetSubsidyRulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSubsidyRules"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kind"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubsidyKind"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"rules"},"name":{"kind":"Name","value":"getSubsidyRules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"allSubsidies"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"kind"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kind"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subsidyRules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"autoApply"}},{"kind":"Field","name":{"kind":"Name","value":"dailyMaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"daysAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventMaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"minOrderCents"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyMaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"noQr"}},{"kind":"Field","name":{"kind":"Name","value":"percentageCap"}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"programMaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"validEverywhere"}},{"kind":"Field","name":{"kind":"Name","value":"accountWhitelistIds"}},{"kind":"Field","name":{"kind":"Name","value":"accountWhitelistAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weeklyMaxCents"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyRecurrence"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"subsidyType"}},{"kind":"Field","name":{"kind":"Name","value":"mealTypes"}},{"kind":"Field","name":{"kind":"Name","value":"externalTags"}},{"kind":"Field","name":{"kind":"Name","value":"mealTypeLabels"}},{"kind":"Field","name":{"kind":"Name","value":"externalTagLabels"}},{"kind":"Field","name":{"kind":"Name","value":"vendors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportedMealPeriods"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"displayPreSubsidyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"preTaxEmployeeContribution"}},{"kind":"Field","name":{"kind":"Name","value":"skipEmailVerification"}},{"kind":"Field","name":{"kind":"Name","value":"coverageDescriptionOverride"}},{"kind":"Field","name":{"kind":"Name","value":"generatedDescription"}},{"kind":"Field","name":{"kind":"Name","value":"timeZoneName"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedByLabel"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"foodaCardProgram"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"allowedHourRanges"}},{"kind":"Field","name":{"kind":"Name","value":"allowedMerchantCategoryIds"}},{"kind":"Field","name":{"kind":"Name","value":"blockedMerchantCategoryIds"}},{"kind":"Field","name":{"kind":"Name","value":"allowedMerchantCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"blockedMerchantCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowedMerchantNames"}},{"kind":"Field","name":{"kind":"Name","value":"blockedMerchantNames"}},{"kind":"Field","name":{"kind":"Name","value":"allowedZipCodes"}},{"kind":"Field","name":{"kind":"Name","value":"stripeAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"stripeAccountId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subsidyAdmins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"mealPeriodFeatureFlag"},"name":{"kind":"Name","value":"getFeatureFlag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"use_meal_period_popup_subsidy","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureFlag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"travelFeatureFlag"},"name":{"kind":"Name","value":"getFeatureFlag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"use_traveling_subsidies","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureFlag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetSubsidyRulesQuery, GetSubsidyRulesQueryVariables>;
export const SearchSubsidyVendorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchSubsidyVendors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchVendorsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchVendors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}}]}}]}}]}}]} as unknown as DocumentNode<SearchSubsidyVendorsQuery, SearchSubsidyVendorsQueryVariables>;
export const UpdateSubsidyRuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSubsidyRule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSubsidyRule"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"updateSubsidyRule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSubsidyRuleMutation, UpdateSubsidyRuleMutationVariables>;
export const CreateTaxCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTaxCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTaxCategory"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"createTaxCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"categoryType"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"isSync"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTaxCategoryMutation, CreateTaxCategoryMutationVariables>;
export const GetLineItemTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLineItemTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"getLineItemTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineItemTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemType"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemSubType"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"eventFinanceLineItemType"}},{"kind":"Field","name":{"kind":"Name","value":"taxCategoryId"}},{"kind":"Field","name":{"kind":"Name","value":"taxCategoryType"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableForUser"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetLineItemTemplatesQuery, GetLineItemTemplatesQueryVariables>;
export const GetProductTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProductTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"getProductTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productTypes"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetProductTypesQuery, GetProductTypesQueryVariables>;
export const GetTaxCategoriesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTaxCategoriesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"getTaxCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"categoryType"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"isSync"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTaxCategoriesQueryQuery, GetTaxCategoriesQueryQueryVariables>;
export const GetTaxCategoryTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTaxCategoryTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"getTaxCategoryTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<GetTaxCategoryTypesQuery, GetTaxCategoryTypesQueryVariables>;
export const GetTaxCategoryVersionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTaxCategoryVersions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetTaxCategoryVersionsRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"getTaxCategoryVersions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"taxCategoryId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"categoryType"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"isSync"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<GetTaxCategoryVersionsQuery, GetTaxCategoryVersionsQueryVariables>;
export const GetTaxRatesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTaxRatesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getTaxRatesInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetTaxRatesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"getTaxRates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getTaxRatesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"refreshedAt"}},{"kind":"Field","name":{"kind":"Name","value":"addressId"}},{"kind":"Field","name":{"kind":"Name","value":"taxCategoryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTaxRatesQueryQuery, GetTaxRatesQueryQueryVariables>;
export const UpdateTaxRatesForBuildingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"updateTaxRatesForBuildings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"updateTaxRatesForBuildings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTaxRatesForBuildingsQuery, UpdateTaxRatesForBuildingsQueryVariables>;
export const UpdateLineItemTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateLineItemType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLineItem"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"updateLineItemType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineItemType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemType"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemSubType"}},{"kind":"Field","name":{"kind":"Name","value":"taxCategoryId"}},{"kind":"Field","name":{"kind":"Name","value":"taxCategoryType"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"eventFinanceLineItemType"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableForUser"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLineItemTypeMutation, UpdateLineItemTypeMutationVariables>;
export const UpdateTaxCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTaxCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTaxCategory"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"updateTaxCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"categoryType"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"isSync"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTaxCategoryMutation, UpdateTaxCategoryMutationVariables>;
export const CreateTenderMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTenderMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTenderMethodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"createTenderMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenderMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"daysAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"accountIds"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTenderMethodMutation, CreateTenderMethodMutationVariables>;
export const GetTenderMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTenderMethods"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetTenderMethods"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"methods"},"name":{"kind":"Name","value":"getTenderMethods"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenderMethods"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"daysAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"accountIds"}},{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"availableToday"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTenderMethodsQuery, GetTenderMethodsQueryVariables>;
export const UpdateTenderMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTenderMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTenderMethodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"updateTenderMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"codeAsString"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenderMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"daysAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"accountIds"}},{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"availableToday"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTenderMethodMutation, UpdateTenderMethodMutationVariables>;
export const CreateAuthenticationDomainDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAuthenticationDomain"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAuthenticationDomain"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAuthenticationDomain"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authenticationDomain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"authenticationProviderId"}},{"kind":"Field","name":{"kind":"Name","value":"useLoginHint"}},{"kind":"Field","name":{"kind":"Name","value":"scimEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"connectionId"}},{"kind":"Field","name":{"kind":"Name","value":"mobileSessionTimeout"}},{"kind":"Field","name":{"kind":"Name","value":"mobileSessionExpiration"}},{"kind":"Field","name":{"kind":"Name","value":"webSessionTimeout"}},{"kind":"Field","name":{"kind":"Name","value":"webSessionExpiration"}},{"kind":"Field","name":{"kind":"Name","value":"testMode"}},{"kind":"Field","name":{"kind":"Name","value":"listOfUsers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<CreateAuthenticationDomainMutation, CreateAuthenticationDomainMutationVariables>;
export const GetUserAuthenticationDomainsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserAuthenticationDomains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAuthenticationDomains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authenticationDomains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"authenticationProviderId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"useLoginHint"}},{"kind":"Field","name":{"kind":"Name","value":"scimEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"connectionId"}},{"kind":"Field","name":{"kind":"Name","value":"webSessionExpiration"}},{"kind":"Field","name":{"kind":"Name","value":"webSessionTimeout"}},{"kind":"Field","name":{"kind":"Name","value":"mobileSessionExpiration"}},{"kind":"Field","name":{"kind":"Name","value":"mobileSessionTimeout"}},{"kind":"Field","name":{"kind":"Name","value":"testMode"}},{"kind":"Field","name":{"kind":"Name","value":"listOfUsers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"getAuthenticationProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authenticationProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"machineName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"urlSuffix"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserAuthenticationDomainsQuery, GetUserAuthenticationDomainsQueryVariables>;
export const UpdateAuthenticationDomainDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAuthenticationDomain"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAuthenticationDomain"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAuthenticationDomain"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authenticationDomain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"authenticationProviderId"}},{"kind":"Field","name":{"kind":"Name","value":"useLoginHint"}},{"kind":"Field","name":{"kind":"Name","value":"scimEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"connectionId"}},{"kind":"Field","name":{"kind":"Name","value":"mobileSessionTimeout"}},{"kind":"Field","name":{"kind":"Name","value":"mobileSessionExpiration"}},{"kind":"Field","name":{"kind":"Name","value":"webSessionTimeout"}},{"kind":"Field","name":{"kind":"Name","value":"webSessionExpiration"}},{"kind":"Field","name":{"kind":"Name","value":"testMode"}},{"kind":"Field","name":{"kind":"Name","value":"listOfUsers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAuthenticationDomainMutation, UpdateAuthenticationDomainMutationVariables>;
export const CreateUserNoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createUserNote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUserNote"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserNote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userNote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateUserNoteMutation, CreateUserNoteMutationVariables>;
export const DeleteUserNoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteUserNote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUserNote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteUserNoteMutation, DeleteUserNoteMutationVariables>;
export const GetUserNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserNotes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userNotes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserNotesQuery, GetUserNotesQueryVariables>;
export const UpdateUserNoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUserNote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserNote"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserNote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userNote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserNoteMutation, UpdateUserNoteMutationVariables>;
export const GetUserFoodaCardOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserFoodaCardOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserFoodaCardOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"declineReason"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalAmountCents"}},{"kind":"Field","name":{"kind":"Name","value":"subsidyAmountCents"}},{"kind":"Field","name":{"kind":"Name","value":"overageAmountCents"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"stripeDashboardUrl"}},{"kind":"Field","name":{"kind":"Name","value":"merchant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"categoryCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripeCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cardType"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"overagePaymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cardTypeHumanized"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"processor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duePaymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cardTypeHumanized"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"processor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subsidyRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserFoodaCardOrdersQuery, GetUserFoodaCardOrdersQueryVariables>;
export const GetUserDeliveryOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserDeliveryOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"created_at desc","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserDeliveryOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prettyId"}},{"kind":"Field","name":{"kind":"Name","value":"orderPath"}},{"kind":"Field","name":{"kind":"Name","value":"eventPrettyId"}},{"kind":"Field","name":{"kind":"Name","value":"eventPath"}},{"kind":"Field","name":{"kind":"Name","value":"eventDropOffTime"}},{"kind":"Field","name":{"kind":"Name","value":"userFacingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"vendors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountCents"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTransaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountCents"}},{"kind":"Field","name":{"kind":"Name","value":"ccLast4"}},{"kind":"Field","name":{"kind":"Name","value":"cardType"}},{"kind":"Field","name":{"kind":"Name","value":"transactedAt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserDeliveryOrdersQuery, GetUserDeliveryOrdersQueryVariables>;
export const GetVendorPopupCapacityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getVendorPopupCapacity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vendorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getVendorPopupCapacity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"vendorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vendorId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxEventsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"maxEventsPerWeek"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"popupCapacityGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetVendorPopupCapacityQuery, GetVendorPopupCapacityQueryVariables>;
export const SearchPopupCapacityVendorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchPopupCapacityVendors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchVendorsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchVendors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"internalName"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"popupCapacityGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SearchPopupCapacityVendorsQuery, SearchPopupCapacityVendorsQueryVariables>;
export const UpdateVendorPopupCapacityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateVendorPopupCapacity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateVendorPopupCapacity"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateVendorPopupCapacity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateVendorPopupCapacityMutation, UpdateVendorPopupCapacityMutationVariables>;